(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("three"));
	else if(typeof define === 'function' && define.amd)
		define("OldSchoolSDK", ["three"], factory);
	else if(typeof exports === 'object')
		exports["OldSchoolSDK"] = factory(require("three"));
	else
		root["OldSchoolSDK"] = factory(root["three"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__9604__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 9252:
/***/ ((module) => {

module.exports = function chebyshev(a, b) {
  var farthest = 0
  var dimensions = Math.max(a.length, b.length)
  for (var i = 0; i < dimensions; i++) {
    var distance = Math.abs((b[i] || 0) - (a[i] || 0))
    if (distance > farthest) {
      farthest = distance
    }
  }
  return farthest
}


/***/ }),

/***/ 6799:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

const validators_1 = __webpack_require__(6049);
function componentToHex(c) {
    const hex = c.toString(16);
    return hex.length === 1 ? '0' + hex : hex;
}
function rgbaToHex(color) {
    const r = Math.floor(color.r * color.a);
    const g = Math.floor(color.g * color.a);
    const b = Math.floor(color.b * color.a);
    return `#${componentToHex(r)}${componentToHex(g)}${componentToHex(b)}`;
}
class Color {
    constructor(r, g, b, a = 1) {
        validators_1.validateAlphaValue(a);
        this.r = r;
        this.g = g;
        this.b = b;
        this.a = a;
    }
    toRGBString() {
        return `rgb(${Math.floor(this.r * this.a)},${Math.floor(this.g * this.a)},${Math.floor(this.b * this.a)})`;
    }
    toRGBAString() {
        return `rgba(${this.r},${this.g},${this.b},${this.a})`;
    }
    toHexString() {
        return rgbaToHex(this);
    }
}
module.exports = Color;


/***/ }),

/***/ 349:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

const Color = __webpack_require__(6799);
const validators_1 = __webpack_require__(6049);
function hexToRgb(hex, alpha) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (result) {
        return new Color(parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16), alpha);
    }
    else {
        throw new Error(`${hex} is not a valid hex value.`);
    }
}
class ColorScale {
    constructor(min, max, colorStops, alpha = 1) {
        validators_1.validateMinMaxValues(min, max);
        validators_1.validateColorStops(colorStops);
        validators_1.validateAlphaValue(alpha);
        this.min = min;
        this.max = max;
        this.alpha = alpha;
        this.colorStops = colorStops.map((colorStop) => hexToRgb(colorStop, alpha));
    }
    getColor(value) {
        const numOfColorStops = this.colorStops.length;
        if (value < this.min)
            return this.colorStops[0];
        if (value > this.max)
            return this.colorStops[numOfColorStops - 1];
        const range = this.max - this.min;
        let weight = (value - this.min) / range;
        const colorStopIndex = Math.max(Math.ceil(weight * (numOfColorStops - 1)), 1);
        const minColor = this.colorStops[colorStopIndex - 1];
        const maxColor = this.colorStops[colorStopIndex];
        weight = weight * (numOfColorStops - 1) - (colorStopIndex - 1);
        const r = Math.floor(weight * maxColor.r + (1 - weight) * minColor.r);
        const g = Math.floor(weight * maxColor.g + (1 - weight) * minColor.g);
        const b = Math.floor(weight * maxColor.b + (1 - weight) * minColor.b);
        return new Color(r, g, b, this.alpha);
    }
}
module.exports = ColorScale;


/***/ }),

/***/ 5416:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

const ColorScale = __webpack_require__(349);
module.exports = ColorScale;


/***/ }),

/***/ 6049:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.validateAlphaValue = exports.validateColorStops = exports.validateMinMaxValues = void 0;
function validateMinMaxValues(min, max) {
    if (min === max) {
        throw new Error('The minimum value cannot be equal to the maximum value.');
    }
    else if (min > max) {
        throw new Error('The minimum value must be less than the maximum value.');
    }
}
exports.validateMinMaxValues = validateMinMaxValues;
function validateColorStops(colorStops) {
    if (colorStops.length < 2) {
        throw new Error('At least two colors must be provided.');
    }
}
exports.validateColorStops = validateColorStops;
function validateAlphaValue(alpha) {
    if (alpha < 0 || alpha > 1) {
        throw new Error('The alpha value must be between 0 and 1.');
    }
}
exports.validateAlphaValue = validateAlphaValue;


/***/ }),

/***/ 2543:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));


/***/ }),

/***/ 9604:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__9604__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "";
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  AccountControls: () => (/* reexport */ AccountControls),
  Actor: () => (/* reexport */ Actor),
  AhrimsRobeskirt: () => (/* reexport */ AhrimsRobeskirt),
  AhrimsRobetop: () => (/* reexport */ AhrimsRobetop),
  Ammo: () => (/* reexport */ Ammo),
  AmmoType: () => (/* reexport */ AmmoType),
  AmuletOfTorture: () => (/* reexport */ AmuletOfTorture),
  AncestralRobebottom: () => (/* reexport */ AncestralRobebottom),
  AncestralRobetop: () => (/* reexport */ AncestralRobetop),
  AncientStaff: () => (/* reexport */ AncientStaff),
  AncientsSpellbookControls: () => (/* reexport */ AncientsSpellbookControls),
  AoeRangedWeapon: () => (/* reexport */ AoeRangedWeapon),
  ArcProjectileMotionInterpolator: () => (/* reexport */ ArcProjectileMotionInterpolator),
  ArmadylChainskirt: () => (/* reexport */ ArmadylChainskirt),
  ArmadylChestplate: () => (/* reexport */ ArmadylChestplate),
  Assets: () => (/* reexport */ Assets),
  AttackIndicators: () => (/* reexport */ AttackIndicators),
  AttackStyle: () => (/* reexport */ AttackStyle),
  AttackStyleTypes: () => (/* reexport */ AttackStyleTypes),
  AttackStylesController: () => (/* reexport */ AttackStylesController),
  AvasAccumulator: () => (/* reexport */ AvasAccumulator),
  AvasAssembler: () => (/* reexport */ AvasAssembler),
  AvernicDefender: () => (/* reexport */ AvernicDefender),
  BarrageSpell: () => (/* reexport */ BarrageSpell),
  BarrowsGloves: () => (/* reexport */ BarrowsGloves),
  BaseControls: () => (/* reexport */ BaseControls),
  BasePrayer: () => (/* reexport */ BasePrayer),
  BasicModel: () => (/* reexport */ BasicModel),
  BasicModelShape: () => (/* reexport */ BasicModelShape),
  BastionPotion: () => (/* reexport */ BastionPotion),
  BlackChinchompa: () => (/* reexport */ BlackChinchompa),
  BlackDhideBody: () => (/* reexport */ BlackDhideBody),
  BlackDhideChaps: () => (/* reexport */ BlackDhideChaps),
  BlackDhideVambraces: () => (/* reexport */ BlackDhideVambraces),
  BladeOfSaeldor: () => (/* reexport */ BladeOfSaeldor),
  BloodBarrageSpell: () => (/* reexport */ BloodBarrageSpell),
  Blowpipe: () => (/* reexport */ Blowpipe),
  BoostPanel: () => (/* reexport */ BoostPanel),
  BowOfFaerdhinen: () => (/* reexport */ BowOfFaerdhinen),
  BrowserUtils: () => (/* reexport */ BrowserUtils),
  CanvasSpriteModel: () => (/* reexport */ CanvasSpriteModel),
  Cape: () => (/* reexport */ Cape),
  CardinalDirection: () => (/* reexport */ CardinalDirection),
  Chest: () => (/* reexport */ Chest),
  Chrome: () => (/* reexport */ Chrome),
  ClanChatControls: () => (/* reexport */ ClanChatControls),
  ClickAnimation: () => (/* reexport */ ClickAnimation),
  ClickController: () => (/* reexport */ ClickController),
  Collision: () => (/* reexport */ Collision),
  CollisionType: () => (/* reexport */ CollisionType),
  CombatControls: () => (/* reexport */ CombatControls),
  ContextMenu: () => (/* reexport */ ContextMenu),
  ControlPanelController: () => (/* reexport */ ControlPanelController),
  CrystalBody: () => (/* reexport */ CrystalBody),
  CrystalHelm: () => (/* reexport */ CrystalHelm),
  CrystalLegs: () => (/* reexport */ CrystalLegs),
  CrystalShield: () => (/* reexport */ CrystalShield),
  DagonhaiRobeTop: () => (/* reexport */ DagonhaiRobeTop),
  DelayedAction: () => (/* reexport */ DelayedAction),
  DeserializePlayerStats: () => (/* reexport */ DeserializePlayerStats),
  DevoutBoots: () => (/* reexport */ DevoutBoots),
  DiamondBoltsE: () => (/* reexport */ DiamondBoltsE),
  DizanasQuiver: () => (/* reexport */ DizanasQuiver),
  DragonArrows: () => (/* reexport */ DragonArrows),
  EQUIPMENT_TYPE_TO_SLOT: () => (/* reexport */ EQUIPMENT_TYPE_TO_SLOT),
  Eating: () => (/* reexport */ Eating),
  EmotesControls: () => (/* reexport */ EmotesControls),
  EmptyControls: () => (/* reexport */ EmptyControls),
  EmptyModel: () => (/* reexport */ EmptyModel),
  Entity: () => (/* reexport */ Entity),
  EntityNames: () => (/* reexport */ EntityNames),
  Equipment: () => (/* reexport */ Equipment),
  EquipmentControls: () => (/* reexport */ EquipmentControls),
  EquipmentTypes: () => (/* reexport */ EquipmentTypes),
  Feet: () => (/* reexport */ Feet),
  FerociousGloves: () => (/* reexport */ FerociousGloves),
  FollowTargetInterpolator: () => (/* reexport */ FollowTargetInterpolator),
  Food: () => (/* reexport */ Food),
  FriendsControls: () => (/* reexport */ FriendsControls),
  GLTFModel: () => (/* reexport */ GLTFModel),
  Gloves: () => (/* reexport */ Gloves),
  GuthixRobeTop: () => (/* reexport */ GuthixRobeTop),
  Helmet: () => (/* reexport */ Helmet),
  HolyBlessing: () => (/* reexport */ HolyBlessing),
  IceBarrageSpell: () => (/* reexport */ IceBarrageSpell),
  ImageLoader: () => (/* reexport */ ImageLoader),
  InfernalCape: () => (/* reexport */ InfernalCape),
  InputController: () => (/* reexport */ InputController),
  InventoryControls: () => (/* reexport */ InventoryControls),
  InvisibleMovementBlocker: () => (/* reexport */ InvisibleMovementBlocker),
  Item: () => (/* reexport */ Item),
  ItemName: () => (/* reexport */ ItemName),
  JusticiarChestguard: () => (/* reexport */ JusticiarChestguard),
  JusticiarFaceguard: () => (/* reexport */ JusticiarFaceguard),
  JusticiarLegguards: () => (/* reexport */ JusticiarLegguards),
  Karambwan: () => (/* reexport */ Karambwan),
  KeyBindingButton: () => (/* reexport */ KeyBindingButton),
  KodaiWand: () => (/* reexport */ KodaiWand),
  Legs: () => (/* reexport */ Legs),
  LineOfSight: () => (/* reexport */ LineOfSight),
  LineOfSightMask: () => (/* reexport */ LineOfSightMask),
  LinearProjectileMotionInterpolator: () => (/* reexport */ LinearProjectileMotionInterpolator),
  LocationUtils: () => (/* reexport */ LocationUtils),
  MagesBook: () => (/* reexport */ MagesBook),
  MagicWeapon: () => (/* reexport */ MagicWeapon),
  MapController: () => (/* reexport */ MapController),
  MasoriBodyF: () => (/* reexport */ MasoriBodyF),
  MasoriChapsF: () => (/* reexport */ MasoriChapsF),
  MasoriMaskF: () => (/* reexport */ MasoriMaskF),
  MeleeWeapon: () => (/* reexport */ MeleeWeapon),
  Mob: () => (/* reexport */ Mob),
  MusicControls: () => (/* reexport */ MusicControls),
  Necklace: () => (/* reexport */ Necklace),
  NecklaceOfAnguish: () => (/* reexport */ NecklaceOfAnguish),
  OccultNecklace: () => (/* reexport */ OccultNecklace),
  Offhand: () => (/* reexport */ Offhand),
  Pathing: () => (/* reexport */ Pathing),
  PegasianBoots: () => (/* reexport */ PegasianBoots),
  Player: () => (/* reexport */ Player),
  PlayerAnimationIndices: () => (/* reexport */ PlayerAnimationIndices),
  PlayerRegenTimer: () => (/* reexport */ PlayerRegenTimer),
  PointingModel: () => (/* reexport */ PointingModel),
  Potion: () => (/* reexport */ Potion),
  PrayerController: () => (/* reexport */ PrayerController),
  PrayerControls: () => (/* reexport */ PrayerControls),
  PrayerGroups: () => (/* reexport */ PrayerGroups),
  PrimordialBoots: () => (/* reexport */ PrimordialBoots),
  Projectile: () => (/* reexport */ Projectile),
  QuestsControls: () => (/* reexport */ QuestsControls),
  Random: () => (/* reexport */ Random),
  RangedWeapon: () => (/* reexport */ RangedWeapon),
  RangerBoots: () => (/* reexport */ RangerBoots),
  Region: () => (/* reexport */ Region),
  Renderable: () => (/* reexport */ Renderable),
  Ring: () => (/* reexport */ Ring),
  RingOfEndurance: () => (/* reexport */ RingOfEndurance),
  RingOfSufferingImbued: () => (/* reexport */ RingOfSufferingImbued),
  RobinHoodHat: () => (/* reexport */ RobinHoodHat),
  RubyBoltsE: () => (/* reexport */ RubyBoltsE),
  RuneCrossbow: () => (/* reexport */ RuneCrossbow),
  RuneKiteshield: () => (/* reexport */ RuneKiteshield),
  SaradominBody: () => (/* reexport */ SaradominBody),
  SaradominBrew: () => (/* reexport */ SaradominBrew),
  SaradominChaps: () => (/* reexport */ SaradominChaps),
  SaradominCoif: () => (/* reexport */ SaradominCoif),
  SaradominDhideBoots: () => (/* reexport */ SaradominDhideBoots),
  ScytheOfVitur: () => (/* reexport */ ScytheOfVitur),
  SerializePlayerStats: () => (/* reexport */ SerializePlayerStats),
  SetEffect: () => (/* reexport */ SetEffect),
  SetEffectTypes: () => (/* reexport */ SetEffectTypes),
  Settings: () => (/* reexport */ Settings),
  SettingsControls: () => (/* reexport */ SettingsControls),
  Shark: () => (/* reexport */ Shark),
  SlayerHelmet: () => (/* reexport */ SlayerHelmet),
  Sound: () => (/* reexport */ Sound),
  SoundCache: () => (/* reexport */ SoundCache),
  StaminaPotion: () => (/* reexport */ StaminaPotion),
  StandardSpellbookControls: () => (/* reexport */ StandardSpellbookControls),
  StatsControls: () => (/* reexport */ StatsControls),
  SuperCombatPotion: () => (/* reexport */ SuperCombatPotion),
  SuperRestore: () => (/* reexport */ SuperRestore),
  TestNpc: () => (/* reexport */ TestNpc),
  TestRegion: () => (/* reexport */ TestRegion),
  TileMarker: () => (/* reexport */ TileMarker),
  TileMarkerModel: () => (/* reexport */ TileMarkerModel),
  ToggleButton: () => (/* reexport */ ToggleButton),
  TorvaFullhelm: () => (/* reexport */ TorvaFullhelm),
  TorvaPlatebody: () => (/* reexport */ TorvaPlatebody),
  TorvaPlatelegs: () => (/* reexport */ TorvaPlatelegs),
  Trainer: () => (/* reexport */ Trainer),
  TwistedBow: () => (/* reexport */ TwistedBow),
  UltorRing: () => (/* reexport */ UltorRing),
  Unit: () => (/* reexport */ Unit),
  UnitEquipment: () => (/* reexport */ UnitEquipment),
  UnitTypes: () => (/* reexport */ UnitTypes),
  Viewport: () => (/* reexport */ Viewport),
  Viewport2d: () => (/* reexport */ Viewport2d),
  Viewport3d: () => (/* reexport */ Viewport3d),
  Weapon: () => (/* reexport */ Weapon),
  World: () => (/* reexport */ World),
  XpDrop: () => (/* reexport */ XpDrop),
  XpDropController: () => (/* reexport */ XpDropController),
  ZaryteVambraces: () => (/* reexport */ ZaryteVambraces),
  __assets_mock: () => (/* reexport */ _mocks_Assets_namespaceObject),
  __sound_cache_mock: () => (/* reexport */ _mocks_SoundCache_namespaceObject),
  drawLineNormally: () => (/* reexport */ drawLineNormally),
  drawLineOnTop: () => (/* reexport */ drawLineOnTop),
  parseText: () => (/* reexport */ parseText)
});

// NAMESPACE OBJECT: ./src/sdk/utils/__mocks__/Assets.ts
var _mocks_Assets_namespaceObject = {};
__webpack_require__.r(_mocks_Assets_namespaceObject);
__webpack_require__.d(_mocks_Assets_namespaceObject, {
  Assets: () => (Assets_Assets)
});

// NAMESPACE OBJECT: ./src/sdk/utils/__mocks__/SoundCache.ts
var _mocks_SoundCache_namespaceObject = {};
__webpack_require__.r(_mocks_SoundCache_namespaceObject);
__webpack_require__.d(_mocks_SoundCache_namespaceObject, {
  Sound: () => (SoundCache_Sound),
  SoundCache: () => (SoundCache_SoundCache)
});

;// CONCATENATED MODULE: ./src/sdk/PlayerStats.ts

function SerializePlayerStats(stats) {
    return JSON.stringify(stats);
}
function DeserializePlayerStats(serializedStats) {
    var stats = JSON.parse(serializedStats) || {};
    stats.attack = stats.attack || 99;
    stats.strength = stats.strength || 99;
    stats.defence = stats.defence || 99;
    stats.range = stats.range || 99;
    stats.magic = stats.magic || 99;
    stats.hitpoint = stats.hitpoint || 99;
    stats.agility = stats.agility || 99;
    stats.prayer = stats.prayer || 99;
    stats.run = stats.run || 10000;
    stats.specialAttack = stats.specialAttack || 100;
    return stats;
}

;// CONCATENATED MODULE: ./src/sdk/Settings.ts


var WASD = ["w", "a", "s", "d"];
var Settings = /** @class */ (function () {
    function Settings() {
    }
    Object.defineProperty(Settings, "tileSize", {
        get: function () {
            return Settings._tileSize * Settings.zoomScale;
        },
        enumerable: false,
        configurable: true
    });
    Settings.checkWasd = function () {
        var result = WASD.includes(Settings.inventory_key) ||
            WASD.includes(Settings.equipment_key) ||
            WASD.includes(Settings.combat_key) ||
            WASD.includes(Settings.prayer_key);
        Settings.isUsingWasdKeybind = result;
        return result;
    };
    Settings.mobileCheck = function () {
        if (Settings._isMobileResult !== null) {
            return Settings._isMobileResult;
        }
        Settings._isMobileResult = /Mobi/.test(navigator.userAgent);
        return Settings._isMobileResult;
    };
    Settings.persistToStorage = function () {
        // window.localStorage.setItem('tileSize', Settings.tileSize);
        // window.localStorage.setItem('framesPerTick', Settings.framesPerTick);
        window.localStorage.setItem("zoomScale", String(Settings.zoomScale));
        window.localStorage.setItem("playsAudio", String(Settings.playsAudio));
        window.localStorage.setItem("playsAreaAudio", String(Settings.playsAreaAudio));
        window.localStorage.setItem("inputDelay", String(Settings.inputDelay));
        window.localStorage.setItem("rotated", Settings.rotated);
        window.localStorage.setItem("displayXpDrops", String(Settings.displayXpDrops));
        window.localStorage.setItem("inventory_key", Settings.inventory_key);
        window.localStorage.setItem("spellbook_key", Settings.spellbook_key);
        window.localStorage.setItem("equipment_key", Settings.equipment_key);
        window.localStorage.setItem("prayer_key", Settings.prayer_key);
        window.localStorage.setItem("combat_key", Settings.combat_key);
        window.localStorage.setItem("stats", SerializePlayerStats(Settings.player_stats));
        window.localStorage.setItem("loadout", Settings.loadout);
        window.localStorage.setItem("onTask", String(Settings.onTask));
        window.localStorage.setItem("southPillar", String(Settings.southPillar));
        window.localStorage.setItem("westPillar", String(Settings.westPillar));
        window.localStorage.setItem("northPillar", String(Settings.northPillar));
        window.localStorage.setItem("displayPlayerLoS", String(Settings.displayPlayerLoS));
        window.localStorage.setItem("displayMobLoS", String(Settings.displayMobLoS));
        window.localStorage.setItem("metronome", String(Settings.metronome));
        window.localStorage.setItem("displayFeedback", String(Settings.displayFeedback));
        window.localStorage.setItem("tile_markers", JSON.stringify(Settings.tile_markers));
        window.localStorage.setItem("tileMarkerColor", Settings.tileMarkerColor);
        window.localStorage.setItem("lockPOV", JSON.stringify(Settings.lockPOV));
        window.localStorage.setItem("menuVisible", String(Settings.menuVisible));
        window.localStorage.setItem("use3dView", String(Settings.use3dView));
        window.localStorage.setItem("maxUiScale", String(Settings.maxUiScale));
        window.localStorage.setItem("antiDrag", String(Settings.antiDrag));
        Settings.checkWasd();
    };
    Settings.read = function (key, defaultValue) {
        var val = window.localStorage.getItem(key);
        if (val === null) {
            return defaultValue;
        }
        else {
            return val;
        }
    };
    Settings.readFromStorage = function () {
        var _a;
        Settings.minimapScale = Settings.mobileCheck() ? 0.65 : 1;
        Settings.controlPanelScale = Settings.mobileCheck() ? 0.9 : 1.5;
        Settings.zoomScale = parseFloat(window.localStorage.getItem("zoomScale")) || 1;
        Settings.playsAudio = window.localStorage.getItem("playsAudio") === "true" || false;
        Settings.playsAreaAudio = window.localStorage.getItem("playsAreaAudio") === "true" || false;
        if (Settings.mobileCheck()) {
            Settings.playsAudio = false;
            Settings.playsAreaAudio = false;
        }
        // Settings.tileSize = parseInt(window.localStorage.getItem('tileSize')) || 23;
        // Settings.framesPerTick = parseInt(window.localStorage.getItem('framesPerTick')) || 30;
        Settings.inputDelay = parseInt((_a = window.localStorage.getItem("inputDelay")) !== null && _a !== void 0 ? _a : "100");
        Settings.rotated = window.localStorage.getItem("rotated") || "south";
        Settings.loadout = window.localStorage.getItem("loadout") || "max_tbow_speed";
        Settings.onTask = window.localStorage.getItem("onTask") === "true" || false;
        Settings.southPillar = window.localStorage.getItem("southPillar") !== "false" || false;
        Settings.westPillar = window.localStorage.getItem("westPillar") !== "false" || false;
        Settings.northPillar = window.localStorage.getItem("northPillar") !== "false" || false;
        Settings.displayPlayerLoS = window.localStorage.getItem("displayPlayerLoS") === "true" || false;
        Settings.displayMobLoS = window.localStorage.getItem("displayMobLoS") === "true" || false;
        Settings.lockPOV = false; //window.localStorage.getItem('lockPOV') !== 'false' || false;
        Settings.displayFeedback = !(window.localStorage.getItem("displayFeedback") === "false" || false);
        Settings.metronome = window.localStorage.getItem("metronome") === "true" || false;
        Settings.displayXpDrops = !(window.localStorage.getItem("displayXpDrops") === "false" || false);
        Settings.inventory_key = window.localStorage.getItem("inventory_key") || "F4";
        Settings.spellbook_key = window.localStorage.getItem("spellbook_key") || "F2";
        Settings.equipment_key = window.localStorage.getItem("equipment_key") || "F1";
        Settings.prayer_key = window.localStorage.getItem("prayer_key") || "F3";
        Settings.combat_key = window.localStorage.getItem("combat_key") || "F5";
        Settings.player_stats = DeserializePlayerStats(window.localStorage.getItem("stats"));
        Settings.tile_markers = JSON.parse(window.localStorage.getItem("tile_markers"));
        Settings.tileMarkerColor = Settings.read("tileMarkerColor", "#FF0000");
        if (window.localStorage.getItem("menuVisible") === "true") {
            Settings.menuVisible = true;
        }
        else if (window.localStorage.getItem("menuVisible") === "false") {
            Settings.menuVisible = false;
        }
        else {
            Settings.menuVisible = Settings.mobileCheck() === false;
        }
        if (!Settings.menuVisible) {
            document.getElementById("right_panel").classList.add("hidden");
        }
        Settings.use3dView = window.localStorage.getItem("use3dView") !== "false" || false;
        if (Settings.use3dView) {
            Settings.rotated = "north";
        }
        Settings.maxUiScale = parseFloat(window.localStorage.getItem("maxUiScale")) || 1.0;
        Settings.antiDrag = parseInt(Settings.read("antiDrag", "5"));
        Settings.checkWasd();
    };
    Settings.zoomScale = 1;
    Settings.fps = 50;
    Settings.tickMs = 600;
    Settings.is_keybinding = false;
    Settings.southPillar = true;
    Settings.westPillar = true;
    Settings.northPillar = true;
    Settings.displayPlayerLoS = false;
    Settings.displayMobLoS = false;
    Settings._isMobileResult = null;
    Settings.use3dView = true;
    Settings.isUsingWasdKeybind = Settings.checkWasd();
    return Settings;
}());


// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(2543);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
;// CONCATENATED MODULE: ./src/sdk/Location.ts

var LocationUtils = /** @class */ (function () {
    function LocationUtils() {
    }
    LocationUtils.closestPointTo = function (x, y, mob) {
        var corners = [];
        for (var xx = 0; xx < mob.size; xx++) {
            for (var yy = 0; yy < mob.size; yy++) {
                corners.push({
                    x: mob.location.x + xx,
                    y: mob.location.y - yy,
                });
            }
        }
        return (0,lodash.minBy)(corners, function (point) { return LocationUtils.dist(x, y, point.x, point.y); });
    };
    LocationUtils.dist = function (x, y, x2, y2) {
        return Math.sqrt(Math.pow(x2 - x, 2) + Math.pow(y2 - y, 2));
    };
    LocationUtils.angle = function (x, y, x2, y2) {
        return Math.atan2(y2 - y, x2 - x);
    };
    return LocationUtils;
}());


;// CONCATENATED MODULE: ./src/sdk/Pathing.ts




var Pathing = /** @class */ (function () {
    function Pathing() {
    }
    Pathing.entitiesAtPoint = function (region, x, y, s) {
        var entities = [];
        for (var i = 0; i < region.entities.length; i++) {
            if (Collision.collisionMath(x, y, s, region.entities[i].location.x, region.entities[i].location.y, region.entities[i].size)) {
                entities.push(region.entities[i]);
            }
        }
        return entities;
    };
    // TODO: Make this more like entitiesAtPoint
    Pathing.mobsAtAoeOffset = function (region, mob, point) {
        var mobs = [];
        for (var i = 0; i < region.mobs.length; i++) {
            var collidedWithSpecificMob = region.mobs[i].location.x === point.x + mob.location.x &&
                region.mobs[i].location.y === point.y + mob.location.y;
            if (collidedWithSpecificMob) {
                mobs.push(region.mobs[i]);
            }
        }
        return (0,lodash.sortBy)(mobs, function (m) { return mob !== m; });
    };
    // Core pathing
    Pathing.linearInterpolation = function (x, y, a) {
        return (y - x) * a + x;
    };
    // TODO: Remove these
    Pathing.dist = function (x, y, x2, y2) {
        return LocationUtils.dist(x, y, x2, y2);
    };
    Pathing.angle = function (x, y, x2, y2) {
        return LocationUtils.angle(x, y, x2, y2);
    };
    Pathing.purgeTileCache = function () {
        Pathing.tileCache = {};
    };
    Pathing.canTileBePathedTo = function (region, x, y, s, mobToAvoid) {
        if (mobToAvoid === void 0) { mobToAvoid = null; }
        var cache = Pathing.tileCache["".concat(region.serialNumber, "-").concat(x, "-").concat(y, "-").concat(s, "-").concat(mobToAvoid ? mobToAvoid.serialNumber : 0)];
        if (cache !== undefined) {
            return cache;
        }
        var collision = false;
        collision = collision || Collision.collidesWithAnyEntities(region, x, y, s);
        if (mobToAvoid) {
            // if no mobs to avoid, avoid them all
            // Player can walk under mobs
            collision = collision || Collision.collidesWithAnyMobs(region, x, y, s, mobToAvoid) !== null;
        }
        Pathing.tileCache["".concat(region.serialNumber, "-").concat(x, "-").concat(y, "-").concat(s, "-").concat(mobToAvoid ? mobToAvoid.serialNumber : 0)] = !collision;
        return !collision;
    };
    /**
     *
     * @param region
     * @param startPoint
     * @param endPoints array of valid end points. the first should be the SW tile.
     * @returns
     */
    Pathing.constructPaths = function (region, _a, endPoints) {
        var _b;
        var x = _a.x, y = _a.y;
        var unpathableEndPoints = endPoints.filter(function (location) { return !Pathing.canTileBePathedTo(region, location.x, location.y, 1); });
        if (unpathableEndPoints.length === endPoints.length) {
            // no pathable end points
            return {
                destination: null,
                path: [],
            };
        }
        var pathableEndPoints = endPoints.filter(function (location) {
            return Pathing.canTileBePathedTo(region, location.x, location.y, 1);
        });
        var pathX = x;
        var pathY = y;
        var nodes = [{ x: x, y: y, parent: null }];
        // The order of possible directions in this array determines if the player moves first straight or diagonaly
        // https://oldschool.runescape.wiki/w/Pathfinding#Determining_the_target_tile
        var directions = [
            { x: -1, y: 0 },
            { x: 1, y: 0 },
            { x: 0, y: 1 },
            { x: 0, y: -1 },
            { x: -1, y: 1 },
            { x: 1, y: 1 },
            { x: -1, y: -1 },
            { x: 1, y: -1 }, // ne
        ];
        var currentDistance = 0;
        // Djikstra search for the optimal route
        var explored = {};
        // initialise first node
        explored[pathX] = {};
        explored[pathX][pathY] = { x: pathX, y: pathY, parent: null, pathLength: 0 };
        var minExploredX = pathX;
        var minExploredY = pathY;
        var maxExploredX = pathX;
        var maxExploredY = pathY;
        var _loop_1 = function () {
            var parentNode = nodes.shift();
            var matchedDestinations = pathableEndPoints.filter(function (d) { return d.x === parentNode.x && d.y === parentNode.y; });
            for (var _i = 0, matchedDestinations_1 = matchedDestinations; _i < matchedDestinations_1.length; _i++) {
                var matchedDestination = matchedDestinations_1[_i];
                var path = [];
                var parent_1 = parentNode;
                while (parent_1) {
                    path.push({ x: parent_1.x, y: parent_1.y });
                    parent_1 = parent_1.parent;
                }
                return { value: { destination: matchedDestination, path: path } };
            }
            currentDistance = ((_b = (explored[parentNode.x] || {})[parentNode.y]) === null || _b === void 0 ? void 0 : _b.pathLength) || 0;
            for (var i = 0; i < directions.length; i++) {
                var iDirection = directions[i];
                pathX = parentNode.x + iDirection.x;
                pathY = parentNode.y + iDirection.y;
                if (!Pathing.canTileBePathedTo(region, pathX, pathY, 1, null)) {
                    // Destination is not a valid square
                    continue;
                }
                if (i >= 4) {
                    // Check neighbouring squares for diagonal moves
                    var neighbourX = parentNode.x;
                    var neighbourY = parentNode.y + iDirection.y;
                    if (!Pathing.canTileBePathedTo(region, neighbourX, neighbourY, 1, null)) {
                        continue;
                    }
                    neighbourX = parentNode.x + iDirection.x;
                    neighbourY = parentNode.y;
                    if (!Pathing.canTileBePathedTo(region, neighbourX, neighbourY, 1, null)) {
                        continue;
                    }
                }
                if (!(pathX in explored)) {
                    explored[pathX] = {};
                    if (pathX < minExploredX) {
                        minExploredX = pathX;
                    }
                    if (pathX > maxExploredX) {
                        maxExploredX = pathX;
                    }
                }
                if (pathY in explored[pathX]) {
                    continue;
                }
                else {
                    explored[pathX][pathY] = {
                        x: pathX,
                        y: pathY,
                        parent: parentNode,
                        pathLength: currentDistance + 1,
                    };
                    if (pathY < minExploredY) {
                        minExploredY = pathY;
                    }
                    if (pathY > maxExploredY) {
                        maxExploredY = pathY;
                    }
                }
                nodes.push({ x: pathX, y: pathY, parent: parentNode });
            }
        };
        while (nodes.length !== 0 && nodes.length < 1000) {
            var state_1 = _loop_1();
            if (typeof state_1 === "object")
                return state_1.value;
        }
        // No path found yet.
        // Find a backup tile within a 21x21 grid of the SW tile of the selection that:
        // - has path length less than 100
        // - has the shortest path distance
        // - has target tile as close as possible in Euclidean distance to the nearest requested tile
        var swTile = endPoints[0];
        var minX = Math.max(minExploredX, swTile.x - 10);
        var minY = Math.max(minExploredY, swTile.y - 10);
        var maxX = Math.max(maxExploredX, swTile.x + 10);
        var maxY = Math.max(maxExploredY, swTile.y + 10);
        var bestBackupTile = null;
        //let minEuclideanDistance = Pathing.dist(swTile.x, swTile.y, startPoint.x, startPoint.y);
        var minEuclideanDistance = Number.MAX_VALUE; // Pathing.dist(swTile.x, swTile.y, startPoint.x, startPoint.y);
        var minPathLength = 100;
        var _loop_2 = function (x_1) {
            if (!(x_1 in explored)) {
                return "continue";
            }
            var _loop_3 = function (y_1) {
                if (!(y_1 in explored[x_1])) {
                    return "continue";
                }
                var pathLength = explored[x_1][y_1].pathLength;
                endPoints.forEach(function (endPoint) {
                    var dist = Pathing.dist(x_1, y_1, endPoint.x, endPoint.y);
                    if (dist < minEuclideanDistance || (dist === minEuclideanDistance && pathLength < minPathLength)) {
                        bestBackupTile = { x: x_1, y: y_1 };
                        minPathLength = pathLength;
                        minEuclideanDistance = dist;
                    }
                });
            };
            for (var y_1 = minY; y_1 <= maxY; ++y_1) {
                _loop_3(y_1);
            }
        };
        for (var x_1 = minX; x_1 <= maxX; ++x_1) {
            _loop_2(x_1);
        }
        // No LoS - path to best backup tile
        if (bestBackupTile) {
            // unwind the path
            var path = [];
            var node = explored[bestBackupTile.x][bestBackupTile.y];
            while (node) {
                path.push({ x: node.x, y: node.y });
                node = node.parent;
            }
            return {
                destination: bestBackupTile,
                path: path,
            };
        }
        // no backup tile found
        return {
            destination: null,
            path: [],
        };
    };
    Pathing.path = function (region, startPoint, endPoint, speed, seeking) {
        var x, y;
        var pathResult = Pathing.constructPaths(region, startPoint, [endPoint]);
        var path = pathResult.path;
        if (path.length === 0) {
            return { x: startPoint.x, y: startPoint.y, path: [] };
        }
        if (seeking && Collision.collidesWithMob(region, path[0].x, path[0].y, 1, seeking)) {
            path.shift();
        }
        if (path.length === 0) {
            return {
                x: startPoint.x,
                y: startPoint.y,
                path: [],
            };
        }
        if (path.length <= speed) {
            // Step to the destination
            x = path[0].x;
            y = path[0].y;
        }
        else {
            // Move two steps forward
            x = path[path.length - speed - 1].x;
            y = path[path.length - speed - 1].y;
        }
        var destination = path[0];
        path.reverse();
        return { x: x, y: y, path: path.slice(1, 3), destination: destination };
    };
    Pathing.tileCache = {};
    return Pathing;
}());


;// CONCATENATED MODULE: ./src/sdk/Collision.ts


var CollisionType;
(function (CollisionType) {
    CollisionType[CollisionType["NONE"] = 0] = "NONE";
    CollisionType[CollisionType["BLOCK_MOVEMENT"] = 1] = "BLOCK_MOVEMENT";
})(CollisionType || (CollisionType = {}));
var Collision = /** @class */ (function () {
    function Collision() {
    }
    Collision.collisionMath = function (x, y, s, x2, y2, s2) {
        return !(x > x2 + s2 - 1 || x + s - 1 < x2 || y - s + 1 > y2 || y < y2 - s2 + 1);
    };
    // include the outer boundary - used for precision checks with perceivedLocation
    Collision.collisionMathInclusive = function (x, y, s, x2, y2, s2) {
        return !(x > x2 + s2 || x + s - 1 < x2 || y - s > y2 || y < y2 - s2 + 1);
    };
    // Mob collision
    Collision.collidesWithMob = function (region, x, y, s, mob) {
        return Collision.collisionMath(x, y, s, mob.location.x, mob.location.y, mob.size);
    };
    Collision.collidesWithAnyMobs = function (region, x, y, s, mobToAvoid) {
        if (mobToAvoid === void 0) { mobToAvoid = null; }
        for (var i = 0; i < region.mobs.length; i++) {
            if (region.mobs[i] === mobToAvoid) {
                continue;
            }
            var collidedWithSpecificMob = Collision.collidesWithMob(region, x, y, s, region.mobs[i]);
            if (collidedWithSpecificMob && region.mobs[i].consumesSpace) {
                return region.mobs[i];
            }
        }
        return null;
    };
    // Entity collision
    // Same as above but only returns entities with collision enabled.
    Collision.collideableEntitiesAtPoint = function (region, x, y, s) {
        return (0,lodash.filter)(Pathing.entitiesAtPoint(region, x, y, s), function (entity) { return entity.collisionType != CollisionType.NONE; });
    };
    Collision.collidesWithAnyEntities = function (region, x, y, s) {
        for (var i = 0; i < region.entities.length; i++) {
            var entity = region.entities[i];
            if (entity.collisionType != CollisionType.NONE &&
                Collision.collisionMath(x, y, s, entity.location.x, entity.location.y, entity.size)) {
                return true;
            }
        }
        return false;
    };
    Collision.collidesWithAnyLoSBlockingEntities = function (region, x, y, s) {
        for (var i = 0; i < region.entities.length; i++) {
            var entity = region.entities[i];
            if (Collision.collisionMath(x, y, s, entity.location.x, entity.location.y, entity.size)) {
                return entity.lineOfSight;
            }
        }
        return null;
    };
    Collision.collidesWithAnyMobsAtPerceivedDisplayLocation = function (region, x, y, tickPercent) {
        var mobs = [];
        for (var i = 0; i < region.mobs.length; i++) {
            var collidedWithSpecificMob = Collision.collidesWithUnitAtPerceivedDisplayLocation(x, y, tickPercent, region.mobs[i]);
            if (collidedWithSpecificMob) {
                mobs.push(region.mobs[i]);
            }
        }
        return mobs;
    };
    Collision.collidesWithUnitAtPerceivedDisplayLocation = function (x, y, tickPercent, unit) {
        var _a = unit.getPerceivedLocation(tickPercent), perceivedX = _a.x, perceivedY = _a.y;
        // WTF
        return Collision.collisionMathInclusive(x, y, 1.0, perceivedX, perceivedY, unit.size);
    };
    Collision.collidesWithAnyPlayersAtPerceivedDisplayLocation = function (region, x, y, tickPercent) {
        var players = [];
        for (var i = 0; i < region.players.length; i++) {
            var collidedWithSpecificPlayer = Collision.collidesWithUnitAtPerceivedDisplayLocation(x, y, tickPercent, region.players[i]);
            if (collidedWithSpecificPlayer) {
                players.push(region.players[i]);
            }
        }
        return players;
    };
    return Collision;
}());


;// CONCATENATED MODULE: ./src/sdk/LineOfSight.ts




/*
 Basically, this entire file is lifted and modified to be as coherent as possible.
 This algorithm makes no sense and is copy pasta'd between basically every trainer.
 I have no clue how it works. I think Woox made a video that helps people understand it.
 https://www.youtube.com/watch?v=vnyNLXTwjCE
*/
var LineOfSightMask;
(function (LineOfSightMask) {
    LineOfSightMask[LineOfSightMask["NONE"] = 0] = "NONE";
    LineOfSightMask[LineOfSightMask["FULL_MASK"] = 131072] = "FULL_MASK";
    LineOfSightMask[LineOfSightMask["EAST_MASK"] = 4096] = "EAST_MASK";
    LineOfSightMask[LineOfSightMask["WEST_MASK"] = 65536] = "WEST_MASK";
    LineOfSightMask[LineOfSightMask["NORTH_MASK"] = 1024] = "NORTH_MASK";
    LineOfSightMask[LineOfSightMask["SOUTH_MASK"] = 16384] = "SOUTH_MASK";
})(LineOfSightMask || (LineOfSightMask = {}));
var LineOfSight = /** @class */ (function () {
    function LineOfSight() {
    }
    LineOfSight.drawLOS = function (region, x, y, s, r, c, isNPC) {
        region.context.globalAlpha = 0.4;
        region.context.fillStyle = c;
        for (var x2 = -r; x2 < r + 1; x2++) {
            for (var y2 = -r; y2 < r + 1; y2++) {
                if (LineOfSight.hasLineOfSight(region, x, y, x + x2, y + y2, s, r, isNPC)) {
                    region.context.fillRect((x + x2) * Settings.tileSize, (y + y2) * Settings.tileSize, Settings.tileSize, Settings.tileSize);
                }
            }
        }
        region.context.globalAlpha = 1;
    };
    LineOfSight.mobHasLineOfSightOfPlayer = function (region, player, x, y, s, r, isNPC) {
        if (r === void 0) { r = 1; }
        if (isNPC === void 0) { isNPC = true; }
        return LineOfSight.hasLineOfSight(region, x, y, player.location.x, player.location.y, s, r, isNPC);
    };
    LineOfSight.playerHasLineOfSightOfMob = function (region, x, y, mob, r) {
        if (r === void 0) { r = 1; }
        var mobPoint = LocationUtils.closestPointTo(x, y, mob);
        return LineOfSight.hasLineOfSight(region, x, y, mobPoint.x, mobPoint.y, 1, r, false);
    };
    LineOfSight.mobHasLineOfSightToMob = function (region, mob1, mob2, r) {
        if (r === void 0) { r = 1; }
        var mob1Point = LocationUtils.closestPointTo(mob1.location.x, mob1.location.y, mob2);
        var mob2Point = LocationUtils.closestPointTo(mob2.location.x, mob2.location.y, mob1);
        return LineOfSight.hasLineOfSight(region, mob1Point.x, mob1Point.y, mob2Point.x, mob2Point.y, 1, r, false);
    };
    LineOfSight.hasLineOfSight = function (region, x1, y1, x2, y2, s, r, isNPC) {
        if (s === void 0) { s = 1; }
        if (r === void 0) { r = 1; }
        if (isNPC === void 0) { isNPC = false; }
        var dx = x2 - x1;
        var dy = y2 - y1;
        if (Collision.collidesWithAnyLoSBlockingEntities(region, x1, y1, 1) ||
            Collision.collidesWithAnyLoSBlockingEntities(region, x2, y2, 1) ||
            Collision.collisionMath(x1, y1, s, x2, y2, 1)) {
            return false;
        }
        // assume range 1 is melee
        if (r === 1) {
            return (dx < s && dx >= 0 && (dy === 1 || dy === -s)) || (dy > -s && dy <= 0 && (dx === -1 || dx === s));
        }
        if (isNPC) {
            var tx = Math.max(x1, Math.min(x1 + s - 1, x2));
            var ty = Math.max(y1 - s + 1, Math.min(y1, y2));
            return LineOfSight.hasLineOfSight(region, x2, y2, tx, ty, 1, r, false);
        }
        var dxAbs = Math.abs(dx);
        var dyAbs = Math.abs(dy);
        if (dxAbs > r || dyAbs > r) {
            return false;
        }
        if (dxAbs > dyAbs) {
            var xTile = x1;
            var y = (y1 << 16) + 0x8000;
            var slope = Math.trunc((dy << 16) / dxAbs); // Integer division
            var xInc = void 0;
            var xMask = void 0;
            var yMask = void 0;
            if (dx > 0) {
                xInc = 1;
                xMask = LineOfSightMask.WEST_MASK | LineOfSightMask.FULL_MASK;
            }
            else {
                xInc = -1;
                xMask = LineOfSightMask.EAST_MASK | LineOfSightMask.FULL_MASK;
            }
            if (dy < 0) {
                y -= 1; // For correct rounding
                yMask = LineOfSightMask.NORTH_MASK | LineOfSightMask.FULL_MASK;
            }
            else {
                yMask = LineOfSightMask.SOUTH_MASK | LineOfSightMask.FULL_MASK;
            }
            while (xTile !== x2) {
                xTile += xInc;
                var yTile = y >>> 16;
                if ((Collision.collidesWithAnyLoSBlockingEntities(region, xTile, yTile, 1) & xMask) !== 0) {
                    return false;
                }
                y += slope;
                var newYTile = y >>> 16;
                if (newYTile !== yTile &&
                    (Collision.collidesWithAnyLoSBlockingEntities(region, xTile, newYTile, 1) & yMask) !== 0) {
                    return false;
                }
            }
        }
        else {
            var yTile = y1;
            var x = (x1 << 16) + 0x8000;
            var slope = Math.trunc((dx << 16) / dyAbs); // Integer division
            var yInc = void 0;
            var yMask = void 0;
            if (dy > 0) {
                yInc = 1;
                yMask = LineOfSightMask.SOUTH_MASK | LineOfSightMask.FULL_MASK;
            }
            else {
                yInc = -1;
                yMask = LineOfSightMask.NORTH_MASK | LineOfSightMask.FULL_MASK;
            }
            var xMask = void 0;
            if (dx < 0) {
                x -= 1; // For correct rounding
                xMask = LineOfSightMask.EAST_MASK | LineOfSightMask.FULL_MASK;
            }
            else {
                xMask = LineOfSightMask.WEST_MASK | LineOfSightMask.FULL_MASK;
            }
            while (yTile !== y2) {
                yTile += yInc;
                var xTile = x >>> 16;
                if ((Collision.collidesWithAnyLoSBlockingEntities(region, xTile, yTile, 1) & yMask) !== 0) {
                    return false;
                }
                x += slope;
                var newXTile = x >>> 16;
                if (newXTile !== xTile &&
                    (Collision.collidesWithAnyLoSBlockingEntities(region, newXTile, yTile, 1) & xMask) !== 0) {
                    return false;
                }
            }
        }
        return true;
    };
    return LineOfSight;
}());


;// CONCATENATED MODULE: ./src/assets/images/hitsplats/heal.png
const heal_namespaceObject = __webpack_require__.p + "6f66afbfcae5a9563001.png";
;// CONCATENATED MODULE: ./src/assets/images/hitsplats/miss.png
const miss_namespaceObject = __webpack_require__.p + "249d7e34a2a593820a90.png";
;// CONCATENATED MODULE: ./src/assets/images/hitsplats/damage.png
const damage_namespaceObject = __webpack_require__.p + "0def8eba418960c4c95c.png";
;// CONCATENATED MODULE: ./src/sdk/utils/ImageLoader.ts
var ImageLoader = /** @class */ (function () {
    function ImageLoader() {
    }
    ImageLoader.createImage = function (src) {
        if (!src) {
            return null;
        }
        if (this.imageCache[src]) {
            return this.imageCache[src];
        }
        ImageLoader.pendingImages++;
        var img = new Image();
        img.src = src;
        img.addEventListener("load", function () {
            ImageLoader.completedImages++;
        });
        img.addEventListener("error", function () {
            img.src = "";
            img.src = src + "?retry=" + String(Math.random());
            ImageLoader.completedImages++;
        });
        this.imageCache[src] = img;
        return img;
    };
    ImageLoader.onAllImagesLoaded = function (loadFn) {
        ImageLoader.onLoadFns.push(loadFn);
    };
    ImageLoader.checkImagesLoaded = function (timer) {
        if (ImageLoader.pendingImages === ImageLoader.completedImages) {
            ImageLoader.onLoadFns.forEach(function (onLoadFunction) { return onLoadFunction(); });
            clearInterval(timer);
        }
    };
    ImageLoader.onLoadFns = [];
    ImageLoader.pendingImages = 0;
    ImageLoader.completedImages = 0;
    ImageLoader.hasLoaded = false;
    ImageLoader.imageCache = {};
    return ImageLoader;
}());


;// CONCATENATED MODULE: ./src/sdk/Renderable.ts
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var NIL_OFFSET = [{ x: 0, y: 0, z: 0 }];
var Renderable = /** @class */ (function () {
    function Renderable() {
        this._selected = false;
        this.cachedModel = null;
        this.animationChangeListener = null;
        // in case the animation is set before animationChangeListener is set
        this.queuedAnimationId = -1;
    }
    /**
     * return the pitch angle of this renderable in radians, i.e. how up/down it is pointing
     * 0 is flat, increasing is up, decreasing is down
     */
    Renderable.prototype.getPerceivedPitch = function (tickPercent) {
        return 0;
    };
    /**
     * allow offsetting the components of a multi-model renderable
     */
    Renderable.prototype.getPerceivedOffsets = function (tickPercent) {
        return NIL_OFFSET;
    };
    Object.defineProperty(Renderable.prototype, "drawOutline", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Renderable.prototype, "outlineRenderOrder", {
        // If null, render normally in the scene. Otherwise sets the renderOrder which can
        // draw it above over elements in the scene, and other lines with lower renderOrder.
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Renderable.prototype, "drawTrueTile", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Renderable.prototype, "trueTileRenderOrder", {
        // If null, render normally in the scene. Otherwise sets the renderOrder which can
        // draw it above over elements in the scene, and other lines with lower renderOrder.
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Renderable.prototype, "height", {
        get: function () {
            return this.size;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Renderable.prototype, "clickboxHeight", {
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Renderable.prototype, "clickboxRadius", {
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Renderable.prototype, "colorHex", {
        get: function () {
            return parseInt(this.color.replace("#", ""), 16);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Renderable.prototype, "selectable", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Renderable.prototype.visible = function (tickPercent) {
        return true;
    };
    Object.defineProperty(Renderable.prototype, "selected", {
        get: function () {
            return this._selected;
        },
        set: function (selected) {
            this._selected = selected;
        },
        enumerable: false,
        configurable: true
    });
    Renderable.prototype.drawUILayer = function (tickPercent, screenPosition, context, scale, hitsplatAbove) {
        if (hitsplatAbove === void 0) { hitsplatAbove = true; }
        // Override me
    };
    // draw in 2d mode
    Renderable.prototype.draw = function (tickPercent, context, offset, scale, drawUnderTile) {
        if (offset === void 0) { offset = { x: 0, y: 0 }; }
        if (scale === void 0) { scale = 20; }
        if (drawUnderTile === void 0) { drawUnderTile = true; }
        // Override me
    };
    /**
     * Return a new model for this renderable in 3d mode. it will be associated with the Renderable and destroyed when the renderable is
     * destroyed.
     */
    Renderable.prototype.create3dModel = function () {
        return null;
    };
    Renderable.prototype.get3dModel = function () {
        var _a;
        return (_a = this.cachedModel) !== null && _a !== void 0 ? _a : this.create3dModel();
    };
    Renderable.prototype.playAnimation = function (index, blend) {
        if (blend === void 0) { blend = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.animationChangeListener) {
                    return [2 /*return*/, this.animationChangeListener.animationChanged(index, blend)];
                }
                else {
                    this.queuedAnimationId = index;
                }
                return [2 /*return*/];
            });
        });
    };
    Renderable.prototype.setAnimationListener = function (listener) {
        this.animationChangeListener = listener;
        if (this.queuedAnimationId >= 0) {
            listener.animationChanged(this.queuedAnimationId, false);
            this.queuedAnimationId = -1;
        }
    };
    Renderable.prototype.clearAnimationListener = function () {
        this.animationChangeListener = null;
    };
    Renderable.prototype.invalidateModel = function () {
        this.cachedModel = null;
        if (this.animationChangeListener) {
            this.animationChangeListener.modelChanged();
        }
    };
    Renderable.prototype.preload = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Create an offscreen version of the model so that loading it is faster next time.
                        this.cachedModel = this.create3dModel();
                        if (!this.cachedModel) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.cachedModel.preload()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    return Renderable;
}());


;// CONCATENATED MODULE: ./src/sdk/utils/SoundCache.ts
var SoundCache_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var SoundCache_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

var LOADING_SOUND = null;
var Sound = /** @class */ (function () {
    function Sound(src, volume) {
        if (volume === void 0) { volume = 1; }
        this.src = src;
        this.volume = volume;
    }
    return Sound;
}());

var SoundCache = /** @class */ (function () {
    function SoundCache() {
    }
    SoundCache.getCachedSound = function (src) {
        if (!src) {
            return null;
        }
        if (this.soundCache[src]) {
            return this.soundCache[src];
        }
        return (this.soundCache[src] = new Audio(src));
    };
    SoundCache.preload = function (src) {
        return SoundCache_awaiter(this, void 0, void 0, function () {
            var response, buffer, audioBuffer;
            return SoundCache_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!SoundCache.context) {
                            return [2 /*return*/, null];
                        }
                        if (SoundCache.cachedSounds[src] === LOADING_SOUND) {
                            return [2 /*return*/, null];
                        }
                        SoundCache.cachedSounds[src] = LOADING_SOUND;
                        return [4 /*yield*/, window.fetch(src)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.arrayBuffer()];
                    case 2:
                        buffer = _a.sent();
                        return [4 /*yield*/, SoundCache.context.decodeAudioData(buffer)];
                    case 3:
                        audioBuffer = _a.sent();
                        SoundCache.cachedSounds[src] = audioBuffer;
                        return [2 /*return*/, audioBuffer];
                }
            });
        });
    };
    SoundCache.play = function (_a, isAreaSound) {
        var _this = this;
        var src = _a.src, volume = _a.volume;
        if (isAreaSound === void 0) { isAreaSound = false; }
        if (!SoundCache.context) {
            return null;
        }
        if (this.cachedSounds[src] === undefined) {
            (function () { return SoundCache_awaiter(_this, void 0, void 0, function () {
                var sound;
                return SoundCache_generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.preload(src)];
                        case 1:
                            sound = _a.sent();
                            // play after loading
                            if (sound) {
                                SoundCache.play({ src: src, volume: volume });
                            }
                            return [2 /*return*/];
                    }
                });
            }); })();
            return;
        }
        if (!this.cachedSounds[src]) {
            return;
        }
        if ((!isAreaSound && !Settings.playsAudio) || (isAreaSound && !Settings.playsAreaAudio)) {
            return;
        }
        var source = SoundCache.context.createBufferSource();
        source.buffer = this.cachedSounds[src];
        var connect = SoundCache.context.destination;
        if (volume !== 1) {
            var gainNode = SoundCache.context.createGain();
            gainNode.gain.value = volume;
            source.connect(gainNode);
            gainNode.connect(SoundCache.context.destination);
            connect = gainNode;
        }
        source.connect(connect);
        source.start();
    };
    SoundCache.soundCache = {};
    SoundCache.context = window.AudioContext ? new AudioContext() : null;
    SoundCache.cachedSounds = {};
    return SoundCache;
}());


;// CONCATENATED MODULE: ./src/sdk/DelayedAction.ts

var DelayedAction = /** @class */ (function () {
    function DelayedAction(action, delay) {
        this.action = action;
        this.delay = delay + 1;
        this.identifier = Math.random() * 1000000;
    }
    DelayedAction.reset = function () {
        this.delayedActions = [];
        this.delayedNpcActions = [];
    };
    /**
     * Register a delayed action to be called in the middle of a tick (after npc actions, before player actions).
     * Use this if you need an action that reads from an NPC and writes to a player in the same tick.
     */
    DelayedAction.registerDelayedNpcAction = function (delayedAction) {
        DelayedAction.delayedNpcActions.push(delayedAction);
        return delayedAction.identifier;
    };
    /**
     * Register a delayed action to be called at the end of the tick (after player action)
     */
    DelayedAction.registerDelayedAction = function (delayedAction) {
        DelayedAction.delayedActions.push(delayedAction);
        return delayedAction.identifier;
    };
    DelayedAction.afterNpcTick = function () {
        var executedActions = [];
        DelayedAction.delayedNpcActions.forEach(function (delayedAction) {
            delayedAction.delay--;
            if (delayedAction.delay === 0) {
                delayedAction.action();
                executedActions.push(delayedAction);
            }
        });
        executedActions.forEach(function (executedActions) {
            (0,lodash.remove)(DelayedAction.delayedNpcActions, executedActions);
        });
    };
    DelayedAction.tick = function () {
        var executedActions = [];
        DelayedAction.delayedActions.forEach(function (delayedAction) {
            delayedAction.delay--;
            if (delayedAction.delay === 0) {
                delayedAction.action();
                executedActions.push(delayedAction);
            }
        });
        executedActions.forEach(function (executedActions) {
            (0,lodash.remove)(DelayedAction.delayedActions, executedActions);
        });
    };
    // actions to be played after npc action (before players)
    DelayedAction.delayedNpcActions = [];
    // actions to be played after player action
    DelayedAction.delayedActions = [];
    return DelayedAction;
}());


;// CONCATENATED MODULE: ./src/sdk/utils/Text.ts
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var parseText = function (text) {
    var segments = [];
    var currentSegment = { text: "", tag: null, inTag: false };
    for (var i = 0; i < text.length; i++) {
        if (text[i] === "<" && !currentSegment.inTag) {
            if (currentSegment.text) {
                segments.push(currentSegment);
            }
            currentSegment = { text: "", tag: "", inTag: true };
        }
        else if (text[i] === "/") {
            // closing tag
            if (currentSegment.text) {
                segments.push(currentSegment);
            }
        }
        else if (text[i] === ">") {
            currentSegment.inTag = false;
        }
        else if (currentSegment.inTag) {
            currentSegment.tag += text[i];
        }
        else {
            currentSegment.text += text[i];
        }
    }
    if (currentSegment.text) {
        segments.push(currentSegment);
    }
    return segments.map(function (_a) {
        var text = _a.text, tag = _a.tag;
        var color = parseColor(tag);
        return __assign({ text: text }, (color && { color: color }));
    });
};
var parseColor = function (tag) { var _a; return ((tag === null || tag === void 0 ? void 0 : tag.includes("col=")) ? (_a = tag.split("=")) === null || _a === void 0 ? void 0 : _a[1] : null); };

;// CONCATENATED MODULE: ./src/sdk/Unit.ts
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};












/* eslint-disable @typescript-eslint/no-explicit-any */
var UnitTypes;
(function (UnitTypes) {
    UnitTypes[UnitTypes["MOB"] = 0] = "MOB";
    UnitTypes[UnitTypes["PLAYER"] = 1] = "PLAYER";
    UnitTypes[UnitTypes["ENTITY"] = 2] = "ENTITY";
})(UnitTypes || (UnitTypes = {}));
var UnitEquipment = /** @class */ (function () {
    function UnitEquipment() {
        this.weapon = null;
        this.offhand = null;
        this.helmet = null;
        this.necklace = null;
        this.chest = null;
        this.legs = null;
        this.feet = null;
        this.gloves = null;
        this.ring = null;
        this.cape = null;
        this.ammo = null;
    }
    return UnitEquipment;
}());

var Unit = /** @class */ (function (_super) {
    __extends(Unit, _super);
    function Unit(region, location, options) {
        var _this = _super.call(this) || this;
        _this.lastOverhead = null;
        _this.attackDelay = 0;
        _this.lastHitAgo = Number.MAX_SAFE_INTEGER;
        _this.hasLOS = false;
        _this.frozen = 0;
        _this.stunned = 0;
        _this.incomingProjectiles = [];
        _this.healHitsplatImage = ImageLoader.createImage(heal_namespaceObject);
        _this.missedHitsplatImage = ImageLoader.createImage(miss_namespaceObject);
        _this.damageHitsplatImage = ImageLoader.createImage(damage_namespaceObject);
        _this.unitImage = ImageLoader.createImage(_this.image);
        _this.equipment = new UnitEquipment();
        _this.setEffects = [];
        _this.autoRetaliate = false;
        _this.age = 0;
        _this.lastRotation = 0;
        _this.hasDiedAndAwaitingRemoval = false;
        _this.nulledTicks = 0;
        _this.overheadText = null;
        _this.overheadTextTimer = 0;
        _this.lastInteraction = null;
        _this.lastInteractionAge = 0;
        _this.dying = -1;
        _this.region = region;
        _this.aggro = options.aggro || null;
        _this.perceivedLocation = location;
        _this.location = location;
        _this.setStats();
        _this.age = options.spawnDelay || 0;
        _this.autoRetaliate = true;
        _this.currentStats.hitpoint = _this.stats.hitpoint;
        if (options.cooldown) {
            _this.attackDelay = options.cooldown;
        }
        return _this;
    }
    Object.defineProperty(Unit.prototype, "deathAnimationLength", {
        get: function () {
            return 3;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "completeSetEffects", {
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "type", {
        get: function () {
            return UnitTypes.MOB;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "isPlayer", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "xpBonusMultiplier", {
        get: function () {
            return 1.0;
        },
        enumerable: false,
        configurable: true
    });
    Unit.prototype.mobName = function () {
        return null;
    };
    Object.defineProperty(Unit.prototype, "isNulled", {
        get: function () {
            return this.nulledTicks > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "combatLevel", {
        get: function () {
            var base = 0.25 * (this.stats.defence + this.stats.hitpoint + Math.floor((this.stats.prayer || 0) * 0.5));
            var melee = (13 / 40) * (this.stats.attack + this.stats.strength);
            var range = (13 / 40) * Math.floor(this.stats.range * (3 / 2));
            var mage = (13 / 40) * Math.floor(this.stats.magic * (3 / 2));
            return Math.floor(base + Math.max(melee, range, mage));
        },
        enumerable: false,
        configurable: true
    });
    Unit.prototype.combatLevelColor = function (against) {
        // https://oldschool.runescape.wiki/w/Combat_level#Colours
        var colorScale = [
            "#ff0000",
            "#ff3000",
            "#ff3000",
            "#ff3000",
            "#ff7000",
            "#ff7000",
            "#ff7000",
            "#ffb000",
            "#ffb000",
            "#ffb000",
            "#ffff00",
            "#c0ff00",
            "#c0ff00",
            "#c0ff00",
            "#80ff00",
            "#80ff00",
            "#80ff00",
            "#40ff00",
            "#40ff00",
            "#40ff00",
            "#00ff00", // -10
        ];
        var myCombatLevel = this.combatLevel;
        var theirCombatLevel = against.combatLevel;
        var difference = Math.min(10, Math.max(-10, theirCombatLevel - myCombatLevel));
        return colorScale[10 - difference];
    };
    Unit.prototype.contextActions = function (region, x, y) {
        return [];
    };
    Unit.prototype.setAggro = function (mob) {
        this.aggro = mob;
        this.lastInteraction = mob;
        this.lastInteractionAge = 0;
    };
    Unit.prototype.grantXp = function (xpDrop) {
        // Override me
    };
    Unit.prototype.setStats = function () {
        // Override me
    };
    Unit.prototype.timerStep = function () {
        // Override me, called before movement
    };
    Unit.prototype.movementStep = function () {
        // Override me
    };
    Unit.prototype.attackStep = function () {
        // Override me, called after all movement has been resolved
        this.nulledTicks--;
        this.attackDelay--;
        this.lastRotation = this.getPerceivedRotation(0);
        if (this.overheadTextTimer <= 0) {
            this.overheadText = null;
        }
        this.overheadTextTimer--;
        this.lastInteractionAge--;
    };
    // called when the unit has attacked
    Unit.prototype.didAttack = function () {
        this.attackDelay = this.attackSpeed;
        this.playAttackAnimation();
    };
    Unit.prototype.playAttackAnimation = function () {
        if (this.attackAnimationId) {
            // only blend if not idle
            var doBlend = this.animationIndex !== this.idlePoseId && this.canBlendAttackAnimation;
            this.playAnimation(this.attackAnimationId, doBlend);
        }
    };
    Unit.prototype.getPerceivedLocation = function (tickPercent) {
        var perceivedX = Pathing.linearInterpolation(this.perceivedLocation.x, this.location.x, tickPercent);
        var perceivedY = Pathing.linearInterpolation(this.perceivedLocation.y, this.location.y, tickPercent);
        return { x: perceivedX, y: perceivedY, z: 0 };
    };
    Unit.prototype.getPerceivedRotation = function (tickPercent) {
        if (this.aggro) {
            var perceivedLocation = this.aggro.getPerceivedLocation(tickPercent);
            return -Pathing.angle(this.location.x + this.size / 2, this.location.y - this.size / 2, perceivedLocation.x + this.aggro.size / 2, perceivedLocation.y - this.aggro.size / 2);
        }
        return this.lastRotation;
    };
    Unit.prototype.addedToWorld = function () {
        // override me
    };
    Unit.prototype.getTrueLocation = function () {
        return this.location;
    };
    Unit.prototype.removedFromWorld = function () {
        // Override me
    };
    Unit.mergeEquipmentBonuses = function (firstBonuses, secondBonuses) {
        return {
            attack: {
                stab: firstBonuses.attack.stab + secondBonuses.attack.stab,
                slash: firstBonuses.attack.slash + secondBonuses.attack.slash,
                crush: firstBonuses.attack.crush + secondBonuses.attack.crush,
                magic: firstBonuses.attack.magic + secondBonuses.attack.magic,
                range: firstBonuses.attack.range + secondBonuses.attack.range,
            },
            defence: {
                stab: firstBonuses.defence.stab + secondBonuses.defence.stab,
                slash: firstBonuses.defence.slash + secondBonuses.defence.slash,
                crush: firstBonuses.defence.crush + secondBonuses.defence.crush,
                magic: firstBonuses.defence.magic + secondBonuses.defence.magic,
                range: firstBonuses.defence.range + secondBonuses.defence.range,
            },
            other: {
                meleeStrength: firstBonuses.other.meleeStrength + secondBonuses.other.meleeStrength,
                rangedStrength: firstBonuses.other.rangedStrength + secondBonuses.other.rangedStrength,
                magicDamage: firstBonuses.other.magicDamage + secondBonuses.other.magicDamage,
                prayer: firstBonuses.other.prayer + secondBonuses.other.prayer,
                crystalAccuracy: (firstBonuses.other.crystalAccuracy || 0) + (secondBonuses.other.crystalAccuracy || 0),
                crystalDamage: (firstBonuses.other.crystalDamage || 0) + (secondBonuses.other.crystalDamage || 0),
            },
            targetSpecific: {
                undead: firstBonuses.targetSpecific.undead + secondBonuses.targetSpecific.undead,
                slayer: firstBonuses.targetSpecific.slayer + secondBonuses.targetSpecific.slayer,
            },
        };
    };
    Unit.emptyBonuses = function () {
        return {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 1,
                prayer: 0,
                crystalAccuracy: 1,
                crystalDamage: 1,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
    };
    Object.defineProperty(Unit.prototype, "bonuses", {
        get: function () {
            return Unit.emptyBonuses();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "attackSpeed", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "flinchDelay", {
        get: function () {
            return Math.floor(this.attackSpeed / 2);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "attackRange", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "maxHit", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "image", {
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "isAnimated", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    // Returns true if the NPC can move towards the unit it is aggro'd against.
    Unit.prototype.canMove = function () {
        return !this.hasLOS && !this.isFrozen() && !this.isStunned() && !this.isDying();
    };
    Unit.prototype.canAttack = function () {
        return !this.isDying() && !this.isStunned();
    };
    Unit.prototype.freeze = function (ticks) {
        if (ticks < this.frozen) {
            return;
        }
        //this.perceivedLocation = this.location;
        this.frozen = ticks;
    };
    Unit.prototype.isFrozen = function () {
        return this.frozen > 0;
    };
    Unit.prototype.isStunned = function () {
        return this.stunned > 0;
    };
    Object.defineProperty(Unit.prototype, "serialNumber", {
        get: function () {
            if (!this._serialNumber) {
                this._serialNumber = String(Math.random());
            }
            return this._serialNumber;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "size", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Unit.prototype.isDying = function () {
        return this.dying > 0;
    };
    Object.defineProperty(Unit.prototype, "collisionType", {
        get: function () {
            return CollisionType.BLOCK_MOVEMENT;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "lineOfSight", {
        get: function () {
            return LineOfSightMask.FULL_MASK;
        },
        enumerable: false,
        configurable: true
    });
    // Returns true if this game object is on the specified tile.
    Unit.prototype.isOnTile = function (x, y) {
        return (x >= this.location.x &&
            x <= this.location.x + this.size &&
            y <= this.location.y &&
            y >= this.location.y - this.size);
    };
    // Returns the closest tile on this mob to the specified point.
    Unit.prototype.getClosestTileTo = function (x, y) {
        // We simply clamp the target point to our own boundary box.
        return [
            (0,lodash.clamp)(x, this.location.x, this.location.x + this.size - 1),
            (0,lodash.clamp)(y, this.location.y - this.size + 1, this.location.y),
        ];
    };
    Object.defineProperty(Unit.prototype, "rangeAttackAnimation", {
        // TODO more modular
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    /** Sounds **/
    // sound to play when hit
    Unit.prototype.hitSound = function (damaged) {
        return null;
    };
    Object.defineProperty(Unit.prototype, "color", {
        get: function () {
            return "#FFFFFF00";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "healthScale", {
        get: function () {
            // the server usually only sends hitpoints as a fraction where this is the denominator.
            return Math.min(this.stats.hitpoint, 30);
        },
        enumerable: false,
        configurable: true
    });
    Unit.prototype.shouldDestroy = function () {
        // this is -1 for a living npc.
        return this.dying === 0;
    };
    Unit.prototype.shouldShowAttackAnimation = function () {
        return this.attackDelay === this.attackSpeed && this.dying === -1 && this.isStunned() === false;
    };
    Unit.prototype.setHasLOS = function () {
        if (!this.aggro) {
            this.hasLOS = false;
            return;
        }
        if (this.aggro.type === UnitTypes.PLAYER) {
            this.hasLOS = LineOfSight.mobHasLineOfSightOfPlayer(this.region, this.aggro, this.location.x, this.location.y, this.size, this.attackRange, true);
        }
        else if (this.type === UnitTypes.PLAYER) {
            this.hasLOS = LineOfSight.playerHasLineOfSightOfMob(this.region, this.location.x, this.location.y, this.aggro, this.attackRange);
        }
        else if (this.type === UnitTypes.MOB && this.aggro.type === UnitTypes.MOB) {
            this.hasLOS = LineOfSight.mobHasLineOfSightToMob(this.region, this, this.aggro, this.attackRange);
        }
        else if (this.aggro.type === UnitTypes.MOB) {
            this.hasLOS = LineOfSight.playerHasLineOfSightOfMob(this.region, this.location.x, this.location.y, this.aggro, this.attackRange);
        }
        else if (this.aggro.type === UnitTypes.ENTITY) {
            this.hasLOS = false;
        }
    };
    // Returns true if this mob is in melee range of its target.
    Unit.prototype.isWithinMeleeRange = function () {
        var targetX = this.aggro.location.x;
        var targetY = this.aggro.location.y;
        var isWithinMeleeRange = false;
        if (targetX === this.location.x - 1 &&
            targetY <= this.location.y + 1 &&
            targetY > this.location.y - this.size - 1) {
            isWithinMeleeRange = true;
        }
        else if (targetY === this.location.y + 1 && targetX >= this.location.x && targetX < this.location.x + this.size) {
            isWithinMeleeRange = true;
        }
        else if (targetX === this.location.x + this.size &&
            targetY <= this.location.y + 1 &&
            targetY > this.location.y - this.size - 1) {
            isWithinMeleeRange = true;
        }
        else if (targetY === this.location.y - this.size &&
            targetX >= this.location.x &&
            targetX < this.location.x + this.size) {
            isWithinMeleeRange = true;
        }
        return isWithinMeleeRange;
    };
    Unit.prototype.addProjectile = function (projectile) {
        if (this.age > 0 && this.autoRetaliate && !this.aggro) {
            this.setAggro(projectile.from);
        }
        this.incomingProjectiles.push(projectile);
    };
    Unit.prototype.setLocation = function (location) {
        this.location = location;
    };
    Unit.prototype.attackAnimation = function (tickPercent, context) {
        // override pls
    };
    Unit.prototype.cancelDeath = function () {
        // e.g. when revived
        this.hasDiedAndAwaitingRemoval = false;
        this.dying = -1;
    };
    Unit.prototype.dead = function () {
        var _this = this;
        this.perceivedLocation = this.location;
        this.dying = this.deathAnimationLength;
        this.aggro = null;
        this.hasDiedAndAwaitingRemoval = true;
        if (this.deathAnimationId) {
            DelayedAction.registerDelayedAction(new DelayedAction(function () {
                return _this.playAnimation(_this.deathAnimationId, false).then(function () {
                    if (_this.hasDiedAndAwaitingRemoval) {
                        // can be cancelled
                        _this.dying = 0;
                        _this.detectDeath();
                    }
                });
            }, 1));
        }
    };
    Unit.prototype.detectDeath = function () {
        if (this.dying === -1 && this.currentStats.hitpoint <= 0) {
            this.dead();
            return;
        }
        if (this.dying > 0) {
            this.dying--;
        }
        if (this.dying === 0) {
            this.removedFromWorld();
        }
    };
    Unit.prototype.processIncomingAttacks = function () {
        var _this = this;
        this.lastHitAgo++;
        this.incomingProjectiles = (0,lodash.filter)(this.incomingProjectiles, function (projectile) { return !projectile.shouldDestroy(); });
        this.incomingProjectiles.forEach(function (projectile) {
            projectile.onTick();
            if (projectile.remainingDelay === 0) {
                // may override damage etc
                projectile.beforeHit();
                // Some attacks can be nullified if they land after the attackers death.
                if (projectile.options &&
                    projectile.options.cancelOnDeath === true &&
                    projectile.from &&
                    projectile.from.isDying() === true) {
                    return;
                }
                if (projectile.damage < 0) {
                    // subtracting a negative gives a positive
                    if (_this.currentStats.hitpoint < _this.stats.hitpoint) {
                        _this.currentStats.hitpoint -= projectile.damage;
                        _this.currentStats.hitpoint = Math.min(_this.currentStats.hitpoint, _this.stats.hitpoint);
                    }
                }
                else {
                    _this.currentStats.hitpoint -= projectile.damage;
                    var sound = _this.hitSound(projectile.damage > 0);
                    if (sound) {
                        SoundCache.play(sound);
                    }
                }
                _this.damageTaken();
                _this.lastHitAgo = 0;
                if (_this.shouldChangeAggro(projectile)) {
                    _this.setAggro(projectile.from);
                    if (_this.attackDelay < _this.flinchDelay + 1) {
                        _this.attackDelay = _this.flinchDelay + 1;
                    }
                }
            }
        });
        this.currentStats.hitpoint = Math.max(0, this.currentStats.hitpoint);
        this.postAttacksEvent();
    };
    Unit.prototype.shouldChangeAggro = function (projectile) {
        return !this.aggro && this.autoRetaliate;
    };
    Unit.prototype.postAttacksEvent = function () {
        // Override me
    };
    Unit.prototype.damageTaken = function () {
        // Override me
    };
    Unit.prototype.setOverheadText = function (text) {
        this.overheadText = text;
        this.overheadTextTimer = 8;
    };
    Unit.prototype.drawOverheadText = function (context, scale, alignCenter, prefix) {
        if (alignCenter === void 0) { alignCenter = true; }
        if (prefix === void 0) { prefix = ""; }
        if (!this.overheadText) {
            return;
        }
        var parsedText = parseText(this.overheadText);
        var textParts = prefix ? __spreadArray([{ text: prefix }], parsedText, true) : parsedText;
        this.drawText(context, textParts, scale, alignCenter, prefix);
    };
    Unit.prototype.drawText = function (context, textParts, scale, alignCenter, prefix) {
        if (alignCenter === void 0) { alignCenter = true; }
        if (prefix === void 0) { prefix = ""; }
        context.font = "24px OSRS";
        var fullText = textParts.map(function (_a) {
            var text = _a.text;
            return text;
        }).join("");
        var fullWidth = context.measureText(fullText);
        var startX = alignCenter ? -(fullWidth.width / 2) : 0;
        context.fillStyle = "black";
        context.fillText(fullText, startX + 1, (-(this.size / 2) * scale) - 10 + 1);
        var x = startX;
        for (var i = 0; i < textParts.length; i++) {
            var _a = textParts[i], text = _a.text, color = _a.color;
            context.fillStyle = color ? "#".concat(color) : "yellow";
            context.fillText(text, x, (-(this.size / 2) * scale) - 10);
            x += context.measureText(text).width;
        }
    };
    Unit.prototype.draw = function (tickPercent, context, offset, scale, drawUnderTile) {
        if (this.isAnimated) {
            this.unitImage = ImageLoader.imageCache[this.image];
        }
        _super.prototype.draw.call(this, tickPercent, context, offset, scale, drawUnderTile);
    };
    Unit.prototype.drawHitsplat = function (projectile) {
        return true;
    };
    Unit.prototype.drawHPBar = function (context, scale) {
        context.fillStyle = "red";
        context.fillRect((-this.size / 2) * scale, -(this.size / 2) * scale, scale * this.size, 5);
        var healthRatio = Math.min(1, Math.ceil((this.currentStats.hitpoint / this.stats.hitpoint) * this.healthScale) / this.healthScale);
        context.fillStyle = "lime";
        var w = healthRatio * (scale * this.size);
        context.fillRect((-this.size / 2) * scale, (-this.size / 2) * scale, w, 5);
    };
    Unit.prototype.drawHitsplats = function (context, scale, above) {
        var _this = this;
        var projectileOffsets = [
            [0, 12],
            [0, 28],
            [-14, 20],
            [14, 20],
        ];
        var projectileCounter = 0;
        var verticalOffset = -((this.size + 1) * scale) / 2;
        if (!above) {
            verticalOffset *= -1;
        }
        this.incomingProjectiles.forEach(function (projectile) {
            if (projectile.remainingDelay > 0) {
                return;
            }
            if (projectileCounter > 3) {
                return;
            }
            projectileCounter++;
            if (_this.drawHitsplat(projectile)) {
                var image = projectile.damage === 0 ? _this.missedHitsplatImage : _this.damageHitsplatImage;
                if (!projectile.offsetX && !projectile.offsetY) {
                    projectile.offsetX = projectileOffsets[0][0];
                    projectile.offsetY = projectileOffsets[0][1];
                }
                projectileOffsets = (0,lodash.remove)(projectileOffsets, function (offset) {
                    return offset[0] !== projectile.offsetX || offset[1] !== projectile.offsetY;
                });
                if (projectile.damage < 0) {
                    image = _this.healHitsplatImage;
                }
                context.drawImage(image, projectile.offsetX - 12, verticalOffset - projectile.offsetY, 24, 23);
                context.fillStyle = "#FFFFFF";
                context.font = "16px Stats_11";
                context.textAlign = "center";
                context.fillText(String(Math.abs(projectile.damage)), projectile.offsetX, verticalOffset - projectile.offsetY + 15);
                context.textAlign = "left";
            }
        });
    };
    Unit.prototype.drawOverheadPrayers = function (context, scale) {
        if (!this.prayerController) {
            return;
        }
        var overhead = this.prayerController.overhead();
        if (overhead) {
            var overheadImg = overhead.overheadImage();
            if (overheadImg) {
                context.drawImage(overheadImg, -scale / 2, -scale * 3, scale, scale);
            }
        }
    };
    Object.defineProperty(Unit.prototype, "idlePoseId", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "walkingPoseId", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "animationIndex", {
        get: function () {
            var _a;
            // can be overriden by setAnimation
            if (this.perceivedLocation.x !== this.location.x || this.perceivedLocation.y !== this.location.y) {
                return (_a = this.walkingPoseId) !== null && _a !== void 0 ? _a : this.idlePoseId;
            }
            return this.idlePoseId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "attackAnimationId", {
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "canBlendAttackAnimation", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "deathAnimationId", {
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    return Unit;
}(Renderable));


;// CONCATENATED MODULE: ./src/sdk/Entity.ts

var Entity_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Entity_assign = (undefined && undefined.__assign) || function () {
    Entity_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return Entity_assign.apply(this, arguments);
};






var Entity = /** @class */ (function (_super) {
    Entity_extends(Entity, _super);
    function Entity(region, location) {
        var _this = _super.call(this) || this;
        _this.dying = -1;
        _this.location = location;
        _this.region = region;
        return _this;
    }
    Object.defineProperty(Entity.prototype, "serialNumber", {
        get: function () {
            if (!this._serialNumber) {
                this._serialNumber = String(Math.random());
            }
            return this._serialNumber;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Entity.prototype, "selectable", {
        // entities are not selectable by default
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Entity.prototype.shouldDestroy = function () {
        return this.dying === 0;
    };
    Object.defineProperty(Entity.prototype, "size", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Entity.prototype.isDying = function () {
        return this.dying > 0;
    };
    Object.defineProperty(Entity.prototype, "collisionType", {
        get: function () {
            return CollisionType.BLOCK_MOVEMENT;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Entity.prototype, "lineOfSight", {
        get: function () {
            return LineOfSightMask.FULL_MASK;
        },
        enumerable: false,
        configurable: true
    });
    // Returns true if this game object is on the specified tile.
    Entity.prototype.isOnTile = function (x, y) {
        return (x >= this.location.x &&
            x <= this.location.x + this.size &&
            y <= this.location.y &&
            y >= this.location.y - this.size);
    };
    // Returns the closest tile on this mob to the specified point.
    Entity.prototype.getClosestTileTo = function (x, y) {
        // We simply clamp the target point to our own boundary box.
        return [
            (0,lodash.clamp)(x, this.location.x, this.location.x + this.size - 1),
            (0,lodash.clamp)(y, this.location.y - this.size + 1, this.location.y),
        ];
    };
    Entity.prototype.entityName = function () {
        return null;
    };
    Entity.prototype.getPerceivedLocation = function (tickPercent) {
        return Entity_assign(Entity_assign({}, this.location), { z: 0 });
    };
    Entity.prototype.getPerceivedRotation = function () {
        return 0;
    };
    Entity.prototype.getTrueLocation = function () {
        return this.location;
    };
    Object.defineProperty(Entity.prototype, "color", {
        get: function () {
            return "#000073";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Entity.prototype, "type", {
        get: function () {
            // Kind of odd that Units live inside the unit class, but this isn't a unit
            return UnitTypes.ENTITY;
        },
        enumerable: false,
        configurable: true
    });
    Entity.prototype.tick = function () {
        // Override me
    };
    Entity.prototype.drawUILayer = function (tickPercent, screenPosition, context, scale, hitsplatAbove) {
        if (hitsplatAbove === void 0) { hitsplatAbove = true; }
        // Override me
    };
    Entity.prototype.draw = function (tickPercent, context) {
        context.fillStyle = "#000073";
        context.fillRect(this.location.x * Settings.tileSize, (this.location.y - this.size + 1) * Settings.tileSize, this.size * Settings.tileSize, this.size * Settings.tileSize);
    };
    Object.defineProperty(Entity.prototype, "animationIndex", {
        get: function () {
            return -1;
        },
        enumerable: false,
        configurable: true
    });
    return Entity;
}(Renderable));


;// CONCATENATED MODULE: ./src/sdk/Item.ts
var Item = /** @class */ (function () {
    function Item() {
        this.defaultAction = "Use";
    }
    Object.defineProperty(Item.prototype, "serialNumber", {
        get: function () {
            if (!this._serialNumber) {
                this._serialNumber = String(Math.random());
            }
            return this._serialNumber;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Item.prototype, "hasInventoryLeftClick", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Item.prototype.inventoryLeftClick = function (player) {
        // Override me
    };
    Item.prototype.contextActions = function (player) {
        var _this = this;
        // use
        // drop
        // examine
        var options = [
            {
                text: [
                    { text: "Drop ", fillStyle: "white" },
                    { text: this.itemName, fillStyle: "#FF911F" },
                ],
                action: function () {
                    player.region.addGroundItem(player, _this, player.location.x, player.location.y);
                    _this.consumeItem(player);
                },
            },
            {
                text: [
                    { text: "Examine ", fillStyle: "white" },
                    { text: this.itemName, fillStyle: "#FF911F" },
                ],
                action: function () {
                    // TODO: Examine feature
                },
            },
        ];
        if (this.defaultAction) {
            options.unshift({
                text: [
                    { text: this.defaultAction + " ", fillStyle: "white" },
                    { text: this.itemName, fillStyle: "#FF911F" },
                ],
                action: function () {
                    _this.inventoryLeftClick(player);
                },
            });
        }
        return options;
    };
    Object.defineProperty(Item.prototype, "itemName", {
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Item.prototype, "weight", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Item.prototype.inventoryPosition = function (player) {
        return player.inventory
            .map(function (item) {
            if (!item) {
                return null;
            }
            return item.serialNumber;
        })
            .indexOf(this.serialNumber);
    };
    Item.prototype.consumeItem = function (player) {
        player.inventory[this.inventoryPosition(player)] = null;
    };
    Object.defineProperty(Item.prototype, "inventoryImage", {
        get: function () {
            return "";
        },
        enumerable: false,
        configurable: true
    });
    return Item;
}());


;// CONCATENATED MODULE: ./src/sdk/Equipment.ts
var Equipment_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var _a;

var EquipmentTypes;
(function (EquipmentTypes) {
    EquipmentTypes["HELMET"] = "helmet";
    EquipmentTypes["CHEST"] = "chest";
    EquipmentTypes["LEGS"] = "legs";
    EquipmentTypes["FEET"] = "feet";
    EquipmentTypes["GLOVES"] = "gloves";
    EquipmentTypes["WEAPON"] = "weapon";
    EquipmentTypes["OFFHAND"] = "offhand";
    EquipmentTypes["AMMO"] = "ammo";
    EquipmentTypes["BACK"] = "back";
    EquipmentTypes["NECK"] = "neck";
    EquipmentTypes["RING"] = "ring";
})(EquipmentTypes || (EquipmentTypes = {}));
// maybe we ought to rename the values instead?
var EQUIPMENT_TYPE_TO_SLOT = (_a = {},
    _a[EquipmentTypes.HELMET] = 'helmet',
    _a[EquipmentTypes.CHEST] = "chest",
    _a[EquipmentTypes.LEGS] = "legs",
    _a[EquipmentTypes.FEET] = "feet",
    _a[EquipmentTypes.GLOVES] = "gloves",
    _a[EquipmentTypes.WEAPON] = "weapon",
    _a[EquipmentTypes.OFFHAND] = "offhand",
    _a[EquipmentTypes.AMMO] = "ammo",
    _a[EquipmentTypes.BACK] = "cape",
    _a[EquipmentTypes.NECK] = "necklace",
    _a[EquipmentTypes.RING] = "ring",
    _a);
var Equipment = /** @class */ (function (_super) {
    Equipment_extends(Equipment, _super);
    function Equipment() {
        var _this = _super.call(this) || this;
        _this.defaultAction = "Equip";
        _this.setStats();
        return _this;
    }
    Object.defineProperty(Equipment.prototype, "hasInventoryLeftClick", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Equipment.prototype.inventoryLeftClick = function (player) {
        var currentItem = this.currentEquipment(player) || null;
        var openInventorySlots = player.openInventorySlots();
        openInventorySlots.unshift(player.inventory.indexOf(this));
        this.assignToPlayer(player);
        player.inventory[openInventorySlots.shift()] = currentItem;
        player.equipmentChanged();
    };
    Object.defineProperty(Equipment.prototype, "equipmentSetEffect", {
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Equipment.prototype.setStats = function () {
        // throw new Error('stats must be set, none were found')
    };
    Equipment.prototype.currentEquipment = function (player) {
        return null;
    };
    Equipment.prototype.assignToPlayer = function (player) {
        throw new Error("not able to assign to unit equipment");
    };
    Equipment.prototype.unassignToPlayer = function (player) {
        throw new Error("not able to unassign to unit equipment");
    };
    Equipment.prototype.unequip = function (player) {
        var openInventorySlots = player.openInventorySlots();
        if (openInventorySlots.length === 0) {
            return;
        }
        this.unassignToPlayer(player);
        player.equipmentChanged();
        player.inventory[openInventorySlots.shift()] = this;
    };
    Object.defineProperty(Equipment.prototype, "type", {
        get: function () {
            throw new Error("equipment must have a type");
        },
        enumerable: false,
        configurable: true
    });
    Equipment.prototype.updateBonuses = function (gear) {
        // update bonuses based on other items that have been equipped
    };
    Object.defineProperty(Equipment.prototype, "model", {
        /**
         * name of the model to render for this item
         */
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Equipment.prototype, "attackAnimationId", {
        /**
         * index of animation to use for attacks if possible
         */
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    return Equipment;
}(Item));


// EXTERNAL MODULE: ./node_modules/chebyshev/index.js
var chebyshev = __webpack_require__(9252);
var chebyshev_default = /*#__PURE__*/__webpack_require__.n(chebyshev);
// EXTERNAL MODULE: external "three"
var external_three_ = __webpack_require__(9604);
;// CONCATENATED MODULE: ./src/sdk/rendering/BasicModel.ts
var BasicModel_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var BasicModel_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

var BasicModelShape;
(function (BasicModelShape) {
    BasicModelShape[BasicModelShape["BOX"] = 0] = "BOX";
    BasicModelShape[BasicModelShape["SPHERE"] = 1] = "SPHERE";
})(BasicModelShape || (BasicModelShape = {}));
var BasicModel = /** @class */ (function () {
    function BasicModel(size, height, color, unit, drawOffset, shape) {
        if (drawOffset === void 0) { drawOffset = {}; }
        if (shape === void 0) { shape = BasicModelShape.BOX; }
        this.size = size;
        this.drawOffset = drawOffset;
        this.shape = shape;
        this.geometry =
            shape === BasicModelShape.BOX
                ? new external_three_.BoxGeometry(size, height, size)
                : new external_three_.SphereGeometry(size / 2, 8, 8);
        this.material = new external_three_.MeshStandardMaterial({ color: color });
        this.mesh = new external_three_.Mesh(this.geometry, this.material);
        this.mesh.userData.clickable = unit !== null && unit.selectable;
        this.mesh.userData.unit = unit;
    }
    BasicModel.forRenderable = function (r) {
        return new BasicModel(r.size, r.height, r.colorHex, r);
    };
    BasicModel.forRenderableCentered = function (r) {
        return new BasicModel(r.size, r.height, r.colorHex, r, {
            x: r.size / 2,
            z: -r.size / 2,
        });
    };
    // centered sphere
    BasicModel.sphereForRenderable = function (r) {
        return new BasicModel(r.size, r.height, r.colorHex, r, { x: r.size / 2, z: -r.size / 2 }, BasicModelShape.SPHERE);
    };
    BasicModel.prototype.draw = function (scene, clockDelta, tickPercent, location, rotation, pitch, visible) {
        if (this.mesh.parent !== scene) {
            scene.add(this.mesh);
        }
        var size = this.size;
        var x = location.x, y = location.y, z = location.z;
        this.mesh.visible = visible;
        // conversion from Location3 to Vector3
        this.mesh.position.x = x + size / 2;
        this.mesh.position.y = z + size / 2;
        this.mesh.position.z = y - size / 2;
        this.mesh.position.add({
            x: this.drawOffset.x || 0,
            y: this.drawOffset.y || 0,
            z: this.drawOffset.z || 0,
        });
        this.mesh.setRotationFromAxisAngle(new external_three_.Vector3(0, 1, 0), rotation);
    };
    BasicModel.prototype.destroy = function (scene) {
        if (this.mesh.parent === scene) {
            scene.remove(this.mesh);
        }
    };
    BasicModel.prototype.getWorldPosition = function () {
        return this.mesh.getWorldPosition(new external_three_.Vector3());
    };
    BasicModel.prototype.preload = function () {
        return BasicModel_awaiter(this, void 0, void 0, function () {
            return BasicModel_generator(this, function (_a) {
                // do nothing
                return [2 /*return*/];
            });
        });
    };
    return BasicModel;
}());


;// CONCATENATED MODULE: ./node_modules/three/examples/jsm/utils/BufferGeometryUtils.js


function computeMikkTSpaceTangents( geometry, MikkTSpace, negateSign = true ) {

	if ( ! MikkTSpace || ! MikkTSpace.isReady ) {

		throw new Error( 'BufferGeometryUtils: Initialized MikkTSpace library required.' );

	}

	if ( ! geometry.hasAttribute( 'position' ) || ! geometry.hasAttribute( 'normal' ) || ! geometry.hasAttribute( 'uv' ) ) {

		throw new Error( 'BufferGeometryUtils: Tangents require "position", "normal", and "uv" attributes.' );

	}

	function getAttributeArray( attribute ) {

		if ( attribute.normalized || attribute.isInterleavedBufferAttribute ) {

			const dstArray = new Float32Array( attribute.count * attribute.itemSize );

			for ( let i = 0, j = 0; i < attribute.count; i ++ ) {

				dstArray[ j ++ ] = attribute.getX( i );
				dstArray[ j ++ ] = attribute.getY( i );

				if ( attribute.itemSize > 2 ) {

					dstArray[ j ++ ] = attribute.getZ( i );

				}

			}

			return dstArray;

		}

		if ( attribute.array instanceof Float32Array ) {

			return attribute.array;

		}

		return new Float32Array( attribute.array );

	}

	// MikkTSpace algorithm requires non-indexed input.

	const _geometry = geometry.index ? geometry.toNonIndexed() : geometry;

	// Compute vertex tangents.

	const tangents = MikkTSpace.generateTangents(

		getAttributeArray( _geometry.attributes.position ),
		getAttributeArray( _geometry.attributes.normal ),
		getAttributeArray( _geometry.attributes.uv )

	);

	// Texture coordinate convention of glTF differs from the apparent
	// default of the MikkTSpace library; .w component must be flipped.

	if ( negateSign ) {

		for ( let i = 3; i < tangents.length; i += 4 ) {

			tangents[ i ] *= - 1;

		}

	}

	//

	_geometry.setAttribute( 'tangent', new BufferAttribute( tangents, 4 ) );

	if ( geometry !== _geometry ) {

		geometry.copy( _geometry );

	}

	return geometry;

}

/**
 * @param  {Array<BufferGeometry>} geometries
 * @param  {Boolean} useGroups
 * @return {BufferGeometry}
 */
function mergeGeometries( geometries, useGroups = false ) {

	const isIndexed = geometries[ 0 ].index !== null;

	const attributesUsed = new Set( Object.keys( geometries[ 0 ].attributes ) );
	const morphAttributesUsed = new Set( Object.keys( geometries[ 0 ].morphAttributes ) );

	const attributes = {};
	const morphAttributes = {};

	const morphTargetsRelative = geometries[ 0 ].morphTargetsRelative;

	const mergedGeometry = new BufferGeometry();

	let offset = 0;

	for ( let i = 0; i < geometries.length; ++ i ) {

		const geometry = geometries[ i ];
		let attributesCount = 0;

		// ensure that all geometries are indexed, or none

		if ( isIndexed !== ( geometry.index !== null ) ) {

			console.error( 'THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them.' );
			return null;

		}

		// gather attributes, exit early if they're different

		for ( const name in geometry.attributes ) {

			if ( ! attributesUsed.has( name ) ) {

				console.error( 'THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. All geometries must have compatible attributes; make sure "' + name + '" attribute exists among all geometries, or in none of them.' );
				return null;

			}

			if ( attributes[ name ] === undefined ) attributes[ name ] = [];

			attributes[ name ].push( geometry.attributes[ name ] );

			attributesCount ++;

		}

		// ensure geometries have the same number of attributes

		if ( attributesCount !== attributesUsed.size ) {

			console.error( 'THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. Make sure all geometries have the same number of attributes.' );
			return null;

		}

		// gather morph attributes, exit early if they're different

		if ( morphTargetsRelative !== geometry.morphTargetsRelative ) {

			console.error( 'THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. .morphTargetsRelative must be consistent throughout all geometries.' );
			return null;

		}

		for ( const name in geometry.morphAttributes ) {

			if ( ! morphAttributesUsed.has( name ) ) {

				console.error( 'THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '.  .morphAttributes must be consistent throughout all geometries.' );
				return null;

			}

			if ( morphAttributes[ name ] === undefined ) morphAttributes[ name ] = [];

			morphAttributes[ name ].push( geometry.morphAttributes[ name ] );

		}

		if ( useGroups ) {

			let count;

			if ( isIndexed ) {

				count = geometry.index.count;

			} else if ( geometry.attributes.position !== undefined ) {

				count = geometry.attributes.position.count;

			} else {

				console.error( 'THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. The geometry must have either an index or a position attribute' );
				return null;

			}

			mergedGeometry.addGroup( offset, count, i );

			offset += count;

		}

	}

	// merge indices

	if ( isIndexed ) {

		let indexOffset = 0;
		const mergedIndex = [];

		for ( let i = 0; i < geometries.length; ++ i ) {

			const index = geometries[ i ].index;

			for ( let j = 0; j < index.count; ++ j ) {

				mergedIndex.push( index.getX( j ) + indexOffset );

			}

			indexOffset += geometries[ i ].attributes.position.count;

		}

		mergedGeometry.setIndex( mergedIndex );

	}

	// merge attributes

	for ( const name in attributes ) {

		const mergedAttribute = mergeAttributes( attributes[ name ] );

		if ( ! mergedAttribute ) {

			console.error( 'THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the ' + name + ' attribute.' );
			return null;

		}

		mergedGeometry.setAttribute( name, mergedAttribute );

	}

	// merge morph attributes

	for ( const name in morphAttributes ) {

		const numMorphTargets = morphAttributes[ name ][ 0 ].length;

		if ( numMorphTargets === 0 ) break;

		mergedGeometry.morphAttributes = mergedGeometry.morphAttributes || {};
		mergedGeometry.morphAttributes[ name ] = [];

		for ( let i = 0; i < numMorphTargets; ++ i ) {

			const morphAttributesToMerge = [];

			for ( let j = 0; j < morphAttributes[ name ].length; ++ j ) {

				morphAttributesToMerge.push( morphAttributes[ name ][ j ][ i ] );

			}

			const mergedMorphAttribute = mergeAttributes( morphAttributesToMerge );

			if ( ! mergedMorphAttribute ) {

				console.error( 'THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the ' + name + ' morphAttribute.' );
				return null;

			}

			mergedGeometry.morphAttributes[ name ].push( mergedMorphAttribute );

		}

	}

	return mergedGeometry;

}

/**
 * @param {Array<BufferAttribute>} attributes
 * @return {BufferAttribute}
 */
function mergeAttributes( attributes ) {

	let TypedArray;
	let itemSize;
	let normalized;
	let gpuType = - 1;
	let arrayLength = 0;

	for ( let i = 0; i < attributes.length; ++ i ) {

		const attribute = attributes[ i ];

		if ( TypedArray === undefined ) TypedArray = attribute.array.constructor;
		if ( TypedArray !== attribute.array.constructor ) {

			console.error( 'THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.array must be of consistent array types across matching attributes.' );
			return null;

		}

		if ( itemSize === undefined ) itemSize = attribute.itemSize;
		if ( itemSize !== attribute.itemSize ) {

			console.error( 'THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.itemSize must be consistent across matching attributes.' );
			return null;

		}

		if ( normalized === undefined ) normalized = attribute.normalized;
		if ( normalized !== attribute.normalized ) {

			console.error( 'THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.normalized must be consistent across matching attributes.' );
			return null;

		}

		if ( gpuType === - 1 ) gpuType = attribute.gpuType;
		if ( gpuType !== attribute.gpuType ) {

			console.error( 'THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.gpuType must be consistent across matching attributes.' );
			return null;

		}

		arrayLength += attribute.count * itemSize;

	}

	const array = new TypedArray( arrayLength );
	const result = new BufferAttribute( array, itemSize, normalized );
	let offset = 0;

	for ( let i = 0; i < attributes.length; ++ i ) {

		const attribute = attributes[ i ];
		if ( attribute.isInterleavedBufferAttribute ) {

			const tupleOffset = offset / itemSize;
			for ( let j = 0, l = attribute.count; j < l; j ++ ) {

				for ( let c = 0; c < itemSize; c ++ ) {

					const value = attribute.getComponent( j, c );
					result.setComponent( j + tupleOffset, c, value );

				}

			}

		} else {

			array.set( attribute.array, offset );

		}

		offset += attribute.count * itemSize;

	}

	if ( gpuType !== undefined ) {

		result.gpuType = gpuType;

	}

	return result;

}

/**
 * @param {BufferAttribute}
 * @return {BufferAttribute}
 */
function deepCloneAttribute( attribute ) {

	if ( attribute.isInstancedInterleavedBufferAttribute || attribute.isInterleavedBufferAttribute ) {

		return deinterleaveAttribute( attribute );

	}

	if ( attribute.isInstancedBufferAttribute ) {

		return new InstancedBufferAttribute().copy( attribute );

	}

	return new BufferAttribute().copy( attribute );

}

/**
 * @param {Array<BufferAttribute>} attributes
 * @return {Array<InterleavedBufferAttribute>}
 */
function interleaveAttributes( attributes ) {

	// Interleaves the provided attributes into an InterleavedBuffer and returns
	// a set of InterleavedBufferAttributes for each attribute
	let TypedArray;
	let arrayLength = 0;
	let stride = 0;

	// calculate the length and type of the interleavedBuffer
	for ( let i = 0, l = attributes.length; i < l; ++ i ) {

		const attribute = attributes[ i ];

		if ( TypedArray === undefined ) TypedArray = attribute.array.constructor;
		if ( TypedArray !== attribute.array.constructor ) {

			console.error( 'AttributeBuffers of different types cannot be interleaved' );
			return null;

		}

		arrayLength += attribute.array.length;
		stride += attribute.itemSize;

	}

	// Create the set of buffer attributes
	const interleavedBuffer = new InterleavedBuffer( new TypedArray( arrayLength ), stride );
	let offset = 0;
	const res = [];
	const getters = [ 'getX', 'getY', 'getZ', 'getW' ];
	const setters = [ 'setX', 'setY', 'setZ', 'setW' ];

	for ( let j = 0, l = attributes.length; j < l; j ++ ) {

		const attribute = attributes[ j ];
		const itemSize = attribute.itemSize;
		const count = attribute.count;
		const iba = new InterleavedBufferAttribute( interleavedBuffer, itemSize, offset, attribute.normalized );
		res.push( iba );

		offset += itemSize;

		// Move the data for each attribute into the new interleavedBuffer
		// at the appropriate offset
		for ( let c = 0; c < count; c ++ ) {

			for ( let k = 0; k < itemSize; k ++ ) {

				iba[ setters[ k ] ]( c, attribute[ getters[ k ] ]( c ) );

			}

		}

	}

	return res;

}

// returns a new, non-interleaved version of the provided attribute
function deinterleaveAttribute( attribute ) {

	const cons = attribute.data.array.constructor;
	const count = attribute.count;
	const itemSize = attribute.itemSize;
	const normalized = attribute.normalized;

	const array = new cons( count * itemSize );
	let newAttribute;
	if ( attribute.isInstancedInterleavedBufferAttribute ) {

		newAttribute = new InstancedBufferAttribute( array, itemSize, normalized, attribute.meshPerAttribute );

	} else {

		newAttribute = new BufferAttribute( array, itemSize, normalized );

	}

	for ( let i = 0; i < count; i ++ ) {

		newAttribute.setX( i, attribute.getX( i ) );

		if ( itemSize >= 2 ) {

			newAttribute.setY( i, attribute.getY( i ) );

		}

		if ( itemSize >= 3 ) {

			newAttribute.setZ( i, attribute.getZ( i ) );

		}

		if ( itemSize >= 4 ) {

			newAttribute.setW( i, attribute.getW( i ) );

		}

	}

	return newAttribute;

}

// deinterleaves all attributes on the geometry
function deinterleaveGeometry( geometry ) {

	const attributes = geometry.attributes;
	const morphTargets = geometry.morphTargets;
	const attrMap = new Map();

	for ( const key in attributes ) {

		const attr = attributes[ key ];
		if ( attr.isInterleavedBufferAttribute ) {

			if ( ! attrMap.has( attr ) ) {

				attrMap.set( attr, deinterleaveAttribute( attr ) );

			}

			attributes[ key ] = attrMap.get( attr );

		}

	}

	for ( const key in morphTargets ) {

		const attr = morphTargets[ key ];
		if ( attr.isInterleavedBufferAttribute ) {

			if ( ! attrMap.has( attr ) ) {

				attrMap.set( attr, deinterleaveAttribute( attr ) );

			}

			morphTargets[ key ] = attrMap.get( attr );

		}

	}

}

/**
 * @param {BufferGeometry} geometry
 * @return {number}
 */
function estimateBytesUsed( geometry ) {

	// Return the estimated memory used by this geometry in bytes
	// Calculate using itemSize, count, and BYTES_PER_ELEMENT to account
	// for InterleavedBufferAttributes.
	let mem = 0;
	for ( const name in geometry.attributes ) {

		const attr = geometry.getAttribute( name );
		mem += attr.count * attr.itemSize * attr.array.BYTES_PER_ELEMENT;

	}

	const indices = geometry.getIndex();
	mem += indices ? indices.count * indices.itemSize * indices.array.BYTES_PER_ELEMENT : 0;
	return mem;

}

/**
 * @param {BufferGeometry} geometry
 * @param {number} tolerance
 * @return {BufferGeometry}
 */
function mergeVertices( geometry, tolerance = 1e-4 ) {

	tolerance = Math.max( tolerance, Number.EPSILON );

	// Generate an index buffer if the geometry doesn't have one, or optimize it
	// if it's already available.
	const hashToIndex = {};
	const indices = geometry.getIndex();
	const positions = geometry.getAttribute( 'position' );
	const vertexCount = indices ? indices.count : positions.count;

	// next value for triangle indices
	let nextIndex = 0;

	// attributes and new attribute arrays
	const attributeNames = Object.keys( geometry.attributes );
	const tmpAttributes = {};
	const tmpMorphAttributes = {};
	const newIndices = [];
	const getters = [ 'getX', 'getY', 'getZ', 'getW' ];
	const setters = [ 'setX', 'setY', 'setZ', 'setW' ];

	// Initialize the arrays, allocating space conservatively. Extra
	// space will be trimmed in the last step.
	for ( let i = 0, l = attributeNames.length; i < l; i ++ ) {

		const name = attributeNames[ i ];
		const attr = geometry.attributes[ name ];

		tmpAttributes[ name ] = new BufferAttribute(
			new attr.array.constructor( attr.count * attr.itemSize ),
			attr.itemSize,
			attr.normalized
		);

		const morphAttr = geometry.morphAttributes[ name ];
		if ( morphAttr ) {

			tmpMorphAttributes[ name ] = new BufferAttribute(
				new morphAttr.array.constructor( morphAttr.count * morphAttr.itemSize ),
				morphAttr.itemSize,
				morphAttr.normalized
			);

		}

	}

	// convert the error tolerance to an amount of decimal places to truncate to
	const halfTolerance = tolerance * 0.5;
	const exponent = Math.log10( 1 / tolerance );
	const hashMultiplier = Math.pow( 10, exponent );
	const hashAdditive = halfTolerance * hashMultiplier;
	for ( let i = 0; i < vertexCount; i ++ ) {

		const index = indices ? indices.getX( i ) : i;

		// Generate a hash for the vertex attributes at the current index 'i'
		let hash = '';
		for ( let j = 0, l = attributeNames.length; j < l; j ++ ) {

			const name = attributeNames[ j ];
			const attribute = geometry.getAttribute( name );
			const itemSize = attribute.itemSize;

			for ( let k = 0; k < itemSize; k ++ ) {

				// double tilde truncates the decimal value
				hash += `${ ~ ~ ( attribute[ getters[ k ] ]( index ) * hashMultiplier + hashAdditive ) },`;

			}

		}

		// Add another reference to the vertex if it's already
		// used by another index
		if ( hash in hashToIndex ) {

			newIndices.push( hashToIndex[ hash ] );

		} else {

			// copy data to the new index in the temporary attributes
			for ( let j = 0, l = attributeNames.length; j < l; j ++ ) {

				const name = attributeNames[ j ];
				const attribute = geometry.getAttribute( name );
				const morphAttr = geometry.morphAttributes[ name ];
				const itemSize = attribute.itemSize;
				const newarray = tmpAttributes[ name ];
				const newMorphArrays = tmpMorphAttributes[ name ];

				for ( let k = 0; k < itemSize; k ++ ) {

					const getterFunc = getters[ k ];
					const setterFunc = setters[ k ];
					newarray[ setterFunc ]( nextIndex, attribute[ getterFunc ]( index ) );

					if ( morphAttr ) {

						for ( let m = 0, ml = morphAttr.length; m < ml; m ++ ) {

							newMorphArrays[ m ][ setterFunc ]( nextIndex, morphAttr[ m ][ getterFunc ]( index ) );

						}

					}

				}

			}

			hashToIndex[ hash ] = nextIndex;
			newIndices.push( nextIndex );
			nextIndex ++;

		}

	}

	// generate result BufferGeometry
	const result = geometry.clone();
	for ( const name in geometry.attributes ) {

		const tmpAttribute = tmpAttributes[ name ];

		result.setAttribute( name, new BufferAttribute(
			tmpAttribute.array.slice( 0, nextIndex * tmpAttribute.itemSize ),
			tmpAttribute.itemSize,
			tmpAttribute.normalized,
		) );

		if ( ! ( name in tmpMorphAttributes ) ) continue;

		for ( let j = 0; j < tmpMorphAttributes[ name ].length; j ++ ) {

			const tmpMorphAttribute = tmpMorphAttributes[ name ][ j ];

			result.morphAttributes[ name ][ j ] = new BufferAttribute(
				tmpMorphAttribute.array.slice( 0, nextIndex * tmpMorphAttribute.itemSize ),
				tmpMorphAttribute.itemSize,
				tmpMorphAttribute.normalized,
			);

		}

	}

	// indices

	result.setIndex( newIndices );

	return result;

}

/**
 * @param {BufferGeometry} geometry
 * @param {number} drawMode
 * @return {BufferGeometry}
 */
function toTrianglesDrawMode( geometry, drawMode ) {

	if ( drawMode === external_three_.TrianglesDrawMode ) {

		console.warn( 'THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles.' );
		return geometry;

	}

	if ( drawMode === external_three_.TriangleFanDrawMode || drawMode === external_three_.TriangleStripDrawMode ) {

		let index = geometry.getIndex();

		// generate index if not present

		if ( index === null ) {

			const indices = [];

			const position = geometry.getAttribute( 'position' );

			if ( position !== undefined ) {

				for ( let i = 0; i < position.count; i ++ ) {

					indices.push( i );

				}

				geometry.setIndex( indices );
				index = geometry.getIndex();

			} else {

				console.error( 'THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible.' );
				return geometry;

			}

		}

		//

		const numberOfTriangles = index.count - 2;
		const newIndices = [];

		if ( drawMode === external_three_.TriangleFanDrawMode ) {

			// gl.TRIANGLE_FAN

			for ( let i = 1; i <= numberOfTriangles; i ++ ) {

				newIndices.push( index.getX( 0 ) );
				newIndices.push( index.getX( i ) );
				newIndices.push( index.getX( i + 1 ) );

			}

		} else {

			// gl.TRIANGLE_STRIP

			for ( let i = 0; i < numberOfTriangles; i ++ ) {

				if ( i % 2 === 0 ) {

					newIndices.push( index.getX( i ) );
					newIndices.push( index.getX( i + 1 ) );
					newIndices.push( index.getX( i + 2 ) );

				} else {

					newIndices.push( index.getX( i + 2 ) );
					newIndices.push( index.getX( i + 1 ) );
					newIndices.push( index.getX( i ) );

				}

			}

		}

		if ( ( newIndices.length / 3 ) !== numberOfTriangles ) {

			console.error( 'THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.' );

		}

		// build final geometry

		const newGeometry = geometry.clone();
		newGeometry.setIndex( newIndices );
		newGeometry.clearGroups();

		return newGeometry;

	} else {

		console.error( 'THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:', drawMode );
		return geometry;

	}

}

/**
 * Calculates the morphed attributes of a morphed/skinned BufferGeometry.
 * Helpful for Raytracing or Decals.
 * @param {Mesh | Line | Points} object An instance of Mesh, Line or Points.
 * @return {Object} An Object with original position/normal attributes and morphed ones.
 */
function computeMorphedAttributes( object ) {

	const _vA = new Vector3();
	const _vB = new Vector3();
	const _vC = new Vector3();

	const _tempA = new Vector3();
	const _tempB = new Vector3();
	const _tempC = new Vector3();

	const _morphA = new Vector3();
	const _morphB = new Vector3();
	const _morphC = new Vector3();

	function _calculateMorphedAttributeData(
		object,
		attribute,
		morphAttribute,
		morphTargetsRelative,
		a,
		b,
		c,
		modifiedAttributeArray
	) {

		_vA.fromBufferAttribute( attribute, a );
		_vB.fromBufferAttribute( attribute, b );
		_vC.fromBufferAttribute( attribute, c );

		const morphInfluences = object.morphTargetInfluences;

		if ( morphAttribute && morphInfluences ) {

			_morphA.set( 0, 0, 0 );
			_morphB.set( 0, 0, 0 );
			_morphC.set( 0, 0, 0 );

			for ( let i = 0, il = morphAttribute.length; i < il; i ++ ) {

				const influence = morphInfluences[ i ];
				const morph = morphAttribute[ i ];

				if ( influence === 0 ) continue;

				_tempA.fromBufferAttribute( morph, a );
				_tempB.fromBufferAttribute( morph, b );
				_tempC.fromBufferAttribute( morph, c );

				if ( morphTargetsRelative ) {

					_morphA.addScaledVector( _tempA, influence );
					_morphB.addScaledVector( _tempB, influence );
					_morphC.addScaledVector( _tempC, influence );

				} else {

					_morphA.addScaledVector( _tempA.sub( _vA ), influence );
					_morphB.addScaledVector( _tempB.sub( _vB ), influence );
					_morphC.addScaledVector( _tempC.sub( _vC ), influence );

				}

			}

			_vA.add( _morphA );
			_vB.add( _morphB );
			_vC.add( _morphC );

		}

		if ( object.isSkinnedMesh ) {

			object.applyBoneTransform( a, _vA );
			object.applyBoneTransform( b, _vB );
			object.applyBoneTransform( c, _vC );

		}

		modifiedAttributeArray[ a * 3 + 0 ] = _vA.x;
		modifiedAttributeArray[ a * 3 + 1 ] = _vA.y;
		modifiedAttributeArray[ a * 3 + 2 ] = _vA.z;
		modifiedAttributeArray[ b * 3 + 0 ] = _vB.x;
		modifiedAttributeArray[ b * 3 + 1 ] = _vB.y;
		modifiedAttributeArray[ b * 3 + 2 ] = _vB.z;
		modifiedAttributeArray[ c * 3 + 0 ] = _vC.x;
		modifiedAttributeArray[ c * 3 + 1 ] = _vC.y;
		modifiedAttributeArray[ c * 3 + 2 ] = _vC.z;

	}

	const geometry = object.geometry;
	const material = object.material;

	let a, b, c;
	const index = geometry.index;
	const positionAttribute = geometry.attributes.position;
	const morphPosition = geometry.morphAttributes.position;
	const morphTargetsRelative = geometry.morphTargetsRelative;
	const normalAttribute = geometry.attributes.normal;
	const morphNormal = geometry.morphAttributes.position;

	const groups = geometry.groups;
	const drawRange = geometry.drawRange;
	let i, j, il, jl;
	let group;
	let start, end;

	const modifiedPosition = new Float32Array( positionAttribute.count * positionAttribute.itemSize );
	const modifiedNormal = new Float32Array( normalAttribute.count * normalAttribute.itemSize );

	if ( index !== null ) {

		// indexed buffer geometry

		if ( Array.isArray( material ) ) {

			for ( i = 0, il = groups.length; i < il; i ++ ) {

				group = groups[ i ];

				start = Math.max( group.start, drawRange.start );
				end = Math.min( ( group.start + group.count ), ( drawRange.start + drawRange.count ) );

				for ( j = start, jl = end; j < jl; j += 3 ) {

					a = index.getX( j );
					b = index.getX( j + 1 );
					c = index.getX( j + 2 );

					_calculateMorphedAttributeData(
						object,
						positionAttribute,
						morphPosition,
						morphTargetsRelative,
						a, b, c,
						modifiedPosition
					);

					_calculateMorphedAttributeData(
						object,
						normalAttribute,
						morphNormal,
						morphTargetsRelative,
						a, b, c,
						modifiedNormal
					);

				}

			}

		} else {

			start = Math.max( 0, drawRange.start );
			end = Math.min( index.count, ( drawRange.start + drawRange.count ) );

			for ( i = start, il = end; i < il; i += 3 ) {

				a = index.getX( i );
				b = index.getX( i + 1 );
				c = index.getX( i + 2 );

				_calculateMorphedAttributeData(
					object,
					positionAttribute,
					morphPosition,
					morphTargetsRelative,
					a, b, c,
					modifiedPosition
				);

				_calculateMorphedAttributeData(
					object,
					normalAttribute,
					morphNormal,
					morphTargetsRelative,
					a, b, c,
					modifiedNormal
				);

			}

		}

	} else {

		// non-indexed buffer geometry

		if ( Array.isArray( material ) ) {

			for ( i = 0, il = groups.length; i < il; i ++ ) {

				group = groups[ i ];

				start = Math.max( group.start, drawRange.start );
				end = Math.min( ( group.start + group.count ), ( drawRange.start + drawRange.count ) );

				for ( j = start, jl = end; j < jl; j += 3 ) {

					a = j;
					b = j + 1;
					c = j + 2;

					_calculateMorphedAttributeData(
						object,
						positionAttribute,
						morphPosition,
						morphTargetsRelative,
						a, b, c,
						modifiedPosition
					);

					_calculateMorphedAttributeData(
						object,
						normalAttribute,
						morphNormal,
						morphTargetsRelative,
						a, b, c,
						modifiedNormal
					);

				}

			}

		} else {

			start = Math.max( 0, drawRange.start );
			end = Math.min( positionAttribute.count, ( drawRange.start + drawRange.count ) );

			for ( i = start, il = end; i < il; i += 3 ) {

				a = i;
				b = i + 1;
				c = i + 2;

				_calculateMorphedAttributeData(
					object,
					positionAttribute,
					morphPosition,
					morphTargetsRelative,
					a, b, c,
					modifiedPosition
				);

				_calculateMorphedAttributeData(
					object,
					normalAttribute,
					morphNormal,
					morphTargetsRelative,
					a, b, c,
					modifiedNormal
				);

			}

		}

	}

	const morphedPositionAttribute = new Float32BufferAttribute( modifiedPosition, 3 );
	const morphedNormalAttribute = new Float32BufferAttribute( modifiedNormal, 3 );

	return {

		positionAttribute: positionAttribute,
		normalAttribute: normalAttribute,
		morphedPositionAttribute: morphedPositionAttribute,
		morphedNormalAttribute: morphedNormalAttribute

	};

}

function mergeGroups( geometry ) {

	if ( geometry.groups.length === 0 ) {

		console.warn( 'THREE.BufferGeometryUtils.mergeGroups(): No groups are defined. Nothing to merge.' );
		return geometry;

	}

	let groups = geometry.groups;

	// sort groups by material index

	groups = groups.sort( ( a, b ) => {

		if ( a.materialIndex !== b.materialIndex ) return a.materialIndex - b.materialIndex;

		return a.start - b.start;

	} );

	// create index for non-indexed geometries

	if ( geometry.getIndex() === null ) {

		const positionAttribute = geometry.getAttribute( 'position' );
		const indices = [];

		for ( let i = 0; i < positionAttribute.count; i += 3 ) {

			indices.push( i, i + 1, i + 2 );

		}

		geometry.setIndex( indices );

	}

	// sort index

	const index = geometry.getIndex();

	const newIndices = [];

	for ( let i = 0; i < groups.length; i ++ ) {

		const group = groups[ i ];

		const groupStart = group.start;
		const groupLength = groupStart + group.count;

		for ( let j = groupStart; j < groupLength; j ++ ) {

			newIndices.push( index.getX( j ) );

		}

	}

	geometry.dispose(); // Required to force buffer recreation
	geometry.setIndex( newIndices );

	// update groups indices

	let start = 0;

	for ( let i = 0; i < groups.length; i ++ ) {

		const group = groups[ i ];

		group.start = start;
		start += group.count;

	}

	// merge groups

	let currentGroup = groups[ 0 ];

	geometry.groups = [ currentGroup ];

	for ( let i = 1; i < groups.length; i ++ ) {

		const group = groups[ i ];

		if ( currentGroup.materialIndex === group.materialIndex ) {

			currentGroup.count += group.count;

		} else {

			currentGroup = group;
			geometry.groups.push( currentGroup );

		}

	}

	return geometry;

}


/**
 * Modifies the supplied geometry if it is non-indexed, otherwise creates a new,
 * non-indexed geometry. Returns the geometry with smooth normals everywhere except
 * faces that meet at an angle greater than the crease angle.
 *
 * @param {BufferGeometry} geometry
 * @param {number} [creaseAngle]
 * @return {BufferGeometry}
 */
function toCreasedNormals( geometry, creaseAngle = Math.PI / 3 /* 60 degrees */ ) {

	const creaseDot = Math.cos( creaseAngle );
	const hashMultiplier = ( 1 + 1e-10 ) * 1e2;

	// reusable vectors
	const verts = [ new Vector3(), new Vector3(), new Vector3() ];
	const tempVec1 = new Vector3();
	const tempVec2 = new Vector3();
	const tempNorm = new Vector3();
	const tempNorm2 = new Vector3();

	// hashes a vector
	function hashVertex( v ) {

		const x = ~ ~ ( v.x * hashMultiplier );
		const y = ~ ~ ( v.y * hashMultiplier );
		const z = ~ ~ ( v.z * hashMultiplier );
		return `${x},${y},${z}`;

	}

	// BufferGeometry.toNonIndexed() warns if the geometry is non-indexed
	// and returns the original geometry
	const resultGeometry = geometry.index ? geometry.toNonIndexed() : geometry;
	const posAttr = resultGeometry.attributes.position;
	const vertexMap = {};

	// find all the normals shared by commonly located vertices
	for ( let i = 0, l = posAttr.count / 3; i < l; i ++ ) {

		const i3 = 3 * i;
		const a = verts[ 0 ].fromBufferAttribute( posAttr, i3 + 0 );
		const b = verts[ 1 ].fromBufferAttribute( posAttr, i3 + 1 );
		const c = verts[ 2 ].fromBufferAttribute( posAttr, i3 + 2 );

		tempVec1.subVectors( c, b );
		tempVec2.subVectors( a, b );

		// add the normal to the map for all vertices
		const normal = new Vector3().crossVectors( tempVec1, tempVec2 ).normalize();
		for ( let n = 0; n < 3; n ++ ) {

			const vert = verts[ n ];
			const hash = hashVertex( vert );
			if ( ! ( hash in vertexMap ) ) {

				vertexMap[ hash ] = [];

			}

			vertexMap[ hash ].push( normal );

		}

	}

	// average normals from all vertices that share a common location if they are within the
	// provided crease threshold
	const normalArray = new Float32Array( posAttr.count * 3 );
	const normAttr = new BufferAttribute( normalArray, 3, false );
	for ( let i = 0, l = posAttr.count / 3; i < l; i ++ ) {

		// get the face normal for this vertex
		const i3 = 3 * i;
		const a = verts[ 0 ].fromBufferAttribute( posAttr, i3 + 0 );
		const b = verts[ 1 ].fromBufferAttribute( posAttr, i3 + 1 );
		const c = verts[ 2 ].fromBufferAttribute( posAttr, i3 + 2 );

		tempVec1.subVectors( c, b );
		tempVec2.subVectors( a, b );

		tempNorm.crossVectors( tempVec1, tempVec2 ).normalize();

		// average all normals that meet the threshold and set the normal value
		for ( let n = 0; n < 3; n ++ ) {

			const vert = verts[ n ];
			const hash = hashVertex( vert );
			const otherNormals = vertexMap[ hash ];
			tempNorm2.set( 0, 0, 0 );

			for ( let k = 0, lk = otherNormals.length; k < lk; k ++ ) {

				const otherNorm = otherNormals[ k ];
				if ( tempNorm.dot( otherNorm ) > creaseDot ) {

					tempNorm2.add( otherNorm );

				}

			}

			tempNorm2.normalize();
			normAttr.setXYZ( i3 + n, tempNorm2.x, tempNorm2.y, tempNorm2.z );

		}

	}

	resultGeometry.setAttribute( 'normal', normAttr );
	return resultGeometry;

}



;// CONCATENATED MODULE: ./node_modules/three/examples/jsm/loaders/GLTFLoader.js



class GLTFLoader extends external_three_.Loader {

	constructor( manager ) {

		super( manager );

		this.dracoLoader = null;
		this.ktx2Loader = null;
		this.meshoptDecoder = null;

		this.pluginCallbacks = [];

		this.register( function ( parser ) {

			return new GLTFMaterialsClearcoatExtension( parser );

		} );

		this.register( function ( parser ) {

			return new GLTFTextureBasisUExtension( parser );

		} );

		this.register( function ( parser ) {

			return new GLTFTextureWebPExtension( parser );

		} );

		this.register( function ( parser ) {

			return new GLTFTextureAVIFExtension( parser );

		} );

		this.register( function ( parser ) {

			return new GLTFMaterialsSheenExtension( parser );

		} );

		this.register( function ( parser ) {

			return new GLTFMaterialsTransmissionExtension( parser );

		} );

		this.register( function ( parser ) {

			return new GLTFMaterialsVolumeExtension( parser );

		} );

		this.register( function ( parser ) {

			return new GLTFMaterialsIorExtension( parser );

		} );

		this.register( function ( parser ) {

			return new GLTFMaterialsEmissiveStrengthExtension( parser );

		} );

		this.register( function ( parser ) {

			return new GLTFMaterialsSpecularExtension( parser );

		} );

		this.register( function ( parser ) {

			return new GLTFMaterialsIridescenceExtension( parser );

		} );

		this.register( function ( parser ) {

			return new GLTFMaterialsAnisotropyExtension( parser );

		} );

		this.register( function ( parser ) {

			return new GLTFMaterialsBumpExtension( parser );

		} );

		this.register( function ( parser ) {

			return new GLTFLightsExtension( parser );

		} );

		this.register( function ( parser ) {

			return new GLTFMeshoptCompression( parser );

		} );

		this.register( function ( parser ) {

			return new GLTFMeshGpuInstancing( parser );

		} );

	}

	load( url, onLoad, onProgress, onError ) {

		const scope = this;

		let resourcePath;

		if ( this.resourcePath !== '' ) {

			resourcePath = this.resourcePath;

		} else if ( this.path !== '' ) {

			// If a base path is set, resources will be relative paths from that plus the relative path of the gltf file
			// Example  path = 'https://my-cnd-server.com/', url = 'assets/models/model.gltf'
			// resourcePath = 'https://my-cnd-server.com/assets/models/'
			// referenced resource 'model.bin' will be loaded from 'https://my-cnd-server.com/assets/models/model.bin'
			// referenced resource '../textures/texture.png' will be loaded from 'https://my-cnd-server.com/assets/textures/texture.png'
			const relativeUrl = external_three_.LoaderUtils.extractUrlBase( url );
			resourcePath = external_three_.LoaderUtils.resolveURL( relativeUrl, this.path );

		} else {

			resourcePath = external_three_.LoaderUtils.extractUrlBase( url );

		}

		// Tells the LoadingManager to track an extra item, which resolves after
		// the model is fully loaded. This means the count of items loaded will
		// be incorrect, but ensures manager.onLoad() does not fire early.
		this.manager.itemStart( url );

		const _onError = function ( e ) {

			if ( onError ) {

				onError( e );

			} else {

				console.error( e );

			}

			scope.manager.itemError( url );
			scope.manager.itemEnd( url );

		};

		const loader = new external_three_.FileLoader( this.manager );

		loader.setPath( this.path );
		loader.setResponseType( 'arraybuffer' );
		loader.setRequestHeader( this.requestHeader );
		loader.setWithCredentials( this.withCredentials );

		loader.load( url, function ( data ) {

			try {

				scope.parse( data, resourcePath, function ( gltf ) {

					onLoad( gltf );

					scope.manager.itemEnd( url );

				}, _onError );

			} catch ( e ) {

				_onError( e );

			}

		}, onProgress, _onError );

	}

	setDRACOLoader( dracoLoader ) {

		this.dracoLoader = dracoLoader;
		return this;

	}

	setDDSLoader() {

		throw new Error(

			'THREE.GLTFLoader: "MSFT_texture_dds" no longer supported. Please update to "KHR_texture_basisu".'

		);

	}

	setKTX2Loader( ktx2Loader ) {

		this.ktx2Loader = ktx2Loader;
		return this;

	}

	setMeshoptDecoder( meshoptDecoder ) {

		this.meshoptDecoder = meshoptDecoder;
		return this;

	}

	register( callback ) {

		if ( this.pluginCallbacks.indexOf( callback ) === - 1 ) {

			this.pluginCallbacks.push( callback );

		}

		return this;

	}

	unregister( callback ) {

		if ( this.pluginCallbacks.indexOf( callback ) !== - 1 ) {

			this.pluginCallbacks.splice( this.pluginCallbacks.indexOf( callback ), 1 );

		}

		return this;

	}

	parse( data, path, onLoad, onError ) {

		let json;
		const extensions = {};
		const plugins = {};
		const textDecoder = new TextDecoder();

		if ( typeof data === 'string' ) {

			json = JSON.parse( data );

		} else if ( data instanceof ArrayBuffer ) {

			const magic = textDecoder.decode( new Uint8Array( data, 0, 4 ) );

			if ( magic === BINARY_EXTENSION_HEADER_MAGIC ) {

				try {

					extensions[ EXTENSIONS.KHR_BINARY_GLTF ] = new GLTFBinaryExtension( data );

				} catch ( error ) {

					if ( onError ) onError( error );
					return;

				}

				json = JSON.parse( extensions[ EXTENSIONS.KHR_BINARY_GLTF ].content );

			} else {

				json = JSON.parse( textDecoder.decode( data ) );

			}

		} else {

			json = data;

		}

		if ( json.asset === undefined || json.asset.version[ 0 ] < 2 ) {

			if ( onError ) onError( new Error( 'THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported.' ) );
			return;

		}

		const parser = new GLTFParser( json, {

			path: path || this.resourcePath || '',
			crossOrigin: this.crossOrigin,
			requestHeader: this.requestHeader,
			manager: this.manager,
			ktx2Loader: this.ktx2Loader,
			meshoptDecoder: this.meshoptDecoder

		} );

		parser.fileLoader.setRequestHeader( this.requestHeader );

		for ( let i = 0; i < this.pluginCallbacks.length; i ++ ) {

			const plugin = this.pluginCallbacks[ i ]( parser );

			if ( ! plugin.name ) console.error( 'THREE.GLTFLoader: Invalid plugin found: missing name' );

			plugins[ plugin.name ] = plugin;

			// Workaround to avoid determining as unknown extension
			// in addUnknownExtensionsToUserData().
			// Remove this workaround if we move all the existing
			// extension handlers to plugin system
			extensions[ plugin.name ] = true;

		}

		if ( json.extensionsUsed ) {

			for ( let i = 0; i < json.extensionsUsed.length; ++ i ) {

				const extensionName = json.extensionsUsed[ i ];
				const extensionsRequired = json.extensionsRequired || [];

				switch ( extensionName ) {

					case EXTENSIONS.KHR_MATERIALS_UNLIT:
						extensions[ extensionName ] = new GLTFMaterialsUnlitExtension();
						break;

					case EXTENSIONS.KHR_DRACO_MESH_COMPRESSION:
						extensions[ extensionName ] = new GLTFDracoMeshCompressionExtension( json, this.dracoLoader );
						break;

					case EXTENSIONS.KHR_TEXTURE_TRANSFORM:
						extensions[ extensionName ] = new GLTFTextureTransformExtension();
						break;

					case EXTENSIONS.KHR_MESH_QUANTIZATION:
						extensions[ extensionName ] = new GLTFMeshQuantizationExtension();
						break;

					default:

						if ( extensionsRequired.indexOf( extensionName ) >= 0 && plugins[ extensionName ] === undefined ) {

							console.warn( 'THREE.GLTFLoader: Unknown extension "' + extensionName + '".' );

						}

				}

			}

		}

		parser.setExtensions( extensions );
		parser.setPlugins( plugins );
		parser.parse( onLoad, onError );

	}

	parseAsync( data, path ) {

		const scope = this;

		return new Promise( function ( resolve, reject ) {

			scope.parse( data, path, resolve, reject );

		} );

	}

}

/* GLTFREGISTRY */

function GLTFRegistry() {

	let objects = {};

	return	{

		get: function ( key ) {

			return objects[ key ];

		},

		add: function ( key, object ) {

			objects[ key ] = object;

		},

		remove: function ( key ) {

			delete objects[ key ];

		},

		removeAll: function () {

			objects = {};

		}

	};

}

/*********************************/
/********** EXTENSIONS ***********/
/*********************************/

const EXTENSIONS = {
	KHR_BINARY_GLTF: 'KHR_binary_glTF',
	KHR_DRACO_MESH_COMPRESSION: 'KHR_draco_mesh_compression',
	KHR_LIGHTS_PUNCTUAL: 'KHR_lights_punctual',
	KHR_MATERIALS_CLEARCOAT: 'KHR_materials_clearcoat',
	KHR_MATERIALS_IOR: 'KHR_materials_ior',
	KHR_MATERIALS_SHEEN: 'KHR_materials_sheen',
	KHR_MATERIALS_SPECULAR: 'KHR_materials_specular',
	KHR_MATERIALS_TRANSMISSION: 'KHR_materials_transmission',
	KHR_MATERIALS_IRIDESCENCE: 'KHR_materials_iridescence',
	KHR_MATERIALS_ANISOTROPY: 'KHR_materials_anisotropy',
	KHR_MATERIALS_UNLIT: 'KHR_materials_unlit',
	KHR_MATERIALS_VOLUME: 'KHR_materials_volume',
	KHR_TEXTURE_BASISU: 'KHR_texture_basisu',
	KHR_TEXTURE_TRANSFORM: 'KHR_texture_transform',
	KHR_MESH_QUANTIZATION: 'KHR_mesh_quantization',
	KHR_MATERIALS_EMISSIVE_STRENGTH: 'KHR_materials_emissive_strength',
	EXT_MATERIALS_BUMP: 'EXT_materials_bump',
	EXT_TEXTURE_WEBP: 'EXT_texture_webp',
	EXT_TEXTURE_AVIF: 'EXT_texture_avif',
	EXT_MESHOPT_COMPRESSION: 'EXT_meshopt_compression',
	EXT_MESH_GPU_INSTANCING: 'EXT_mesh_gpu_instancing'
};

/**
 * Punctual Lights Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_lights_punctual
 */
class GLTFLightsExtension {

	constructor( parser ) {

		this.parser = parser;
		this.name = EXTENSIONS.KHR_LIGHTS_PUNCTUAL;

		// Object3D instance caches
		this.cache = { refs: {}, uses: {} };

	}

	_markDefs() {

		const parser = this.parser;
		const nodeDefs = this.parser.json.nodes || [];

		for ( let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex ++ ) {

			const nodeDef = nodeDefs[ nodeIndex ];

			if ( nodeDef.extensions
					&& nodeDef.extensions[ this.name ]
					&& nodeDef.extensions[ this.name ].light !== undefined ) {

				parser._addNodeRef( this.cache, nodeDef.extensions[ this.name ].light );

			}

		}

	}

	_loadLight( lightIndex ) {

		const parser = this.parser;
		const cacheKey = 'light:' + lightIndex;
		let dependency = parser.cache.get( cacheKey );

		if ( dependency ) return dependency;

		const json = parser.json;
		const extensions = ( json.extensions && json.extensions[ this.name ] ) || {};
		const lightDefs = extensions.lights || [];
		const lightDef = lightDefs[ lightIndex ];
		let lightNode;

		const color = new external_three_.Color( 0xffffff );

		if ( lightDef.color !== undefined ) color.setRGB( lightDef.color[ 0 ], lightDef.color[ 1 ], lightDef.color[ 2 ], external_three_.LinearSRGBColorSpace );

		const range = lightDef.range !== undefined ? lightDef.range : 0;

		switch ( lightDef.type ) {

			case 'directional':
				lightNode = new external_three_.DirectionalLight( color );
				lightNode.target.position.set( 0, 0, - 1 );
				lightNode.add( lightNode.target );
				break;

			case 'point':
				lightNode = new external_three_.PointLight( color );
				lightNode.distance = range;
				break;

			case 'spot':
				lightNode = new external_three_.SpotLight( color );
				lightNode.distance = range;
				// Handle spotlight properties.
				lightDef.spot = lightDef.spot || {};
				lightDef.spot.innerConeAngle = lightDef.spot.innerConeAngle !== undefined ? lightDef.spot.innerConeAngle : 0;
				lightDef.spot.outerConeAngle = lightDef.spot.outerConeAngle !== undefined ? lightDef.spot.outerConeAngle : Math.PI / 4.0;
				lightNode.angle = lightDef.spot.outerConeAngle;
				lightNode.penumbra = 1.0 - lightDef.spot.innerConeAngle / lightDef.spot.outerConeAngle;
				lightNode.target.position.set( 0, 0, - 1 );
				lightNode.add( lightNode.target );
				break;

			default:
				throw new Error( 'THREE.GLTFLoader: Unexpected light type: ' + lightDef.type );

		}

		// Some lights (e.g. spot) default to a position other than the origin. Reset the position
		// here, because node-level parsing will only override position if explicitly specified.
		lightNode.position.set( 0, 0, 0 );

		lightNode.decay = 2;

		assignExtrasToUserData( lightNode, lightDef );

		if ( lightDef.intensity !== undefined ) lightNode.intensity = lightDef.intensity;

		lightNode.name = parser.createUniqueName( lightDef.name || ( 'light_' + lightIndex ) );

		dependency = Promise.resolve( lightNode );

		parser.cache.add( cacheKey, dependency );

		return dependency;

	}

	getDependency( type, index ) {

		if ( type !== 'light' ) return;

		return this._loadLight( index );

	}

	createNodeAttachment( nodeIndex ) {

		const self = this;
		const parser = this.parser;
		const json = parser.json;
		const nodeDef = json.nodes[ nodeIndex ];
		const lightDef = ( nodeDef.extensions && nodeDef.extensions[ this.name ] ) || {};
		const lightIndex = lightDef.light;

		if ( lightIndex === undefined ) return null;

		return this._loadLight( lightIndex ).then( function ( light ) {

			return parser._getNodeRef( self.cache, lightIndex, light );

		} );

	}

}

/**
 * Unlit Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_unlit
 */
class GLTFMaterialsUnlitExtension {

	constructor() {

		this.name = EXTENSIONS.KHR_MATERIALS_UNLIT;

	}

	getMaterialType() {

		return external_three_.MeshBasicMaterial;

	}

	extendParams( materialParams, materialDef, parser ) {

		const pending = [];

		materialParams.color = new external_three_.Color( 1.0, 1.0, 1.0 );
		materialParams.opacity = 1.0;

		const metallicRoughness = materialDef.pbrMetallicRoughness;

		if ( metallicRoughness ) {

			if ( Array.isArray( metallicRoughness.baseColorFactor ) ) {

				const array = metallicRoughness.baseColorFactor;

				materialParams.color.setRGB( array[ 0 ], array[ 1 ], array[ 2 ], external_three_.LinearSRGBColorSpace );
				materialParams.opacity = array[ 3 ];

			}

			if ( metallicRoughness.baseColorTexture !== undefined ) {

				pending.push( parser.assignTexture( materialParams, 'map', metallicRoughness.baseColorTexture, external_three_.SRGBColorSpace ) );

			}

		}

		return Promise.all( pending );

	}

}

/**
 * Materials Emissive Strength Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/blob/5768b3ce0ef32bc39cdf1bef10b948586635ead3/extensions/2.0/Khronos/KHR_materials_emissive_strength/README.md
 */
class GLTFMaterialsEmissiveStrengthExtension {

	constructor( parser ) {

		this.parser = parser;
		this.name = EXTENSIONS.KHR_MATERIALS_EMISSIVE_STRENGTH;

	}

	extendMaterialParams( materialIndex, materialParams ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) {

			return Promise.resolve();

		}

		const emissiveStrength = materialDef.extensions[ this.name ].emissiveStrength;

		if ( emissiveStrength !== undefined ) {

			materialParams.emissiveIntensity = emissiveStrength;

		}

		return Promise.resolve();

	}

}

/**
 * Clearcoat Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_clearcoat
 */
class GLTFMaterialsClearcoatExtension {

	constructor( parser ) {

		this.parser = parser;
		this.name = EXTENSIONS.KHR_MATERIALS_CLEARCOAT;

	}

	getMaterialType( materialIndex ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) return null;

		return external_three_.MeshPhysicalMaterial;

	}

	extendMaterialParams( materialIndex, materialParams ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) {

			return Promise.resolve();

		}

		const pending = [];

		const extension = materialDef.extensions[ this.name ];

		if ( extension.clearcoatFactor !== undefined ) {

			materialParams.clearcoat = extension.clearcoatFactor;

		}

		if ( extension.clearcoatTexture !== undefined ) {

			pending.push( parser.assignTexture( materialParams, 'clearcoatMap', extension.clearcoatTexture ) );

		}

		if ( extension.clearcoatRoughnessFactor !== undefined ) {

			materialParams.clearcoatRoughness = extension.clearcoatRoughnessFactor;

		}

		if ( extension.clearcoatRoughnessTexture !== undefined ) {

			pending.push( parser.assignTexture( materialParams, 'clearcoatRoughnessMap', extension.clearcoatRoughnessTexture ) );

		}

		if ( extension.clearcoatNormalTexture !== undefined ) {

			pending.push( parser.assignTexture( materialParams, 'clearcoatNormalMap', extension.clearcoatNormalTexture ) );

			if ( extension.clearcoatNormalTexture.scale !== undefined ) {

				const scale = extension.clearcoatNormalTexture.scale;

				materialParams.clearcoatNormalScale = new external_three_.Vector2( scale, scale );

			}

		}

		return Promise.all( pending );

	}

}

/**
 * Iridescence Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_iridescence
 */
class GLTFMaterialsIridescenceExtension {

	constructor( parser ) {

		this.parser = parser;
		this.name = EXTENSIONS.KHR_MATERIALS_IRIDESCENCE;

	}

	getMaterialType( materialIndex ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) return null;

		return external_three_.MeshPhysicalMaterial;

	}

	extendMaterialParams( materialIndex, materialParams ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) {

			return Promise.resolve();

		}

		const pending = [];

		const extension = materialDef.extensions[ this.name ];

		if ( extension.iridescenceFactor !== undefined ) {

			materialParams.iridescence = extension.iridescenceFactor;

		}

		if ( extension.iridescenceTexture !== undefined ) {

			pending.push( parser.assignTexture( materialParams, 'iridescenceMap', extension.iridescenceTexture ) );

		}

		if ( extension.iridescenceIor !== undefined ) {

			materialParams.iridescenceIOR = extension.iridescenceIor;

		}

		if ( materialParams.iridescenceThicknessRange === undefined ) {

			materialParams.iridescenceThicknessRange = [ 100, 400 ];

		}

		if ( extension.iridescenceThicknessMinimum !== undefined ) {

			materialParams.iridescenceThicknessRange[ 0 ] = extension.iridescenceThicknessMinimum;

		}

		if ( extension.iridescenceThicknessMaximum !== undefined ) {

			materialParams.iridescenceThicknessRange[ 1 ] = extension.iridescenceThicknessMaximum;

		}

		if ( extension.iridescenceThicknessTexture !== undefined ) {

			pending.push( parser.assignTexture( materialParams, 'iridescenceThicknessMap', extension.iridescenceThicknessTexture ) );

		}

		return Promise.all( pending );

	}

}

/**
 * Sheen Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/main/extensions/2.0/Khronos/KHR_materials_sheen
 */
class GLTFMaterialsSheenExtension {

	constructor( parser ) {

		this.parser = parser;
		this.name = EXTENSIONS.KHR_MATERIALS_SHEEN;

	}

	getMaterialType( materialIndex ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) return null;

		return external_three_.MeshPhysicalMaterial;

	}

	extendMaterialParams( materialIndex, materialParams ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) {

			return Promise.resolve();

		}

		const pending = [];

		materialParams.sheenColor = new external_three_.Color( 0, 0, 0 );
		materialParams.sheenRoughness = 0;
		materialParams.sheen = 1;

		const extension = materialDef.extensions[ this.name ];

		if ( extension.sheenColorFactor !== undefined ) {

			const colorFactor = extension.sheenColorFactor;
			materialParams.sheenColor.setRGB( colorFactor[ 0 ], colorFactor[ 1 ], colorFactor[ 2 ], external_three_.LinearSRGBColorSpace );

		}

		if ( extension.sheenRoughnessFactor !== undefined ) {

			materialParams.sheenRoughness = extension.sheenRoughnessFactor;

		}

		if ( extension.sheenColorTexture !== undefined ) {

			pending.push( parser.assignTexture( materialParams, 'sheenColorMap', extension.sheenColorTexture, external_three_.SRGBColorSpace ) );

		}

		if ( extension.sheenRoughnessTexture !== undefined ) {

			pending.push( parser.assignTexture( materialParams, 'sheenRoughnessMap', extension.sheenRoughnessTexture ) );

		}

		return Promise.all( pending );

	}

}

/**
 * Transmission Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_transmission
 * Draft: https://github.com/KhronosGroup/glTF/pull/1698
 */
class GLTFMaterialsTransmissionExtension {

	constructor( parser ) {

		this.parser = parser;
		this.name = EXTENSIONS.KHR_MATERIALS_TRANSMISSION;

	}

	getMaterialType( materialIndex ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) return null;

		return external_three_.MeshPhysicalMaterial;

	}

	extendMaterialParams( materialIndex, materialParams ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) {

			return Promise.resolve();

		}

		const pending = [];

		const extension = materialDef.extensions[ this.name ];

		if ( extension.transmissionFactor !== undefined ) {

			materialParams.transmission = extension.transmissionFactor;

		}

		if ( extension.transmissionTexture !== undefined ) {

			pending.push( parser.assignTexture( materialParams, 'transmissionMap', extension.transmissionTexture ) );

		}

		return Promise.all( pending );

	}

}

/**
 * Materials Volume Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_volume
 */
class GLTFMaterialsVolumeExtension {

	constructor( parser ) {

		this.parser = parser;
		this.name = EXTENSIONS.KHR_MATERIALS_VOLUME;

	}

	getMaterialType( materialIndex ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) return null;

		return external_three_.MeshPhysicalMaterial;

	}

	extendMaterialParams( materialIndex, materialParams ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) {

			return Promise.resolve();

		}

		const pending = [];

		const extension = materialDef.extensions[ this.name ];

		materialParams.thickness = extension.thicknessFactor !== undefined ? extension.thicknessFactor : 0;

		if ( extension.thicknessTexture !== undefined ) {

			pending.push( parser.assignTexture( materialParams, 'thicknessMap', extension.thicknessTexture ) );

		}

		materialParams.attenuationDistance = extension.attenuationDistance || Infinity;

		const colorArray = extension.attenuationColor || [ 1, 1, 1 ];
		materialParams.attenuationColor = new external_three_.Color().setRGB( colorArray[ 0 ], colorArray[ 1 ], colorArray[ 2 ], external_three_.LinearSRGBColorSpace );

		return Promise.all( pending );

	}

}

/**
 * Materials ior Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_ior
 */
class GLTFMaterialsIorExtension {

	constructor( parser ) {

		this.parser = parser;
		this.name = EXTENSIONS.KHR_MATERIALS_IOR;

	}

	getMaterialType( materialIndex ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) return null;

		return external_three_.MeshPhysicalMaterial;

	}

	extendMaterialParams( materialIndex, materialParams ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) {

			return Promise.resolve();

		}

		const extension = materialDef.extensions[ this.name ];

		materialParams.ior = extension.ior !== undefined ? extension.ior : 1.5;

		return Promise.resolve();

	}

}

/**
 * Materials specular Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_specular
 */
class GLTFMaterialsSpecularExtension {

	constructor( parser ) {

		this.parser = parser;
		this.name = EXTENSIONS.KHR_MATERIALS_SPECULAR;

	}

	getMaterialType( materialIndex ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) return null;

		return external_three_.MeshPhysicalMaterial;

	}

	extendMaterialParams( materialIndex, materialParams ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) {

			return Promise.resolve();

		}

		const pending = [];

		const extension = materialDef.extensions[ this.name ];

		materialParams.specularIntensity = extension.specularFactor !== undefined ? extension.specularFactor : 1.0;

		if ( extension.specularTexture !== undefined ) {

			pending.push( parser.assignTexture( materialParams, 'specularIntensityMap', extension.specularTexture ) );

		}

		const colorArray = extension.specularColorFactor || [ 1, 1, 1 ];
		materialParams.specularColor = new external_three_.Color().setRGB( colorArray[ 0 ], colorArray[ 1 ], colorArray[ 2 ], external_three_.LinearSRGBColorSpace );

		if ( extension.specularColorTexture !== undefined ) {

			pending.push( parser.assignTexture( materialParams, 'specularColorMap', extension.specularColorTexture, external_three_.SRGBColorSpace ) );

		}

		return Promise.all( pending );

	}

}


/**
 * Materials bump Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/EXT_materials_bump
 */
class GLTFMaterialsBumpExtension {

	constructor( parser ) {

		this.parser = parser;
		this.name = EXTENSIONS.EXT_MATERIALS_BUMP;

	}

	getMaterialType( materialIndex ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) return null;

		return external_three_.MeshPhysicalMaterial;

	}

	extendMaterialParams( materialIndex, materialParams ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) {

			return Promise.resolve();

		}

		const pending = [];

		const extension = materialDef.extensions[ this.name ];

		materialParams.bumpScale = extension.bumpFactor !== undefined ? extension.bumpFactor : 1.0;

		if ( extension.bumpTexture !== undefined ) {

			pending.push( parser.assignTexture( materialParams, 'bumpMap', extension.bumpTexture ) );

		}

		return Promise.all( pending );

	}

}

/**
 * Materials anisotropy Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_anisotropy
 */
class GLTFMaterialsAnisotropyExtension {

	constructor( parser ) {

		this.parser = parser;
		this.name = EXTENSIONS.KHR_MATERIALS_ANISOTROPY;

	}

	getMaterialType( materialIndex ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) return null;

		return external_three_.MeshPhysicalMaterial;

	}

	extendMaterialParams( materialIndex, materialParams ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) {

			return Promise.resolve();

		}

		const pending = [];

		const extension = materialDef.extensions[ this.name ];

		if ( extension.anisotropyStrength !== undefined ) {

			materialParams.anisotropy = extension.anisotropyStrength;

		}

		if ( extension.anisotropyRotation !== undefined ) {

			materialParams.anisotropyRotation = extension.anisotropyRotation;

		}

		if ( extension.anisotropyTexture !== undefined ) {

			pending.push( parser.assignTexture( materialParams, 'anisotropyMap', extension.anisotropyTexture ) );

		}

		return Promise.all( pending );

	}

}

/**
 * BasisU Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_texture_basisu
 */
class GLTFTextureBasisUExtension {

	constructor( parser ) {

		this.parser = parser;
		this.name = EXTENSIONS.KHR_TEXTURE_BASISU;

	}

	loadTexture( textureIndex ) {

		const parser = this.parser;
		const json = parser.json;

		const textureDef = json.textures[ textureIndex ];

		if ( ! textureDef.extensions || ! textureDef.extensions[ this.name ] ) {

			return null;

		}

		const extension = textureDef.extensions[ this.name ];
		const loader = parser.options.ktx2Loader;

		if ( ! loader ) {

			if ( json.extensionsRequired && json.extensionsRequired.indexOf( this.name ) >= 0 ) {

				throw new Error( 'THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures' );

			} else {

				// Assumes that the extension is optional and that a fallback texture is present
				return null;

			}

		}

		return parser.loadTextureImage( textureIndex, extension.source, loader );

	}

}

/**
 * WebP Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_texture_webp
 */
class GLTFTextureWebPExtension {

	constructor( parser ) {

		this.parser = parser;
		this.name = EXTENSIONS.EXT_TEXTURE_WEBP;
		this.isSupported = null;

	}

	loadTexture( textureIndex ) {

		const name = this.name;
		const parser = this.parser;
		const json = parser.json;

		const textureDef = json.textures[ textureIndex ];

		if ( ! textureDef.extensions || ! textureDef.extensions[ name ] ) {

			return null;

		}

		const extension = textureDef.extensions[ name ];
		const source = json.images[ extension.source ];

		let loader = parser.textureLoader;
		if ( source.uri ) {

			const handler = parser.options.manager.getHandler( source.uri );
			if ( handler !== null ) loader = handler;

		}

		return this.detectSupport().then( function ( isSupported ) {

			if ( isSupported ) return parser.loadTextureImage( textureIndex, extension.source, loader );

			if ( json.extensionsRequired && json.extensionsRequired.indexOf( name ) >= 0 ) {

				throw new Error( 'THREE.GLTFLoader: WebP required by asset but unsupported.' );

			}

			// Fall back to PNG or JPEG.
			return parser.loadTexture( textureIndex );

		} );

	}

	detectSupport() {

		if ( ! this.isSupported ) {

			this.isSupported = new Promise( function ( resolve ) {

				const image = new Image();

				// Lossy test image. Support for lossy images doesn't guarantee support for all
				// WebP images, unfortunately.
				image.src = 'data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA';

				image.onload = image.onerror = function () {

					resolve( image.height === 1 );

				};

			} );

		}

		return this.isSupported;

	}

}

/**
 * AVIF Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_texture_avif
 */
class GLTFTextureAVIFExtension {

	constructor( parser ) {

		this.parser = parser;
		this.name = EXTENSIONS.EXT_TEXTURE_AVIF;
		this.isSupported = null;

	}

	loadTexture( textureIndex ) {

		const name = this.name;
		const parser = this.parser;
		const json = parser.json;

		const textureDef = json.textures[ textureIndex ];

		if ( ! textureDef.extensions || ! textureDef.extensions[ name ] ) {

			return null;

		}

		const extension = textureDef.extensions[ name ];
		const source = json.images[ extension.source ];

		let loader = parser.textureLoader;
		if ( source.uri ) {

			const handler = parser.options.manager.getHandler( source.uri );
			if ( handler !== null ) loader = handler;

		}

		return this.detectSupport().then( function ( isSupported ) {

			if ( isSupported ) return parser.loadTextureImage( textureIndex, extension.source, loader );

			if ( json.extensionsRequired && json.extensionsRequired.indexOf( name ) >= 0 ) {

				throw new Error( 'THREE.GLTFLoader: AVIF required by asset but unsupported.' );

			}

			// Fall back to PNG or JPEG.
			return parser.loadTexture( textureIndex );

		} );

	}

	detectSupport() {

		if ( ! this.isSupported ) {

			this.isSupported = new Promise( function ( resolve ) {

				const image = new Image();

				// Lossy test image.
				image.src = 'data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAABcAAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAEAAAABAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQAMAAAAABNjb2xybmNseAACAAIABoAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAAB9tZGF0EgAKCBgABogQEDQgMgkQAAAAB8dSLfI=';
				image.onload = image.onerror = function () {

					resolve( image.height === 1 );

				};

			} );

		}

		return this.isSupported;

	}

}

/**
 * meshopt BufferView Compression Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_meshopt_compression
 */
class GLTFMeshoptCompression {

	constructor( parser ) {

		this.name = EXTENSIONS.EXT_MESHOPT_COMPRESSION;
		this.parser = parser;

	}

	loadBufferView( index ) {

		const json = this.parser.json;
		const bufferView = json.bufferViews[ index ];

		if ( bufferView.extensions && bufferView.extensions[ this.name ] ) {

			const extensionDef = bufferView.extensions[ this.name ];

			const buffer = this.parser.getDependency( 'buffer', extensionDef.buffer );
			const decoder = this.parser.options.meshoptDecoder;

			if ( ! decoder || ! decoder.supported ) {

				if ( json.extensionsRequired && json.extensionsRequired.indexOf( this.name ) >= 0 ) {

					throw new Error( 'THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files' );

				} else {

					// Assumes that the extension is optional and that fallback buffer data is present
					return null;

				}

			}

			return buffer.then( function ( res ) {

				const byteOffset = extensionDef.byteOffset || 0;
				const byteLength = extensionDef.byteLength || 0;

				const count = extensionDef.count;
				const stride = extensionDef.byteStride;

				const source = new Uint8Array( res, byteOffset, byteLength );

				if ( decoder.decodeGltfBufferAsync ) {

					return decoder.decodeGltfBufferAsync( count, stride, source, extensionDef.mode, extensionDef.filter ).then( function ( res ) {

						return res.buffer;

					} );

				} else {

					// Support for MeshoptDecoder 0.18 or earlier, without decodeGltfBufferAsync
					return decoder.ready.then( function () {

						const result = new ArrayBuffer( count * stride );
						decoder.decodeGltfBuffer( new Uint8Array( result ), count, stride, source, extensionDef.mode, extensionDef.filter );
						return result;

					} );

				}

			} );

		} else {

			return null;

		}

	}

}

/**
 * GPU Instancing Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_mesh_gpu_instancing
 *
 */
class GLTFMeshGpuInstancing {

	constructor( parser ) {

		this.name = EXTENSIONS.EXT_MESH_GPU_INSTANCING;
		this.parser = parser;

	}

	createNodeMesh( nodeIndex ) {

		const json = this.parser.json;
		const nodeDef = json.nodes[ nodeIndex ];

		if ( ! nodeDef.extensions || ! nodeDef.extensions[ this.name ] ||
			nodeDef.mesh === undefined ) {

			return null;

		}

		const meshDef = json.meshes[ nodeDef.mesh ];

		// No Points or Lines + Instancing support yet

		for ( const primitive of meshDef.primitives ) {

			if ( primitive.mode !== WEBGL_CONSTANTS.TRIANGLES &&
				 primitive.mode !== WEBGL_CONSTANTS.TRIANGLE_STRIP &&
				 primitive.mode !== WEBGL_CONSTANTS.TRIANGLE_FAN &&
				 primitive.mode !== undefined ) {

				return null;

			}

		}

		const extensionDef = nodeDef.extensions[ this.name ];
		const attributesDef = extensionDef.attributes;

		// @TODO: Can we support InstancedMesh + SkinnedMesh?

		const pending = [];
		const attributes = {};

		for ( const key in attributesDef ) {

			pending.push( this.parser.getDependency( 'accessor', attributesDef[ key ] ).then( accessor => {

				attributes[ key ] = accessor;
				return attributes[ key ];

			} ) );

		}

		if ( pending.length < 1 ) {

			return null;

		}

		pending.push( this.parser.createNodeMesh( nodeIndex ) );

		return Promise.all( pending ).then( results => {

			const nodeObject = results.pop();
			const meshes = nodeObject.isGroup ? nodeObject.children : [ nodeObject ];
			const count = results[ 0 ].count; // All attribute counts should be same
			const instancedMeshes = [];

			for ( const mesh of meshes ) {

				// Temporal variables
				const m = new external_three_.Matrix4();
				const p = new external_three_.Vector3();
				const q = new external_three_.Quaternion();
				const s = new external_three_.Vector3( 1, 1, 1 );

				const instancedMesh = new external_three_.InstancedMesh( mesh.geometry, mesh.material, count );

				for ( let i = 0; i < count; i ++ ) {

					if ( attributes.TRANSLATION ) {

						p.fromBufferAttribute( attributes.TRANSLATION, i );

					}

					if ( attributes.ROTATION ) {

						q.fromBufferAttribute( attributes.ROTATION, i );

					}

					if ( attributes.SCALE ) {

						s.fromBufferAttribute( attributes.SCALE, i );

					}

					instancedMesh.setMatrixAt( i, m.compose( p, q, s ) );

				}

				// Add instance attributes to the geometry, excluding TRS.
				for ( const attributeName in attributes ) {

					if ( attributeName === '_COLOR_0' ) {

						const attr = attributes[ attributeName ];
						instancedMesh.instanceColor = new external_three_.InstancedBufferAttribute( attr.array, attr.itemSize, attr.normalized );

					} else if ( attributeName !== 'TRANSLATION' &&
						 attributeName !== 'ROTATION' &&
						 attributeName !== 'SCALE' ) {

						mesh.geometry.setAttribute( attributeName, attributes[ attributeName ] );

					}

				}

				// Just in case
				external_three_.Object3D.prototype.copy.call( instancedMesh, mesh );

				this.parser.assignFinalMaterial( instancedMesh );

				instancedMeshes.push( instancedMesh );

			}

			if ( nodeObject.isGroup ) {

				nodeObject.clear();

				nodeObject.add( ... instancedMeshes );

				return nodeObject;

			}

			return instancedMeshes[ 0 ];

		} );

	}

}

/* BINARY EXTENSION */
const BINARY_EXTENSION_HEADER_MAGIC = 'glTF';
const BINARY_EXTENSION_HEADER_LENGTH = 12;
const BINARY_EXTENSION_CHUNK_TYPES = { JSON: 0x4E4F534A, BIN: 0x004E4942 };

class GLTFBinaryExtension {

	constructor( data ) {

		this.name = EXTENSIONS.KHR_BINARY_GLTF;
		this.content = null;
		this.body = null;

		const headerView = new DataView( data, 0, BINARY_EXTENSION_HEADER_LENGTH );
		const textDecoder = new TextDecoder();

		this.header = {
			magic: textDecoder.decode( new Uint8Array( data.slice( 0, 4 ) ) ),
			version: headerView.getUint32( 4, true ),
			length: headerView.getUint32( 8, true )
		};

		if ( this.header.magic !== BINARY_EXTENSION_HEADER_MAGIC ) {

			throw new Error( 'THREE.GLTFLoader: Unsupported glTF-Binary header.' );

		} else if ( this.header.version < 2.0 ) {

			throw new Error( 'THREE.GLTFLoader: Legacy binary file detected.' );

		}

		const chunkContentsLength = this.header.length - BINARY_EXTENSION_HEADER_LENGTH;
		const chunkView = new DataView( data, BINARY_EXTENSION_HEADER_LENGTH );
		let chunkIndex = 0;

		while ( chunkIndex < chunkContentsLength ) {

			const chunkLength = chunkView.getUint32( chunkIndex, true );
			chunkIndex += 4;

			const chunkType = chunkView.getUint32( chunkIndex, true );
			chunkIndex += 4;

			if ( chunkType === BINARY_EXTENSION_CHUNK_TYPES.JSON ) {

				const contentArray = new Uint8Array( data, BINARY_EXTENSION_HEADER_LENGTH + chunkIndex, chunkLength );
				this.content = textDecoder.decode( contentArray );

			} else if ( chunkType === BINARY_EXTENSION_CHUNK_TYPES.BIN ) {

				const byteOffset = BINARY_EXTENSION_HEADER_LENGTH + chunkIndex;
				this.body = data.slice( byteOffset, byteOffset + chunkLength );

			}

			// Clients must ignore chunks with unknown types.

			chunkIndex += chunkLength;

		}

		if ( this.content === null ) {

			throw new Error( 'THREE.GLTFLoader: JSON content not found.' );

		}

	}

}

/**
 * DRACO Mesh Compression Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_draco_mesh_compression
 */
class GLTFDracoMeshCompressionExtension {

	constructor( json, dracoLoader ) {

		if ( ! dracoLoader ) {

			throw new Error( 'THREE.GLTFLoader: No DRACOLoader instance provided.' );

		}

		this.name = EXTENSIONS.KHR_DRACO_MESH_COMPRESSION;
		this.json = json;
		this.dracoLoader = dracoLoader;
		this.dracoLoader.preload();

	}

	decodePrimitive( primitive, parser ) {

		const json = this.json;
		const dracoLoader = this.dracoLoader;
		const bufferViewIndex = primitive.extensions[ this.name ].bufferView;
		const gltfAttributeMap = primitive.extensions[ this.name ].attributes;
		const threeAttributeMap = {};
		const attributeNormalizedMap = {};
		const attributeTypeMap = {};

		for ( const attributeName in gltfAttributeMap ) {

			const threeAttributeName = ATTRIBUTES[ attributeName ] || attributeName.toLowerCase();

			threeAttributeMap[ threeAttributeName ] = gltfAttributeMap[ attributeName ];

		}

		for ( const attributeName in primitive.attributes ) {

			const threeAttributeName = ATTRIBUTES[ attributeName ] || attributeName.toLowerCase();

			if ( gltfAttributeMap[ attributeName ] !== undefined ) {

				const accessorDef = json.accessors[ primitive.attributes[ attributeName ] ];
				const componentType = WEBGL_COMPONENT_TYPES[ accessorDef.componentType ];

				attributeTypeMap[ threeAttributeName ] = componentType.name;
				attributeNormalizedMap[ threeAttributeName ] = accessorDef.normalized === true;

			}

		}

		return parser.getDependency( 'bufferView', bufferViewIndex ).then( function ( bufferView ) {

			return new Promise( function ( resolve, reject ) {

				dracoLoader.decodeDracoFile( bufferView, function ( geometry ) {

					for ( const attributeName in geometry.attributes ) {

						const attribute = geometry.attributes[ attributeName ];
						const normalized = attributeNormalizedMap[ attributeName ];

						if ( normalized !== undefined ) attribute.normalized = normalized;

					}

					resolve( geometry );

				}, threeAttributeMap, attributeTypeMap, external_three_.LinearSRGBColorSpace, reject );

			} );

		} );

	}

}

/**
 * Texture Transform Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_texture_transform
 */
class GLTFTextureTransformExtension {

	constructor() {

		this.name = EXTENSIONS.KHR_TEXTURE_TRANSFORM;

	}

	extendTexture( texture, transform ) {

		if ( ( transform.texCoord === undefined || transform.texCoord === texture.channel )
			&& transform.offset === undefined
			&& transform.rotation === undefined
			&& transform.scale === undefined ) {

			// See https://github.com/mrdoob/three.js/issues/21819.
			return texture;

		}

		texture = texture.clone();

		if ( transform.texCoord !== undefined ) {

			texture.channel = transform.texCoord;

		}

		if ( transform.offset !== undefined ) {

			texture.offset.fromArray( transform.offset );

		}

		if ( transform.rotation !== undefined ) {

			texture.rotation = transform.rotation;

		}

		if ( transform.scale !== undefined ) {

			texture.repeat.fromArray( transform.scale );

		}

		texture.needsUpdate = true;

		return texture;

	}

}

/**
 * Mesh Quantization Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_mesh_quantization
 */
class GLTFMeshQuantizationExtension {

	constructor() {

		this.name = EXTENSIONS.KHR_MESH_QUANTIZATION;

	}

}

/*********************************/
/********** INTERPOLATION ********/
/*********************************/

// Spline Interpolation
// Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#appendix-c-spline-interpolation
class GLTFCubicSplineInterpolant extends external_three_.Interpolant {

	constructor( parameterPositions, sampleValues, sampleSize, resultBuffer ) {

		super( parameterPositions, sampleValues, sampleSize, resultBuffer );

	}

	copySampleValue_( index ) {

		// Copies a sample value to the result buffer. See description of glTF
		// CUBICSPLINE values layout in interpolate_() function below.

		const result = this.resultBuffer,
			values = this.sampleValues,
			valueSize = this.valueSize,
			offset = index * valueSize * 3 + valueSize;

		for ( let i = 0; i !== valueSize; i ++ ) {

			result[ i ] = values[ offset + i ];

		}

		return result;

	}

	interpolate_( i1, t0, t, t1 ) {

		const result = this.resultBuffer;
		const values = this.sampleValues;
		const stride = this.valueSize;

		const stride2 = stride * 2;
		const stride3 = stride * 3;

		const td = t1 - t0;

		const p = ( t - t0 ) / td;
		const pp = p * p;
		const ppp = pp * p;

		const offset1 = i1 * stride3;
		const offset0 = offset1 - stride3;

		const s2 = - 2 * ppp + 3 * pp;
		const s3 = ppp - pp;
		const s0 = 1 - s2;
		const s1 = s3 - pp + p;

		// Layout of keyframe output values for CUBICSPLINE animations:
		//   [ inTangent_1, splineVertex_1, outTangent_1, inTangent_2, splineVertex_2, ... ]
		for ( let i = 0; i !== stride; i ++ ) {

			const p0 = values[ offset0 + i + stride ]; // splineVertex_k
			const m0 = values[ offset0 + i + stride2 ] * td; // outTangent_k * (t_k+1 - t_k)
			const p1 = values[ offset1 + i + stride ]; // splineVertex_k+1
			const m1 = values[ offset1 + i ] * td; // inTangent_k+1 * (t_k+1 - t_k)

			result[ i ] = s0 * p0 + s1 * m0 + s2 * p1 + s3 * m1;

		}

		return result;

	}

}

const _q = new external_three_.Quaternion();

class GLTFCubicSplineQuaternionInterpolant extends GLTFCubicSplineInterpolant {

	interpolate_( i1, t0, t, t1 ) {

		const result = super.interpolate_( i1, t0, t, t1 );

		_q.fromArray( result ).normalize().toArray( result );

		return result;

	}

}


/*********************************/
/********** INTERNALS ************/
/*********************************/

/* CONSTANTS */

const WEBGL_CONSTANTS = {
	FLOAT: 5126,
	//FLOAT_MAT2: 35674,
	FLOAT_MAT3: 35675,
	FLOAT_MAT4: 35676,
	FLOAT_VEC2: 35664,
	FLOAT_VEC3: 35665,
	FLOAT_VEC4: 35666,
	LINEAR: 9729,
	REPEAT: 10497,
	SAMPLER_2D: 35678,
	POINTS: 0,
	LINES: 1,
	LINE_LOOP: 2,
	LINE_STRIP: 3,
	TRIANGLES: 4,
	TRIANGLE_STRIP: 5,
	TRIANGLE_FAN: 6,
	UNSIGNED_BYTE: 5121,
	UNSIGNED_SHORT: 5123
};

const WEBGL_COMPONENT_TYPES = {
	5120: Int8Array,
	5121: Uint8Array,
	5122: Int16Array,
	5123: Uint16Array,
	5125: Uint32Array,
	5126: Float32Array
};

const WEBGL_FILTERS = {
	9728: external_three_.NearestFilter,
	9729: external_three_.LinearFilter,
	9984: external_three_.NearestMipmapNearestFilter,
	9985: external_three_.LinearMipmapNearestFilter,
	9986: external_three_.NearestMipmapLinearFilter,
	9987: external_three_.LinearMipmapLinearFilter
};

const WEBGL_WRAPPINGS = {
	33071: external_three_.ClampToEdgeWrapping,
	33648: external_three_.MirroredRepeatWrapping,
	10497: external_three_.RepeatWrapping
};

const WEBGL_TYPE_SIZES = {
	'SCALAR': 1,
	'VEC2': 2,
	'VEC3': 3,
	'VEC4': 4,
	'MAT2': 4,
	'MAT3': 9,
	'MAT4': 16
};

const ATTRIBUTES = {
	POSITION: 'position',
	NORMAL: 'normal',
	TANGENT: 'tangent',
	TEXCOORD_0: 'uv',
	TEXCOORD_1: 'uv1',
	TEXCOORD_2: 'uv2',
	TEXCOORD_3: 'uv3',
	COLOR_0: 'color',
	WEIGHTS_0: 'skinWeight',
	JOINTS_0: 'skinIndex',
};

const PATH_PROPERTIES = {
	scale: 'scale',
	translation: 'position',
	rotation: 'quaternion',
	weights: 'morphTargetInfluences'
};

const INTERPOLATION = {
	CUBICSPLINE: undefined, // We use a custom interpolant (GLTFCubicSplineInterpolation) for CUBICSPLINE tracks. Each
		                        // keyframe track will be initialized with a default interpolation type, then modified.
	LINEAR: external_three_.InterpolateLinear,
	STEP: external_three_.InterpolateDiscrete
};

const ALPHA_MODES = {
	OPAQUE: 'OPAQUE',
	MASK: 'MASK',
	BLEND: 'BLEND'
};

/**
 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#default-material
 */
function createDefaultMaterial( cache ) {

	if ( cache[ 'DefaultMaterial' ] === undefined ) {

		cache[ 'DefaultMaterial' ] = new external_three_.MeshStandardMaterial( {
			color: 0xFFFFFF,
			emissive: 0x000000,
			metalness: 1,
			roughness: 1,
			transparent: false,
			depthTest: true,
			side: external_three_.FrontSide
		} );

	}

	return cache[ 'DefaultMaterial' ];

}

function addUnknownExtensionsToUserData( knownExtensions, object, objectDef ) {

	// Add unknown glTF extensions to an object's userData.

	for ( const name in objectDef.extensions ) {

		if ( knownExtensions[ name ] === undefined ) {

			object.userData.gltfExtensions = object.userData.gltfExtensions || {};
			object.userData.gltfExtensions[ name ] = objectDef.extensions[ name ];

		}

	}

}

/**
 * @param {Object3D|Material|BufferGeometry} object
 * @param {GLTF.definition} gltfDef
 */
function assignExtrasToUserData( object, gltfDef ) {

	if ( gltfDef.extras !== undefined ) {

		if ( typeof gltfDef.extras === 'object' ) {

			Object.assign( object.userData, gltfDef.extras );

		} else {

			console.warn( 'THREE.GLTFLoader: Ignoring primitive type .extras, ' + gltfDef.extras );

		}

	}

}

/**
 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#morph-targets
 *
 * @param {BufferGeometry} geometry
 * @param {Array<GLTF.Target>} targets
 * @param {GLTFParser} parser
 * @return {Promise<BufferGeometry>}
 */
function addMorphTargets( geometry, targets, parser ) {

	let hasMorphPosition = false;
	let hasMorphNormal = false;
	let hasMorphColor = false;

	for ( let i = 0, il = targets.length; i < il; i ++ ) {

		const target = targets[ i ];

		if ( target.POSITION !== undefined ) hasMorphPosition = true;
		if ( target.NORMAL !== undefined ) hasMorphNormal = true;
		if ( target.COLOR_0 !== undefined ) hasMorphColor = true;

		if ( hasMorphPosition && hasMorphNormal && hasMorphColor ) break;

	}

	if ( ! hasMorphPosition && ! hasMorphNormal && ! hasMorphColor ) return Promise.resolve( geometry );

	const pendingPositionAccessors = [];
	const pendingNormalAccessors = [];
	const pendingColorAccessors = [];

	for ( let i = 0, il = targets.length; i < il; i ++ ) {

		const target = targets[ i ];

		if ( hasMorphPosition ) {

			const pendingAccessor = target.POSITION !== undefined
				? parser.getDependency( 'accessor', target.POSITION )
				: geometry.attributes.position;

			pendingPositionAccessors.push( pendingAccessor );

		}

		if ( hasMorphNormal ) {

			const pendingAccessor = target.NORMAL !== undefined
				? parser.getDependency( 'accessor', target.NORMAL )
				: geometry.attributes.normal;

			pendingNormalAccessors.push( pendingAccessor );

		}

		if ( hasMorphColor ) {

			const pendingAccessor = target.COLOR_0 !== undefined
				? parser.getDependency( 'accessor', target.COLOR_0 )
				: geometry.attributes.color;

			pendingColorAccessors.push( pendingAccessor );

		}

	}

	return Promise.all( [
		Promise.all( pendingPositionAccessors ),
		Promise.all( pendingNormalAccessors ),
		Promise.all( pendingColorAccessors )
	] ).then( function ( accessors ) {

		const morphPositions = accessors[ 0 ];
		const morphNormals = accessors[ 1 ];
		const morphColors = accessors[ 2 ];

		if ( hasMorphPosition ) geometry.morphAttributes.position = morphPositions;
		if ( hasMorphNormal ) geometry.morphAttributes.normal = morphNormals;
		if ( hasMorphColor ) geometry.morphAttributes.color = morphColors;
		geometry.morphTargetsRelative = true;

		return geometry;

	} );

}

/**
 * @param {Mesh} mesh
 * @param {GLTF.Mesh} meshDef
 */
function updateMorphTargets( mesh, meshDef ) {

	mesh.updateMorphTargets();

	if ( meshDef.weights !== undefined ) {

		for ( let i = 0, il = meshDef.weights.length; i < il; i ++ ) {

			mesh.morphTargetInfluences[ i ] = meshDef.weights[ i ];

		}

	}

	// .extras has user-defined data, so check that .extras.targetNames is an array.
	if ( meshDef.extras && Array.isArray( meshDef.extras.targetNames ) ) {

		const targetNames = meshDef.extras.targetNames;

		if ( mesh.morphTargetInfluences.length === targetNames.length ) {

			mesh.morphTargetDictionary = {};

			for ( let i = 0, il = targetNames.length; i < il; i ++ ) {

				mesh.morphTargetDictionary[ targetNames[ i ] ] = i;

			}

		} else {

			console.warn( 'THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.' );

		}

	}

}

function createPrimitiveKey( primitiveDef ) {

	let geometryKey;

	const dracoExtension = primitiveDef.extensions && primitiveDef.extensions[ EXTENSIONS.KHR_DRACO_MESH_COMPRESSION ];

	if ( dracoExtension ) {

		geometryKey = 'draco:' + dracoExtension.bufferView
				+ ':' + dracoExtension.indices
				+ ':' + createAttributesKey( dracoExtension.attributes );

	} else {

		geometryKey = primitiveDef.indices + ':' + createAttributesKey( primitiveDef.attributes ) + ':' + primitiveDef.mode;

	}

	if ( primitiveDef.targets !== undefined ) {

		for ( let i = 0, il = primitiveDef.targets.length; i < il; i ++ ) {

			geometryKey += ':' + createAttributesKey( primitiveDef.targets[ i ] );

		}

	}

	return geometryKey;

}

function createAttributesKey( attributes ) {

	let attributesKey = '';

	const keys = Object.keys( attributes ).sort();

	for ( let i = 0, il = keys.length; i < il; i ++ ) {

		attributesKey += keys[ i ] + ':' + attributes[ keys[ i ] ] + ';';

	}

	return attributesKey;

}

function getNormalizedComponentScale( constructor ) {

	// Reference:
	// https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_mesh_quantization#encoding-quantized-data

	switch ( constructor ) {

		case Int8Array:
			return 1 / 127;

		case Uint8Array:
			return 1 / 255;

		case Int16Array:
			return 1 / 32767;

		case Uint16Array:
			return 1 / 65535;

		default:
			throw new Error( 'THREE.GLTFLoader: Unsupported normalized accessor component type.' );

	}

}

function getImageURIMimeType( uri ) {

	if ( uri.search( /\.jpe?g($|\?)/i ) > 0 || uri.search( /^data\:image\/jpeg/ ) === 0 ) return 'image/jpeg';
	if ( uri.search( /\.webp($|\?)/i ) > 0 || uri.search( /^data\:image\/webp/ ) === 0 ) return 'image/webp';

	return 'image/png';

}

const _identityMatrix = new external_three_.Matrix4();

/* GLTF PARSER */

class GLTFParser {

	constructor( json = {}, options = {} ) {

		this.json = json;
		this.extensions = {};
		this.plugins = {};
		this.options = options;

		// loader object cache
		this.cache = new GLTFRegistry();

		// associations between Three.js objects and glTF elements
		this.associations = new Map();

		// BufferGeometry caching
		this.primitiveCache = {};

		// Node cache
		this.nodeCache = {};

		// Object3D instance caches
		this.meshCache = { refs: {}, uses: {} };
		this.cameraCache = { refs: {}, uses: {} };
		this.lightCache = { refs: {}, uses: {} };

		this.sourceCache = {};
		this.textureCache = {};

		// Track node names, to ensure no duplicates
		this.nodeNamesUsed = {};

		// Use an ImageBitmapLoader if imageBitmaps are supported. Moves much of the
		// expensive work of uploading a texture to the GPU off the main thread.

		let isSafari = false;
		let isFirefox = false;
		let firefoxVersion = - 1;

		if ( typeof navigator !== 'undefined' ) {

			isSafari = /^((?!chrome|android).)*safari/i.test( navigator.userAgent ) === true;
			isFirefox = navigator.userAgent.indexOf( 'Firefox' ) > - 1;
			firefoxVersion = isFirefox ? navigator.userAgent.match( /Firefox\/([0-9]+)\./ )[ 1 ] : - 1;

		}

		if ( typeof createImageBitmap === 'undefined' || isSafari || ( isFirefox && firefoxVersion < 98 ) ) {

			this.textureLoader = new external_three_.TextureLoader( this.options.manager );

		} else {

			this.textureLoader = new external_three_.ImageBitmapLoader( this.options.manager );

		}

		this.textureLoader.setCrossOrigin( this.options.crossOrigin );
		this.textureLoader.setRequestHeader( this.options.requestHeader );

		this.fileLoader = new external_three_.FileLoader( this.options.manager );
		this.fileLoader.setResponseType( 'arraybuffer' );

		if ( this.options.crossOrigin === 'use-credentials' ) {

			this.fileLoader.setWithCredentials( true );

		}

	}

	setExtensions( extensions ) {

		this.extensions = extensions;

	}

	setPlugins( plugins ) {

		this.plugins = plugins;

	}

	parse( onLoad, onError ) {

		const parser = this;
		const json = this.json;
		const extensions = this.extensions;

		// Clear the loader cache
		this.cache.removeAll();
		this.nodeCache = {};

		// Mark the special nodes/meshes in json for efficient parse
		this._invokeAll( function ( ext ) {

			return ext._markDefs && ext._markDefs();

		} );

		Promise.all( this._invokeAll( function ( ext ) {

			return ext.beforeRoot && ext.beforeRoot();

		} ) ).then( function () {

			return Promise.all( [

				parser.getDependencies( 'scene' ),
				parser.getDependencies( 'animation' ),
				parser.getDependencies( 'camera' ),

			] );

		} ).then( function ( dependencies ) {

			const result = {
				scene: dependencies[ 0 ][ json.scene || 0 ],
				scenes: dependencies[ 0 ],
				animations: dependencies[ 1 ],
				cameras: dependencies[ 2 ],
				asset: json.asset,
				parser: parser,
				userData: {}
			};

			addUnknownExtensionsToUserData( extensions, result, json );

			assignExtrasToUserData( result, json );

			return Promise.all( parser._invokeAll( function ( ext ) {

				return ext.afterRoot && ext.afterRoot( result );

			} ) ).then( function () {

				for ( const scene of result.scenes ) {

					scene.updateMatrixWorld();

				}

				onLoad( result );

			} );

		} ).catch( onError );

	}

	/**
	 * Marks the special nodes/meshes in json for efficient parse.
	 */
	_markDefs() {

		const nodeDefs = this.json.nodes || [];
		const skinDefs = this.json.skins || [];
		const meshDefs = this.json.meshes || [];

		// Nothing in the node definition indicates whether it is a Bone or an
		// Object3D. Use the skins' joint references to mark bones.
		for ( let skinIndex = 0, skinLength = skinDefs.length; skinIndex < skinLength; skinIndex ++ ) {

			const joints = skinDefs[ skinIndex ].joints;

			for ( let i = 0, il = joints.length; i < il; i ++ ) {

				nodeDefs[ joints[ i ] ].isBone = true;

			}

		}

		// Iterate over all nodes, marking references to shared resources,
		// as well as skeleton joints.
		for ( let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex ++ ) {

			const nodeDef = nodeDefs[ nodeIndex ];

			if ( nodeDef.mesh !== undefined ) {

				this._addNodeRef( this.meshCache, nodeDef.mesh );

				// Nothing in the mesh definition indicates whether it is
				// a SkinnedMesh or Mesh. Use the node's mesh reference
				// to mark SkinnedMesh if node has skin.
				if ( nodeDef.skin !== undefined ) {

					meshDefs[ nodeDef.mesh ].isSkinnedMesh = true;

				}

			}

			if ( nodeDef.camera !== undefined ) {

				this._addNodeRef( this.cameraCache, nodeDef.camera );

			}

		}

	}

	/**
	 * Counts references to shared node / Object3D resources. These resources
	 * can be reused, or "instantiated", at multiple nodes in the scene
	 * hierarchy. Mesh, Camera, and Light instances are instantiated and must
	 * be marked. Non-scenegraph resources (like Materials, Geometries, and
	 * Textures) can be reused directly and are not marked here.
	 *
	 * Example: CesiumMilkTruck sample model reuses "Wheel" meshes.
	 */
	_addNodeRef( cache, index ) {

		if ( index === undefined ) return;

		if ( cache.refs[ index ] === undefined ) {

			cache.refs[ index ] = cache.uses[ index ] = 0;

		}

		cache.refs[ index ] ++;

	}

	/** Returns a reference to a shared resource, cloning it if necessary. */
	_getNodeRef( cache, index, object ) {

		if ( cache.refs[ index ] <= 1 ) return object;

		const ref = object.clone();

		// Propagates mappings to the cloned object, prevents mappings on the
		// original object from being lost.
		const updateMappings = ( original, clone ) => {

			const mappings = this.associations.get( original );
			if ( mappings != null ) {

				this.associations.set( clone, mappings );

			}

			for ( const [ i, child ] of original.children.entries() ) {

				updateMappings( child, clone.children[ i ] );

			}

		};

		updateMappings( object, ref );

		ref.name += '_instance_' + ( cache.uses[ index ] ++ );

		return ref;

	}

	_invokeOne( func ) {

		const extensions = Object.values( this.plugins );
		extensions.push( this );

		for ( let i = 0; i < extensions.length; i ++ ) {

			const result = func( extensions[ i ] );

			if ( result ) return result;

		}

		return null;

	}

	_invokeAll( func ) {

		const extensions = Object.values( this.plugins );
		extensions.unshift( this );

		const pending = [];

		for ( let i = 0; i < extensions.length; i ++ ) {

			const result = func( extensions[ i ] );

			if ( result ) pending.push( result );

		}

		return pending;

	}

	/**
	 * Requests the specified dependency asynchronously, with caching.
	 * @param {string} type
	 * @param {number} index
	 * @return {Promise<Object3D|Material|THREE.Texture|AnimationClip|ArrayBuffer|Object>}
	 */
	getDependency( type, index ) {

		const cacheKey = type + ':' + index;
		let dependency = this.cache.get( cacheKey );

		if ( ! dependency ) {

			switch ( type ) {

				case 'scene':
					dependency = this.loadScene( index );
					break;

				case 'node':
					dependency = this._invokeOne( function ( ext ) {

						return ext.loadNode && ext.loadNode( index );

					} );
					break;

				case 'mesh':
					dependency = this._invokeOne( function ( ext ) {

						return ext.loadMesh && ext.loadMesh( index );

					} );
					break;

				case 'accessor':
					dependency = this.loadAccessor( index );
					break;

				case 'bufferView':
					dependency = this._invokeOne( function ( ext ) {

						return ext.loadBufferView && ext.loadBufferView( index );

					} );
					break;

				case 'buffer':
					dependency = this.loadBuffer( index );
					break;

				case 'material':
					dependency = this._invokeOne( function ( ext ) {

						return ext.loadMaterial && ext.loadMaterial( index );

					} );
					break;

				case 'texture':
					dependency = this._invokeOne( function ( ext ) {

						return ext.loadTexture && ext.loadTexture( index );

					} );
					break;

				case 'skin':
					dependency = this.loadSkin( index );
					break;

				case 'animation':
					dependency = this._invokeOne( function ( ext ) {

						return ext.loadAnimation && ext.loadAnimation( index );

					} );
					break;

				case 'camera':
					dependency = this.loadCamera( index );
					break;

				default:
					dependency = this._invokeOne( function ( ext ) {

						return ext != this && ext.getDependency && ext.getDependency( type, index );

					} );

					if ( ! dependency ) {

						throw new Error( 'Unknown type: ' + type );

					}

					break;

			}

			this.cache.add( cacheKey, dependency );

		}

		return dependency;

	}

	/**
	 * Requests all dependencies of the specified type asynchronously, with caching.
	 * @param {string} type
	 * @return {Promise<Array<Object>>}
	 */
	getDependencies( type ) {

		let dependencies = this.cache.get( type );

		if ( ! dependencies ) {

			const parser = this;
			const defs = this.json[ type + ( type === 'mesh' ? 'es' : 's' ) ] || [];

			dependencies = Promise.all( defs.map( function ( def, index ) {

				return parser.getDependency( type, index );

			} ) );

			this.cache.add( type, dependencies );

		}

		return dependencies;

	}

	/**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
	 * @param {number} bufferIndex
	 * @return {Promise<ArrayBuffer>}
	 */
	loadBuffer( bufferIndex ) {

		const bufferDef = this.json.buffers[ bufferIndex ];
		const loader = this.fileLoader;

		if ( bufferDef.type && bufferDef.type !== 'arraybuffer' ) {

			throw new Error( 'THREE.GLTFLoader: ' + bufferDef.type + ' buffer type is not supported.' );

		}

		// If present, GLB container is required to be the first buffer.
		if ( bufferDef.uri === undefined && bufferIndex === 0 ) {

			return Promise.resolve( this.extensions[ EXTENSIONS.KHR_BINARY_GLTF ].body );

		}

		const options = this.options;

		return new Promise( function ( resolve, reject ) {

			loader.load( external_three_.LoaderUtils.resolveURL( bufferDef.uri, options.path ), resolve, undefined, function () {

				reject( new Error( 'THREE.GLTFLoader: Failed to load buffer "' + bufferDef.uri + '".' ) );

			} );

		} );

	}

	/**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
	 * @param {number} bufferViewIndex
	 * @return {Promise<ArrayBuffer>}
	 */
	loadBufferView( bufferViewIndex ) {

		const bufferViewDef = this.json.bufferViews[ bufferViewIndex ];

		return this.getDependency( 'buffer', bufferViewDef.buffer ).then( function ( buffer ) {

			const byteLength = bufferViewDef.byteLength || 0;
			const byteOffset = bufferViewDef.byteOffset || 0;
			return buffer.slice( byteOffset, byteOffset + byteLength );

		} );

	}

	/**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#accessors
	 * @param {number} accessorIndex
	 * @return {Promise<BufferAttribute|InterleavedBufferAttribute>}
	 */
	loadAccessor( accessorIndex ) {

		const parser = this;
		const json = this.json;

		const accessorDef = this.json.accessors[ accessorIndex ];

		if ( accessorDef.bufferView === undefined && accessorDef.sparse === undefined ) {

			const itemSize = WEBGL_TYPE_SIZES[ accessorDef.type ];
			const TypedArray = WEBGL_COMPONENT_TYPES[ accessorDef.componentType ];
			const normalized = accessorDef.normalized === true;

			const array = new TypedArray( accessorDef.count * itemSize );
			return Promise.resolve( new external_three_.BufferAttribute( array, itemSize, normalized ) );

		}

		const pendingBufferViews = [];

		if ( accessorDef.bufferView !== undefined ) {

			pendingBufferViews.push( this.getDependency( 'bufferView', accessorDef.bufferView ) );

		} else {

			pendingBufferViews.push( null );

		}

		if ( accessorDef.sparse !== undefined ) {

			pendingBufferViews.push( this.getDependency( 'bufferView', accessorDef.sparse.indices.bufferView ) );
			pendingBufferViews.push( this.getDependency( 'bufferView', accessorDef.sparse.values.bufferView ) );

		}

		return Promise.all( pendingBufferViews ).then( function ( bufferViews ) {

			const bufferView = bufferViews[ 0 ];

			const itemSize = WEBGL_TYPE_SIZES[ accessorDef.type ];
			const TypedArray = WEBGL_COMPONENT_TYPES[ accessorDef.componentType ];

			// For VEC3: itemSize is 3, elementBytes is 4, itemBytes is 12.
			const elementBytes = TypedArray.BYTES_PER_ELEMENT;
			const itemBytes = elementBytes * itemSize;
			const byteOffset = accessorDef.byteOffset || 0;
			const byteStride = accessorDef.bufferView !== undefined ? json.bufferViews[ accessorDef.bufferView ].byteStride : undefined;
			const normalized = accessorDef.normalized === true;
			let array, bufferAttribute;

			// The buffer is not interleaved if the stride is the item size in bytes.
			if ( byteStride && byteStride !== itemBytes ) {

				// Each "slice" of the buffer, as defined by 'count' elements of 'byteStride' bytes, gets its own InterleavedBuffer
				// This makes sure that IBA.count reflects accessor.count properly
				const ibSlice = Math.floor( byteOffset / byteStride );
				const ibCacheKey = 'InterleavedBuffer:' + accessorDef.bufferView + ':' + accessorDef.componentType + ':' + ibSlice + ':' + accessorDef.count;
				let ib = parser.cache.get( ibCacheKey );

				if ( ! ib ) {

					array = new TypedArray( bufferView, ibSlice * byteStride, accessorDef.count * byteStride / elementBytes );

					// Integer parameters to IB/IBA are in array elements, not bytes.
					ib = new external_three_.InterleavedBuffer( array, byteStride / elementBytes );

					parser.cache.add( ibCacheKey, ib );

				}

				bufferAttribute = new external_three_.InterleavedBufferAttribute( ib, itemSize, ( byteOffset % byteStride ) / elementBytes, normalized );

			} else {

				if ( bufferView === null ) {

					array = new TypedArray( accessorDef.count * itemSize );

				} else {

					array = new TypedArray( bufferView, byteOffset, accessorDef.count * itemSize );

				}

				bufferAttribute = new external_three_.BufferAttribute( array, itemSize, normalized );

			}

			// https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#sparse-accessors
			if ( accessorDef.sparse !== undefined ) {

				const itemSizeIndices = WEBGL_TYPE_SIZES.SCALAR;
				const TypedArrayIndices = WEBGL_COMPONENT_TYPES[ accessorDef.sparse.indices.componentType ];

				const byteOffsetIndices = accessorDef.sparse.indices.byteOffset || 0;
				const byteOffsetValues = accessorDef.sparse.values.byteOffset || 0;

				const sparseIndices = new TypedArrayIndices( bufferViews[ 1 ], byteOffsetIndices, accessorDef.sparse.count * itemSizeIndices );
				const sparseValues = new TypedArray( bufferViews[ 2 ], byteOffsetValues, accessorDef.sparse.count * itemSize );

				if ( bufferView !== null ) {

					// Avoid modifying the original ArrayBuffer, if the bufferView wasn't initialized with zeroes.
					bufferAttribute = new external_three_.BufferAttribute( bufferAttribute.array.slice(), bufferAttribute.itemSize, bufferAttribute.normalized );

				}

				for ( let i = 0, il = sparseIndices.length; i < il; i ++ ) {

					const index = sparseIndices[ i ];

					bufferAttribute.setX( index, sparseValues[ i * itemSize ] );
					if ( itemSize >= 2 ) bufferAttribute.setY( index, sparseValues[ i * itemSize + 1 ] );
					if ( itemSize >= 3 ) bufferAttribute.setZ( index, sparseValues[ i * itemSize + 2 ] );
					if ( itemSize >= 4 ) bufferAttribute.setW( index, sparseValues[ i * itemSize + 3 ] );
					if ( itemSize >= 5 ) throw new Error( 'THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.' );

				}

			}

			return bufferAttribute;

		} );

	}

	/**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#textures
	 * @param {number} textureIndex
	 * @return {Promise<THREE.Texture|null>}
	 */
	loadTexture( textureIndex ) {

		const json = this.json;
		const options = this.options;
		const textureDef = json.textures[ textureIndex ];
		const sourceIndex = textureDef.source;
		const sourceDef = json.images[ sourceIndex ];

		let loader = this.textureLoader;

		if ( sourceDef.uri ) {

			const handler = options.manager.getHandler( sourceDef.uri );
			if ( handler !== null ) loader = handler;

		}

		return this.loadTextureImage( textureIndex, sourceIndex, loader );

	}

	loadTextureImage( textureIndex, sourceIndex, loader ) {

		const parser = this;
		const json = this.json;

		const textureDef = json.textures[ textureIndex ];
		const sourceDef = json.images[ sourceIndex ];

		const cacheKey = ( sourceDef.uri || sourceDef.bufferView ) + ':' + textureDef.sampler;

		if ( this.textureCache[ cacheKey ] ) {

			// See https://github.com/mrdoob/three.js/issues/21559.
			return this.textureCache[ cacheKey ];

		}

		const promise = this.loadImageSource( sourceIndex, loader ).then( function ( texture ) {

			texture.flipY = false;

			texture.name = textureDef.name || sourceDef.name || '';

			if ( texture.name === '' && typeof sourceDef.uri === 'string' && sourceDef.uri.startsWith( 'data:image/' ) === false ) {

				texture.name = sourceDef.uri;

			}

			const samplers = json.samplers || {};
			const sampler = samplers[ textureDef.sampler ] || {};

			texture.magFilter = WEBGL_FILTERS[ sampler.magFilter ] || external_three_.LinearFilter;
			texture.minFilter = WEBGL_FILTERS[ sampler.minFilter ] || external_three_.LinearMipmapLinearFilter;
			texture.wrapS = WEBGL_WRAPPINGS[ sampler.wrapS ] || external_three_.RepeatWrapping;
			texture.wrapT = WEBGL_WRAPPINGS[ sampler.wrapT ] || external_three_.RepeatWrapping;

			parser.associations.set( texture, { textures: textureIndex } );

			return texture;

		} ).catch( function () {

			return null;

		} );

		this.textureCache[ cacheKey ] = promise;

		return promise;

	}

	loadImageSource( sourceIndex, loader ) {

		const parser = this;
		const json = this.json;
		const options = this.options;

		if ( this.sourceCache[ sourceIndex ] !== undefined ) {

			return this.sourceCache[ sourceIndex ].then( ( texture ) => texture.clone() );

		}

		const sourceDef = json.images[ sourceIndex ];

		const URL = self.URL || self.webkitURL;

		let sourceURI = sourceDef.uri || '';
		let isObjectURL = false;

		if ( sourceDef.bufferView !== undefined ) {

			// Load binary image data from bufferView, if provided.

			sourceURI = parser.getDependency( 'bufferView', sourceDef.bufferView ).then( function ( bufferView ) {

				isObjectURL = true;
				const blob = new Blob( [ bufferView ], { type: sourceDef.mimeType } );
				sourceURI = URL.createObjectURL( blob );
				return sourceURI;

			} );

		} else if ( sourceDef.uri === undefined ) {

			throw new Error( 'THREE.GLTFLoader: Image ' + sourceIndex + ' is missing URI and bufferView' );

		}

		const promise = Promise.resolve( sourceURI ).then( function ( sourceURI ) {

			return new Promise( function ( resolve, reject ) {

				let onLoad = resolve;

				if ( loader.isImageBitmapLoader === true ) {

					onLoad = function ( imageBitmap ) {

						const texture = new external_three_.Texture( imageBitmap );
						texture.needsUpdate = true;

						resolve( texture );

					};

				}

				loader.load( external_three_.LoaderUtils.resolveURL( sourceURI, options.path ), onLoad, undefined, reject );

			} );

		} ).then( function ( texture ) {

			// Clean up resources and configure Texture.

			if ( isObjectURL === true ) {

				URL.revokeObjectURL( sourceURI );

			}

			texture.userData.mimeType = sourceDef.mimeType || getImageURIMimeType( sourceDef.uri );

			return texture;

		} ).catch( function ( error ) {

			console.error( 'THREE.GLTFLoader: Couldn\'t load texture', sourceURI );
			throw error;

		} );

		this.sourceCache[ sourceIndex ] = promise;
		return promise;

	}

	/**
	 * Asynchronously assigns a texture to the given material parameters.
	 * @param {Object} materialParams
	 * @param {string} mapName
	 * @param {Object} mapDef
	 * @return {Promise<Texture>}
	 */
	assignTexture( materialParams, mapName, mapDef, colorSpace ) {

		const parser = this;

		return this.getDependency( 'texture', mapDef.index ).then( function ( texture ) {

			if ( ! texture ) return null;

			if ( mapDef.texCoord !== undefined && mapDef.texCoord > 0 ) {

				texture = texture.clone();
				texture.channel = mapDef.texCoord;

			}

			if ( parser.extensions[ EXTENSIONS.KHR_TEXTURE_TRANSFORM ] ) {

				const transform = mapDef.extensions !== undefined ? mapDef.extensions[ EXTENSIONS.KHR_TEXTURE_TRANSFORM ] : undefined;

				if ( transform ) {

					const gltfReference = parser.associations.get( texture );
					texture = parser.extensions[ EXTENSIONS.KHR_TEXTURE_TRANSFORM ].extendTexture( texture, transform );
					parser.associations.set( texture, gltfReference );

				}

			}

			if ( colorSpace !== undefined ) {

				texture.colorSpace = colorSpace;

			}

			materialParams[ mapName ] = texture;

			return texture;

		} );

	}

	/**
	 * Assigns final material to a Mesh, Line, or Points instance. The instance
	 * already has a material (generated from the glTF material options alone)
	 * but reuse of the same glTF material may require multiple threejs materials
	 * to accommodate different primitive types, defines, etc. New materials will
	 * be created if necessary, and reused from a cache.
	 * @param  {Object3D} mesh Mesh, Line, or Points instance.
	 */
	assignFinalMaterial( mesh ) {

		const geometry = mesh.geometry;
		let material = mesh.material;

		const useDerivativeTangents = geometry.attributes.tangent === undefined;
		const useVertexColors = geometry.attributes.color !== undefined;
		const useFlatShading = geometry.attributes.normal === undefined;

		if ( mesh.isPoints ) {

			const cacheKey = 'PointsMaterial:' + material.uuid;

			let pointsMaterial = this.cache.get( cacheKey );

			if ( ! pointsMaterial ) {

				pointsMaterial = new external_three_.PointsMaterial();
				external_three_.Material.prototype.copy.call( pointsMaterial, material );
				pointsMaterial.color.copy( material.color );
				pointsMaterial.map = material.map;
				pointsMaterial.sizeAttenuation = false; // glTF spec says points should be 1px

				this.cache.add( cacheKey, pointsMaterial );

			}

			material = pointsMaterial;

		} else if ( mesh.isLine ) {

			const cacheKey = 'LineBasicMaterial:' + material.uuid;

			let lineMaterial = this.cache.get( cacheKey );

			if ( ! lineMaterial ) {

				lineMaterial = new external_three_.LineBasicMaterial();
				external_three_.Material.prototype.copy.call( lineMaterial, material );
				lineMaterial.color.copy( material.color );
				lineMaterial.map = material.map;

				this.cache.add( cacheKey, lineMaterial );

			}

			material = lineMaterial;

		}

		// Clone the material if it will be modified
		if ( useDerivativeTangents || useVertexColors || useFlatShading ) {

			let cacheKey = 'ClonedMaterial:' + material.uuid + ':';

			if ( useDerivativeTangents ) cacheKey += 'derivative-tangents:';
			if ( useVertexColors ) cacheKey += 'vertex-colors:';
			if ( useFlatShading ) cacheKey += 'flat-shading:';

			let cachedMaterial = this.cache.get( cacheKey );

			if ( ! cachedMaterial ) {

				cachedMaterial = material.clone();

				if ( useVertexColors ) cachedMaterial.vertexColors = true;
				if ( useFlatShading ) cachedMaterial.flatShading = true;

				if ( useDerivativeTangents ) {

					// https://github.com/mrdoob/three.js/issues/11438#issuecomment-507003995
					if ( cachedMaterial.normalScale ) cachedMaterial.normalScale.y *= - 1;
					if ( cachedMaterial.clearcoatNormalScale ) cachedMaterial.clearcoatNormalScale.y *= - 1;

				}

				this.cache.add( cacheKey, cachedMaterial );

				this.associations.set( cachedMaterial, this.associations.get( material ) );

			}

			material = cachedMaterial;

		}

		mesh.material = material;

	}

	getMaterialType( /* materialIndex */ ) {

		return external_three_.MeshStandardMaterial;

	}

	/**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#materials
	 * @param {number} materialIndex
	 * @return {Promise<Material>}
	 */
	loadMaterial( materialIndex ) {

		const parser = this;
		const json = this.json;
		const extensions = this.extensions;
		const materialDef = json.materials[ materialIndex ];

		let materialType;
		const materialParams = {};
		const materialExtensions = materialDef.extensions || {};

		const pending = [];

		if ( materialExtensions[ EXTENSIONS.KHR_MATERIALS_UNLIT ] ) {

			const kmuExtension = extensions[ EXTENSIONS.KHR_MATERIALS_UNLIT ];
			materialType = kmuExtension.getMaterialType();
			pending.push( kmuExtension.extendParams( materialParams, materialDef, parser ) );

		} else {

			// Specification:
			// https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#metallic-roughness-material

			const metallicRoughness = materialDef.pbrMetallicRoughness || {};

			materialParams.color = new external_three_.Color( 1.0, 1.0, 1.0 );
			materialParams.opacity = 1.0;

			if ( Array.isArray( metallicRoughness.baseColorFactor ) ) {

				const array = metallicRoughness.baseColorFactor;

				materialParams.color.setRGB( array[ 0 ], array[ 1 ], array[ 2 ], external_three_.LinearSRGBColorSpace );
				materialParams.opacity = array[ 3 ];

			}

			if ( metallicRoughness.baseColorTexture !== undefined ) {

				pending.push( parser.assignTexture( materialParams, 'map', metallicRoughness.baseColorTexture, external_three_.SRGBColorSpace ) );

			}

			materialParams.metalness = metallicRoughness.metallicFactor !== undefined ? metallicRoughness.metallicFactor : 1.0;
			materialParams.roughness = metallicRoughness.roughnessFactor !== undefined ? metallicRoughness.roughnessFactor : 1.0;

			if ( metallicRoughness.metallicRoughnessTexture !== undefined ) {

				pending.push( parser.assignTexture( materialParams, 'metalnessMap', metallicRoughness.metallicRoughnessTexture ) );
				pending.push( parser.assignTexture( materialParams, 'roughnessMap', metallicRoughness.metallicRoughnessTexture ) );

			}

			materialType = this._invokeOne( function ( ext ) {

				return ext.getMaterialType && ext.getMaterialType( materialIndex );

			} );

			pending.push( Promise.all( this._invokeAll( function ( ext ) {

				return ext.extendMaterialParams && ext.extendMaterialParams( materialIndex, materialParams );

			} ) ) );

		}

		if ( materialDef.doubleSided === true ) {

			materialParams.side = external_three_.DoubleSide;

		}

		const alphaMode = materialDef.alphaMode || ALPHA_MODES.OPAQUE;

		if ( alphaMode === ALPHA_MODES.BLEND ) {

			materialParams.transparent = true;

			// See: https://github.com/mrdoob/three.js/issues/17706
			materialParams.depthWrite = false;

		} else {

			materialParams.transparent = false;

			if ( alphaMode === ALPHA_MODES.MASK ) {

				materialParams.alphaTest = materialDef.alphaCutoff !== undefined ? materialDef.alphaCutoff : 0.5;

			}

		}

		if ( materialDef.normalTexture !== undefined && materialType !== external_three_.MeshBasicMaterial ) {

			pending.push( parser.assignTexture( materialParams, 'normalMap', materialDef.normalTexture ) );

			materialParams.normalScale = new external_three_.Vector2( 1, 1 );

			if ( materialDef.normalTexture.scale !== undefined ) {

				const scale = materialDef.normalTexture.scale;

				materialParams.normalScale.set( scale, scale );

			}

		}

		if ( materialDef.occlusionTexture !== undefined && materialType !== external_three_.MeshBasicMaterial ) {

			pending.push( parser.assignTexture( materialParams, 'aoMap', materialDef.occlusionTexture ) );

			if ( materialDef.occlusionTexture.strength !== undefined ) {

				materialParams.aoMapIntensity = materialDef.occlusionTexture.strength;

			}

		}

		if ( materialDef.emissiveFactor !== undefined && materialType !== external_three_.MeshBasicMaterial ) {

			const emissiveFactor = materialDef.emissiveFactor;
			materialParams.emissive = new external_three_.Color().setRGB( emissiveFactor[ 0 ], emissiveFactor[ 1 ], emissiveFactor[ 2 ], external_three_.LinearSRGBColorSpace );

		}

		if ( materialDef.emissiveTexture !== undefined && materialType !== external_three_.MeshBasicMaterial ) {

			pending.push( parser.assignTexture( materialParams, 'emissiveMap', materialDef.emissiveTexture, external_three_.SRGBColorSpace ) );

		}

		return Promise.all( pending ).then( function () {

			const material = new materialType( materialParams );

			if ( materialDef.name ) material.name = materialDef.name;

			assignExtrasToUserData( material, materialDef );

			parser.associations.set( material, { materials: materialIndex } );

			if ( materialDef.extensions ) addUnknownExtensionsToUserData( extensions, material, materialDef );

			return material;

		} );

	}

	/** When Object3D instances are targeted by animation, they need unique names. */
	createUniqueName( originalName ) {

		const sanitizedName = external_three_.PropertyBinding.sanitizeNodeName( originalName || '' );

		if ( sanitizedName in this.nodeNamesUsed ) {

			return sanitizedName + '_' + ( ++ this.nodeNamesUsed[ sanitizedName ] );

		} else {

			this.nodeNamesUsed[ sanitizedName ] = 0;

			return sanitizedName;

		}

	}

	/**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#geometry
	 *
	 * Creates BufferGeometries from primitives.
	 *
	 * @param {Array<GLTF.Primitive>} primitives
	 * @return {Promise<Array<BufferGeometry>>}
	 */
	loadGeometries( primitives ) {

		const parser = this;
		const extensions = this.extensions;
		const cache = this.primitiveCache;

		function createDracoPrimitive( primitive ) {

			return extensions[ EXTENSIONS.KHR_DRACO_MESH_COMPRESSION ]
				.decodePrimitive( primitive, parser )
				.then( function ( geometry ) {

					return addPrimitiveAttributes( geometry, primitive, parser );

				} );

		}

		const pending = [];

		for ( let i = 0, il = primitives.length; i < il; i ++ ) {

			const primitive = primitives[ i ];
			const cacheKey = createPrimitiveKey( primitive );

			// See if we've already created this geometry
			const cached = cache[ cacheKey ];

			if ( cached ) {

				// Use the cached geometry if it exists
				pending.push( cached.promise );

			} else {

				let geometryPromise;

				if ( primitive.extensions && primitive.extensions[ EXTENSIONS.KHR_DRACO_MESH_COMPRESSION ] ) {

					// Use DRACO geometry if available
					geometryPromise = createDracoPrimitive( primitive );

				} else {

					// Otherwise create a new geometry
					geometryPromise = addPrimitiveAttributes( new external_three_.BufferGeometry(), primitive, parser );

				}

				// Cache this geometry
				cache[ cacheKey ] = { primitive: primitive, promise: geometryPromise };

				pending.push( geometryPromise );

			}

		}

		return Promise.all( pending );

	}

	/**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#meshes
	 * @param {number} meshIndex
	 * @return {Promise<Group|Mesh|SkinnedMesh>}
	 */
	loadMesh( meshIndex ) {

		const parser = this;
		const json = this.json;
		const extensions = this.extensions;

		const meshDef = json.meshes[ meshIndex ];
		const primitives = meshDef.primitives;

		const pending = [];

		for ( let i = 0, il = primitives.length; i < il; i ++ ) {

			const material = primitives[ i ].material === undefined
				? createDefaultMaterial( this.cache )
				: this.getDependency( 'material', primitives[ i ].material );

			pending.push( material );

		}

		pending.push( parser.loadGeometries( primitives ) );

		return Promise.all( pending ).then( function ( results ) {

			const materials = results.slice( 0, results.length - 1 );
			const geometries = results[ results.length - 1 ];

			const meshes = [];

			for ( let i = 0, il = geometries.length; i < il; i ++ ) {

				const geometry = geometries[ i ];
				const primitive = primitives[ i ];

				// 1. create Mesh

				let mesh;

				const material = materials[ i ];

				if ( primitive.mode === WEBGL_CONSTANTS.TRIANGLES ||
						primitive.mode === WEBGL_CONSTANTS.TRIANGLE_STRIP ||
						primitive.mode === WEBGL_CONSTANTS.TRIANGLE_FAN ||
						primitive.mode === undefined ) {

					// .isSkinnedMesh isn't in glTF spec. See ._markDefs()
					mesh = meshDef.isSkinnedMesh === true
						? new external_three_.SkinnedMesh( geometry, material )
						: new external_three_.Mesh( geometry, material );

					if ( mesh.isSkinnedMesh === true ) {

						// normalize skin weights to fix malformed assets (see #15319)
						mesh.normalizeSkinWeights();

					}

					if ( primitive.mode === WEBGL_CONSTANTS.TRIANGLE_STRIP ) {

						mesh.geometry = toTrianglesDrawMode( mesh.geometry, external_three_.TriangleStripDrawMode );

					} else if ( primitive.mode === WEBGL_CONSTANTS.TRIANGLE_FAN ) {

						mesh.geometry = toTrianglesDrawMode( mesh.geometry, external_three_.TriangleFanDrawMode );

					}

				} else if ( primitive.mode === WEBGL_CONSTANTS.LINES ) {

					mesh = new external_three_.LineSegments( geometry, material );

				} else if ( primitive.mode === WEBGL_CONSTANTS.LINE_STRIP ) {

					mesh = new external_three_.Line( geometry, material );

				} else if ( primitive.mode === WEBGL_CONSTANTS.LINE_LOOP ) {

					mesh = new external_three_.LineLoop( geometry, material );

				} else if ( primitive.mode === WEBGL_CONSTANTS.POINTS ) {

					mesh = new external_three_.Points( geometry, material );

				} else {

					throw new Error( 'THREE.GLTFLoader: Primitive mode unsupported: ' + primitive.mode );

				}

				if ( Object.keys( mesh.geometry.morphAttributes ).length > 0 ) {

					updateMorphTargets( mesh, meshDef );

				}

				mesh.name = parser.createUniqueName( meshDef.name || ( 'mesh_' + meshIndex ) );

				assignExtrasToUserData( mesh, meshDef );

				if ( primitive.extensions ) addUnknownExtensionsToUserData( extensions, mesh, primitive );

				parser.assignFinalMaterial( mesh );

				meshes.push( mesh );

			}

			for ( let i = 0, il = meshes.length; i < il; i ++ ) {

				parser.associations.set( meshes[ i ], {
					meshes: meshIndex,
					primitives: i
				} );

			}

			if ( meshes.length === 1 ) {

				if ( meshDef.extensions ) addUnknownExtensionsToUserData( extensions, meshes[ 0 ], meshDef );

				return meshes[ 0 ];

			}

			const group = new external_three_.Group();

			if ( meshDef.extensions ) addUnknownExtensionsToUserData( extensions, group, meshDef );

			parser.associations.set( group, { meshes: meshIndex } );

			for ( let i = 0, il = meshes.length; i < il; i ++ ) {

				group.add( meshes[ i ] );

			}

			return group;

		} );

	}

	/**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#cameras
	 * @param {number} cameraIndex
	 * @return {Promise<THREE.Camera>}
	 */
	loadCamera( cameraIndex ) {

		let camera;
		const cameraDef = this.json.cameras[ cameraIndex ];
		const params = cameraDef[ cameraDef.type ];

		if ( ! params ) {

			console.warn( 'THREE.GLTFLoader: Missing camera parameters.' );
			return;

		}

		if ( cameraDef.type === 'perspective' ) {

			camera = new external_three_.PerspectiveCamera( external_three_.MathUtils.radToDeg( params.yfov ), params.aspectRatio || 1, params.znear || 1, params.zfar || 2e6 );

		} else if ( cameraDef.type === 'orthographic' ) {

			camera = new external_three_.OrthographicCamera( - params.xmag, params.xmag, params.ymag, - params.ymag, params.znear, params.zfar );

		}

		if ( cameraDef.name ) camera.name = this.createUniqueName( cameraDef.name );

		assignExtrasToUserData( camera, cameraDef );

		return Promise.resolve( camera );

	}

	/**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#skins
	 * @param {number} skinIndex
	 * @return {Promise<Skeleton>}
	 */
	loadSkin( skinIndex ) {

		const skinDef = this.json.skins[ skinIndex ];

		const pending = [];

		for ( let i = 0, il = skinDef.joints.length; i < il; i ++ ) {

			pending.push( this._loadNodeShallow( skinDef.joints[ i ] ) );

		}

		if ( skinDef.inverseBindMatrices !== undefined ) {

			pending.push( this.getDependency( 'accessor', skinDef.inverseBindMatrices ) );

		} else {

			pending.push( null );

		}

		return Promise.all( pending ).then( function ( results ) {

			const inverseBindMatrices = results.pop();
			const jointNodes = results;

			// Note that bones (joint nodes) may or may not be in the
			// scene graph at this time.

			const bones = [];
			const boneInverses = [];

			for ( let i = 0, il = jointNodes.length; i < il; i ++ ) {

				const jointNode = jointNodes[ i ];

				if ( jointNode ) {

					bones.push( jointNode );

					const mat = new external_three_.Matrix4();

					if ( inverseBindMatrices !== null ) {

						mat.fromArray( inverseBindMatrices.array, i * 16 );

					}

					boneInverses.push( mat );

				} else {

					console.warn( 'THREE.GLTFLoader: Joint "%s" could not be found.', skinDef.joints[ i ] );

				}

			}

			return new external_three_.Skeleton( bones, boneInverses );

		} );

	}

	/**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#animations
	 * @param {number} animationIndex
	 * @return {Promise<AnimationClip>}
	 */
	loadAnimation( animationIndex ) {

		const json = this.json;
		const parser = this;

		const animationDef = json.animations[ animationIndex ];
		const animationName = animationDef.name ? animationDef.name : 'animation_' + animationIndex;

		const pendingNodes = [];
		const pendingInputAccessors = [];
		const pendingOutputAccessors = [];
		const pendingSamplers = [];
		const pendingTargets = [];

		for ( let i = 0, il = animationDef.channels.length; i < il; i ++ ) {

			const channel = animationDef.channels[ i ];
			const sampler = animationDef.samplers[ channel.sampler ];
			const target = channel.target;
			const name = target.node;
			const input = animationDef.parameters !== undefined ? animationDef.parameters[ sampler.input ] : sampler.input;
			const output = animationDef.parameters !== undefined ? animationDef.parameters[ sampler.output ] : sampler.output;

			if ( target.node === undefined ) continue;

			pendingNodes.push( this.getDependency( 'node', name ) );
			pendingInputAccessors.push( this.getDependency( 'accessor', input ) );
			pendingOutputAccessors.push( this.getDependency( 'accessor', output ) );
			pendingSamplers.push( sampler );
			pendingTargets.push( target );

		}

		return Promise.all( [

			Promise.all( pendingNodes ),
			Promise.all( pendingInputAccessors ),
			Promise.all( pendingOutputAccessors ),
			Promise.all( pendingSamplers ),
			Promise.all( pendingTargets )

		] ).then( function ( dependencies ) {

			const nodes = dependencies[ 0 ];
			const inputAccessors = dependencies[ 1 ];
			const outputAccessors = dependencies[ 2 ];
			const samplers = dependencies[ 3 ];
			const targets = dependencies[ 4 ];

			const tracks = [];

			for ( let i = 0, il = nodes.length; i < il; i ++ ) {

				const node = nodes[ i ];
				const inputAccessor = inputAccessors[ i ];
				const outputAccessor = outputAccessors[ i ];
				const sampler = samplers[ i ];
				const target = targets[ i ];

				if ( node === undefined ) continue;

				if ( node.updateMatrix ) {

					node.updateMatrix();

				}

				const createdTracks = parser._createAnimationTracks( node, inputAccessor, outputAccessor, sampler, target );

				if ( createdTracks ) {

					for ( let k = 0; k < createdTracks.length; k ++ ) {

						tracks.push( createdTracks[ k ] );

					}

				}

			}

			return new external_three_.AnimationClip( animationName, undefined, tracks );

		} );

	}

	createNodeMesh( nodeIndex ) {

		const json = this.json;
		const parser = this;
		const nodeDef = json.nodes[ nodeIndex ];

		if ( nodeDef.mesh === undefined ) return null;

		return parser.getDependency( 'mesh', nodeDef.mesh ).then( function ( mesh ) {

			const node = parser._getNodeRef( parser.meshCache, nodeDef.mesh, mesh );

			// if weights are provided on the node, override weights on the mesh.
			if ( nodeDef.weights !== undefined ) {

				node.traverse( function ( o ) {

					if ( ! o.isMesh ) return;

					for ( let i = 0, il = nodeDef.weights.length; i < il; i ++ ) {

						o.morphTargetInfluences[ i ] = nodeDef.weights[ i ];

					}

				} );

			}

			return node;

		} );

	}

	/**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#nodes-and-hierarchy
	 * @param {number} nodeIndex
	 * @return {Promise<Object3D>}
	 */
	loadNode( nodeIndex ) {

		const json = this.json;
		const parser = this;

		const nodeDef = json.nodes[ nodeIndex ];

		const nodePending = parser._loadNodeShallow( nodeIndex );

		const childPending = [];
		const childrenDef = nodeDef.children || [];

		for ( let i = 0, il = childrenDef.length; i < il; i ++ ) {

			childPending.push( parser.getDependency( 'node', childrenDef[ i ] ) );

		}

		const skeletonPending = nodeDef.skin === undefined
			? Promise.resolve( null )
			: parser.getDependency( 'skin', nodeDef.skin );

		return Promise.all( [
			nodePending,
			Promise.all( childPending ),
			skeletonPending
		] ).then( function ( results ) {

			const node = results[ 0 ];
			const children = results[ 1 ];
			const skeleton = results[ 2 ];

			if ( skeleton !== null ) {

				// This full traverse should be fine because
				// child glTF nodes have not been added to this node yet.
				node.traverse( function ( mesh ) {

					if ( ! mesh.isSkinnedMesh ) return;

					mesh.bind( skeleton, _identityMatrix );

				} );

			}

			for ( let i = 0, il = children.length; i < il; i ++ ) {

				node.add( children[ i ] );

			}

			return node;

		} );

	}

	// ._loadNodeShallow() parses a single node.
	// skin and child nodes are created and added in .loadNode() (no '_' prefix).
	_loadNodeShallow( nodeIndex ) {

		const json = this.json;
		const extensions = this.extensions;
		const parser = this;

		// This method is called from .loadNode() and .loadSkin().
		// Cache a node to avoid duplication.

		if ( this.nodeCache[ nodeIndex ] !== undefined ) {

			return this.nodeCache[ nodeIndex ];

		}

		const nodeDef = json.nodes[ nodeIndex ];

		// reserve node's name before its dependencies, so the root has the intended name.
		const nodeName = nodeDef.name ? parser.createUniqueName( nodeDef.name ) : '';

		const pending = [];

		const meshPromise = parser._invokeOne( function ( ext ) {

			return ext.createNodeMesh && ext.createNodeMesh( nodeIndex );

		} );

		if ( meshPromise ) {

			pending.push( meshPromise );

		}

		if ( nodeDef.camera !== undefined ) {

			pending.push( parser.getDependency( 'camera', nodeDef.camera ).then( function ( camera ) {

				return parser._getNodeRef( parser.cameraCache, nodeDef.camera, camera );

			} ) );

		}

		parser._invokeAll( function ( ext ) {

			return ext.createNodeAttachment && ext.createNodeAttachment( nodeIndex );

		} ).forEach( function ( promise ) {

			pending.push( promise );

		} );

		this.nodeCache[ nodeIndex ] = Promise.all( pending ).then( function ( objects ) {

			let node;

			// .isBone isn't in glTF spec. See ._markDefs
			if ( nodeDef.isBone === true ) {

				node = new external_three_.Bone();

			} else if ( objects.length > 1 ) {

				node = new external_three_.Group();

			} else if ( objects.length === 1 ) {

				node = objects[ 0 ];

			} else {

				node = new external_three_.Object3D();

			}

			if ( node !== objects[ 0 ] ) {

				for ( let i = 0, il = objects.length; i < il; i ++ ) {

					node.add( objects[ i ] );

				}

			}

			if ( nodeDef.name ) {

				node.userData.name = nodeDef.name;
				node.name = nodeName;

			}

			assignExtrasToUserData( node, nodeDef );

			if ( nodeDef.extensions ) addUnknownExtensionsToUserData( extensions, node, nodeDef );

			if ( nodeDef.matrix !== undefined ) {

				const matrix = new external_three_.Matrix4();
				matrix.fromArray( nodeDef.matrix );
				node.applyMatrix4( matrix );

			} else {

				if ( nodeDef.translation !== undefined ) {

					node.position.fromArray( nodeDef.translation );

				}

				if ( nodeDef.rotation !== undefined ) {

					node.quaternion.fromArray( nodeDef.rotation );

				}

				if ( nodeDef.scale !== undefined ) {

					node.scale.fromArray( nodeDef.scale );

				}

			}

			if ( ! parser.associations.has( node ) ) {

				parser.associations.set( node, {} );

			}

			parser.associations.get( node ).nodes = nodeIndex;

			return node;

		} );

		return this.nodeCache[ nodeIndex ];

	}

	/**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#scenes
	 * @param {number} sceneIndex
	 * @return {Promise<Group>}
	 */
	loadScene( sceneIndex ) {

		const extensions = this.extensions;
		const sceneDef = this.json.scenes[ sceneIndex ];
		const parser = this;

		// Loader returns Group, not Scene.
		// See: https://github.com/mrdoob/three.js/issues/18342#issuecomment-578981172
		const scene = new external_three_.Group();
		if ( sceneDef.name ) scene.name = parser.createUniqueName( sceneDef.name );

		assignExtrasToUserData( scene, sceneDef );

		if ( sceneDef.extensions ) addUnknownExtensionsToUserData( extensions, scene, sceneDef );

		const nodeIds = sceneDef.nodes || [];

		const pending = [];

		for ( let i = 0, il = nodeIds.length; i < il; i ++ ) {

			pending.push( parser.getDependency( 'node', nodeIds[ i ] ) );

		}

		return Promise.all( pending ).then( function ( nodes ) {

			for ( let i = 0, il = nodes.length; i < il; i ++ ) {

				scene.add( nodes[ i ] );

			}

			// Removes dangling associations, associations that reference a node that
			// didn't make it into the scene.
			const reduceAssociations = ( node ) => {

				const reducedAssociations = new Map();

				for ( const [ key, value ] of parser.associations ) {

					if ( key instanceof external_three_.Material || key instanceof external_three_.Texture ) {

						reducedAssociations.set( key, value );

					}

				}

				node.traverse( ( node ) => {

					const mappings = parser.associations.get( node );

					if ( mappings != null ) {

						reducedAssociations.set( node, mappings );

					}

				} );

				return reducedAssociations;

			};

			parser.associations = reduceAssociations( scene );

			return scene;

		} );

	}

	_createAnimationTracks( node, inputAccessor, outputAccessor, sampler, target ) {

		const tracks = [];

		const targetName = node.name ? node.name : node.uuid;
		const targetNames = [];

		if ( PATH_PROPERTIES[ target.path ] === PATH_PROPERTIES.weights ) {

			node.traverse( function ( object ) {

				if ( object.morphTargetInfluences ) {

					targetNames.push( object.name ? object.name : object.uuid );

				}

			} );

		} else {

			targetNames.push( targetName );

		}

		let TypedKeyframeTrack;

		switch ( PATH_PROPERTIES[ target.path ] ) {

			case PATH_PROPERTIES.weights:

				TypedKeyframeTrack = external_three_.NumberKeyframeTrack;
				break;

			case PATH_PROPERTIES.rotation:

				TypedKeyframeTrack = external_three_.QuaternionKeyframeTrack;
				break;

			case PATH_PROPERTIES.position:
			case PATH_PROPERTIES.scale:

				TypedKeyframeTrack = external_three_.VectorKeyframeTrack;
				break;

			default:

				switch ( outputAccessor.itemSize ) {

					case 1:
						TypedKeyframeTrack = external_three_.NumberKeyframeTrack;
						break;
					case 2:
					case 3:
					default:
						TypedKeyframeTrack = external_three_.VectorKeyframeTrack;
						break;

				}

				break;

		}

		const interpolation = sampler.interpolation !== undefined ? INTERPOLATION[ sampler.interpolation ] : external_three_.InterpolateLinear;


		const outputArray = this._getArrayFromAccessor( outputAccessor );

		for ( let j = 0, jl = targetNames.length; j < jl; j ++ ) {

			const track = new TypedKeyframeTrack(
				targetNames[ j ] + '.' + PATH_PROPERTIES[ target.path ],
				inputAccessor.array,
				outputArray,
				interpolation
			);

			// Override interpolation with custom factory method.
			if ( sampler.interpolation === 'CUBICSPLINE' ) {

				this._createCubicSplineTrackInterpolant( track );

			}

			tracks.push( track );

		}

		return tracks;

	}

	_getArrayFromAccessor( accessor ) {

		let outputArray = accessor.array;

		if ( accessor.normalized ) {

			const scale = getNormalizedComponentScale( outputArray.constructor );
			const scaled = new Float32Array( outputArray.length );

			for ( let j = 0, jl = outputArray.length; j < jl; j ++ ) {

				scaled[ j ] = outputArray[ j ] * scale;

			}

			outputArray = scaled;

		}

		return outputArray;

	}

	_createCubicSplineTrackInterpolant( track ) {

		track.createInterpolant = function InterpolantFactoryMethodGLTFCubicSpline( result ) {

			// A CUBICSPLINE keyframe in glTF has three output values for each input value,
			// representing inTangent, splineVertex, and outTangent. As a result, track.getValueSize()
			// must be divided by three to get the interpolant's sampleSize argument.

			const interpolantType = ( this instanceof external_three_.QuaternionKeyframeTrack ) ? GLTFCubicSplineQuaternionInterpolant : GLTFCubicSplineInterpolant;

			return new interpolantType( this.times, this.values, this.getValueSize() / 3, result );

		};

		// Mark as CUBICSPLINE. `track.getInterpolation()` doesn't support custom interpolants.
		track.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = true;

	}

}

/**
 * @param {BufferGeometry} geometry
 * @param {GLTF.Primitive} primitiveDef
 * @param {GLTFParser} parser
 */
function computeBounds( geometry, primitiveDef, parser ) {

	const attributes = primitiveDef.attributes;

	const box = new external_three_.Box3();

	if ( attributes.POSITION !== undefined ) {

		const accessor = parser.json.accessors[ attributes.POSITION ];

		const min = accessor.min;
		const max = accessor.max;

		// glTF requires 'min' and 'max', but VRM (which extends glTF) currently ignores that requirement.

		if ( min !== undefined && max !== undefined ) {

			box.set(
				new external_three_.Vector3( min[ 0 ], min[ 1 ], min[ 2 ] ),
				new external_three_.Vector3( max[ 0 ], max[ 1 ], max[ 2 ] )
			);

			if ( accessor.normalized ) {

				const boxScale = getNormalizedComponentScale( WEBGL_COMPONENT_TYPES[ accessor.componentType ] );
				box.min.multiplyScalar( boxScale );
				box.max.multiplyScalar( boxScale );

			}

		} else {

			console.warn( 'THREE.GLTFLoader: Missing min/max properties for accessor POSITION.' );

			return;

		}

	} else {

		return;

	}

	const targets = primitiveDef.targets;

	if ( targets !== undefined ) {

		const maxDisplacement = new external_three_.Vector3();
		const vector = new external_three_.Vector3();

		for ( let i = 0, il = targets.length; i < il; i ++ ) {

			const target = targets[ i ];

			if ( target.POSITION !== undefined ) {

				const accessor = parser.json.accessors[ target.POSITION ];
				const min = accessor.min;
				const max = accessor.max;

				// glTF requires 'min' and 'max', but VRM (which extends glTF) currently ignores that requirement.

				if ( min !== undefined && max !== undefined ) {

					// we need to get max of absolute components because target weight is [-1,1]
					vector.setX( Math.max( Math.abs( min[ 0 ] ), Math.abs( max[ 0 ] ) ) );
					vector.setY( Math.max( Math.abs( min[ 1 ] ), Math.abs( max[ 1 ] ) ) );
					vector.setZ( Math.max( Math.abs( min[ 2 ] ), Math.abs( max[ 2 ] ) ) );


					if ( accessor.normalized ) {

						const boxScale = getNormalizedComponentScale( WEBGL_COMPONENT_TYPES[ accessor.componentType ] );
						vector.multiplyScalar( boxScale );

					}

					// Note: this assumes that the sum of all weights is at most 1. This isn't quite correct - it's more conservative
					// to assume that each target can have a max weight of 1. However, for some use cases - notably, when morph targets
					// are used to implement key-frame animations and as such only two are active at a time - this results in very large
					// boxes. So for now we make a box that's sometimes a touch too small but is hopefully mostly of reasonable size.
					maxDisplacement.max( vector );

				} else {

					console.warn( 'THREE.GLTFLoader: Missing min/max properties for accessor POSITION.' );

				}

			}

		}

		// As per comment above this box isn't conservative, but has a reasonable size for a very large number of morph targets.
		box.expandByVector( maxDisplacement );

	}

	geometry.boundingBox = box;

	const sphere = new external_three_.Sphere();

	box.getCenter( sphere.center );
	sphere.radius = box.min.distanceTo( box.max ) / 2;

	geometry.boundingSphere = sphere;

}

/**
 * @param {BufferGeometry} geometry
 * @param {GLTF.Primitive} primitiveDef
 * @param {GLTFParser} parser
 * @return {Promise<BufferGeometry>}
 */
function addPrimitiveAttributes( geometry, primitiveDef, parser ) {

	const attributes = primitiveDef.attributes;

	const pending = [];

	function assignAttributeAccessor( accessorIndex, attributeName ) {

		return parser.getDependency( 'accessor', accessorIndex )
			.then( function ( accessor ) {

				geometry.setAttribute( attributeName, accessor );

			} );

	}

	for ( const gltfAttributeName in attributes ) {

		const threeAttributeName = ATTRIBUTES[ gltfAttributeName ] || gltfAttributeName.toLowerCase();

		// Skip attributes already provided by e.g. Draco extension.
		if ( threeAttributeName in geometry.attributes ) continue;

		pending.push( assignAttributeAccessor( attributes[ gltfAttributeName ], threeAttributeName ) );

	}

	if ( primitiveDef.indices !== undefined && ! geometry.index ) {

		const accessor = parser.getDependency( 'accessor', primitiveDef.indices ).then( function ( accessor ) {

			geometry.setIndex( accessor );

		} );

		pending.push( accessor );

	}

	if ( external_three_.ColorManagement.workingColorSpace !== external_three_.LinearSRGBColorSpace && 'COLOR_0' in attributes ) {

		console.warn( `THREE.GLTFLoader: Converting vertex colors from "srgb-linear" to "${external_three_.ColorManagement.workingColorSpace}" not supported.` );

	}

	assignExtrasToUserData( geometry, primitiveDef );

	computeBounds( geometry, primitiveDef, parser );

	return Promise.all( pending ).then( function () {

		return primitiveDef.targets !== undefined
			? addMorphTargets( geometry, primitiveDef.targets, parser )
			: geometry;

	} );

}



;// CONCATENATED MODULE: ./node_modules/three/examples/jsm/libs/meshopt_decoder.module.js
// This file is part of meshoptimizer library and is distributed under the terms of MIT License.
// Copyright (C) 2016-2022, by Arseny Kapoulkine (arseny.kapoulkine@gmail.com)
var MeshoptDecoder = (function() {
	"use strict";

	// Built with clang version 14.0.4
	// Built from meshoptimizer 0.18
	var wasm_base = "b9H79Tebbbe8Fv9Gbb9Gvuuuuueu9Giuuub9Geueu9Giuuueuikqbeeedddillviebeoweuec:q;iekr;leDo9TW9T9VV95dbH9F9F939H79T9F9J9H229F9Jt9VV7bb8A9TW79O9V9Wt9F9KW9J9V9KW9wWVtW949c919M9MWVbeY9TW79O9V9Wt9F9KW9J9V9KW69U9KW949c919M9MWVbdE9TW79O9V9Wt9F9KW9J9V9KW69U9KW949tWG91W9U9JWbiL9TW79O9V9Wt9F9KW9J9V9KWS9P2tWV9p9JtblK9TW79O9V9Wt9F9KW9J9V9KWS9P2tWV9r919HtbvL9TW79O9V9Wt9F9KW9J9V9KWS9P2tWVT949Wbol79IV9Rbrq:P8Yqdbk;3sezu8Jjjjjbcj;eb9Rgv8Kjjjjbc9:hodnadcefal0mbcuhoaiRbbc:Ge9hmbavaialfgrad9Radz1jjjbhwcj;abad9UhoaicefhldnadTmbaoc;WFbGgocjdaocjd6EhDcbhqinaqae9pmeaDaeaq9RaqaDfae6Egkcsfgocl4cifcd4hxdndndndnaoc9WGgmTmbcbhPcehsawcjdfhzalhHinaraH9Rax6midnaraHaxfgl9RcK6mbczhoinawcj;cbfaogifgoc9WfhOdndndndndnaHaic9WfgAco4fRbbaAci4coG4ciGPlbedibkaO9cb83ibaOcwf9cb83ibxikaOalRblalRbbgAco4gCaCciSgCE86bbaocGfalclfaCfgORbbaAcl4ciGgCaCciSgCE86bbaocVfaOaCfgORbbaAcd4ciGgCaCciSgCE86bbaoc7faOaCfgORbbaAciGgAaAciSgAE86bbaoctfaOaAfgARbbalRbegOco4gCaCciSgCE86bbaoc91faAaCfgARbbaOcl4ciGgCaCciSgCE86bbaoc4faAaCfgARbbaOcd4ciGgCaCciSgCE86bbaoc93faAaCfgARbbaOciGgOaOciSgOE86bbaoc94faAaOfgARbbalRbdgOco4gCaCciSgCE86bbaoc95faAaCfgARbbaOcl4ciGgCaCciSgCE86bbaoc96faAaCfgARbbaOcd4ciGgCaCciSgCE86bbaoc97faAaCfgARbbaOciGgOaOciSgOE86bbaoc98faAaOfgORbbalRbiglco4gAaAciSgAE86bbaoc99faOaAfgORbbalcl4ciGgAaAciSgAE86bbaoc9:faOaAfgORbbalcd4ciGgAaAciSgAE86bbaocufaOaAfgoRbbalciGglalciSglE86bbaoalfhlxdkaOalRbwalRbbgAcl4gCaCcsSgCE86bbaocGfalcwfaCfgORbbaAcsGgAaAcsSgAE86bbaocVfaOaAfgORbbalRbegAcl4gCaCcsSgCE86bbaoc7faOaCfgORbbaAcsGgAaAcsSgAE86bbaoctfaOaAfgORbbalRbdgAcl4gCaCcsSgCE86bbaoc91faOaCfgORbbaAcsGgAaAcsSgAE86bbaoc4faOaAfgORbbalRbigAcl4gCaCcsSgCE86bbaoc93faOaCfgORbbaAcsGgAaAcsSgAE86bbaoc94faOaAfgORbbalRblgAcl4gCaCcsSgCE86bbaoc95faOaCfgORbbaAcsGgAaAcsSgAE86bbaoc96faOaAfgORbbalRbvgAcl4gCaCcsSgCE86bbaoc97faOaCfgORbbaAcsGgAaAcsSgAE86bbaoc98faOaAfgORbbalRbogAcl4gCaCcsSgCE86bbaoc99faOaCfgORbbaAcsGgAaAcsSgAE86bbaoc9:faOaAfgORbbalRbrglcl4gAaAcsSgAE86bbaocufaOaAfgoRbbalcsGglalcsSglE86bbaoalfhlxekaOal8Pbb83bbaOcwfalcwf8Pbb83bbalczfhlkdnaiam9pmbaiczfhoaral9RcL0mekkaiam6mialTmidnakTmbawaPfRbbhOcbhoazhiinaiawcj;cbfaofRbbgAce4cbaAceG9R7aOfgO86bbaiadfhiaocefgoak9hmbkkazcefhzaPcefgPad6hsalhHaPad9hmexvkkcbhlasceGmdxikalaxad2fhCdnakTmbcbhHcehsawcjdfhminaral9Rax6mialTmdalaxfhlawaHfRbbhOcbhoamhiinaiawcj;cbfaofRbbgAce4cbaAceG9R7aOfgO86bbaiadfhiaocefgoak9hmbkamcefhmaHcefgHad6hsaHad9hmbkaChlxikcbhocehsinaral9Rax6mdalTmealaxfhlaocefgoad6hsadao9hmbkaChlxdkcbhlasceGTmekc9:hoxikabaqad2fawcjdfakad2z1jjjb8Aawawcjdfakcufad2fadz1jjjb8Aakaqfhqalmbkc9:hoxekcbc99aral9Radcaadca0ESEhokavcj;ebf8Kjjjjbaok;yzeHu8Jjjjjbc;ae9Rgv8Kjjjjbc9:hodnaeci9UgrcHfal0mbcuhoaiRbbgwc;WeGc;Ge9hmbawcsGgDce0mbavc;abfcFecjez:jjjjb8AavcUf9cu83ibavc8Wf9cu83ibavcyf9cu83ibavcaf9cu83ibavcKf9cu83ibavczf9cu83ibav9cu83iwav9cu83ibaialfc9WfhqaicefgwarfhodnaeTmbcmcsaDceSEhkcbhxcbhmcbhDcbhicbhlindnaoaq9nmbc9:hoxikdndnawRbbgrc;Ve0mbavc;abfalarcl4cu7fcsGcitfgPydlhsaPydbhzdnarcsGgPak9pmbavaiarcu7fcsGcdtfydbaxaPEhraPThPdndnadcd9hmbabaDcetfgHaz87ebaHcdfas87ebaHclfar87ebxekabaDcdtfgHazBdbaHclfasBdbaHcwfarBdbkaxaPfhxavc;abfalcitfgHarBdbaHasBdlavaicdtfarBdbavc;abfalcefcsGglcitfgHazBdbaHarBdlaiaPfhialcefhlxdkdndnaPcsSmbamaPfaPc987fcefhmxekaocefhrao8SbbgPcFeGhHdndnaPcu9mmbarhoxekaocvfhoaHcFbGhHcrhPdninar8SbbgOcFbGaPtaHVhHaOcu9kmearcefhraPcrfgPc8J9hmbxdkkarcefhokaHce4cbaHceG9R7amfhmkdndnadcd9hmbabaDcetfgraz87ebarcdfas87ebarclfam87ebxekabaDcdtfgrazBdbarclfasBdbarcwfamBdbkavc;abfalcitfgramBdbarasBdlavaicdtfamBdbavc;abfalcefcsGglcitfgrazBdbaramBdlaicefhialcefhlxekdnarcpe0mbaxcefgOavaiaqarcsGfRbbgPcl49RcsGcdtfydbaPcz6gHEhravaiaP9RcsGcdtfydbaOaHfgsaPcsGgOEhPaOThOdndnadcd9hmbabaDcetfgzax87ebazcdfar87ebazclfaP87ebxekabaDcdtfgzaxBdbazclfarBdbazcwfaPBdbkavaicdtfaxBdbavc;abfalcitfgzarBdbazaxBdlavaicefgicsGcdtfarBdbavc;abfalcefcsGcitfgzaPBdbazarBdlavaiaHfcsGgicdtfaPBdbavc;abfalcdfcsGglcitfgraxBdbaraPBdlalcefhlaiaOfhiasaOfhxxekaxcbaoRbbgzEgAarc;:eSgrfhsazcsGhCazcl4hXdndnazcs0mbascefhOxekashOavaiaX9RcsGcdtfydbhskdndnaCmbaOcefhxxekaOhxavaiaz9RcsGcdtfydbhOkdndnarTmbaocefhrxekaocdfhrao8SbegHcFeGhPdnaHcu9kmbaocofhAaPcFbGhPcrhodninar8SbbgHcFbGaotaPVhPaHcu9kmearcefhraocrfgoc8J9hmbkaAhrxekarcefhrkaPce4cbaPceG9R7amfgmhAkdndnaXcsSmbarhPxekarcefhPar8SbbgocFeGhHdnaocu9kmbarcvfhsaHcFbGhHcrhodninaP8SbbgrcFbGaotaHVhHarcu9kmeaPcefhPaocrfgoc8J9hmbkashPxekaPcefhPkaHce4cbaHceG9R7amfgmhskdndnaCcsSmbaPhoxekaPcefhoaP8SbbgrcFeGhHdnarcu9kmbaPcvfhOaHcFbGhHcrhrdninao8SbbgPcFbGartaHVhHaPcu9kmeaocefhoarcrfgrc8J9hmbkaOhoxekaocefhokaHce4cbaHceG9R7amfgmhOkdndnadcd9hmbabaDcetfgraA87ebarcdfas87ebarclfaO87ebxekabaDcdtfgraABdbarclfasBdbarcwfaOBdbkavc;abfalcitfgrasBdbaraABdlavaicdtfaABdbavc;abfalcefcsGcitfgraOBdbarasBdlavaicefgicsGcdtfasBdbavc;abfalcdfcsGcitfgraABdbaraOBdlavaiazcz6aXcsSVfgicsGcdtfaOBdbaiaCTaCcsSVfhialcifhlkawcefhwalcsGhlaicsGhiaDcifgDae6mbkkcbc99aoaqSEhokavc;aef8Kjjjjbaok:llevu8Jjjjjbcz9Rhvc9:hodnaecvfal0mbcuhoaiRbbc;:eGc;qe9hmbav9cb83iwaicefhraialfc98fhwdnaeTmbdnadcdSmbcbhDindnaraw6mbc9:skarcefhoar8SbbglcFeGhidndnalcu9mmbaohrxekarcvfhraicFbGhicrhldninao8SbbgdcFbGaltaiVhiadcu9kmeaocefhoalcrfglc8J9hmbxdkkaocefhrkabaDcdtfaicd4cbaice4ceG9R7avcwfaiceGcdtVgoydbfglBdbaoalBdbaDcefgDae9hmbxdkkcbhDindnaraw6mbc9:skarcefhoar8SbbglcFeGhidndnalcu9mmbaohrxekarcvfhraicFbGhicrhldninao8SbbgdcFbGaltaiVhiadcu9kmeaocefhoalcrfglc8J9hmbxdkkaocefhrkabaDcetfaicd4cbaice4ceG9R7avcwfaiceGcdtVgoydbfgl87ebaoalBdbaDcefgDae9hmbkkcbc99arawSEhokaok:Lvoeue99dud99eud99dndnadcl9hmbaeTmeindndnabcdfgd8Sbb:Yab8Sbbgi:Ygl:l:tabcefgv8Sbbgo:Ygr:l:tgwJbb;:9cawawNJbbbbawawJbbbb9GgDEgq:mgkaqaicb9iEalMgwawNakaqaocb9iEarMgqaqNMM:r:vglNJbbbZJbbb:;aDEMgr:lJbbb9p9DTmbar:Ohixekcjjjj94hikadai86bbdndnaqalNJbbbZJbbb:;aqJbbbb9GEMgq:lJbbb9p9DTmbaq:Ohdxekcjjjj94hdkavad86bbdndnawalNJbbbZJbbb:;awJbbbb9GEMgw:lJbbb9p9DTmbaw:Ohdxekcjjjj94hdkabad86bbabclfhbaecufgembxdkkaeTmbindndnabclfgd8Ueb:Yab8Uebgi:Ygl:l:tabcdfgv8Uebgo:Ygr:l:tgwJb;:FSawawNJbbbbawawJbbbb9GgDEgq:mgkaqaicb9iEalMgwawNakaqaocb9iEarMgqaqNMM:r:vglNJbbbZJbbb:;aDEMgr:lJbbb9p9DTmbar:Ohixekcjjjj94hikadai87ebdndnaqalNJbbbZJbbb:;aqJbbbb9GEMgq:lJbbb9p9DTmbaq:Ohdxekcjjjj94hdkavad87ebdndnawalNJbbbZJbbb:;awJbbbb9GEMgw:lJbbb9p9DTmbaw:Ohdxekcjjjj94hdkabad87ebabcwfhbaecufgembkkk;siliui99iue99dnaeTmbcbhiabhlindndnJ;Zl81Zalcof8UebgvciV:Y:vgoal8Ueb:YNgrJb;:FSNJbbbZJbbb:;arJbbbb9GEMgw:lJbbb9p9DTmbaw:OhDxekcjjjj94hDkalclf8Uebhqalcdf8UebhkabavcefciGaiVcetfaD87ebdndnaoak:YNgwJb;:FSNJbbbZJbbb:;awJbbbb9GEMgx:lJbbb9p9DTmbax:Ohkxekcjjjj94hkkabavcdfciGaiVcetfak87ebdndnaoaq:YNgoJb;:FSNJbbbZJbbb:;aoJbbbb9GEMgx:lJbbb9p9DTmbax:Ohqxekcjjjj94hqkabavcufciGaiVcetfaq87ebdndnJbbjZararN:tawawN:taoaoN:tgrJbbbbarJbbbb9GE:rJb;:FSNJbbbZMgr:lJbbb9p9DTmbar:Ohqxekcjjjj94hqkabavciGaiVcetfaq87ebalcwfhlaiclfhiaecufgembkkk9mbdnadcd4ae2geTmbinababydbgdcwtcw91:Yadce91cjjj;8ifcjjj98G::NUdbabclfhbaecufgembkkk9teiucbcbydj1jjbgeabcifc98GfgbBdj1jjbdndnabZbcztgd9nmbcuhiabad9RcFFifcz4nbcuSmekaehikaik;LeeeudndnaeabVciGTmbabhixekdndnadcz9pmbabhixekabhiinaiaeydbBdbaiclfaeclfydbBdbaicwfaecwfydbBdbaicxfaecxfydbBdbaiczfhiaeczfheadc9Wfgdcs0mbkkadcl6mbinaiaeydbBdbaeclfheaiclfhiadc98fgdci0mbkkdnadTmbinaiaeRbb86bbaicefhiaecefheadcufgdmbkkabk;aeedudndnabciGTmbabhixekaecFeGc:b:c:ew2hldndnadcz9pmbabhixekabhiinaialBdbaicxfalBdbaicwfalBdbaiclfalBdbaiczfhiadc9Wfgdcs0mbkkadcl6mbinaialBdbaiclfhiadc98fgdci0mbkkdnadTmbinaiae86bbaicefhiadcufgdmbkkabkkkebcjwklz9Kbb";
	var wasm_simd = "b9H79TebbbeKl9Gbb9Gvuuuuueu9Giuuub9Geueuikqbbebeedddilve9Weeeviebeoweuec:q;Aekr;leDo9TW9T9VV95dbH9F9F939H79T9F9J9H229F9Jt9VV7bb8A9TW79O9V9Wt9F9KW9J9V9KW9wWVtW949c919M9MWVbdY9TW79O9V9Wt9F9KW9J9V9KW69U9KW949c919M9MWVblE9TW79O9V9Wt9F9KW9J9V9KW69U9KW949tWG91W9U9JWbvL9TW79O9V9Wt9F9KW9J9V9KWS9P2tWV9p9JtboK9TW79O9V9Wt9F9KW9J9V9KWS9P2tWV9r919HtbrL9TW79O9V9Wt9F9KW9J9V9KWS9P2tWVT949Wbwl79IV9RbDq;t9tqlbzik9:evu8Jjjjjbcz9Rhbcbheincbhdcbhiinabcwfadfaicjuaead4ceGglE86bbaialfhiadcefgdcw9hmbkaec:q:yjjbfai86bbaecitc:q1jjbfab8Piw83ibaecefgecjd9hmbkk;h8JlHud97euo978Jjjjjbcj;kb9Rgv8Kjjjjbc9:hodnadcefal0mbcuhoaiRbbc:Ge9hmbavaialfgrad9Rad;8qbbcj;abad9UhoaicefhldnadTmbaoc;WFbGgocjdaocjd6EhwcbhDinaDae9pmeawaeaD9RaDawfae6Egqcsfgoc9WGgkci2hxakcethmaocl4cifcd4hPabaDad2fhscbhzdnincehHalhOcbhAdninaraO9RaP6miavcj;cbfaAak2fhCaOaPfhlcbhidnakc;ab6mbaral9Rc;Gb6mbcbhoinaCaofhidndndndndnaOaoco4fRbbgXciGPlbedibkaipxbbbbbbbbbbbbbbbbpklbxikaialpbblalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLgQcdp:meaQpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogLpxiiiiiiiiiiiiiiiip8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklbalclfaYpQbfaKc:q:yjjbfRbbfhlxdkaialpbbwalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogLpxssssssssssssssssp8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklbalcwfaYpQbfaKc:q:yjjbfRbbfhlxekaialpbbbpklbalczfhlkdndndndndnaXcd4ciGPlbedibkaipxbbbbbbbbbbbbbbbbpklzxikaialpbblalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLgQcdp:meaQpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogLpxiiiiiiiiiiiiiiiip8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklzalclfaYpQbfaKc:q:yjjbfRbbfhlxdkaialpbbwalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogLpxssssssssssssssssp8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklzalcwfaYpQbfaKc:q:yjjbfRbbfhlxekaialpbbbpklzalczfhlkdndndndndnaXcl4ciGPlbedibkaipxbbbbbbbbbbbbbbbbpklaxikaialpbblalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLgQcdp:meaQpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogLpxiiiiiiiiiiiiiiiip8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklaalclfaYpQbfaKc:q:yjjbfRbbfhlxdkaialpbbwalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogLpxssssssssssssssssp8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklaalcwfaYpQbfaKc:q:yjjbfRbbfhlxekaialpbbbpklaalczfhlkdndndndndnaXco4Plbedibkaipxbbbbbbbbbbbbbbbbpkl8WxikaialpbblalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLgQcdp:meaQpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogLpxiiiiiiiiiiiiiiiip8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgXcitc:q1jjbfpbibaXc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgXcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spkl8WalclfaYpQbfaXc:q:yjjbfRbbfhlxdkaialpbbwalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogLpxssssssssssssssssp8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgXcitc:q1jjbfpbibaXc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgXcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spkl8WalcwfaYpQbfaXc:q:yjjbfRbbfhlxekaialpbbbpkl8Walczfhlkaoc;abfhiaocjefak0meaihoaral9Rc;Fb0mbkkdndnaiak9pmbaici4hoinaral9RcK6mdaCaifhXdndndndndnaOaico4fRbbaocoG4ciGPlbedibkaXpxbbbbbbbbbbbbbbbbpklbxikaXalpbblalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLgQcdp:meaQpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogLpxiiiiiiiiiiiiiiiip8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklbalclfaYpQbfaKc:q:yjjbfRbbfhlxdkaXalpbbwalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogLpxssssssssssssssssp8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklbalcwfaYpQbfaKc:q:yjjbfRbbfhlxekaXalpbbbpklbalczfhlkaocdfhoaiczfgiak6mbkkalTmbaAci6hHalhOaAcefgohAaoclSmdxekkcbhlaHceGmdkdnakTmbavcjdfazfhiavazfpbdbhYcbhXinaiavcj;cbfaXfgopblbgLcep9TaLpxeeeeeeeeeeeeeeeegQp9op9Hp9rgLaoakfpblbg8Acep9Ta8AaQp9op9Hp9rg8ApmbzeHdOiAlCvXoQrLgEaoamfpblbg3cep9Ta3aQp9op9Hp9rg3aoaxfpblbg5cep9Ta5aQp9op9Hp9rg5pmbzeHdOiAlCvXoQrLg8EpmbezHdiOAlvCXorQLgQaQpmbedibedibedibediaYp9UgYp9AdbbaiadfgoaYaQaQpmlvorlvorlvorlvorp9UgYp9AdbbaoadfgoaYaQaQpmwDqkwDqkwDqkwDqkp9UgYp9AdbbaoadfgoaYaQaQpmxmPsxmPsxmPsxmPsp9UgYp9AdbbaoadfgoaYaEa8EpmwDKYqk8AExm35Ps8E8FgQaQpmbedibedibedibedip9UgYp9AdbbaoadfgoaYaQaQpmlvorlvorlvorlvorp9UgYp9AdbbaoadfgoaYaQaQpmwDqkwDqkwDqkwDqkp9UgYp9AdbbaoadfgoaYaQaQpmxmPsxmPsxmPsxmPsp9UgYp9AdbbaoadfgoaYaLa8ApmwKDYq8AkEx3m5P8Es8FgLa3a5pmwKDYq8AkEx3m5P8Es8Fg8ApmbezHdiOAlvCXorQLgQaQpmbedibedibedibedip9UgYp9AdbbaoadfgoaYaQaQpmlvorlvorlvorlvorp9UgYp9AdbbaoadfgoaYaQaQpmwDqkwDqkwDqkwDqkp9UgYp9AdbbaoadfgoaYaQaQpmxmPsxmPsxmPsxmPsp9UgYp9AdbbaoadfgoaYaLa8ApmwDKYqk8AExm35Ps8E8FgQaQpmbedibedibedibedip9UgYp9AdbbaoadfgoaYaQaQpmlvorlvorlvorlvorp9UgYp9AdbbaoadfgoaYaQaQpmwDqkwDqkwDqkwDqkp9UgYp9AdbbaoadfgoaYaQaQpmxmPsxmPsxmPsxmPsp9UgYp9AdbbaoadfhiaXczfgXak6mbkkazclfgzad6mbkasavcjdfaqad2;8qbbavavcjdfaqcufad2fad;8qbbaqaDfhDc9:hoalmexikkc9:hoxekcbc99aral9Radcaadca0ESEhokavcj;kbf8Kjjjjbaokwbz:bjjjbk;uzeHu8Jjjjjbc;ae9Rgv8Kjjjjbc9:hodnaeci9UgrcHfal0mbcuhoaiRbbgwc;WeGc;Ge9hmbawcsGgDce0mbavc;abfcFecje;8kbavcUf9cu83ibavc8Wf9cu83ibavcyf9cu83ibavcaf9cu83ibavcKf9cu83ibavczf9cu83ibav9cu83iwav9cu83ibaialfc9WfhqaicefgwarfhodnaeTmbcmcsaDceSEhkcbhxcbhmcbhDcbhicbhlindnaoaq9nmbc9:hoxikdndnawRbbgrc;Ve0mbavc;abfalarcl4cu7fcsGcitfgPydlhsaPydbhzdnarcsGgPak9pmbavaiarcu7fcsGcdtfydbaxaPEhraPThPdndnadcd9hmbabaDcetfgHaz87ebaHcdfas87ebaHclfar87ebxekabaDcdtfgHazBdbaHclfasBdbaHcwfarBdbkaxaPfhxavc;abfalcitfgHarBdbaHasBdlavaicdtfarBdbavc;abfalcefcsGglcitfgHazBdbaHarBdlaiaPfhialcefhlxdkdndnaPcsSmbamaPfaPc987fcefhmxekaocefhrao8SbbgPcFeGhHdndnaPcu9mmbarhoxekaocvfhoaHcFbGhHcrhPdninar8SbbgOcFbGaPtaHVhHaOcu9kmearcefhraPcrfgPc8J9hmbxdkkarcefhokaHce4cbaHceG9R7amfhmkdndnadcd9hmbabaDcetfgraz87ebarcdfas87ebarclfam87ebxekabaDcdtfgrazBdbarclfasBdbarcwfamBdbkavc;abfalcitfgramBdbarasBdlavaicdtfamBdbavc;abfalcefcsGglcitfgrazBdbaramBdlaicefhialcefhlxekdnarcpe0mbaxcefgOavaiaqarcsGfRbbgPcl49RcsGcdtfydbaPcz6gHEhravaiaP9RcsGcdtfydbaOaHfgsaPcsGgOEhPaOThOdndnadcd9hmbabaDcetfgzax87ebazcdfar87ebazclfaP87ebxekabaDcdtfgzaxBdbazclfarBdbazcwfaPBdbkavaicdtfaxBdbavc;abfalcitfgzarBdbazaxBdlavaicefgicsGcdtfarBdbavc;abfalcefcsGcitfgzaPBdbazarBdlavaiaHfcsGgicdtfaPBdbavc;abfalcdfcsGglcitfgraxBdbaraPBdlalcefhlaiaOfhiasaOfhxxekaxcbaoRbbgzEgAarc;:eSgrfhsazcsGhCazcl4hXdndnazcs0mbascefhOxekashOavaiaX9RcsGcdtfydbhskdndnaCmbaOcefhxxekaOhxavaiaz9RcsGcdtfydbhOkdndnarTmbaocefhrxekaocdfhrao8SbegHcFeGhPdnaHcu9kmbaocofhAaPcFbGhPcrhodninar8SbbgHcFbGaotaPVhPaHcu9kmearcefhraocrfgoc8J9hmbkaAhrxekarcefhrkaPce4cbaPceG9R7amfgmhAkdndnaXcsSmbarhPxekarcefhPar8SbbgocFeGhHdnaocu9kmbarcvfhsaHcFbGhHcrhodninaP8SbbgrcFbGaotaHVhHarcu9kmeaPcefhPaocrfgoc8J9hmbkashPxekaPcefhPkaHce4cbaHceG9R7amfgmhskdndnaCcsSmbaPhoxekaPcefhoaP8SbbgrcFeGhHdnarcu9kmbaPcvfhOaHcFbGhHcrhrdninao8SbbgPcFbGartaHVhHaPcu9kmeaocefhoarcrfgrc8J9hmbkaOhoxekaocefhokaHce4cbaHceG9R7amfgmhOkdndnadcd9hmbabaDcetfgraA87ebarcdfas87ebarclfaO87ebxekabaDcdtfgraABdbarclfasBdbarcwfaOBdbkavc;abfalcitfgrasBdbaraABdlavaicdtfaABdbavc;abfalcefcsGcitfgraOBdbarasBdlavaicefgicsGcdtfasBdbavc;abfalcdfcsGcitfgraABdbaraOBdlavaiazcz6aXcsSVfgicsGcdtfaOBdbaiaCTaCcsSVfhialcifhlkawcefhwalcsGhlaicsGhiaDcifgDae6mbkkcbc99aoaqSEhokavc;aef8Kjjjjbaok:llevu8Jjjjjbcz9Rhvc9:hodnaecvfal0mbcuhoaiRbbc;:eGc;qe9hmbav9cb83iwaicefhraialfc98fhwdnaeTmbdnadcdSmbcbhDindnaraw6mbc9:skarcefhoar8SbbglcFeGhidndnalcu9mmbaohrxekarcvfhraicFbGhicrhldninao8SbbgdcFbGaltaiVhiadcu9kmeaocefhoalcrfglc8J9hmbxdkkaocefhrkabaDcdtfaicd4cbaice4ceG9R7avcwfaiceGcdtVgoydbfglBdbaoalBdbaDcefgDae9hmbxdkkcbhDindnaraw6mbc9:skarcefhoar8SbbglcFeGhidndnalcu9mmbaohrxekarcvfhraicFbGhicrhldninao8SbbgdcFbGaltaiVhiadcu9kmeaocefhoalcrfglc8J9hmbxdkkaocefhrkabaDcetfaicd4cbaice4ceG9R7avcwfaiceGcdtVgoydbfgl87ebaoalBdbaDcefgDae9hmbkkcbc99arawSEhokaok:EPliuo97eue978Jjjjjbca9Rhidndnadcl9hmbdnaec98GglTmbcbhvabhdinadadpbbbgocKp:RecKp:Sep;6egraocwp:RecKp:Sep;6earp;Geaoczp:RecKp:Sep;6egwp;Gep;Kep;LegDpxbbbbbbbbbbbbbbbbp:2egqarpxbbbjbbbjbbbjbbbjgkp9op9rp;Kegrpxbb;:9cbb;:9cbb;:9cbb;:9cararp;MeaDaDp;Meawaqawakp9op9rp;Kegrarp;Mep;Kep;Kep;Jep;Negwp;Mepxbbn0bbn0bbn0bbn0gqp;KepxFbbbFbbbFbbbFbbbp9oaopxbbbFbbbFbbbFbbbFp9op9qarawp;Meaqp;Kecwp:RepxbFbbbFbbbFbbbFbbp9op9qaDawp;Meaqp;Keczp:RepxbbFbbbFbbbFbbbFbp9op9qpkbbadczfhdavclfgval6mbkkalae9pmeaiaeciGgvcdtgdVcbczad9R;8kbaiabalcdtfglad;8qbbdnavTmbaiaipblbgocKp:RecKp:Sep;6egraocwp:RecKp:Sep;6earp;Geaoczp:RecKp:Sep;6egwp;Gep;Kep;LegDpxbbbbbbbbbbbbbbbbp:2egqarpxbbbjbbbjbbbjbbbjgkp9op9rp;Kegrpxbb;:9cbb;:9cbb;:9cbb;:9cararp;MeaDaDp;Meawaqawakp9op9rp;Kegrarp;Mep;Kep;Kep;Jep;Negwp;Mepxbbn0bbn0bbn0bbn0gqp;KepxFbbbFbbbFbbbFbbbp9oaopxbbbFbbbFbbbFbbbFp9op9qarawp;Meaqp;Kecwp:RepxbFbbbFbbbFbbbFbbp9op9qaDawp;Meaqp;Keczp:RepxbbFbbbFbbbFbbbFbp9op9qpklbkalaiad;8qbbskdnaec98GgxTmbcbhvabhdinadczfglalpbbbgopxbbbbbbFFbbbbbbFFgkp9oadpbbbgDaopmlvorxmPsCXQL358E8FpxFubbFubbFubbFubbp9op;6eaDaopmbediwDqkzHOAKY8AEgoczp:Sep;6egrp;Geaoczp:Reczp:Sep;6egwp;Gep;Kep;Legopxb;:FSb;:FSb;:FSb;:FSawaopxbbbbbbbbbbbbbbbbp:2egqawpxbbbjbbbjbbbjbbbjgmp9op9rp;Kegwawp;Meaoaop;Mearaqaramp9op9rp;Kegoaop;Mep;Kep;Kep;Jep;Negrp;Mepxbbn0bbn0bbn0bbn0gqp;Keczp:Reawarp;Meaqp;KepxFFbbFFbbFFbbFFbbp9op9qgwaoarp;Meaqp;KepxFFbbFFbbFFbbFFbbp9ogopmwDKYqk8AExm35Ps8E8Fp9qpkbbadaDakp9oawaopmbezHdiOAlvCXorQLp9qpkbbadcafhdavclfgvax6mbkkaxae9pmbaiaeciGgvcitgdfcbcaad9R;8kbaiabaxcitfglad;8qbbdnavTmbaiaipblzgopxbbbbbbFFbbbbbbFFgkp9oaipblbgDaopmlvorxmPsCXQL358E8FpxFubbFubbFubbFubbp9op;6eaDaopmbediwDqkzHOAKY8AEgoczp:Sep;6egrp;Geaoczp:Reczp:Sep;6egwp;Gep;Kep;Legopxb;:FSb;:FSb;:FSb;:FSawaopxbbbbbbbbbbbbbbbbp:2egqawpxbbbjbbbjbbbjbbbjgmp9op9rp;Kegwawp;Meaoaop;Mearaqaramp9op9rp;Kegoaop;Mep;Kep;Kep;Jep;Negrp;Mepxbbn0bbn0bbn0bbn0gqp;Keczp:Reawarp;Meaqp;KepxFFbbFFbbFFbbFFbbp9op9qgwaoarp;Meaqp;KepxFFbbFFbbFFbbFFbbp9ogopmwDKYqk8AExm35Ps8E8Fp9qpklzaiaDakp9oawaopmbezHdiOAlvCXorQLp9qpklbkalaiad;8qbbkk;4wllue97euv978Jjjjjbc8W9Rhidnaec98GglTmbcbhvabhoinaiaopbbbgraoczfgwpbbbgDpmlvorxmPsCXQL358E8Fgqczp:Segkclp:RepklbaopxbbjZbbjZbbjZbbjZpx;Zl81Z;Zl81Z;Zl81Z;Zl81Zakpxibbbibbbibbbibbbp9qp;6ep;NegkaraDpmbediwDqkzHOAKY8AEgrczp:Reczp:Sep;6ep;MegDaDp;Meakarczp:Sep;6ep;Megxaxp;Meakaqczp:Reczp:Sep;6ep;Megqaqp;Mep;Kep;Kep;Lepxbbbbbbbbbbbbbbbbp:4ep;Jepxb;:FSb;:FSb;:FSb;:FSgkp;Mepxbbn0bbn0bbn0bbn0grp;KepxFFbbFFbbFFbbFFbbgmp9oaxakp;Mearp;Keczp:Rep9qgxaqakp;Mearp;Keczp:ReaDakp;Mearp;Keamp9op9qgkpmbezHdiOAlvCXorQLgrp5baipblbpEb:T:j83ibaocwfarp5eaipblbpEe:T:j83ibawaxakpmwDKYqk8AExm35Ps8E8Fgkp5baipblbpEd:T:j83ibaocKfakp5eaipblbpEi:T:j83ibaocafhoavclfgval6mbkkdnalae9pmbaiaeciGgvcitgofcbcaao9R;8kbaiabalcitfgwao;8qbbdnavTmbaiaipblbgraipblzgDpmlvorxmPsCXQL358E8Fgqczp:Segkclp:RepklaaipxbbjZbbjZbbjZbbjZpx;Zl81Z;Zl81Z;Zl81Z;Zl81Zakpxibbbibbbibbbibbbp9qp;6ep;NegkaraDpmbediwDqkzHOAKY8AEgrczp:Reczp:Sep;6ep;MegDaDp;Meakarczp:Sep;6ep;Megxaxp;Meakaqczp:Reczp:Sep;6ep;Megqaqp;Mep;Kep;Kep;Lepxbbbbbbbbbbbbbbbbp:4ep;Jepxb;:FSb;:FSb;:FSb;:FSgkp;Mepxbbn0bbn0bbn0bbn0grp;KepxFFbbFFbbFFbbFFbbgmp9oaxakp;Mearp;Keczp:Rep9qgxaqakp;Mearp;Keczp:ReaDakp;Mearp;Keamp9op9qgkpmbezHdiOAlvCXorQLgrp5baipblapEb:T:j83ibaiarp5eaipblapEe:T:j83iwaiaxakpmwDKYqk8AExm35Ps8E8Fgkp5baipblapEd:T:j83izaiakp5eaipblapEi:T:j83iKkawaiao;8qbbkk:Pddiue978Jjjjjbc;ab9Rhidnadcd4ae2glc98GgvTmbcbhdabheinaeaepbbbgocwp:Recwp:Sep;6eaocep:SepxbbjZbbjZbbjZbbjZp:UepxbbjFbbjFbbjFbbjFp9op;Mepkbbaeczfheadclfgdav6mbkkdnaval9pmbaialciGgdcdtgeVcbc;abae9R;8kbaiabavcdtfgvae;8qbbdnadTmbaiaipblbgocwp:Recwp:Sep;6eaocep:SepxbbjZbbjZbbjZbbjZp:UepxbbjFbbjFbbjFbbjFp9op;Mepklbkavaiae;8qbbkk9teiucbcbydj1jjbgeabcifc98GfgbBdj1jjbdndnabZbcztgd9nmbcuhiabad9RcFFifcz4nbcuSmekaehikaikkkebcjwklz9Tbb";

	var detector = new Uint8Array([0,97,115,109,1,0,0,0,1,4,1,96,0,0,3,3,2,0,0,5,3,1,0,1,12,1,0,10,22,2,12,0,65,0,65,0,65,0,252,10,0,0,11,7,0,65,0,253,15,26,11]);
	var wasmpack = new Uint8Array([32,0,65,2,1,106,34,33,3,128,11,4,13,64,6,253,10,7,15,116,127,5,8,12,40,16,19,54,20,9,27,255,113,17,42,67,24,23,146,148,18,14,22,45,70,69,56,114,101,21,25,63,75,136,108,28,118,29,73,115]);

	if (typeof WebAssembly !== 'object') {
		return {
			supported: false,
		};
	}

	var wasm = WebAssembly.validate(detector) ? wasm_simd : wasm_base;

	var instance;

	var ready =
		WebAssembly.instantiate(unpack(wasm), {})
		.then(function(result) {
			instance = result.instance;
			instance.exports.__wasm_call_ctors();
		});

	function unpack(data) {
		var result = new Uint8Array(data.length);
		for (var i = 0; i < data.length; ++i) {
			var ch = data.charCodeAt(i);
			result[i] = ch > 96 ? ch - 97 : ch > 64 ? ch - 39 : ch + 4;
		}
		var write = 0;
		for (var i = 0; i < data.length; ++i) {
			result[write++] = (result[i] < 60) ? wasmpack[result[i]] : (result[i] - 60) * 64 + result[++i];
		}
		return result.buffer.slice(0, write);
	}

	function decode(fun, target, count, size, source, filter) {
		var sbrk = instance.exports.sbrk;
		var count4 = (count + 3) & ~3;
		var tp = sbrk(count4 * size);
		var sp = sbrk(source.length);
		var heap = new Uint8Array(instance.exports.memory.buffer);
		heap.set(source, sp);
		var res = fun(tp, count, size, sp, source.length);
		if (res == 0 && filter) {
			filter(tp, count4, size);
		}
		target.set(heap.subarray(tp, tp + count * size));
		sbrk(tp - sbrk(0));
		if (res != 0) {
			throw new Error("Malformed buffer data: " + res);
		}
	}

	var filters = {
		NONE: "",
		OCTAHEDRAL: "meshopt_decodeFilterOct",
		QUATERNION: "meshopt_decodeFilterQuat",
		EXPONENTIAL: "meshopt_decodeFilterExp",
	};

	var decoders = {
		ATTRIBUTES: "meshopt_decodeVertexBuffer",
		TRIANGLES: "meshopt_decodeIndexBuffer",
		INDICES: "meshopt_decodeIndexSequence",
	};

	var workers = [];
	var requestId = 0;

	function createWorker(url) {
		var worker = {
			object: new Worker(url),
			pending: 0,
			requests: {}
		};

		worker.object.onmessage = function(event) {
			var data = event.data;

			worker.pending -= data.count;
			worker.requests[data.id][data.action](data.value);

			delete worker.requests[data.id];
		};

		return worker;
	}

	function initWorkers(count) {
		var source =
			"var instance; var ready = WebAssembly.instantiate(new Uint8Array([" + new Uint8Array(unpack(wasm)) + "]), {})" +
			".then(function(result) { instance = result.instance; instance.exports.__wasm_call_ctors(); });" +
			"self.onmessage = workerProcess;" +
			decode.toString() + workerProcess.toString();

		var blob = new Blob([source], {type: 'text/javascript'});
		var url = URL.createObjectURL(blob);

		for (var i = 0; i < count; ++i) {
			workers[i] = createWorker(url);
		}

		URL.revokeObjectURL(url);
	}

	function decodeWorker(count, size, source, mode, filter) {
		var worker = workers[0];

		for (var i = 1; i < workers.length; ++i) {
			if (workers[i].pending < worker.pending) {
				worker = workers[i];
			}
		}

		return new Promise(function (resolve, reject) {
			var data = new Uint8Array(source);
			var id = requestId++;

			worker.pending += count;
			worker.requests[id] = { resolve: resolve, reject: reject };
			worker.object.postMessage({ id: id, count: count, size: size, source: data, mode: mode, filter: filter }, [ data.buffer ]);
		});
	}

	function workerProcess(event) {
		ready.then(function() {
			var data = event.data;
			try {
				var target = new Uint8Array(data.count * data.size);
				decode(instance.exports[data.mode], target, data.count, data.size, data.source, instance.exports[data.filter]);
				self.postMessage({ id: data.id, count: data.count, action: "resolve", value: target }, [ target.buffer ]);
			} catch (error) {
				self.postMessage({ id: data.id, count: data.count, action: "reject", value: error });
			}
		});
	}

	return {
		ready: ready,
		supported: true,
		useWorkers: function(count) {
			initWorkers(count);
		},
		decodeVertexBuffer: function(target, count, size, source, filter) {
			decode(instance.exports.meshopt_decodeVertexBuffer, target, count, size, source, instance.exports[filters[filter]]);
		},
		decodeIndexBuffer: function(target, count, size, source) {
			decode(instance.exports.meshopt_decodeIndexBuffer, target, count, size, source);
		},
		decodeIndexSequence: function(target, count, size, source) {
			decode(instance.exports.meshopt_decodeIndexSequence, target, count, size, source);
		},
		decodeGltfBuffer: function(target, count, size, source, mode, filter) {
			decode(instance.exports[decoders[mode]], target, count, size, source, instance.exports[filters[filter]]);
		},
		decodeGltfBufferAsync: function(count, size, source, mode, filter) {
			if (workers.length > 0) {
				return decodeWorker(count, size, source, decoders[mode], filters[filter]);
			}

			return ready.then(function() {
				var target = new Uint8Array(count * size);
				decode(instance.exports[decoders[mode]], target, count, size, source, instance.exports[filters[filter]]);
				return target;
			});
		}
	};
})();



;// CONCATENATED MODULE: ./src/sdk/rendering/RenderUtils.ts
var drawLineOnTop = function (mesh, renderOrder) {
    mesh.renderOrder = renderOrder;
    mesh.material.depthTest = false;
    mesh.material.transparent = true;
};
var drawLineNormally = function (mesh) {
    mesh.renderOrder = 0;
    mesh.material.depthTest = true;
    mesh.material.transparent = false;
};

;// CONCATENATED MODULE: ./src/sdk/rendering/GLTFModel.ts
var GLTFModel_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var GLTFModel_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};




var OUTLINE_NORMAL = 0xffffff;
var OUTLINE_TRUE_TILE = 0x00ffff;
var OUTLINE_SELECTED = 0xff0000;
// global loader across models
var loader = new GLTFLoader();
loader.setMeshoptDecoder(MeshoptDecoder);
// cache a copy of each model
var globalModelCache = {};
var DRAW_HITBOX = false;
var DEFAULT_SCALE = 1 / 128;
var DEFAULT_VERTICAL_OFFSET = -0.49;
/**
 * Render the model using one or more GLTF models. If there are multiple models, they are drawn superimposed on the same spot and are expected
 * to have the same animation set.
 */
var GLTFModel = /** @class */ (function () {
    function GLTFModel(renderable, models, options) {
        var _a, _b, _c;
        this.renderable = renderable;
        this.models = models;
        this.options = options;
        // parent object for all models loaded into this
        this.loadedModel = null;
        this.hasInitialisedModel = false;
        this.mixers = [];
        this.lastPoseId = -1;
        this.playingAnimationId = -1;
        this.playingAnimationCanBlend = false;
        this.playingAnimationPromiseResolve = null;
        // first index is the model ID, second index is the animation ID.
        this.animations = [];
        // models are loaded and inserted into `loadedModel` in indeterminate orders, so we save the index of each model
        this.modelOrder = [];
        var size = renderable.size;
        this.scale = (_a = options.scale) !== null && _a !== void 0 ? _a : DEFAULT_SCALE;
        this.verticalOffset = (_b = options.verticalOffset) !== null && _b !== void 0 ? _b : DEFAULT_VERTICAL_OFFSET;
        this.originOffset = (_c = options.originOffset) !== null && _c !== void 0 ? _c : { x: 0, y: 0 };
        this.outlineMaterial = new external_three_.LineBasicMaterial({
            color: OUTLINE_NORMAL,
        });
        var points = [
            new external_three_.Vector3(0, 0, 0),
            new external_three_.Vector3(size, 0, 0),
            new external_three_.Vector3(size, 0, 0),
            new external_three_.Vector3(size, 0, -size),
            new external_three_.Vector3(size, 0, -size),
            new external_three_.Vector3(0, 0, -size),
            new external_three_.Vector3(0, 0, -size),
            new external_three_.Vector3(0, 0, 0),
        ];
        var outlineGeometry = new external_three_.BufferGeometry().setFromPoints(points);
        this.outline = new external_three_.LineSegments(outlineGeometry, this.outlineMaterial);
        this.outline.visible = renderable.drawOutline;
        var trueTileGeometry = new external_three_.BufferGeometry().setFromPoints(points);
        this.trueTile = new external_three_.LineSegments(trueTileGeometry, new external_three_.LineBasicMaterial({
            color: OUTLINE_TRUE_TILE,
        }));
        this.trueTile.visible = renderable.drawTrueTile;
        var hullMaterial = new external_three_.MeshBasicMaterial({ color: 0x00000000 });
        hullMaterial.transparent = true;
        // size of hull get set once the model loads
        this.hullGeometry = new external_three_.CylinderGeometry(1, 1, 1, 6);
        this.clickHull = new external_three_.Mesh(this.hullGeometry, hullMaterial);
        this.clickHull.userData.clickable = renderable.selectable;
        this.clickHull.userData.unit = renderable;
        this.clickHull.visible = DRAW_HITBOX;
    }
    GLTFModel.forRenderable = function (r, model, options) {
        if (options === void 0) { options = {}; }
        return new GLTFModel(r, [model], options);
    };
    GLTFModel.forRenderableMulti = function (r, models, options) {
        if (options === void 0) { options = {}; }
        return new GLTFModel(r, models, options);
    };
    GLTFModel.prototype.animationChanged = function (id, blend) {
        return GLTFModel_awaiter(this, void 0, void 0, function () {
            return GLTFModel_generator(this, function (_a) {
                return [2 /*return*/, this.startPlayingAnimation(id, blend)];
            });
        });
    };
    GLTFModel.prototype.modelChanged = function () {
        var _this = this;
        if (!this.loadedModel) {
            return;
        }
        // TODO: handle model order that gets out of whack
        // TODO: what if get3dModel() now returns something other than GLTFModel? Bad times...
        var newModels = this.renderable.get3dModel().models;
        var toRemove = this.models.filter(function (model) { return !newModels.includes(model); });
        var toAdd = newModels.filter(function (model) { return !_this.models.includes(model); });
        toRemove.forEach(function (name) { return _this.loadedModel.remove(_this.loadedModel.getObjectByName(name)); });
        this.models = newModels;
        // (index is wrong here...)
        toAdd.forEach(function (name, index) { return _this.loadAndAddSingleModel(_this.loadedModel, name, index); });
    };
    GLTFModel.prototype.stopCurrentAnimation = function () {
        // needed otherwise the animations bleed into each other
        this.mixers.forEach(function (mixer) { return mixer.stopAllAction(); });
    };
    /**
     *
     * @param id id (in the animation file) to play
     * @param blend blend the new animation with the pose animation
     */
    GLTFModel.prototype.startPlayingAnimation = function (id, blend) {
        var _this = this;
        if (blend === void 0) { blend = false; }
        if (!blend) {
            this.stopCurrentAnimation();
            this.animations.forEach(function (animationsForModel) {
                animationsForModel.forEach(function (animation) { return animation.setEffectiveWeight(1.0); });
            });
        }
        else {
            this.animations.forEach(function (animationsForModel) {
                animationsForModel.forEach(function (animation) { return animation.setEffectiveWeight(0.5); });
            });
        }
        this.playingAnimationId = id;
        this.playingAnimationCanBlend = blend;
        this.animations.forEach(function (animationsForModel) {
            // play the animation for each part of the body
            var newAnimation = animationsForModel[id];
            newAnimation.setEffectiveWeight(blend ? 1 : 1.0);
            newAnimation.stop().setLoop(external_three_.LoopOnce, 1).play();
        });
        // reset the timer of the mixers because it seems to bug out and show the first frame sometimes
        // suspect that it has to do with the mixer time exceeding the length of the animation?
        this.mixers.forEach(function (mixerForModel) { return mixerForModel.setTime(0); });
        return new Promise(function (resolve) {
            _this.playingAnimationPromiseResolve = resolve;
            return;
        });
    };
    GLTFModel.prototype.onAnimationFinished = function (action) {
        var _this = this;
        this.stopCurrentAnimation();
        var nextAnimIndex = this.renderable.animationIndex;
        this.animations.forEach(function (animationsForModel, i) {
            var newAnimation = animationsForModel[nextAnimIndex];
            if (_this.playingAnimationCanBlend) {
                newAnimation.setEffectiveWeight(1.0);
            }
            // play the fallback/pose animation
            newAnimation.stop().setLoop(external_three_.LoopRepeat, Number.POSITIVE_INFINITY).play();
        });
        this.playingAnimationId = -1;
        this.playingAnimationCanBlend = false;
        if (this.playingAnimationPromiseResolve) {
            this.playingAnimationPromiseResolve();
            this.playingAnimationPromiseResolve = null;
        }
    };
    GLTFModel.prototype.onPoseChanged = function (newPoseId) {
        var _this = this;
        this.animations.forEach(function (animationsForModel, i) {
            var lastAnimation = animationsForModel[_this.lastPoseId];
            if (lastAnimation) {
                lastAnimation.stop();
            }
            if (_this.playingAnimationId >= 0 && !_this.playingAnimationCanBlend) {
                return;
            }
            var newAnimation = animationsForModel[newPoseId];
            // play the fallback/pose animation
            newAnimation.stop().setLoop(external_three_.LoopRepeat, Number.POSITIVE_INFINITY).play();
        });
    };
    GLTFModel.prototype.loadAndAddSingleModel = function (target, model, index) {
        var _this = this;
        var processGltf = function (gltf, clone) {
            var _a, _b;
            if (clone === void 0) { clone = false; }
            var scale = _this.scale;
            gltf.scene.name = model;
            gltf.scene.traverse(function (o) {
                if (o.isMesh) {
                    o.material.name = model;
                }
            });
            // make adjustments
            gltf.scene.scale.set(scale, scale, scale);
            var animations = gltf.animations;
            var scene = gltf.scene;
            if (clone) {
                scene = scene.clone();
            }
            target.add(scene);
            var size = new external_three_.Vector3();
            new external_three_.Box3().setFromObject(scene).getSize(size);
            var clickboxHeight = (_a = _this.renderable.clickboxHeight) !== null && _a !== void 0 ? _a : Math.max(_this.renderable.size, 0.4 * size.y);
            var clickboxRadius = (_b = _this.renderable.clickboxRadius) !== null && _b !== void 0 ? _b : _this.renderable.size * 0.4;
            _this.hullGeometry.scale(clickboxRadius, clickboxHeight, clickboxRadius);
            _this.hullGeometry.translate(0, clickboxHeight / 2 - 0.49, 0);
            // load and start animating
            if (animations.length === 0) {
                return;
            }
            var mixer = new external_three_.AnimationMixer(scene);
            _this.mixers.push(mixer);
            _this.animations.push(animations.map(function (animation) {
                var action = mixer.clipAction(animation);
                action.clampWhenFinished = true;
                action.zeroSlopeAtEnd = false;
                action.zeroSlopeAtStart = false;
                return action;
            }));
            _this.onAnimationFinished();
            // add listener to first mixer only
            if (_this.mixers.length === 1) {
                mixer.addEventListener("finished", function (e) {
                    _this.onAnimationFinished(e.action);
                });
            }
            _this.modelOrder.push(index);
        };
        if (model in globalModelCache) {
            // prevents reloading the model from file
            processGltf(globalModelCache[model], true);
        }
        else {
            loader.load(model, function (gltf) {
                globalModelCache[model] = gltf;
                processGltf(gltf);
            });
        }
    };
    GLTFModel.prototype.initialiseWholeModel = function () {
        var _this = this;
        var preparingMesh = new external_three_.Object3D();
        this.models.forEach(function (model, index) { return _this.loadAndAddSingleModel(preparingMesh, model, index); });
        this.loadedModel = preparingMesh;
    };
    GLTFModel.prototype.draw = function (scene, clockDelta, tickPercent, location, rotation, pitch, visible, modelOffsets) {
        var _this = this;
        var _a, _b;
        if (!this.hasInitialisedModel) {
            this.initialiseWholeModel();
            this.hasInitialisedModel = true;
        }
        if (this.loadedModel && this.loadedModel.parent !== scene) {
            scene.add(this.loadedModel);
            this.renderable.setAnimationListener(this);
        }
        if (this.outline.parent !== scene) {
            scene.add(this.outline);
            scene.add(this.trueTile);
            scene.add(this.clickHull);
        }
        this.outline.visible = this.renderable.drawOutline && visible;
        if (this.loadedModel) {
            this.loadedModel.visible = visible;
        }
        this.outlineMaterial.color.setHex(this.renderable.selected ? OUTLINE_SELECTED : OUTLINE_NORMAL);
        if (this.renderable.selected || this.renderable.outlineRenderOrder !== null) {
            drawLineOnTop(this.outline, (_a = this.renderable.outlineRenderOrder) !== null && _a !== void 0 ? _a : 1000);
        }
        else {
            drawLineNormally(this.outline);
        }
        if (this.renderable.animationIndex !== this.lastPoseId) {
            // start a new pose if the pose index changes and we're not currently playing an animation
            this.onPoseChanged(this.renderable.animationIndex);
            this.lastPoseId = this.renderable.animationIndex;
        }
        var x = location.x, y = location.y, z = location.z;
        this.outline.position.x = x;
        this.outline.position.y = -0.49;
        this.outline.position.z = y;
        this.outline.visible = this.renderable.drawOutline;
        if (this.renderable.drawTrueTile) {
            var _c = this.renderable.getTrueLocation(), trueX = _c.x, trueY = _c.y;
            this.trueTile.position.x = trueX;
            this.trueTile.position.y = -0.495;
            this.trueTile.position.z = trueY;
            if (this.renderable.trueTileRenderOrder !== null) {
                drawLineOnTop(this.trueTile, (_b = this.renderable.trueTileRenderOrder) !== null && _b !== void 0 ? _b : 1000);
            }
            else {
                drawLineNormally(this.trueTile);
            }
        }
        this.trueTile.visible = this.renderable.drawTrueTile;
        this.clickHull.position.x = x + this.renderable.size / 2;
        this.clickHull.position.z = y - this.renderable.size / 2;
        if (this.loadedModel) {
            this.mixers.forEach(function (mixer) { return mixer.update(clockDelta); });
            var size = this.renderable.size;
            var adjustedRotation = rotation + Math.PI / 2;
            this.loadedModel.position.x = x + size / 2 + this.originOffset.x;
            this.loadedModel.position.y = z + this.verticalOffset;
            this.loadedModel.position.z = y - size / 2 + this.originOffset.y;
            this.loadedModel.rotation.order = "YXZ";
            this.loadedModel.rotation.set(pitch, adjustedRotation, 0);
            this.loadedModel.children.forEach(function (child, idx) {
                var insertionIdx = _this.modelOrder[idx];
                if (modelOffsets[insertionIdx]) {
                    var offset = modelOffsets[insertionIdx];
                    child.position.set(offset.x, offset.z, offset.y);
                }
                else {
                    child.position.set(0, 0, 0);
                }
            });
        }
    };
    GLTFModel.prototype.destroy = function (scene) {
        if (this.loadedModel && this.loadedModel.parent === scene) {
            scene.remove(this.loadedModel);
            this.renderable.clearAnimationListener();
        }
        if (this.outline.parent === scene) {
            scene.remove(this.outline);
            scene.remove(this.trueTile);
            scene.remove(this.clickHull);
        }
    };
    GLTFModel.prototype.getWorldPosition = function () {
        return this.outline.getWorldPosition(new external_three_.Vector3());
    };
    GLTFModel.until = function (condition) {
        var poll = function (res) {
            if (condition()) {
                res();
            }
            else {
                setTimeout(function () { return poll(res); }, 50);
            }
        };
        return new Promise(poll);
    };
    GLTFModel.prototype.preload = function () {
        return GLTFModel_awaiter(this, void 0, void 0, function () {
            return GLTFModel_generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(this.models.map(function (model) { return GLTFModel.preload(model); }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    GLTFModel.preload = function (model) {
        return GLTFModel_awaiter(this, void 0, void 0, function () {
            var scene, gltf, camera, renderer, didRender;
            return GLTFModel_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        scene = new external_three_.Scene();
                        return [4 /*yield*/, loader.loadAsync(model)];
                    case 1:
                        gltf = _a.sent();
                        camera = new external_three_.PerspectiveCamera();
                        gltf.scene.scale.set(0.01, 0.01, 0.01);
                        gltf.scene.position.set(20, 0, 20);
                        scene.add(gltf.scene);
                        camera.position.set(10, 10, 10);
                        camera.lookAt(gltf.scene.position);
                        renderer = new external_three_.WebGLRenderer({
                            canvas: new OffscreenCanvas(1, 1),
                        });
                        renderer.setSize(1, 1, false);
                        didRender = false;
                        requestAnimationFrame(function () {
                            renderer.render(scene, camera);
                            didRender = true;
                        });
                        return [4 /*yield*/, GLTFModel.until(function () { return didRender; })];
                    case 2:
                        _a.sent();
                        scene.remove(gltf.scene);
                        renderer.dispose();
                        renderer.forceContextLoss();
                        return [2 /*return*/];
                }
            });
        });
    };
    return GLTFModel;
}());


;// CONCATENATED MODULE: ./src/sdk/Trainer.ts
// container for globals to prevent circular dependencies. Do NOT import Viewport into this class.
var Trainer = /** @class */ (function () {
    function Trainer() {
    }
    Trainer.setClickController = function (clickController) {
        this._clickController = clickController;
    };
    Trainer.setPlayer = function (player) {
        this._player = player;
    };
    Object.defineProperty(Trainer, "player", {
        get: function () {
            return this._player;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Trainer, "clickController", {
        get: function () {
            return this._clickController;
        },
        enumerable: false,
        configurable: true
    });
    Trainer.reset = function () {
        Trainer._player.region.reset();
    };
    return Trainer;
}());


;// CONCATENATED MODULE: ./src/sdk/weapons/Projectile.ts

var Projectile_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Projectile_assign = (undefined && undefined.__assign) || function () {
    Projectile_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return Projectile_assign.apply(this, arguments);
};









var targetIsLocation = function (x) { return x.x !== undefined; };
var Projectile = /** @class */ (function (_super) {
    Projectile_extends(Projectile, _super);
    /*
      This should take the player and mob object, and do chebyshev on the size of them
    */
    function Projectile(weapon, damage, from, to, attackStyle, options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this) || this;
        _this.weapon = weapon;
        _this.options = {};
        _this.age = 0;
        _this.attackStyle = attackStyle;
        if (Number.isNaN(damage)) {
            throw new Error("invalid damage value ".concat(damage));
        }
        _this.damage = Math.floor(damage);
        if (!targetIsLocation(to) && _this.damage > to.currentStats.hitpoint) {
            _this.damage = to.currentStats.hitpoint;
        }
        _this.options = Projectile_assign({ checkPrayerAtHit: false, modelScale: 1.0, verticalOffset: 0.0, visualDelayTicks: 0, visualHitEarlyTicks: 0 }, options);
        _this.startLocation = {
            x: from.location.x + (from.size - 1) / 2,
            y: from.location.y - (from.size - 1) / 2,
        };
        _this.currentLocation = Projectile_assign({}, _this.startLocation);
        _this.currentHeight = from.height * 0.75 + _this.options.verticalOffset; // projectile origin
        _this.from = from;
        _this.to = to;
        _this.distance = 999999;
        if (!weapon || Weapon.isMeleeAttackStyle(attackStyle)) {
            _this.distance = 0;
            _this.remainingDelay = 1;
        }
        else if (weapon) {
            if (weapon.image) {
                _this.image = weapon.image;
            }
            if (options.forceSWTile) {
                // Things like ice barrage calculate distance to SW tile only
                var targetSW = targetIsLocation(to) ? to : to.location;
                _this.distance = chebyshev_default()([_this.from.location.x, _this.from.location.y], [targetSW.x, targetSW.y]);
            }
            else if (targetIsLocation(to)) {
                var closestTile = to;
                var closestTileFrom = from.getClosestTileTo(to.x, to.y);
                _this.distance = chebyshev_default()([closestTileFrom[0], closestTileFrom[1]], [closestTile[0], closestTile[1]]);
            }
            else {
                var closestTile = to.getClosestTileTo(_this.from.location.x, _this.from.location.y);
                var closestTileFrom = from.getClosestTileTo(to.location.x, to.location.y);
                _this.distance = chebyshev_default()([closestTileFrom[0], closestTileFrom[1]], [closestTile[0], closestTile[1]]);
            }
            _this.remainingDelay = weapon.calculateHitDelay(_this.distance);
            if (from.isPlayer) {
                _this.remainingDelay++;
            }
            if (_this.options.reduceDelay) {
                _this.remainingDelay -= _this.options.reduceDelay;
                if (_this.remainingDelay < 1) {
                    _this.remainingDelay = 1;
                }
            }
        }
        _this.checkSound(_this.options.projectileSound, _this.options.visualDelayTicks);
        _this.checkSound(_this.options.sound, 0);
        _this.remainingDelay = options.setDelay || _this.remainingDelay;
        _this.totalDelay = _this.remainingDelay;
        _this._color = _this.options.color || _this.getColor();
        _this._size = _this.options.size || 0.5;
        if (_this.options.motionInterpolator) {
            _this.interpolator = _this.options.motionInterpolator;
        }
        else {
            _this.interpolator = new LinearProjectileMotionInterpolator();
        }
        return _this;
    }
    Projectile.prototype.isMeleeStyle = function () {
        return this.attackStyle === "slash" || this.attackStyle === "crush" || this.attackStyle === "stab";
    };
    Projectile.prototype.getColor = function () {
        if (this.isMeleeStyle()) {
            return "#FF0000";
        }
        else if (this.attackStyle === "range") {
            return "#00FF00";
        }
        else if (this.attackStyle === "magic") {
            return "#0000FF";
        }
        else if (this.attackStyle === "heal") {
            return "#9813aa";
        }
        else if (this.attackStyle === "recoil") {
            return "#000000";
        }
        console.log("[WARN] This style is not accounted for in custom coloring: ", this.attackStyle);
        return "#000000";
    };
    Projectile.prototype.getTargetDestination = function (tickPercent) {
        if (targetIsLocation(this.to)) {
            return this.to;
        }
        var _a = this.to.getPerceivedLocation(tickPercent), toX = _a.x, toY = _a.y;
        var endHeight = this.to.height * 0.5;
        var targetSize = this.to.size;
        var x = toX + (targetSize - 1) / 2;
        var y = toY - (targetSize - 1) / 2;
        return { x: x, y: y, z: endHeight };
    };
    Projectile.prototype.getPerceivedRotation = function (tickPercent) {
        var startX = this.startLocation.x;
        var startY = this.startLocation.y;
        var _a = this.getTargetDestination(tickPercent), endX = _a.x, endY = _a.y;
        return -Pathing.angle(startX, startY, endX, endY);
    };
    Projectile.prototype.getPerceivedPitch = function (tickPercent) {
        // pass in the CENTERED position of the projectile`
        var startX = this.startLocation.x;
        var startY = this.startLocation.y;
        var startHeight = this.currentHeight;
        var _a = this.getTargetDestination(tickPercent), endX = _a.x, endY = _a.y, endHeight = _a.z;
        var percent = this.getPercent(tickPercent);
        return this.interpolator.interpolatePitch({ x: startX, y: startY, z: startHeight }, { x: endX, y: endY, z: endHeight }, percent);
    };
    Projectile.prototype.getPercent = function (tickPercent) {
        var numerator = this.age - this.options.visualDelayTicks + tickPercent;
        var denominator = this.totalDelay - this.options.visualDelayTicks - this.options.visualHitEarlyTicks;
        // special case for short lifetime projectiles - we let it appear early
        if (denominator <= 0 && this.age >= this.options.visualDelayTicks - 1) {
            return tickPercent;
        }
        return numerator / denominator;
    };
    Projectile.prototype.checkSound = function (sound, delay) {
        if (Settings.playsAudio && sound && this.age === delay) {
            var player = Trainer.player;
            // projectiles launched at the player always play at full volume
            var volumeRatio = this.from === player || this.to === player
                ? 1.0
                : 1 /
                    Pathing.dist(Trainer.player.location.x, Trainer.player.location.y, this.startLocation.x, this.startLocation.y);
            volumeRatio = Math.min(1, Math.max(0, Math.sqrt(volumeRatio)));
            SoundCache.play({
                src: sound.src,
                volume: volumeRatio * sound.volume,
            });
        }
    };
    Projectile.prototype.onTick = function () {
        var targetLocation = this.getTargetDestination(0.0);
        this.currentLocation = {
            x: Pathing.linearInterpolation(this.currentLocation.x, targetLocation.x, 1 / (this.remainingDelay + 1)),
            y: Pathing.linearInterpolation(this.currentLocation.y, targetLocation.y, 1 / (this.remainingDelay + 1)),
        };
        this.remainingDelay--;
        this.age++;
        this.checkSound(this.options.projectileSound, this.options.visualDelayTicks);
    };
    // called as the projectile lands but before damage is calculated
    Projectile.prototype.beforeHit = function () {
        var _a;
        if (this.options.hitSound) {
            SoundCache.play(this.options.hitSound);
        }
        if (!targetIsLocation(this.to) && this.options.checkPrayerAtHit && ((_a = this.weapon) === null || _a === void 0 ? void 0 : _a.isBlockable(this.from, this.to, { attackStyle: this.attackStyle }))) {
            this.damage = 0;
        }
    };
    Projectile.prototype.shouldDestroy = function () {
        return this.age >= this.totalDelay + Math.max(0, -this.options.visualHitEarlyTicks);
    };
    Projectile.prototype.visible = function (tickPercent) {
        var percent = this.getPercent(tickPercent);
        return percent > 0 && percent <= 1;
    };
    Projectile.prototype.getPerceivedLocation = function (tickPercent) {
        var startX = this.startLocation.x;
        var startY = this.startLocation.y;
        var startHeight = this.currentHeight;
        var _a = this.getTargetDestination(tickPercent), endX = _a.x, endY = _a.y, endHeight = _a.z;
        var percent = this.getPercent(tickPercent);
        return this.interpolator.interpolate({ x: startX, y: startY, z: startHeight }, { x: endX, y: endY, z: endHeight }, percent);
    };
    Projectile.prototype.getPerceivedOffsets = function (tickPercent) {
        if (this.options.offsetsInterpolator) {
            var startX = this.startLocation.x;
            var startY = this.startLocation.y;
            var startHeight = this.currentHeight;
            var _a = this.getTargetDestination(tickPercent), endX = _a.x, endY = _a.y, endHeight = _a.z;
            var percent = this.getPercent(tickPercent);
            return this.options.offsetsInterpolator.interpolateOffsets({ x: startX, y: startY, z: startHeight }, { x: endX, y: endY, z: endHeight }, percent);
        }
        return _super.prototype.getPerceivedOffsets.call(this, tickPercent);
    };
    Projectile.prototype.getTrueLocation = function () {
        return this.getPerceivedLocation(0);
    };
    Object.defineProperty(Projectile.prototype, "size", {
        get: function () {
            return this._size;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Projectile.prototype, "color", {
        get: function () {
            return this._color;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Projectile.prototype, "drawOutline", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Projectile.prototype.create3dModel = function () {
        if (this.options.hidden || !this.attackStyle || this.color === "#000000") {
            return null;
        }
        if (this.options.models) {
            return GLTFModel.forRenderableMulti(this, this.options.models, { scale: this.options.modelScale });
        }
        if (this.options.model) {
            return GLTFModel.forRenderable(this, this.options.model, { scale: this.options.modelScale });
        }
        return BasicModel.sphereForRenderable(this);
    };
    Object.defineProperty(Projectile.prototype, "animationIndex", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    return Projectile;
}(Renderable));

var LinearProjectileMotionInterpolator = /** @class */ (function () {
    function LinearProjectileMotionInterpolator() {
    }
    LinearProjectileMotionInterpolator.prototype.interpolate = function (from, to, percent) {
        // default linear
        var startX = from.x;
        var startY = from.y;
        var startHeight = from.z;
        var endX = to.x;
        var endY = to.y;
        var endHeight = to.z;
        var perceivedX = Pathing.linearInterpolation(startX, endX, percent);
        var perceivedY = Pathing.linearInterpolation(startY, endY, percent);
        var perceivedHeight = startHeight === endHeight ? startHeight : Pathing.linearInterpolation(startHeight, endHeight, percent);
        return { x: perceivedX, y: perceivedY, z: perceivedHeight };
    };
    LinearProjectileMotionInterpolator.prototype.interpolatePitch = function (from, to, percent) {
        return 0;
    };
    return LinearProjectileMotionInterpolator;
}());

var ArcProjectileMotionInterpolator = /** @class */ (function () {
    function ArcProjectileMotionInterpolator(height) {
        this.height = height;
    }
    ArcProjectileMotionInterpolator.prototype.interpolate = function (from, to, percent) {
        var startX = from.x;
        var startY = from.y;
        var startHeight = from.z;
        var endX = to.x;
        var endY = to.y;
        var endHeight = to.z;
        var perceivedX = Pathing.linearInterpolation(startX, endX, percent);
        var perceivedY = Pathing.linearInterpolation(startY, endY, percent);
        var perceivedHeight = Math.sin(percent * Math.PI) * this.height + (endHeight - startHeight) * percent + startHeight;
        return { x: perceivedX, y: perceivedY, z: perceivedHeight };
    };
    ArcProjectileMotionInterpolator.prototype.interpolatePitch = function (from, to, percent) {
        return Math.sin(-(0.75 + percent * 0.5) * Math.PI);
    };
    return ArcProjectileMotionInterpolator;
}());

// Simply sticks to the target
var FollowTargetInterpolator = /** @class */ (function () {
    function FollowTargetInterpolator() {
    }
    FollowTargetInterpolator.prototype.interpolate = function (from, to, percent) {
        var endX = to.x;
        var endY = to.y;
        var endHeight = to.z;
        return { x: endX, y: endY, z: endHeight };
    };
    FollowTargetInterpolator.prototype.interpolatePitch = function (from, to, percent) {
        return 0;
    };
    return FollowTargetInterpolator;
}());


;// CONCATENATED MODULE: ./src/sdk/SetEffect.ts
var SetEffectTypes;
(function (SetEffectTypes) {
    SetEffectTypes["JUSTICIAR"] = "JUSTICIAR";
})(SetEffectTypes || (SetEffectTypes = {}));
var SetEffect = /** @class */ (function () {
    function SetEffect() {
    }
    SetEffect.effectName = function () {
        return "";
    };
    SetEffect.itemsInSet = function () {
        return [];
    };
    return SetEffect;
}());


;// CONCATENATED MODULE: ./src/sdk/ItemName.ts
var ItemName;
(function (ItemName) {
    ItemName["BLOOD_BARRAGE"] = "Blood Barrage";
    ItemName["ICE_BARRAGE"] = "Ice Barrage";
    ItemName["AHRIMS_ROBETOP"] = "Ahrim's robetop";
    ItemName["AHRIMS_ROBESKIRT"] = "Ahrim's robeskirt";
    ItemName["ANCESTRAL_ROBEBOTTOM"] = "Ancestral Robe bottom";
    ItemName["ANCESTRAL_ROBETOP"] = "Ancestral Robe top";
    ItemName["ANCIENT_STAFF"] = "Ancient staff";
    ItemName["ARMADYL_CHAINSKIRT"] = "Armadyl Chainskirt";
    ItemName["ARMADYL_CHESTPLATE"] = "Armadyl Chestplate";
    ItemName["AVAS_ACCUMULATOR"] = "Ava's accumulator";
    ItemName["AVAS_ASSEMBLER"] = "Avas Assembler";
    ItemName["BARROWS_GLOVES"] = "Barrows Gloves";
    ItemName["BASTION_POTION"] = "Bastion Potion";
    ItemName["BLACK_D_HIDE_BODY"] = "Black d'hide body";
    ItemName["BLACK_D_HIDE_CHAPS"] = "Black d'hide chaps";
    ItemName["BLACK_D_HIDE_VAMBRACES"] = "Black d'hide vambraces";
    ItemName["BLACK_CHINCHOMPA"] = "Black chinchompa";
    ItemName["BOWFA"] = "Bow of faerdhinen";
    ItemName["CRYSTAL_BODY"] = "Crystal Body";
    ItemName["CRYSTAL_HELM"] = "Crystal Helm";
    ItemName["CRYSTAL_LEGS"] = "Crystal Legs";
    ItemName["CRYSTAL_SHIELD"] = "Crystal Shield";
    ItemName["DAGON_HAI_ROBE_TOP"] = "Dagon'hai robe top";
    ItemName["DEVOUT_BOOTS"] = "Devout Boots";
    ItemName["DIAMOND_BOLTS_E"] = "Diamond bolts (e)";
    ItemName["DRAGON_ARROWS"] = "Dragon arrow";
    ItemName["GUTHIX_ROBE_TOP"] = "Guthix robe top";
    ItemName["HOLY_BLESSING"] = "Holy Blessing";
    ItemName["JUSTICIAR_CHESTGUARD"] = "Justiciar Chestguard";
    ItemName["JUSTICIAR_FACEGUARD"] = "Justiciar Faceguard";
    ItemName["JUSTICIAR_LEGGUARDS"] = "Justiciar Legguards";
    ItemName["KARAMBWAN"] = "Karambwan";
    ItemName["KODAI_WAND"] = "Kodai Wand";
    ItemName["MAGES_BOOK"] = "Mage's Book";
    ItemName["NECKLACE_OF_ANGUISH"] = "Necklace of Anguish";
    ItemName["OCCULT_NECKLACE"] = "Occult necklace";
    ItemName["PEGASIAN_BOOTS"] = "Pegasian Boots";
    ItemName["RANGER_BOOTS"] = "Ranger boots";
    ItemName["RING_OF_ENDURANCE"] = "Ring of Endurance";
    ItemName["RING_OF_SUFFERING_I"] = "Ring of Suffering (i)";
    ItemName["ROBIN_HOOD_HAT"] = "Robin hood hat";
    ItemName["RUBY_BOLTS_E"] = "Ruby bolts (e)";
    ItemName["RUNE_CROSSBOW"] = "Rune Crossbow";
    ItemName["RUNE_KITESHIELD"] = "Rune kiteshield";
    ItemName["SARADOMIN_BREW"] = "Saradomin Brew";
    ItemName["SARADOMIN_COIF"] = "Saradomin coif";
    ItemName["SARADOMIN_D_HIDE_BODY"] = "Saradomin d'hide body";
    ItemName["SARADOMIN_D_HIDE_BOOTS"] = "Saradomin d'hide boots";
    ItemName["SARADOMIN_D_HIDE_CHAPS"] = "Saradomin chaps";
    ItemName["SCYTHE_OF_VITUR"] = "Scythe of Vitur";
    ItemName["SHARK"] = "Shark";
    ItemName["SLAYER_HELMET_I"] = "Slayer helm (i)";
    ItemName["STAMINA_POTION"] = "Stamina Potion";
    ItemName["SUPER_RESTORE"] = "Super Restore";
    ItemName["TOXIC_BLOWPIPE"] = "Toxic Blowpipe";
    ItemName["TWISTED_BOW"] = "Twisted Bow";
    ItemName["ZARYTE_VAMBRACES"] = "Zaryte Vambraces";
    ItemName["MASORI_CHAPS_F"] = "Masori chaps (f)";
    ItemName["MASORI_BODY_F"] = "Masori body (f)";
    ItemName["MASORI_MASK_F"] = "Masori mask (f)";
    ItemName["DIZANAS_QUIVER"] = "Dizana's Quiver";
    ItemName["TORVA_PLATEBODY"] = "Torva platebody";
    ItemName["TORVA_PLATELEGS"] = "Torva platelegs";
    ItemName["TORVA_FULL_HELM"] = "Torva full helm";
    ItemName["AMULET_OF_TORTURE"] = "Amulet of torture";
    ItemName["PRIMORDIAL_BOOTS"] = "Primordial boots";
    ItemName["FEROCIOUS_GLOVES"] = "Ferocious gloves";
    ItemName["INFERNAL_CAPE"] = "Infernal cape";
    ItemName["SUPER_COMBAT_POTION"] = "Super combat potion";
    ItemName["BLADE_OF_SAELDOR"] = "Blade of saeldor";
    ItemName["AVERNIC_DEFENDER"] = "Avernic defender";
    ItemName["ULTOR_RING"] = "Ultor ring";
})(ItemName || (ItemName = {}));

;// CONCATENATED MODULE: ./src/assets/images/attackstyles/bow/accurate.png
const accurate_namespaceObject = __webpack_require__.p + "4ad955e3e08acdaebae5.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/bow/rapid.png
const rapid_namespaceObject = __webpack_require__.p + "b8fb2b682edcd2fd0f31.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/bow/longrange.png
const longrange_namespaceObject = __webpack_require__.p + "e89453914d6c939f248d.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/crossbows/accurate.png
const crossbows_accurate_namespaceObject = __webpack_require__.p + "61b23f64d3fe3ef0365f.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/crossbows/rapid.png
const crossbows_rapid_namespaceObject = __webpack_require__.p + "20ee1c00b1bad640f19c.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/crossbows/longrange.png
const crossbows_longrange_namespaceObject = __webpack_require__.p + "c0a2958faf3bbda91647.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/thrown/accurate.png
const thrown_accurate_namespaceObject = __webpack_require__.p + "52ecbb297eb6cb51d0d9.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/thrown/rapid.png
const thrown_rapid_namespaceObject = __webpack_require__.p + "56cc6ecbe7ace0122258.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/thrown/longrange.png
const thrown_longrange_namespaceObject = __webpack_require__.p + "1efea757d1b5335efe5d.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/staff/accurate.png
const staff_accurate_namespaceObject = __webpack_require__.p + "b14ef7443e26e4d5ee77.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/staff/aggressive.png
const aggressive_namespaceObject = __webpack_require__.p + "d330ac570b8787c5ed3c.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/staff/defensive.png
const defensive_namespaceObject = __webpack_require__.p + "925bf3a7692ef36f18ec.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/scythe/accurate.png
const scythe_accurate_namespaceObject = __webpack_require__.p + "0b96802520c114a99283.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/scythe/aggressiveslash.png
const aggressiveslash_namespaceObject = __webpack_require__.p + "46f97131f3c070803132.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/scythe/aggressivecrush.png
const aggressivecrush_namespaceObject = __webpack_require__.p + "74bae84163e8f31e48e2.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/scythe/defensive.png
const scythe_defensive_namespaceObject = __webpack_require__.p + "af4b3e185fc815a9ff04.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/chinchompas/short.png
const short_namespaceObject = __webpack_require__.p + "af0254e0a8460e2b048f.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/chinchompas/medium.png
const medium_namespaceObject = __webpack_require__.p + "226b0622b3a4dc1e37e7.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/chinchompas/long.png
const long_namespaceObject = __webpack_require__.p + "840747bbf1378388e397.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/swords/chop.png
const chop_namespaceObject = __webpack_require__.p + "bd4a0d8d88e478fd2f7d.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/swords/slash.png
const slash_namespaceObject = __webpack_require__.p + "8e1229e08828b015ee01.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/swords/lunge.png
const lunge_namespaceObject = __webpack_require__.p + "f2bf0e6cf3af145fcf7b.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/swords/block.png
const block_namespaceObject = __webpack_require__.p + "5615e73134324ee99e5c.png";
;// CONCATENATED MODULE: ./src/sdk/AttackStylesController.ts

var AttackStylesController_a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
























//https://oldschool.runescape.wiki/w/Weapons/Types
var AttackStyleTypes;
(function (AttackStyleTypes) {
    AttackStyleTypes["CROSSBOW"] = "CROSSBOW";
    AttackStyleTypes["BOW"] = "BOW";
    AttackStyleTypes["CHINCHOMPA"] = "CHINCOMPA";
    AttackStyleTypes["GUN"] = "GUN";
    AttackStyleTypes["THROWN"] = "THROWN";
    AttackStyleTypes["BLADEDSTAFF"] = "BLADEDSTAFF";
    AttackStyleTypes["POWEREDSTAFF"] = "POWEREDSTAFF";
    AttackStyleTypes["STAFF"] = "STAFF";
    AttackStyleTypes["SALAMANDER"] = "SALAMANDER";
    AttackStyleTypes["TWOHANDSWORD"] = "TWOHANDSWORD";
    AttackStyleTypes["AXE"] = "AXE";
    AttackStyleTypes["BANNER"] = "BANNER";
    AttackStyleTypes["BLUNT"] = "BLUNT";
    AttackStyleTypes["BLUDGEON"] = "BLUDGEON";
    AttackStyleTypes["BULWARK"] = "BULWARK";
    AttackStyleTypes["CLAW"] = "CLAW";
    AttackStyleTypes["PICKAXE"] = "PICKAXE";
    AttackStyleTypes["POLEARM"] = "POLEARM";
    AttackStyleTypes["POLESTAFF"] = "POLESTAFF";
    AttackStyleTypes["SCYTHE"] = "SCYTHE";
    AttackStyleTypes["SLASHSWORD"] = "SLASHSWORD";
    AttackStyleTypes["SPEAR"] = "SPEAR";
    AttackStyleTypes["SPIKEDWEAPON"] = "SPIKEDWEAPON";
    AttackStyleTypes["STABSWORD"] = "STABSWORD";
    AttackStyleTypes["UNARMED"] = "UNARMED";
    AttackStyleTypes["WHIP"] = "WHIP";
})(AttackStyleTypes || (AttackStyleTypes = {}));
var AttackStyle;
(function (AttackStyle) {
    AttackStyle["ACCURATE"] = "ACCURATE";
    AttackStyle["RAPID"] = "RAPID";
    AttackStyle["LONGRANGE"] = "LONGRANGE";
    AttackStyle["REAP"] = "REAP";
    AttackStyle["AGGRESSIVECRUSH"] = "AGGRESSIVE (CRUSH)";
    AttackStyle["AGGRESSIVESLASH"] = "AGGRESSIVE (SLASH)";
    AttackStyle["STAB"] = "STAB";
    AttackStyle["DEFENSIVE"] = "DEFENSIVE";
    AttackStyle["CONTROLLED"] = "CONTROLLED";
    AttackStyle["AUTOCAST"] = "AUTOCAST";
    AttackStyle["SHORT_FUSE"] = "SHORT_FUSE";
    AttackStyle["MEDIUM_FUSE"] = "MEDIUM_FUSE";
    AttackStyle["LONG_FUSE"] = "LONG_FUSE";
})(AttackStyle || (AttackStyle = {}));
// xp multiplier constants
var DEFENCE_2 = { skill: "defence", multiplier: 2 };
var HITPOINTS_133 = { skill: "hitpoint", multiplier: 1.33 };
var MELEE_ACCURATE = [{ skill: "attack", multiplier: 4 }, HITPOINTS_133];
var MELEE_AGGRESSIVE = [{ skill: "strength", multiplier: 4 }, HITPOINTS_133];
var MELEE_DEFENSIVE = [{ skill: "defence", multiplier: 4 }, HITPOINTS_133];
var MELEE_CONTROLLED = [
    { skill: "attack", multiplier: 1.33 },
    { skill: "strength", multiplier: 1.33 },
    { skill: "defence", multiplier: 1.33 },
    HITPOINTS_133,
];
var RANGE_ACCURATE = [{ skill: "range", multiplier: 4 }, HITPOINTS_133];
var RANGE_RAPID = [{ skill: "range", multiplier: 4 }, HITPOINTS_133];
var RANGE_LONGRANGE = [{ skill: "range", multiplier: 2 }, DEFENCE_2, HITPOINTS_133];
// This badly needs a refactor to classify each styles by parent style
var AttackStylesController = /** @class */ (function () {
    function AttackStylesController() {
        this.stylesMap = {};
    }
    AttackStylesController.prototype.getAttackStyleForType = function (type, weapon) {
        if (!this.stylesMap[type]) {
            this.stylesMap[type] = weapon.defaultStyle();
        }
        return this.stylesMap[type];
    };
    AttackStylesController.prototype.setWeaponAttackStyle = function (weapon, newStyle) {
        this.stylesMap[weapon.attackStyleCategory()] = newStyle;
    };
    AttackStylesController.prototype.getWeaponAttackStyle = function (weapon) {
        return this.stylesMap[weapon.attackStyleCategory()];
    };
    AttackStylesController.prototype.getWeaponXpDrops = function (style, damage, npcMultiplier) {
        return AttackStylesController.attackStyleXpType[style].map(function (_a) {
            var skill = _a.skill, skillMultiplier = _a.multiplier;
            return ({
                xp: damage * skillMultiplier * npcMultiplier,
                skill: skill,
            });
        });
    };
    AttackStylesController.prototype.getWeaponStrengthBonus = function (style) {
        var _a;
        return (_a = AttackStylesController.attackStyleStrengthBonus[style]) !== null && _a !== void 0 ? _a : 0;
    };
    AttackStylesController.attackStyleImageMap = (AttackStylesController_a = {},
        AttackStylesController_a[AttackStyleTypes.CROSSBOW] = (_b = {},
            _b[AttackStyle.ACCURATE] = ImageLoader.createImage(crossbows_accurate_namespaceObject),
            _b[AttackStyle.RAPID] = ImageLoader.createImage(crossbows_rapid_namespaceObject),
            _b[AttackStyle.LONGRANGE] = ImageLoader.createImage(crossbows_longrange_namespaceObject),
            _b),
        AttackStylesController_a[AttackStyleTypes.BOW] = (_c = {},
            _c[AttackStyle.ACCURATE] = ImageLoader.createImage(accurate_namespaceObject),
            _c[AttackStyle.RAPID] = ImageLoader.createImage(rapid_namespaceObject),
            _c[AttackStyle.LONGRANGE] = ImageLoader.createImage(longrange_namespaceObject),
            _c),
        AttackStylesController_a[AttackStyleTypes.STAFF] = (_d = {},
            _d[AttackStyle.ACCURATE] = ImageLoader.createImage(staff_accurate_namespaceObject),
            _d[AttackStyle.AGGRESSIVECRUSH] = ImageLoader.createImage(aggressive_namespaceObject),
            _d[AttackStyle.DEFENSIVE] = ImageLoader.createImage(defensive_namespaceObject),
            _d[AttackStyle.AUTOCAST] = ImageLoader.createImage(defensive_namespaceObject),
            _d),
        AttackStylesController_a[AttackStyleTypes.THROWN] = (_e = {},
            _e[AttackStyle.ACCURATE] = ImageLoader.createImage(thrown_accurate_namespaceObject),
            _e[AttackStyle.RAPID] = ImageLoader.createImage(thrown_rapid_namespaceObject),
            _e[AttackStyle.LONGRANGE] = ImageLoader.createImage(thrown_longrange_namespaceObject),
            _e),
        AttackStylesController_a[AttackStyleTypes.SCYTHE] = (_f = {},
            _f[AttackStyle.REAP] = ImageLoader.createImage(scythe_accurate_namespaceObject),
            _f[AttackStyle.AGGRESSIVESLASH] = ImageLoader.createImage(aggressiveslash_namespaceObject),
            _f[AttackStyle.AGGRESSIVECRUSH] = ImageLoader.createImage(aggressivecrush_namespaceObject),
            _f[AttackStyle.DEFENSIVE] = ImageLoader.createImage(scythe_defensive_namespaceObject),
            _f),
        AttackStylesController_a[AttackStyleTypes.SLASHSWORD] = (_g = {},
            _g[AttackStyle.ACCURATE] = ImageLoader.createImage(chop_namespaceObject),
            _g[AttackStyle.AGGRESSIVESLASH] = ImageLoader.createImage(slash_namespaceObject),
            _g[AttackStyle.STAB] = ImageLoader.createImage(lunge_namespaceObject),
            _g[AttackStyle.DEFENSIVE] = ImageLoader.createImage(block_namespaceObject),
            _g),
        AttackStylesController_a[AttackStyleTypes.CHINCHOMPA] = (_h = {},
            _h[AttackStyle.SHORT_FUSE] = ImageLoader.createImage(short_namespaceObject),
            _h[AttackStyle.MEDIUM_FUSE] = ImageLoader.createImage(medium_namespaceObject),
            _h[AttackStyle.LONG_FUSE] = ImageLoader.createImage(long_namespaceObject),
            _h),
        AttackStylesController_a);
    AttackStylesController.attackStyleXpType = (_j = {},
        _j[AttackStyle.ACCURATE] = RANGE_ACCURATE,
        _j[AttackStyle.RAPID] = RANGE_RAPID,
        _j[AttackStyle.LONGRANGE] = RANGE_LONGRANGE,
        _j[AttackStyle.REAP] = MELEE_ACCURATE,
        _j[AttackStyle.AGGRESSIVECRUSH] = MELEE_AGGRESSIVE,
        _j[AttackStyle.AGGRESSIVESLASH] = MELEE_AGGRESSIVE,
        // TODO: add different defensives for different weapons
        _j[AttackStyle.DEFENSIVE] = MELEE_DEFENSIVE,
        _j[AttackStyle.STAB] = MELEE_CONTROLLED,
        _j[AttackStyle.CONTROLLED] = MELEE_CONTROLLED,
        _j[AttackStyle.AUTOCAST] = [{ skill: "magic", multiplier: 2 }, HITPOINTS_133],
        // TODO: AUTOCAST_DEFENSIVE
        _j[AttackStyle.SHORT_FUSE] = RANGE_ACCURATE,
        _j[AttackStyle.MEDIUM_FUSE] = RANGE_RAPID,
        _j[AttackStyle.LONG_FUSE] = RANGE_LONGRANGE,
        _j);
    AttackStylesController.attackStyleStrengthBonus = (_k = {},
        // aggressive = 3
        _k[AttackStyle.AGGRESSIVECRUSH] = 3,
        _k[AttackStyle.AGGRESSIVESLASH] = 3,
        // controlled = 1
        _k[AttackStyle.CONTROLLED] = 1,
        _k[AttackStyle.STAB] = 1,
        _k);
    AttackStylesController.controller = new AttackStylesController();
    return AttackStylesController;
}());


;// CONCATENATED MODULE: ./src/sdk/Random.ts
var Random = /** @class */ (function () {
    function Random() {
    }
    Random.setRandom = function (fn) {
        Random.randomFn = fn;
    };
    Random.reset = function () {
        Random.memory = 0;
        Random.callCount = 0;
    };
    Random.get = function () {
        this.callCount++;
        return Random.randomFn();
    };
    Random.memory = 0;
    Random.callCount = 0;
    Random.randomFn = function () { return Math.random(); };
    return Random;
}());


;// CONCATENATED MODULE: ./src/sdk/rendering/GLTFAnimationConstants.ts
// this just happens to be the order that we exported the models animations in - see ASSETS.md
var PlayerAnimationIndices;
(function (PlayerAnimationIndices) {
    PlayerAnimationIndices[PlayerAnimationIndices["Idle"] = 0] = "Idle";
    PlayerAnimationIndices[PlayerAnimationIndices["Walk"] = 1] = "Walk";
    PlayerAnimationIndices[PlayerAnimationIndices["Run"] = 2] = "Run";
    PlayerAnimationIndices[PlayerAnimationIndices["Rotate180"] = 3] = "Rotate180";
    PlayerAnimationIndices[PlayerAnimationIndices["StrafeLeft"] = 4] = "StrafeLeft";
    PlayerAnimationIndices[PlayerAnimationIndices["StrafeRight"] = 5] = "StrafeRight";
    PlayerAnimationIndices[PlayerAnimationIndices["FireBow"] = 6] = "FireBow";
    PlayerAnimationIndices[PlayerAnimationIndices["FireBlowpipe"] = 7] = "FireBlowpipe";
    PlayerAnimationIndices[PlayerAnimationIndices["ThrowChinchompa"] = 8] = "ThrowChinchompa";
    PlayerAnimationIndices[PlayerAnimationIndices["ScytheIdle"] = 9] = "ScytheIdle";
    PlayerAnimationIndices[PlayerAnimationIndices["ScytheSwing"] = 10] = "ScytheSwing";
    PlayerAnimationIndices[PlayerAnimationIndices["SwordSlash"] = 11] = "SwordSlash";
})(PlayerAnimationIndices || (PlayerAnimationIndices = {}));

;// CONCATENATED MODULE: ./src/sdk/XpDrop.ts
var XpDrop = /** @class */ (function () {
    function XpDrop(skill, xp) {
        this.skill = skill;
        this.xp = xp;
    }
    return XpDrop;
}());


;// CONCATENATED MODULE: ./src/sdk/gear/Weapon.ts

var Weapon_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Weapon_assign = (undefined && undefined.__assign) || function () {
    Weapon_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return Weapon_assign.apply(this, arguments);
};











var Weapon = /** @class */ (function (_super) {
    Weapon_extends(Weapon, _super);
    function Weapon(projectileOptions) {
        if (projectileOptions === void 0) { projectileOptions = {}; }
        var _this = _super.call(this) || this;
        _this.projectileOptions = projectileOptions;
        _this.lastHitHit = false;
        _this.selected = false;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        return _this;
    }
    Weapon.prototype.attackStyles = function () {
        return [];
    };
    Weapon.prototype.compatibleAmmo = function () {
        return [];
    };
    Weapon.prototype.attackStyleCategory = function () {
        return null;
    };
    Weapon.prototype.defaultStyle = function () {
        return AttackStyle.RAPID;
    };
    Weapon.prototype.attackStyle = function () {
        return AttackStylesController.controller.getAttackStyleForType(this.attackStyleCategory(), this);
    };
    Weapon.prototype.assignToPlayer = function (player) {
        player.equipment.weapon = this;
        player.interruptCombat();
    };
    Weapon.prototype.unassignToPlayer = function (player) {
        player.equipment.weapon = null;
    };
    Weapon.prototype.currentEquipment = function (player) {
        return player.equipment.weapon;
    };
    Weapon.prototype.hasSpecialAttack = function () {
        return false;
    };
    Weapon.prototype.specialAttackDrain = function () {
        return 50;
    };
    Weapon.prototype.specialAttack = function (from, to, bonuses, options) {
        if (bonuses === void 0) { bonuses = {}; }
        if (options === void 0) { options = {}; }
        // Override me
    };
    Weapon.prototype.inventoryLeftClick = function (player) {
        var currentWeapon = player.equipment.weapon || null;
        var currentOffhand = player.equipment.offhand || null;
        var openInventorySlots = player.openInventorySlots();
        openInventorySlots.unshift(player.inventory.indexOf(this));
        var neededInventorySlots = 0;
        if (this.isTwoHander && currentWeapon) {
            neededInventorySlots++;
        }
        if (this.isTwoHander && currentOffhand) {
            neededInventorySlots++;
        }
        if (currentWeapon) {
            neededInventorySlots--;
        }
        if (neededInventorySlots > openInventorySlots.length) {
            return;
        }
        this.assignToPlayer(player);
        if (currentWeapon) {
            player.inventory[openInventorySlots.shift()] = currentWeapon;
        }
        else {
            player.inventory[openInventorySlots.shift()] = null;
            openInventorySlots = player.openInventorySlots();
        }
        if (this.isTwoHander && currentOffhand) {
            player.inventory[openInventorySlots.shift()] = currentOffhand;
            player.equipment.offhand = null;
        }
        player.equipmentChanged();
    };
    Weapon.prototype.cast = function (from, to) {
        // Override me
    };
    Weapon.prototype.rollDamage = function (from, to, bonuses) {
        this.damageRoll = Math.floor(this._rollAttack(from, to, bonuses));
        this.damage = Math.min(this.damageRoll, to.currentStats.hitpoint);
    };
    Weapon.prototype.calculateHitDelay = function (distance) {
        return 999;
    };
    // Return value: If the attack was performed or not. If the attack was not performed, do not reset timers.
    Weapon.prototype.attack = function (from, to, bonuses, options) {
        var _this = this;
        if (bonuses === void 0) { bonuses = {}; }
        if (options === void 0) { options = {}; }
        this._calculatePrayerEffects(from, to, bonuses);
        bonuses.styleBonus = bonuses.styleBonus || 0;
        bonuses.voidMultiplier = bonuses.voidMultiplier || 1;
        bonuses.gearMeleeMultiplier = bonuses.gearMeleeMultiplier || 1;
        bonuses.gearMageMultiplier = bonuses.gearMageMultiplier || 1;
        bonuses.gearRangeMultiplier = bonuses.gearRangeMultiplier || 1;
        bonuses.overallMultiplier = bonuses.overallMultiplier || 1.0;
        this.rollDamage(from, to, bonuses);
        if (this.damage === -1) {
            return false;
        }
        if (to.setEffects) {
            (0,lodash.find)(to.setEffects, function (effect) {
                if (effect.effectName() === SetEffectTypes.JUSTICIAR) {
                    var tosDefenceBonus = to.bonuses.defence[bonuses.attackStyle];
                    if (tosDefenceBonus !== undefined) {
                        // hack?
                        var justiciarDamageReduction = Math.max(tosDefenceBonus / 3000, 0);
                        _this.damage -= Math.ceil(justiciarDamageReduction * _this.damage);
                    }
                }
            });
        }
        // Protection prayers
        if (this.isBlockable(from, to, bonuses)) {
            this.damage = 0;
        }
        // sanitize damage output
        this.damage = Math.floor(Math.max(Math.min(to.currentStats.hitpoint, this.damage, 100), 0));
        if (to.equipment.ring && to.equipment.ring.itemName === ItemName.RING_OF_SUFFERING_I && this.damage > 0) {
            from.addProjectile(new Projectile(this, Math.floor(this.damage * 0.1) + 1, to, from, "recoil", { reduceDelay: 15, hidden: true }));
        }
        this.grantXp(from, to);
        this.registerProjectile(from, to, bonuses, options);
        return true;
    };
    Weapon.prototype._rollAttack = function (from, to, bonuses) {
        this.lastHitHit = false;
        return Random.get() > this._hitChance(from, to, bonuses) ? 0 : this._calculateHitDamage(from, to, bonuses);
    };
    Weapon.prototype._calculateHitDamage = function (from, to, bonuses) {
        this.lastHitHit = true;
        return Math.floor(Random.get() * (this._maxHit(from, to, bonuses) + 1));
    };
    Weapon.prototype._attackRoll = function (from, to, bonuses) {
        return 0; // weapons implement this at the type tier
    };
    Weapon.prototype._defenceRoll = function (from, to, bonuses) {
        return 0; // weapons implement this at the type tier
    };
    Weapon.prototype._maxHit = function (from, to, bonuses) {
        return 0; // weapons implement this at the type tier
    };
    Weapon.prototype._hitChance = function (from, to, bonuses) {
        var attackRoll = this._attackRoll(from, to, bonuses);
        var defenceRoll = this._defenceRoll(from, to, bonuses);
        var hitChance = attackRoll > defenceRoll ? 1 - (defenceRoll + 2) / (2 * attackRoll + 1) : attackRoll / (2 * defenceRoll + 1);
        return hitChance;
    };
    Weapon.prototype.isBlockable = function (from, to, bonuses) {
        return false; // weapons implement this at the type tier
    };
    Weapon.prototype.grantXp = function (from, to) {
        if (from.type === UnitTypes.PLAYER && this.damage > 0) {
            AttackStylesController.controller
                .getWeaponXpDrops(this.attackStyle(), this.damage, to.xpBonusMultiplier)
                .forEach(function (_a) {
                var skill = _a.skill, xp = _a.xp;
                from.grantXp(new XpDrop(skill, xp));
            });
        }
    };
    Weapon.prototype._calculatePrayerEffects = function (from, to, bonuses) {
        // weapons implement this at the type tier
    };
    Weapon.prototype.registerProjectile = function (from, to, bonuses, options) {
        if (options === void 0) { options = {}; }
        to.addProjectile(new Projectile(this, this.damage, from, to, bonuses.attackStyle, Weapon_assign(Weapon_assign({ sound: this.attackSound, hitSound: this.attackLandingSound, model: this.projectileModel }, this.projectileOptions), options)));
    };
    Object.defineProperty(Weapon.prototype, "image", {
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Weapon.prototype, "attackRange", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Weapon.prototype, "attackSpeed", {
        get: function () {
            return 10;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Weapon.prototype, "aoe", {
        get: function () {
            return [{ x: 0, y: 0 }];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Weapon.prototype, "isAreaAttack", {
        // Returns true if this attack is an area-based attack that doesn't require line of sight to
        // the target (including if the target is underneath).
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Weapon.prototype, "isMeleeAttack", {
        // Returns true if this attack is a melee attack (and therefore cannot attack on corners).
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Weapon.prototype, "isTwoHander", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Weapon.isMeleeAttackStyle = function (style) {
        return style === "crush" || style === "slash" || style === "stab";
    };
    Object.defineProperty(Weapon.prototype, "attackSound", {
        get: function () {
            // Override me
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Weapon.prototype, "specialAttackSound", {
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Weapon.prototype, "attackLandingSound", {
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Weapon.prototype, "projectileModel", {
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Weapon.prototype, "idleAnimationId", {
        get: function () {
            return PlayerAnimationIndices.Idle;
        },
        enumerable: false,
        configurable: true
    });
    return Weapon;
}(Equipment));


;// CONCATENATED MODULE: ./src/sdk/rendering/CanvasSpriteModel.ts
var CanvasSpriteModel_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var CanvasSpriteModel_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


var CANVAS_TILE_SIZE = 20;
var CanvasSpriteModel_OUTLINE_NORMAL = 0xffffff;
var CanvasSpriteModel_OUTLINE_SELECTED = 0xff0000;
/**
 * Render the model using a sprite derived from the 2d representation of the renderable.
 */
var CanvasSpriteModel = /** @class */ (function () {
    function CanvasSpriteModel(renderable) {
        this.renderable = renderable;
        var size = renderable.size;
        this.canvas = new OffscreenCanvas(size * CANVAS_TILE_SIZE, size * CANVAS_TILE_SIZE);
        this.context = this.canvas.getContext("2d");
        this.texture = new external_three_.Texture(this.canvas);
        this.texture.needsUpdate = true;
        this.texture.colorSpace = external_three_.LinearSRGBColorSpace;
        var material = new external_three_.SpriteMaterial({
            alphaTest: 0.5,
            map: this.texture,
            transparent: true,
            color: 0xffffff,
        });
        this.sprite = new external_three_.Sprite(material);
        this.sprite.scale.set(size, size, size);
        // trial and error to get the sprite to sit on top of the tile. could probably be set per-mob
        this.sprite.center.y = 0.075;
        this.sprite.userData.clickable = renderable.selectable;
        this.sprite.userData.unit = renderable;
        this.outlineMaterial = new external_three_.LineBasicMaterial({
            color: CanvasSpriteModel_OUTLINE_NORMAL,
        });
        var points = [
            new external_three_.Vector3(0, 0, 0),
            new external_three_.Vector3(size, 0, 0),
            new external_three_.Vector3(size, 0, 0),
            new external_three_.Vector3(size, 0, -size),
            new external_three_.Vector3(size, 0, -size),
            new external_three_.Vector3(0, 0, -size),
            new external_three_.Vector3(0, 0, -size),
            new external_three_.Vector3(0, 0, 0),
        ];
        var geometry = new external_three_.BufferGeometry().setFromPoints(points);
        this.outline = new external_three_.LineSegments(geometry, this.outlineMaterial);
    }
    CanvasSpriteModel.forRenderable = function (r) {
        return new CanvasSpriteModel(r);
    };
    CanvasSpriteModel.prototype.draw = function (scene, clockDelta, tickPercent, location, rotation, pitch, visible) {
        var _a;
        if (this.sprite.parent !== scene) {
            scene.add(this.sprite);
            scene.add(this.outline);
        }
        var size = this.renderable.size;
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.renderable.draw(tickPercent, this.context, { x: 0, y: size - 1 }, CANVAS_TILE_SIZE, false);
        this.texture.needsUpdate = true;
        this.outlineMaterial.color.setHex(this.renderable.selected ? CanvasSpriteModel_OUTLINE_SELECTED : CanvasSpriteModel_OUTLINE_NORMAL);
        if (this.renderable.selected || this.renderable.outlineRenderOrder !== null) {
            drawLineOnTop(this.outline, (_a = this.renderable.outlineRenderOrder) !== null && _a !== void 0 ? _a : 100);
        }
        else {
            drawLineNormally(this.outline);
        }
        this.sprite.visible = visible;
        this.outline.visible = visible;
        var x = location.x, y = location.y;
        this.outline.position.x = x;
        this.outline.position.y = -0.49;
        this.outline.position.z = y;
        this.sprite.position.x = x + size / 2;
        this.sprite.position.y = -0.5;
        this.sprite.position.z = y - size / 2;
    };
    CanvasSpriteModel.prototype.destroy = function (scene) {
        if (this.sprite.parent === scene) {
            scene.remove(this.sprite);
            scene.remove(this.outline);
        }
    };
    CanvasSpriteModel.prototype.getWorldPosition = function () {
        return this.sprite.getWorldPosition(new external_three_.Vector3());
    };
    CanvasSpriteModel.prototype.preload = function () {
        return CanvasSpriteModel_awaiter(this, void 0, void 0, function () {
            return CanvasSpriteModel_generator(this, function (_a) {
                // do nothing
                return [2 /*return*/];
            });
        });
    };
    return CanvasSpriteModel;
}());


;// CONCATENATED MODULE: ./src/sdk/Input.ts

var MAX_QUEUED_ACTIONS = 8;
/**
 * Controller to manage delayed inputs (due to input lag and/or tick timers)
 */
var InputController = /** @class */ (function () {
    function InputController() {
        this.inputDelay = null;
        this.queuedActions = [];
    }
    InputController.prototype.queueAction = function (fn) {
        var _this = this;
        /*if (this.inputDelay) {
          clearTimeout(this.inputDelay);
        }*/
        if (this.queuedActions.length >= MAX_QUEUED_ACTIONS) {
            return;
        }
        this.inputDelay = setTimeout(function () {
            _this.queuedActions.push(fn);
        }, Settings.inputDelay);
    };
    InputController.prototype.onWorldTick = function () {
        var actions = this.flushQueuedActions();
        actions.forEach(function (action) { return action(); });
    };
    InputController.prototype.flushQueuedActions = function () {
        var actions = this.queuedActions;
        this.queuedActions = [];
        return actions;
    };
    InputController.controller = new InputController();
    return InputController;
}());


;// CONCATENATED MODULE: ./src/sdk/Mob.ts

var Mob_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();











var AttackIndicators;
(function (AttackIndicators) {
    AttackIndicators[AttackIndicators["NONE"] = 0] = "NONE";
    AttackIndicators[AttackIndicators["HIT"] = 1] = "HIT";
    AttackIndicators[AttackIndicators["BLOCKED"] = 2] = "BLOCKED";
    AttackIndicators[AttackIndicators["SCAN"] = 3] = "SCAN";
})(AttackIndicators || (AttackIndicators = {}));
var Mob = /** @class */ (function (_super) {
    Mob_extends(Mob, _super);
    function Mob(region, location, options) {
        var _this = _super.call(this, region, location, options) || this;
        _this.mobId = Mob.mobIdTracker++;
        _this.hasResurrected = false;
        _this.removableWithRightClick = false;
        return _this;
    }
    Object.defineProperty(Mob.prototype, "type", {
        get: function () {
            return UnitTypes.MOB;
        },
        enumerable: false,
        configurable: true
    });
    Mob.prototype.canBeAttacked = function () {
        return true;
    };
    Mob.prototype.setStats = function () {
        // non boosted numbers
        this.stats = {
            attack: 99,
            strength: 99,
            defence: 99,
            range: 99,
            magic: 99,
            hitpoint: 99,
        };
        // with boosts
        this.currentStats = {
            attack: 99,
            strength: 99,
            defence: 99,
            range: 99,
            magic: 99,
            hitpoint: 99,
        };
    };
    Object.defineProperty(Mob.prototype, "bonuses", {
        get: function () {
            return {
                attack: {
                    stab: 0,
                    slash: 0,
                    crush: 0,
                    magic: 0,
                    range: 0,
                },
                defence: {
                    stab: 0,
                    slash: 0,
                    crush: 0,
                    magic: 0,
                    range: 0,
                },
                other: {
                    meleeStrength: 0,
                    rangedStrength: 0,
                    magicDamage: 0,
                    prayer: 0,
                },
            };
        },
        enumerable: false,
        configurable: true
    });
    /**
     *
     * @returns the next location to move to
     */
    Mob.prototype.getNextMovementStep = function () {
        var dx = this.location.x + Math.sign(this.aggro.location.x - this.location.x);
        var dy = this.location.y + Math.sign(this.aggro.location.y - this.location.y);
        if (Collision.collisionMath(this.location.x, this.location.y, this.size, this.aggro.location.x, this.aggro.location.y, 1)) {
            if (this.aggro && this.aggro.lastInteraction === this && this.aggro.lastInteractionAge === 0) {
                // cannot move
                return { dx: this.location.x, dy: this.location.y };
            }
            // Random movement if player is under the mob.
            if (Random.get() < 0.5) {
                dy = this.location.y;
                if (Random.get() < 0.5) {
                    dx = this.location.x + 1;
                }
                else {
                    dx = this.location.x - 1;
                }
            }
            else {
                dx = this.location.x;
                if (Random.get() < 0.5) {
                    dy = this.location.y + 1;
                }
                else {
                    dy = this.location.y - 1;
                }
            }
        }
        else if (Collision.collisionMath(dx, dy, this.size, this.aggro.location.x, this.aggro.location.y, 1)) {
            // allows corner safespotting
            dy = this.location.y;
        }
        if (this.attackDelay > this.attackSpeed) {
            // No movement right after melee dig. 8 ticks after the dig it should be able to move again.
            dx = this.location.x;
            dy = this.location.y;
        }
        return { dx: dx, dy: dy };
    };
    Mob.prototype.timerStep = function () {
        // override me
    };
    Mob.prototype.movementStep = function () {
        var _this = this;
        if (this.dying === 0) {
            return;
        }
        this.processIncomingAttacks();
        this.age--;
        if (this.age > 0) {
            return;
        }
        this.perceivedLocation = { x: this.location.x, y: this.location.y };
        this.setHasLOS();
        if (this.canMove() && this.aggro) {
            var _a = this.getNextMovementStep(), dx = _a.dx, dy = _a.dy;
            var xOff = dx - this.location.x;
            var yOff = this.location.y - dy;
            var xTiles = this.getXMovementTiles(xOff, yOff);
            var yTiles = this.getYMovementTiles(xOff, yOff);
            var xSpace = (0,lodash.every)(xTiles.map(function (location) {
                return Pathing.canTileBePathedTo(_this.region, location.x, location.y, 1, _this.consumesSpace);
            }), Boolean);
            var ySpace = (0,lodash.every)(yTiles.map(function (location) {
                return Pathing.canTileBePathedTo(_this.region, location.x, location.y, 1, _this.consumesSpace);
            }), Boolean);
            var both = xSpace && ySpace;
            // if (this.mobName() === EntityName.JAL_AK){
            //   this.tcc =  xTiles; //xTiles.concat(yTiles);
            // }
            if (!both) {
                xTiles = this.getXMovementTiles(xOff, 0);
                xSpace = (0,lodash.every)(xTiles.map(function (location) {
                    return Pathing.canTileBePathedTo(_this.region, location.x, location.y, 1, _this.consumesSpace);
                }), Boolean);
                if (!xSpace) {
                    yTiles = this.getYMovementTiles(0, yOff);
                    ySpace = (0,lodash.every)(yTiles.map(function (location) {
                        return Pathing.canTileBePathedTo(_this.region, location.x, location.y, 1, _this.consumesSpace);
                    }), Boolean);
                }
            }
            if (both) {
                this.location.x = dx;
                this.location.y = dy;
            }
            else if (xSpace) {
                this.location.x = dx;
            }
            else if (ySpace) {
                this.location.y = dy;
            }
        }
    };
    Mob.prototype.getXMovementTiles = function (xOff, yOff) {
        var start = yOff === -1 ? -1 : 0;
        var end = yOff === 1 ? this.size + 1 : this.size;
        var xTiles = [];
        if (xOff === -1) {
            for (var i = start; i < end; i++) {
                xTiles.push({
                    x: this.location.x - 1,
                    y: this.location.y - i,
                });
            }
        }
        else if (xOff === 1) {
            for (var i = start; i < end; i++) {
                xTiles.push({
                    x: this.location.x + this.size,
                    y: this.location.y - i,
                });
            }
        }
        return xTiles;
    };
    Mob.prototype.getYMovementTiles = function (xOff, yOff) {
        var start = xOff === -1 ? -1 : 0;
        var end = xOff === 1 ? this.size + 1 : this.size;
        var yTiles = [];
        if (yOff === -1) {
            // south
            for (var i = start; i < end; i++) {
                yTiles.push({
                    x: this.location.x + i,
                    y: this.location.y + 1,
                });
            }
        }
        else if (yOff === 1) {
            // north
            for (var i = start; i < end; i++) {
                yTiles.push({
                    x: this.location.x + i,
                    y: this.location.y - this.size,
                });
            }
        }
        return yTiles;
    };
    // todo: Rename this possibly? it returns the attack style if it's possible
    Mob.prototype.canMeleeIfClose = function () {
        return "";
    };
    Mob.prototype.attackStep = function () {
        _super.prototype.attackStep.call(this);
        if (this.age > 0) {
            return;
        }
        if (this.dying === 0) {
            return;
        }
        this.attackIfPossible();
        this.detectDeath();
        this.frozen--;
        this.stunned--;
    };
    Mob.prototype.attackStyleForNewAttack = function () {
        return "slash";
    };
    Mob.prototype.attackIfPossible = function () {
        this.hadLOS = this.hasLOS;
        this.setHasLOS();
        if (!this.aggro || this.canAttack() === false) {
            return;
        }
        this.attackStyle = this.attackStyleForNewAttack();
        var weaponIsAreaAttack = this.weapons[this.attackStyle].isAreaAttack;
        var isUnderAggro = false;
        if (!weaponIsAreaAttack) {
            isUnderAggro = Collision.collisionMath(this.location.x, this.location.y, this.size, this.aggro.location.x, this.aggro.location.y, 1);
        }
        this.attackFeedback = AttackIndicators.NONE;
        if (!isUnderAggro && this.hasLOS && this.attackDelay <= 0) {
            this.attack() && this.didAttack();
        }
    };
    Mob.prototype.magicMaxHit = function () {
        return 0;
    };
    Mob.prototype.attack = function () {
        if (this.aggro.dying >= 0) {
            return false;
        }
        if (this.canMeleeIfClose() && Weapon.isMeleeAttackStyle(this.attackStyle) === false) {
            if (this.isWithinMeleeRange() && Random.get() < 0.5) {
                this.attackStyle = this.canMeleeIfClose();
            }
        }
        if (this.weapons[this.attackStyle].isBlockable(this, this.aggro, {
            attackStyle: this.attackStyle,
        })) {
            this.attackFeedback = AttackIndicators.BLOCKED;
        }
        else {
            this.attackFeedback = AttackIndicators.HIT;
        }
        this.weapons[this.attackStyle].attack(this, this.aggro /* hack */, {
            attackStyle: this.attackStyle,
            magicBaseSpellDamage: this.magicMaxHit(),
        });
        return true;
    };
    Mob.prototype.visible = function () {
        return this.region.world.getReadyTimer <= 0;
    };
    Object.defineProperty(Mob.prototype, "consumesSpace", {
        get: function () {
            return this;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Mob.prototype, "combatLevel", {
        get: function () {
            return 99;
        },
        enumerable: false,
        configurable: true
    });
    Mob.prototype.contextActions = function (region, x, y) {
        var _this = this;
        var actions = [
            {
                text: [
                    { text: "Attack ", fillStyle: "white" },
                    { text: this.mobName(), fillStyle: "yellow" },
                    {
                        text: " (level ".concat(this.combatLevel, ")"),
                        fillStyle: Trainer.player.combatLevelColor(this),
                    },
                ],
                action: function () {
                    Trainer.clickController.redClick();
                    InputController.controller.queueAction(function () { return Trainer.clickController.playerAttackClick(_this); });
                },
            },
        ];
        // hack hack hack
        if (this.removableWithRightClick) {
            actions.push({
                text: [
                    { text: "Remove ", fillStyle: "white" },
                    { text: this.mobName(), fillStyle: "yellow" },
                    {
                        text: " (level ".concat(this.combatLevel, ")"),
                        fillStyle: Trainer.player.combatLevelColor(this),
                    },
                ],
                action: function () {
                    _this.region.removeMob(_this);
                },
            });
        }
        return actions;
    };
    Mob.prototype.drawOverTile = function (tickPercent, context, scale) {
        // Override me
    };
    Mob.prototype.drawUnderTile = function (tickPercent, context, scale) {
        context.fillStyle = "#00000000";
        if (Settings.displayFeedback) {
            if (this.dying > -1) {
                context.fillStyle = "#964B0073";
            }
            else if (this.attackFeedback === AttackIndicators.BLOCKED) {
                context.fillStyle = "#00FF0073";
            }
            else if (this.attackFeedback === AttackIndicators.HIT) {
                context.fillStyle = "#FF000073";
            }
            else if (this.attackFeedback === AttackIndicators.SCAN) {
                context.fillStyle = "#FFFF0073";
            }
            else if (this.hasLOS) {
                context.fillStyle = "#FF730073";
            }
            else {
                context.fillStyle = this.color;
            }
        }
        // Draw mob
        context.fillRect(-(this.size * scale) / 2, -(this.size * scale) / 2, this.size * scale, this.size * scale);
    };
    Mob.prototype.draw = function (tickPercent, context, offset, scale, drawUnderTile) {
        _super.prototype.draw.call(this, tickPercent, context, offset, scale, drawUnderTile);
        if (Settings.displayMobLoS) {
            LineOfSight.drawLOS(this.region, this.location.x, this.location.y, this.size, this.attackRange, "#FF000055", this.type === UnitTypes.MOB);
        }
        var perceivedX = offset.x;
        var perceivedY = offset.y;
        context.save();
        context.translate(perceivedX * scale + (this.size * scale) / 2, (perceivedY - this.size + 1) * scale + (this.size * scale) / 2);
        if (drawUnderTile) {
            this.drawUnderTile(tickPercent, context, scale);
        }
        var currentImage = this.unitImage;
        if (Settings.rotated === "south") {
            context.rotate(Math.PI);
        }
        if (Settings.rotated === "south") {
            context.scale(-1, 1);
        }
        context.save();
        if (this.shouldShowAttackAnimation()) {
            this.attackAnimation(tickPercent, context);
        }
        if (currentImage) {
            context.drawImage(currentImage, -(this.size * scale) / 2, -(this.size * scale) / 2, this.size * scale, this.size * scale);
        }
        context.restore();
        if (Settings.rotated === "south") {
            context.scale(-1, 1);
        }
        this.drawOverTile(tickPercent, context, scale);
        if (this.aggro) {
            var unit = this.aggro;
            if (LineOfSight.playerHasLineOfSightOfMob(this.region, this.aggro.location.x, this.aggro.location.y, this, unit.attackRange)) {
                context.strokeStyle = "#00FF0073";
                context.lineWidth = 1;
                context.strokeRect(-(this.size * scale) / 2, -(this.size * scale) / 2, this.size * scale, this.size * scale);
            }
        }
        context.restore();
        if (!this.tcc) {
            return;
        }
        // if (this.mobName() !== EntityName.JAL_AK) {
        //   return;
        // }
        // if (this.mobId !== 4) {
        //   return;
        // }
        /*this.tcc.forEach((location: Location) => {
          context.fillStyle = "#00FF0073";
          context.fillRect(location.x * scale, location.y * scale, scale, scale);
        });*/
    };
    Mob.prototype.drawUILayer = function (tickPercent, offset, context, scale, hitsplatsAbove) {
        context.save();
        context.translate(offset.x, offset.y);
        if (Settings.rotated === "south") {
            context.rotate(Math.PI);
        }
        this.drawHPBar(context, scale);
        this.drawOverheadText(context, scale);
        this.drawHitsplats(context, scale, hitsplatsAbove);
        this.drawOverheadPrayers(context, scale);
        context.restore();
    };
    Mob.prototype.create3dModel = function () {
        return CanvasSpriteModel.forRenderable(this);
    };
    Object.defineProperty(Mob.prototype, "color", {
        get: function () {
            return "#FF0000";
        },
        enumerable: false,
        configurable: true
    });
    Mob.mobIdTracker = 0;
    return Mob;
}(Unit));


;// CONCATENATED MODULE: ./src/assets/images/xpdrops/attack.png
const attack_namespaceObject = __webpack_require__.p + "a5a3001cb77ef38bd153.png";
;// CONCATENATED MODULE: ./src/assets/images/xpdrops/strength.png
const strength_namespaceObject = __webpack_require__.p + "ef6954ed9e91fed3ca39.png";
;// CONCATENATED MODULE: ./src/assets/images/xpdrops/defence.png
const defence_namespaceObject = __webpack_require__.p + "ad69a47f269969a25eb9.png";
;// CONCATENATED MODULE: ./src/assets/images/xpdrops/range.png
const range_namespaceObject = __webpack_require__.p + "08918c8be0e9b68185a0.png";
;// CONCATENATED MODULE: ./src/assets/images/xpdrops/magic.png
const magic_namespaceObject = __webpack_require__.p + "0b7151b64115c1093479.png";
;// CONCATENATED MODULE: ./src/assets/images/xpdrops/hitpoint.png
const hitpoint_namespaceObject = __webpack_require__.p + "0e781837baf9aa422284.png";
;// CONCATENATED MODULE: ./src/sdk/XpDropController.ts









var XpDropController = /** @class */ (function () {
    function XpDropController() {
        this.canvas = new OffscreenCanvas(110, 200);
        this.ctx = this.canvas.getContext("2d");
        this.drops = [{ abc: "asdf" }, {}, {}, {}];
        this.lastDropSkill = null;
        this.startupTimeout();
    }
    XpDropController.prototype.startupTimeout = function () {
        var _this = this;
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(function () {
            _this.lastDropSkill = null;
        }, 1000 * 16); // Not sure if 16 seconds is correct but good enough for now
    };
    XpDropController.prototype.registerXpDrop = function (drop) {
        this.drops.push(drop);
        if (drop.skill) {
            this.lastDropSkill = drop.skill;
        }
    };
    XpDropController.prototype.tick = function () {
        this.drops.shift();
        if (this.drops.length < 4) {
            this.drops.push({}); // TODO: This is bad
        }
    };
    XpDropController.prototype.draw = function (destinationCanvas, x, y, tickPercent) {
        var _this = this;
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        if (!Settings.displayXpDrops) {
            return;
        }
        var scale = Settings.maxUiScale;
        this.canvas.width = 110 * scale * 2;
        this.canvas.height = 200 * scale * 2;
        var skillInfo = (0,lodash.find)(XpDropController.skills, { type: this.lastDropSkill });
        if (skillInfo && skillInfo.type) {
            // Draw overall XP box at top
            this.ctx.lineWidth = 1;
            this.ctx.strokeStyle = XpDropController.outlineColor;
            this.ctx.strokeRect(0, 0, 110 * scale, 42 * scale);
            this.ctx.strokeStyle = XpDropController.inlineColor;
            this.ctx.strokeRect(1 * scale, 1 * scale, 109 * scale, 41 * scale);
            this.ctx.strokeRect(1 * scale, 30 * scale, 108 * scale, 11 * scale);
            this.ctx.fillStyle = XpDropController.fillColor;
            this.ctx.fillRect(2 * scale, 2 * scale, 108 * scale, 40 * scale);
            this.ctx.fillStyle = "#000000";
            this.ctx.fillRect(2 * scale, 31 * scale, 106 * scale, 9 * scale);
            this.ctx.fillStyle = "#00BF00";
            this.ctx.fillRect(3 * scale, 32 * scale, 90 * scale, 7 * scale);
            this.ctx.fillStyle = "#FFFFFF";
            this.ctx.font = "".concat(Math.floor(16 * scale), "px Stats_11");
            this.ctx.textAlign = "right";
            this.ctx.drawImage(skillInfo.image, 4 * scale, 2 * scale, 26 * scale, 26 * scale);
            this.ctx.fillStyle = "#000000";
            this.ctx.fillText("200,000,000", 106 * scale, 21 * scale);
            this.ctx.fillStyle = "#FFFFFF";
            this.ctx.fillText("200,000,000", 105 * scale, 20 * scale);
        }
        var xpDropYOffset = 85;
        var dropFontSize = Math.floor(16 * (Settings.maxUiScale * 2));
        this.ctx.fillStyle = "#FFFFFF";
        this.ctx.font = "".concat(dropFontSize, "px Stats_11");
        this.ctx.textAlign = "right";
        this.drops.forEach(function (drop, index) {
            var textSize = dropFontSize + 4;
            if (!drop.skill) {
                return;
            }
            var skill = drop.skill;
            var skillInfo = (0,lodash.find)(XpDropController.skills, { type: skill });
            if (skillInfo.image) {
                _this.ctx.drawImage(skillInfo.image, 110 - _this.ctx.measureText(String(drop.xp)).width - 20, (index - tickPercent) * textSize - 13 + xpDropYOffset, 16, 16),
                    skillInfo.image.width * Settings.maxUiScale * 2,
                    skillInfo.image.height * Settings.maxUiScale * 2;
            }
            _this.ctx.fillText(String(drop.xp), 110, (index - tickPercent) * textSize + xpDropYOffset);
        });
        destinationCanvas.drawImage(this.canvas, x, y);
    };
    XpDropController.controller = new XpDropController();
    XpDropController.outlineColor = "#3A3021";
    XpDropController.inlineColor = "#5D5344";
    XpDropController.fillColor = "#5D534473"; // guess ATM
    XpDropController.skills = [
        { type: "attack", imgSrc: attack_namespaceObject, image: null },
        { type: "strength", imgSrc: strength_namespaceObject, image: null },
        { type: "defence", imgSrc: defence_namespaceObject, image: null },
        { type: "range", imgSrc: range_namespaceObject, image: null },
        { type: "magic", imgSrc: magic_namespaceObject, image: null },
        { type: "hitpoint", imgSrc: hitpoint_namespaceObject, image: null },
    ];
    return XpDropController;
}());

XpDropController.skills.forEach(function (skill) {
    skill.image = ImageLoader.createImage(skill.imgSrc);
});

;// CONCATENATED MODULE: ./src/sdk/Eating.ts

var Eating = /** @class */ (function () {
    function Eating() {
        this.foodDelay = 0;
        this.potionDelay = 0;
        this.comboDelay = 0;
        this.redemptioned = false;
    }
    Eating.prototype.tickFood = function (player) {
        this.foodDelay--;
        this.potionDelay--;
        this.comboDelay--;
        if (this.currentFood) {
            this.currentFood.eat(player);
            player.attackDelay += 3;
            this.currentFood = null;
        }
        if (this.currentPotion) {
            this.currentPotion.drink(player);
            this.currentPotion = null;
        }
        if (this.currentComboFood) {
            this.currentComboFood.eat(player);
            player.attackDelay += 3;
            this.currentComboFood = null;
        }
    };
    Eating.prototype.checkRedemption = function (player) {
        if (this.redemptioned) {
            player.currentStats.prayer = 0;
            player.currentStats.hitpoint += Math.floor(player.stats.prayer / 4);
            this.redemptioned = false;
        }
    };
    Eating.prototype.canEatFood = function () {
        return this.foodDelay <= 0;
    };
    Eating.prototype.canDrinkPotion = function () {
        return this.potionDelay <= 0;
    };
    Eating.prototype.canEatComboFood = function () {
        return this.comboDelay <= 0;
    };
    // The weird way that the lower tiers also eat the higher tiers forces the behavior of food -> potion -> karambwan
    Eating.prototype.eatFood = function (food) {
        if (!this.canEatFood()) {
            return;
        }
        this.currentFood = food || null;
        this.foodDelay = 3;
        if (this.currentFood) {
            this.currentFood.consumeItem(this.player);
        }
    };
    Eating.prototype.drinkPotion = function (potion) {
        if (!this.canDrinkPotion()) {
            return false;
        }
        this.currentPotion = potion || null;
        this.foodDelay = 3;
        this.potionDelay = 3;
        if (this.currentPotion) {
            this.currentPotion.doses--;
        }
        return true;
    };
    Eating.prototype.eatComboFood = function (karambwan) {
        if (!this.canEatComboFood()) {
            return;
        }
        this.foodDelay = 3;
        this.potionDelay = 3;
        this.currentComboFood = karambwan || null;
        this.comboDelay = 3;
        if (this.currentComboFood) {
            this.currentComboFood.consumeItem(this.player);
        }
    };
    return Eating;
}());


;// CONCATENATED MODULE: ./src/sdk/PlayerRegenTimers.ts

var PlayerRegenTimer = /** @class */ (function () {
    function PlayerRegenTimer(player) {
        this.player = player;
        this.spec = 50;
        this.hitpoint = 100;
    }
    PlayerRegenTimer.prototype.specUsed = function () {
        if (this.spec <= 0) {
            this.spec = 50;
        }
    };
    PlayerRegenTimer.prototype.regen = function () {
        this.specRegen();
        this.hitpointRegen();
    };
    PlayerRegenTimer.prototype.specRegen = function () {
        this.spec--;
        if (this.spec === 0) {
            this.spec = 50;
            this.player.currentStats.specialAttack += 10;
            this.player.currentStats.specialAttack = Math.min(100, this.player.currentStats.specialAttack);
        }
    };
    PlayerRegenTimer.prototype.hitpointRegen = function () {
        this.hitpoint--;
        if (this.hitpoint === 0) {
            this.hitpoint = 100;
            this.player.currentStats.hitpoint++;
            this.player.currentStats.hitpoint = Math.min(this.player.stats.hitpoint, this.player.currentStats.hitpoint);
        }
    };
    return PlayerRegenTimer;
}());


;// CONCATENATED MODULE: ./src/sdk/BasePrayer.ts



var PrayerGroups;
(function (PrayerGroups) {
    PrayerGroups["OVERHEADS"] = "overheads";
    PrayerGroups["DEFENCE"] = "defence";
    PrayerGroups["STRENGTH"] = "strength";
    PrayerGroups["ACCURACY"] = "accuracy";
    PrayerGroups["RANGE"] = "range";
    PrayerGroups["HEARTS"] = "hearts";
    PrayerGroups["PROTECTITEM"] = "protectitem";
    PrayerGroups["PRESERVE"] = "preserve";
})(PrayerGroups || (PrayerGroups = {}));
var BasePrayer = /** @class */ (function () {
    function BasePrayer() {
        this.lastActivated = 0;
        this.lastDeactivated = 0;
        // server-side
        this.isActive = false;
        // client-side
        this.isLit = false;
        this.deactivate();
    }
    BasePrayer.prototype.levelRequirement = function () {
        return 99;
    };
    BasePrayer.prototype.tick = function () {
        var ping = Settings.inputDelay || 0;
        var now = Date.now();
        if (this.isLit && !this.isActive) {
            if (now >= this.lastActivated + ping) {
                this.isActive = true;
            }
            this.isLit = true;
        }
        else if (!this.isLit && this.isActive) {
            if (now >= this.lastDeactivated + ping) {
                this.isActive = false;
            }
            this.isLit = false;
        }
    };
    BasePrayer.prototype.drainRate = function () {
        throw new Error("prayer does not have proper drain rate");
    };
    // currently only used for overheads
    BasePrayer.prototype.feature = function () {
        return "";
    };
    Object.defineProperty(BasePrayer.prototype, "name", {
        get: function () {
            return "Protect from Magic";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePrayer.prototype, "groups", {
        get: function () {
            return [];
        },
        enumerable: false,
        configurable: true
    });
    BasePrayer.prototype.activate = function (player) {
        if (player.stats.prayer < this.levelRequirement()) {
            return;
        }
        this.lastActivated = Date.now();
        this.isLit = true;
    };
    BasePrayer.prototype.toggle = function (player) {
        if (player.stats.prayer < this.levelRequirement()) {
            return;
        }
        this.isLit = !this.isLit;
        if (this.isLit) {
            this.lastActivated = Date.now();
        }
        else {
            this.lastDeactivated = Date.now();
        }
    };
    BasePrayer.prototype.deactivate = function () {
        this.isLit = false;
    };
    BasePrayer.prototype.isOverhead = function () {
        return false;
    };
    BasePrayer.prototype.overheadImageReference = function () {
        return "";
    };
    BasePrayer.prototype.overheadImage = function () {
        if (!this.cachedImage && this.overheadImageReference()) {
            this.cachedImage = ImageLoader.createImage(this.overheadImageReference());
            return null;
        }
        return this.cachedImage;
    };
    BasePrayer.prototype.playOffSound = function () {
        // Override me
    };
    BasePrayer.prototype.playOnSound = function () {
        // Override me
    };
    return BasePrayer;
}());


;// CONCATENATED MODULE: ./src/content/prayers/Augury.ts

var Augury_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var Augury = /** @class */ (function (_super) {
    Augury_extends(Augury, _super);
    function Augury() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Augury.prototype, "name", {
        get: function () {
            return "Augury";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Augury.prototype, "groups", {
        get: function () {
            return [PrayerGroups.ACCURACY, PrayerGroups.STRENGTH, PrayerGroups.DEFENCE];
        },
        enumerable: false,
        configurable: true
    });
    Augury.prototype.levelRequirement = function () {
        return 77;
    };
    Augury.prototype.isOverhead = function () {
        return false;
    };
    Augury.prototype.feature = function () {
        return "offensiveMagic";
    };
    Augury.prototype.drainRate = function () {
        return 24;
    };
    Augury.prototype.playOnSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    Augury.prototype.playOffSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return Augury;
}(BasePrayer));


;// CONCATENATED MODULE: ./src/content/prayers/BurstOfStrength.ts

var BurstOfStrength_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var BurstOfStrength = /** @class */ (function (_super) {
    BurstOfStrength_extends(BurstOfStrength, _super);
    function BurstOfStrength() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BurstOfStrength.prototype, "name", {
        get: function () {
            return "Burst of Strength";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BurstOfStrength.prototype, "groups", {
        get: function () {
            return [PrayerGroups.STRENGTH];
        },
        enumerable: false,
        configurable: true
    });
    BurstOfStrength.prototype.levelRequirement = function () {
        return 4;
    };
    BurstOfStrength.prototype.drainRate = function () {
        return 3;
    };
    BurstOfStrength.prototype.isOverhead = function () {
        return false;
    };
    BurstOfStrength.prototype.feature = function () {
        return "offensiveStrength";
    };
    BurstOfStrength.prototype.playOnSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    BurstOfStrength.prototype.playOffSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return BurstOfStrength;
}(BasePrayer));


;// CONCATENATED MODULE: ./src/content/prayers/Chivalry.ts

var Chivalry_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var Chivalry = /** @class */ (function (_super) {
    Chivalry_extends(Chivalry, _super);
    function Chivalry() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Chivalry.prototype, "name", {
        get: function () {
            return "Chivalry";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Chivalry.prototype, "groups", {
        get: function () {
            return [PrayerGroups.ACCURACY, PrayerGroups.STRENGTH, PrayerGroups.DEFENCE];
        },
        enumerable: false,
        configurable: true
    });
    Chivalry.prototype.levelRequirement = function () {
        return 60;
    };
    Chivalry.prototype.drainRate = function () {
        return 24;
    };
    Chivalry.prototype.isOverhead = function () {
        return false;
    };
    Chivalry.prototype.feature = function () {
        return "offensiveAttack";
    };
    Chivalry.prototype.playOnSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    Chivalry.prototype.playOffSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return Chivalry;
}(BasePrayer));


;// CONCATENATED MODULE: ./src/content/prayers/ClarityOfThought.ts

var ClarityOfThought_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var ClarityOfThought = /** @class */ (function (_super) {
    ClarityOfThought_extends(ClarityOfThought, _super);
    function ClarityOfThought() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ClarityOfThought.prototype, "name", {
        get: function () {
            return "Clarity of Thought";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClarityOfThought.prototype, "groups", {
        get: function () {
            return [PrayerGroups.ACCURACY];
        },
        enumerable: false,
        configurable: true
    });
    ClarityOfThought.prototype.levelRequirement = function () {
        return 7;
    };
    ClarityOfThought.prototype.drainRate = function () {
        return 3;
    };
    ClarityOfThought.prototype.isOverhead = function () {
        return false;
    };
    ClarityOfThought.prototype.feature = function () {
        return "offensiveAttack";
    };
    ClarityOfThought.prototype.playOnSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    ClarityOfThought.prototype.playOffSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return ClarityOfThought;
}(BasePrayer));


;// CONCATENATED MODULE: ./src/content/prayers/EagleEye.ts

var EagleEye_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var EagleEye = /** @class */ (function (_super) {
    EagleEye_extends(EagleEye, _super);
    function EagleEye() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(EagleEye.prototype, "name", {
        get: function () {
            return "Eagle Eye";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EagleEye.prototype, "groups", {
        get: function () {
            return [PrayerGroups.ACCURACY, PrayerGroups.STRENGTH];
        },
        enumerable: false,
        configurable: true
    });
    EagleEye.prototype.levelRequirement = function () {
        return 44;
    };
    EagleEye.prototype.drainRate = function () {
        return 12;
    };
    EagleEye.prototype.isOverhead = function () {
        return false;
    };
    EagleEye.prototype.feature = function () {
        return "offensiveRange";
    };
    EagleEye.prototype.playOnSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    EagleEye.prototype.playOffSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return EagleEye;
}(BasePrayer));


;// CONCATENATED MODULE: ./src/content/prayers/HawkEye.ts

var HawkEye_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var HawkEye = /** @class */ (function (_super) {
    HawkEye_extends(HawkEye, _super);
    function HawkEye() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(HawkEye.prototype, "name", {
        get: function () {
            return "Hawk Eye";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HawkEye.prototype, "groups", {
        get: function () {
            return [PrayerGroups.ACCURACY, PrayerGroups.STRENGTH];
        },
        enumerable: false,
        configurable: true
    });
    HawkEye.prototype.levelRequirement = function () {
        return 26;
    };
    HawkEye.prototype.drainRate = function () {
        return 6;
    };
    HawkEye.prototype.isOverhead = function () {
        return false;
    };
    HawkEye.prototype.feature = function () {
        return "offensiveRange";
    };
    HawkEye.prototype.playOnSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    HawkEye.prototype.playOffSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return HawkEye;
}(BasePrayer));


;// CONCATENATED MODULE: ./src/content/prayers/ImprovedReflexes.ts

var ImprovedReflexes_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var ImprovedReflexes = /** @class */ (function (_super) {
    ImprovedReflexes_extends(ImprovedReflexes, _super);
    function ImprovedReflexes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ImprovedReflexes.prototype, "name", {
        get: function () {
            return "Improved Reflexes";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImprovedReflexes.prototype, "groups", {
        get: function () {
            return [PrayerGroups.ACCURACY];
        },
        enumerable: false,
        configurable: true
    });
    ImprovedReflexes.prototype.levelRequirement = function () {
        return 16;
    };
    ImprovedReflexes.prototype.drainRate = function () {
        return 6;
    };
    ImprovedReflexes.prototype.isOverhead = function () {
        return false;
    };
    ImprovedReflexes.prototype.feature = function () {
        return "offensiveAttack";
    };
    ImprovedReflexes.prototype.playOnSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    ImprovedReflexes.prototype.playOffSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return ImprovedReflexes;
}(BasePrayer));


;// CONCATENATED MODULE: ./src/content/prayers/IncredibleReflexes.ts

var IncredibleReflexes_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var IncredibleReflexes = /** @class */ (function (_super) {
    IncredibleReflexes_extends(IncredibleReflexes, _super);
    function IncredibleReflexes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(IncredibleReflexes.prototype, "name", {
        get: function () {
            return "Incredible Reflexes";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IncredibleReflexes.prototype, "groups", {
        get: function () {
            return [PrayerGroups.ACCURACY];
        },
        enumerable: false,
        configurable: true
    });
    IncredibleReflexes.prototype.levelRequirement = function () {
        return 34;
    };
    IncredibleReflexes.prototype.drainRate = function () {
        return 12;
    };
    IncredibleReflexes.prototype.isOverhead = function () {
        return false;
    };
    IncredibleReflexes.prototype.feature = function () {
        return "offensiveAttack";
    };
    IncredibleReflexes.prototype.playOnSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    IncredibleReflexes.prototype.playOffSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return IncredibleReflexes;
}(BasePrayer));


;// CONCATENATED MODULE: ./src/content/prayers/MysticLore.ts

var MysticLore_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var MysticLore = /** @class */ (function (_super) {
    MysticLore_extends(MysticLore, _super);
    function MysticLore() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MysticLore.prototype, "name", {
        get: function () {
            return "Mystic Lore";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MysticLore.prototype, "groups", {
        get: function () {
            return [PrayerGroups.ACCURACY, PrayerGroups.STRENGTH];
        },
        enumerable: false,
        configurable: true
    });
    MysticLore.prototype.levelRequirement = function () {
        return 27;
    };
    MysticLore.prototype.drainRate = function () {
        return 6;
    };
    MysticLore.prototype.isOverhead = function () {
        return false;
    };
    MysticLore.prototype.feature = function () {
        return "offensiveMagic";
    };
    MysticLore.prototype.playOnSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    MysticLore.prototype.playOffSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return MysticLore;
}(BasePrayer));


;// CONCATENATED MODULE: ./src/content/prayers/MysticMight.ts

var MysticMight_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var MysticMight = /** @class */ (function (_super) {
    MysticMight_extends(MysticMight, _super);
    function MysticMight() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MysticMight.prototype, "name", {
        get: function () {
            return "Mystic Might";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MysticMight.prototype, "groups", {
        get: function () {
            return [PrayerGroups.ACCURACY, PrayerGroups.STRENGTH];
        },
        enumerable: false,
        configurable: true
    });
    MysticMight.prototype.levelRequirement = function () {
        return 45;
    };
    MysticMight.prototype.drainRate = function () {
        return 12;
    };
    MysticMight.prototype.isOverhead = function () {
        return false;
    };
    MysticMight.prototype.feature = function () {
        return "offensiveMagic";
    };
    MysticMight.prototype.playOnSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    MysticMight.prototype.playOffSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return MysticMight;
}(BasePrayer));


;// CONCATENATED MODULE: ./src/content/prayers/MysticWill.ts

var MysticWill_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var MysticWill = /** @class */ (function (_super) {
    MysticWill_extends(MysticWill, _super);
    function MysticWill() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MysticWill.prototype, "name", {
        get: function () {
            return "Mystic Will";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MysticWill.prototype, "groups", {
        get: function () {
            return [PrayerGroups.ACCURACY, PrayerGroups.STRENGTH];
        },
        enumerable: false,
        configurable: true
    });
    MysticWill.prototype.levelRequirement = function () {
        return 9;
    };
    MysticWill.prototype.drainRate = function () {
        return 3;
    };
    MysticWill.prototype.isOverhead = function () {
        return false;
    };
    MysticWill.prototype.feature = function () {
        return "offensiveMagic";
    };
    MysticWill.prototype.playOnSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    MysticWill.prototype.playOffSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return MysticWill;
}(BasePrayer));


;// CONCATENATED MODULE: ./src/content/prayers/Piety.ts

var Piety_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var Piety = /** @class */ (function (_super) {
    Piety_extends(Piety, _super);
    function Piety() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Piety.prototype, "name", {
        get: function () {
            return "Piety";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Piety.prototype, "groups", {
        get: function () {
            return [PrayerGroups.ACCURACY, PrayerGroups.STRENGTH, PrayerGroups.DEFENCE];
        },
        enumerable: false,
        configurable: true
    });
    Piety.prototype.levelRequirement = function () {
        return 70;
    };
    Piety.prototype.drainRate = function () {
        return 24;
    };
    Piety.prototype.isOverhead = function () {
        return false;
    };
    Piety.prototype.feature = function () {
        return "offensiveAttack";
    };
    Piety.prototype.playOnSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    Piety.prototype.playOffSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return Piety;
}(BasePrayer));


;// CONCATENATED MODULE: ./src/content/prayers/Preserve.ts

var Preserve_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var Preserve = /** @class */ (function (_super) {
    Preserve_extends(Preserve, _super);
    function Preserve() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Preserve.prototype, "name", {
        get: function () {
            return "Preserve";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Preserve.prototype, "groups", {
        get: function () {
            return [PrayerGroups.PRESERVE]; // TODO: Incorrect
        },
        enumerable: false,
        configurable: true
    });
    Preserve.prototype.levelRequirement = function () {
        return 100;
    };
    Preserve.prototype.drainRate = function () {
        return 2;
    };
    Preserve.prototype.isOverhead = function () {
        return false;
    };
    Preserve.prototype.feature = function () {
        return "preserve";
    };
    Preserve.prototype.playOnSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    Preserve.prototype.playOffSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return Preserve;
}(BasePrayer));


;// CONCATENATED MODULE: ./src/content/prayers/ProtectItem.ts

var ProtectItem_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var ProtectItem = /** @class */ (function (_super) {
    ProtectItem_extends(ProtectItem, _super);
    function ProtectItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ProtectItem.prototype, "name", {
        get: function () {
            return "Protect Item";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProtectItem.prototype, "groups", {
        get: function () {
            return [PrayerGroups.PROTECTITEM]; // TODO: Incorrect
        },
        enumerable: false,
        configurable: true
    });
    ProtectItem.prototype.levelRequirement = function () {
        return 100;
    };
    ProtectItem.prototype.drainRate = function () {
        return 2;
    };
    ProtectItem.prototype.isOverhead = function () {
        return false;
    };
    ProtectItem.prototype.feature = function () {
        return "";
    };
    ProtectItem.prototype.playOnSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    ProtectItem.prototype.playOffSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return ProtectItem;
}(BasePrayer));


;// CONCATENATED MODULE: ./src/assets/images/prayers/mageOver.png
const mageOver_namespaceObject = __webpack_require__.p + "fe99a91eeb128d8be1d2.png";
;// CONCATENATED MODULE: ./src/assets/sounds/mageOn.ogg
const mageOn_namespaceObject = __webpack_require__.p + "4eefe1a9d512bc7e3c96.ogg";
;// CONCATENATED MODULE: ./src/assets/sounds/mageOff.ogg
const mageOff_namespaceObject = __webpack_require__.p + "1a5aebbf6442ec2dfbc1.ogg";
;// CONCATENATED MODULE: ./src/content/prayers/ProtectMage.ts

var ProtectMage_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var ProtectMage = /** @class */ (function (_super) {
    ProtectMage_extends(ProtectMage, _super);
    function ProtectMage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ProtectMage.prototype, "name", {
        get: function () {
            return "Protect from Magic";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProtectMage.prototype, "groups", {
        get: function () {
            return [PrayerGroups.OVERHEADS];
        },
        enumerable: false,
        configurable: true
    });
    ProtectMage.prototype.levelRequirement = function () {
        return 37;
    };
    ProtectMage.prototype.drainRate = function () {
        return 12;
    };
    ProtectMage.prototype.isOverhead = function () {
        return true;
    };
    ProtectMage.prototype.overheadImageReference = function () {
        return mageOver_namespaceObject;
    };
    ProtectMage.prototype.feature = function () {
        return "magic";
    };
    ProtectMage.prototype.playOnSound = function () {
        if (Settings.playsAudio) {
            SoundCache.play(new Sound(mageOn_namespaceObject, 0.35));
        }
    };
    ProtectMage.prototype.playOffSound = function () {
        if (Settings.playsAudio) {
            SoundCache.play(new Sound(mageOff_namespaceObject, 0.35));
        }
    };
    return ProtectMage;
}(BasePrayer));


;// CONCATENATED MODULE: ./src/assets/images/prayers/meleeOver.png
const meleeOver_namespaceObject = __webpack_require__.p + "5ad83928ec6982dee94a.png";
;// CONCATENATED MODULE: ./src/assets/sounds/meleeOn.ogg
const meleeOn_namespaceObject = __webpack_require__.p + "3b71db031396f30042b1.ogg";
;// CONCATENATED MODULE: ./src/assets/sounds/meleeOff.ogg
const meleeOff_namespaceObject = __webpack_require__.p + "395ac1a9baa2026f2788.ogg";
;// CONCATENATED MODULE: ./src/content/prayers/ProtectMelee.ts

var ProtectMelee_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var ProtectMelee = /** @class */ (function (_super) {
    ProtectMelee_extends(ProtectMelee, _super);
    function ProtectMelee() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ProtectMelee.prototype, "name", {
        get: function () {
            return "Protect from Melee";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProtectMelee.prototype, "groups", {
        get: function () {
            return [PrayerGroups.OVERHEADS];
        },
        enumerable: false,
        configurable: true
    });
    ProtectMelee.prototype.levelRequirement = function () {
        return 43;
    };
    ProtectMelee.prototype.drainRate = function () {
        return 12;
    };
    ProtectMelee.prototype.isOverhead = function () {
        return true;
    };
    ProtectMelee.prototype.overheadImageReference = function () {
        return meleeOver_namespaceObject;
    };
    ProtectMelee.prototype.feature = function () {
        return "melee";
    };
    ProtectMelee.prototype.playOnSound = function () {
        if (Settings.playsAudio) {
            SoundCache.play(new Sound(meleeOn_namespaceObject, 0.35));
        }
    };
    ProtectMelee.prototype.playOffSound = function () {
        if (Settings.playsAudio) {
            SoundCache.play(new Sound(meleeOff_namespaceObject, 0.35));
        }
    };
    return ProtectMelee;
}(BasePrayer));


;// CONCATENATED MODULE: ./src/assets/images/prayers/rangeOver.png
const rangeOver_namespaceObject = __webpack_require__.p + "60ca147bb4530f1e23d6.png";
;// CONCATENATED MODULE: ./src/assets/sounds/rangeOn.ogg
const rangeOn_namespaceObject = __webpack_require__.p + "a4704be277145aa0de86.ogg";
;// CONCATENATED MODULE: ./src/assets/sounds/rangeOff.ogg
const rangeOff_namespaceObject = __webpack_require__.p + "459103be09726a92da33.ogg";
;// CONCATENATED MODULE: ./src/content/prayers/ProtectRange.ts

var ProtectRange_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var ProtectRange = /** @class */ (function (_super) {
    ProtectRange_extends(ProtectRange, _super);
    function ProtectRange() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ProtectRange.prototype, "name", {
        get: function () {
            return "Protect from Range";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProtectRange.prototype, "groups", {
        get: function () {
            return [PrayerGroups.OVERHEADS];
        },
        enumerable: false,
        configurable: true
    });
    ProtectRange.prototype.levelRequirement = function () {
        return 34;
    };
    ProtectRange.prototype.drainRate = function () {
        return 12;
    };
    ProtectRange.prototype.isOverhead = function () {
        return true;
    };
    ProtectRange.prototype.overheadImageReference = function () {
        return rangeOver_namespaceObject;
    };
    ProtectRange.prototype.feature = function () {
        return "range";
    };
    ProtectRange.prototype.playOnSound = function () {
        if (Settings.playsAudio) {
            SoundCache.play(new Sound(rangeOn_namespaceObject, 0.35));
        }
    };
    ProtectRange.prototype.playOffSound = function () {
        if (Settings.playsAudio) {
            SoundCache.play(new Sound(rangeOff_namespaceObject, 0.35));
        }
    };
    return ProtectRange;
}(BasePrayer));


;// CONCATENATED MODULE: ./src/content/prayers/RapidHeal.ts

var RapidHeal_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var RapidHeal = /** @class */ (function (_super) {
    RapidHeal_extends(RapidHeal, _super);
    function RapidHeal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(RapidHeal.prototype, "name", {
        get: function () {
            return "Rapid Heal";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RapidHeal.prototype, "groups", {
        get: function () {
            return [PrayerGroups.HEARTS];
        },
        enumerable: false,
        configurable: true
    });
    RapidHeal.prototype.levelRequirement = function () {
        return 100;
    };
    RapidHeal.prototype.drainRate = function () {
        return 2;
    };
    RapidHeal.prototype.isOverhead = function () {
        return false;
    };
    RapidHeal.prototype.feature = function () {
        return "";
    };
    RapidHeal.prototype.playOnSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    RapidHeal.prototype.playOffSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return RapidHeal;
}(BasePrayer));


;// CONCATENATED MODULE: ./src/content/prayers/RapidRestore.ts

var RapidRestore_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var RapidRestore = /** @class */ (function (_super) {
    RapidRestore_extends(RapidRestore, _super);
    function RapidRestore() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(RapidRestore.prototype, "name", {
        get: function () {
            return "Rapid Restore";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RapidRestore.prototype, "groups", {
        get: function () {
            return [PrayerGroups.HEARTS];
        },
        enumerable: false,
        configurable: true
    });
    RapidRestore.prototype.levelRequirement = function () {
        return 100;
    };
    RapidRestore.prototype.drainRate = function () {
        return 1;
    };
    RapidRestore.prototype.isOverhead = function () {
        return false;
    };
    RapidRestore.prototype.feature = function () {
        return "";
    };
    RapidRestore.prototype.playOnSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    RapidRestore.prototype.playOffSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return RapidRestore;
}(BasePrayer));


;// CONCATENATED MODULE: ./src/assets/images/prayers/redemptionOver.png
const redemptionOver_namespaceObject = __webpack_require__.p + "0cf6744ec00b154c280f.png";
;// CONCATENATED MODULE: ./src/content/prayers/Redemption.ts

var Redemption_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var Redemption = /** @class */ (function (_super) {
    Redemption_extends(Redemption, _super);
    function Redemption() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Redemption.prototype, "name", {
        get: function () {
            return "Redemption";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Redemption.prototype, "groups", {
        get: function () {
            return [PrayerGroups.OVERHEADS];
        },
        enumerable: false,
        configurable: true
    });
    Redemption.prototype.levelRequirement = function () {
        return 49;
    };
    Redemption.prototype.drainRate = function () {
        return 6;
    };
    Redemption.prototype.isOverhead = function () {
        return true;
    };
    Redemption.prototype.overheadImageReference = function () {
        return redemptionOver_namespaceObject;
    };
    Redemption.prototype.feature = function () {
        return "";
    };
    Redemption.prototype.playOnSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    Redemption.prototype.playOffSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return Redemption;
}(BasePrayer));


;// CONCATENATED MODULE: ./src/content/prayers/Retribution.ts

var Retribution_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var Retribution = /** @class */ (function (_super) {
    Retribution_extends(Retribution, _super);
    function Retribution() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Retribution.prototype, "name", {
        get: function () {
            return "Retribution";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Retribution.prototype, "groups", {
        get: function () {
            return [PrayerGroups.OVERHEADS]; // TODO: Incorrect
        },
        enumerable: false,
        configurable: true
    });
    Retribution.prototype.levelRequirement = function () {
        return 100;
    };
    Retribution.prototype.drainRate = function () {
        return 3;
    };
    Retribution.prototype.isOverhead = function () {
        return false;
    };
    Retribution.prototype.feature = function () {
        return "";
    };
    Retribution.prototype.playOnSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    Retribution.prototype.playOffSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return Retribution;
}(BasePrayer));


;// CONCATENATED MODULE: ./src/content/prayers/Rigour.ts

var Rigour_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var Rigour = /** @class */ (function (_super) {
    Rigour_extends(Rigour, _super);
    function Rigour() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Rigour.prototype, "name", {
        get: function () {
            return "Rigour";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Rigour.prototype, "groups", {
        get: function () {
            return [PrayerGroups.ACCURACY, PrayerGroups.STRENGTH, PrayerGroups.DEFENCE];
        },
        enumerable: false,
        configurable: true
    });
    Rigour.prototype.levelRequirement = function () {
        return 74;
    };
    Rigour.prototype.drainRate = function () {
        return 24;
    };
    Rigour.prototype.isOverhead = function () {
        return false;
    };
    Rigour.prototype.feature = function () {
        return "offensiveRange";
    };
    Rigour.prototype.playOnSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    Rigour.prototype.playOffSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return Rigour;
}(BasePrayer));


;// CONCATENATED MODULE: ./src/content/prayers/RockSkin.ts

var RockSkin_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var RockSkin = /** @class */ (function (_super) {
    RockSkin_extends(RockSkin, _super);
    function RockSkin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(RockSkin.prototype, "name", {
        get: function () {
            return "Rock Skin";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RockSkin.prototype, "groups", {
        get: function () {
            return [PrayerGroups.DEFENCE];
        },
        enumerable: false,
        configurable: true
    });
    RockSkin.prototype.levelRequirement = function () {
        return 10;
    };
    RockSkin.prototype.drainRate = function () {
        return 6;
    };
    RockSkin.prototype.isOverhead = function () {
        return false;
    };
    RockSkin.prototype.feature = function () {
        return "defensive";
    };
    RockSkin.prototype.playOnSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    RockSkin.prototype.playOffSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return RockSkin;
}(BasePrayer));


;// CONCATENATED MODULE: ./src/content/prayers/SharpEye.ts

var SharpEye_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var SharpEye = /** @class */ (function (_super) {
    SharpEye_extends(SharpEye, _super);
    function SharpEye() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SharpEye.prototype, "name", {
        get: function () {
            return "Sharp Eye";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SharpEye.prototype, "groups", {
        get: function () {
            return [PrayerGroups.ACCURACY, PrayerGroups.STRENGTH];
        },
        enumerable: false,
        configurable: true
    });
    SharpEye.prototype.levelRequirement = function () {
        return 8;
    };
    SharpEye.prototype.drainRate = function () {
        return 3;
    };
    SharpEye.prototype.isOverhead = function () {
        return false;
    };
    SharpEye.prototype.feature = function () {
        return "offensiveRange";
    };
    SharpEye.prototype.playOnSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    SharpEye.prototype.playOffSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return SharpEye;
}(BasePrayer));


;// CONCATENATED MODULE: ./src/content/prayers/Smite.ts

var Smite_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var Smite = /** @class */ (function (_super) {
    Smite_extends(Smite, _super);
    function Smite() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Smite.prototype, "name", {
        get: function () {
            return "Smite";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Smite.prototype, "groups", {
        get: function () {
            return [PrayerGroups.OVERHEADS];
        },
        enumerable: false,
        configurable: true
    });
    Smite.prototype.levelRequirement = function () {
        return 100;
    };
    Smite.prototype.drainRate = function () {
        return 18;
    };
    Smite.prototype.isOverhead = function () {
        return false;
    };
    Smite.prototype.feature = function () {
        return "smite";
    };
    Smite.prototype.playOnSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    Smite.prototype.playOffSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return Smite;
}(BasePrayer));


;// CONCATENATED MODULE: ./src/content/prayers/SteelSkin.ts

var SteelSkin_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var SteelSkin = /** @class */ (function (_super) {
    SteelSkin_extends(SteelSkin, _super);
    function SteelSkin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SteelSkin.prototype, "name", {
        get: function () {
            return "Steel Skin";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SteelSkin.prototype, "groups", {
        get: function () {
            return [PrayerGroups.DEFENCE];
        },
        enumerable: false,
        configurable: true
    });
    SteelSkin.prototype.levelRequirement = function () {
        return 28;
    };
    SteelSkin.prototype.drainRate = function () {
        return 12;
    };
    SteelSkin.prototype.isOverhead = function () {
        return false;
    };
    SteelSkin.prototype.feature = function () {
        return "defensive";
    };
    SteelSkin.prototype.playOnSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    SteelSkin.prototype.playOffSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return SteelSkin;
}(BasePrayer));


;// CONCATENATED MODULE: ./src/content/prayers/SuperhumanStrength.ts

var SuperhumanStrength_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var SuperhumanStrength = /** @class */ (function (_super) {
    SuperhumanStrength_extends(SuperhumanStrength, _super);
    function SuperhumanStrength() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SuperhumanStrength.prototype, "name", {
        get: function () {
            return "Superhuman Strength";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuperhumanStrength.prototype, "groups", {
        get: function () {
            return [PrayerGroups.STRENGTH];
        },
        enumerable: false,
        configurable: true
    });
    SuperhumanStrength.prototype.levelRequirement = function () {
        return 13;
    };
    SuperhumanStrength.prototype.drainRate = function () {
        return 6;
    };
    SuperhumanStrength.prototype.isOverhead = function () {
        return false;
    };
    SuperhumanStrength.prototype.feature = function () {
        return "offensiveStrength";
    };
    SuperhumanStrength.prototype.playOnSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    SuperhumanStrength.prototype.playOffSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return SuperhumanStrength;
}(BasePrayer));


;// CONCATENATED MODULE: ./src/content/prayers/ThickSkin.ts

var ThickSkin_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var ThickSkin = /** @class */ (function (_super) {
    ThickSkin_extends(ThickSkin, _super);
    function ThickSkin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ThickSkin.prototype, "name", {
        get: function () {
            return "Thick Skin";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThickSkin.prototype, "groups", {
        get: function () {
            return [PrayerGroups.DEFENCE];
        },
        enumerable: false,
        configurable: true
    });
    ThickSkin.prototype.levelRequirement = function () {
        return 1;
    };
    ThickSkin.prototype.drainRate = function () {
        return 3;
    };
    ThickSkin.prototype.isOverhead = function () {
        return false;
    };
    ThickSkin.prototype.feature = function () {
        return "defensive";
    };
    ThickSkin.prototype.playOnSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    ThickSkin.prototype.playOffSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return ThickSkin;
}(BasePrayer));


;// CONCATENATED MODULE: ./src/content/prayers/UltimateStrength.ts

var UltimateStrength_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var UltimateStrength = /** @class */ (function (_super) {
    UltimateStrength_extends(UltimateStrength, _super);
    function UltimateStrength() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(UltimateStrength.prototype, "name", {
        get: function () {
            return "Ultimate Strength";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UltimateStrength.prototype, "groups", {
        get: function () {
            return [PrayerGroups.STRENGTH];
        },
        enumerable: false,
        configurable: true
    });
    UltimateStrength.prototype.levelRequirement = function () {
        return 31;
    };
    UltimateStrength.prototype.drainRate = function () {
        return 12;
    };
    UltimateStrength.prototype.isOverhead = function () {
        return false;
    };
    UltimateStrength.prototype.feature = function () {
        return "offensiveStrength";
    };
    UltimateStrength.prototype.playOnSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    UltimateStrength.prototype.playOffSound = function () {
        if (Settings.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return UltimateStrength;
}(BasePrayer));


;// CONCATENATED MODULE: ./src/sdk/PrayerController.ts































var PrayerController = /** @class */ (function () {
    function PrayerController(player) {
        this.drainCounter = 0;
        this.prayers = [
            new ThickSkin(),
            new BurstOfStrength(),
            new ClarityOfThought(),
            new SharpEye(),
            new MysticWill(),
            new RockSkin(),
            new SuperhumanStrength(),
            new ImprovedReflexes(),
            new RapidRestore(),
            new RapidHeal(),
            new ProtectItem(),
            new HawkEye(),
            new MysticLore(),
            new SteelSkin(),
            new UltimateStrength(),
            new IncredibleReflexes(),
            new ProtectMage(),
            new ProtectRange(),
            new ProtectMelee(),
            new EagleEye(),
            new MysticMight(),
            new Retribution(),
            new Redemption(),
            new Smite(),
            new Preserve(),
            new Chivalry(),
            new Piety(),
            new Rigour(),
            new Augury(),
        ];
        this.player = player;
    }
    PrayerController.prototype.tick = function (player) {
        // "transfer" prayers from client to "server"
        this.prayers.forEach(function (prayer) { return prayer.tick(); });
        // Deactivate any incompatible prayers
        var conflictingPrayers = {};
        player.prayerController.prayers.forEach(function (activePrayer) {
            activePrayer.groups.forEach(function (group) {
                if (!conflictingPrayers[group]) {
                    conflictingPrayers[group] = [];
                }
                conflictingPrayers[group].push(activePrayer);
            });
        });
        for (var prayer in conflictingPrayers) {
            conflictingPrayers[prayer].sort(function (p1, p2) { return p2.lastActivated - p1.lastActivated; });
            conflictingPrayers[prayer].shift();
            conflictingPrayers[prayer].forEach(function (prayer) {
                prayer.isLit = false;
                prayer.isActive = false;
            });
        }
        // calc prayer drain
        var prayerDrainThisTick = this.drainRate();
        this.drainCounter += prayerDrainThisTick;
        while (this.drainCounter > this.player.prayerDrainResistance) {
            this.player.currentStats.prayer--;
            this.drainCounter -= this.player.prayerDrainResistance;
        }
        // deactivate prayers when out of prayer
        if (this.player.currentStats.prayer <= 0) {
            this.activePrayers().forEach(function (prayer) { return prayer.deactivate(); });
            this.player.currentStats.prayer = 0;
        }
    };
    PrayerController.prototype.drainRate = function () {
        return this.activePrayers().reduce(function (a, b) { return a + b.drainRate(); }, 0);
    };
    PrayerController.prototype.findPrayerByName = function (name) {
        return (0,lodash.find)(this.prayers, function (prayer) { return prayer.name === name; });
    };
    PrayerController.prototype.isPrayerActiveByName = function (name) {
        return (0,lodash.find)(this.activePrayers(), function (prayer) { return prayer.name === name; });
    };
    PrayerController.prototype.activePrayers = function () {
        return (0,lodash.filter)(this.prayers, function (prayer) { return prayer.isActive; });
    };
    PrayerController.prototype.matchFeature = function (feature) {
        return (0,lodash.find)(this.activePrayers(), function (prayer) { return prayer.feature() === feature; });
    };
    PrayerController.prototype.matchGroup = function (group) {
        return (0,lodash.find)(this.activePrayers(), function (prayer) { return prayer.groups.includes(group); });
    };
    PrayerController.prototype.overhead = function () {
        return (0,lodash.find)(this.activePrayers(), function (prayer) { return (0,lodash.intersection)(prayer.groups, [PrayerGroups.OVERHEADS]).length; });
    };
    return PrayerController;
}());


;// CONCATENATED MODULE: ./src/sdk/gear/Ammo.ts
var Ammo_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var AmmoType;
(function (AmmoType) {
    AmmoType[AmmoType["BLESSING"] = 0] = "BLESSING";
    AmmoType[AmmoType["AMMO"] = 1] = "AMMO";
})(AmmoType || (AmmoType = {}));
var Ammo = /** @class */ (function (_super) {
    Ammo_extends(Ammo, _super);
    function Ammo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Ammo.prototype, "type", {
        get: function () {
            return EquipmentTypes.AMMO;
        },
        enumerable: false,
        configurable: true
    });
    Ammo.prototype.ammoType = function () {
        return AmmoType.AMMO;
    };
    Ammo.prototype.assignToPlayer = function (player) {
        player.equipment.ammo = this;
    };
    Ammo.prototype.unassignToPlayer = function (player) {
        player.equipment.ammo = null;
    };
    Ammo.prototype.currentEquipment = function (player) {
        return player.equipment.ammo;
    };
    return Ammo;
}(Equipment));


;// CONCATENATED MODULE: ./src/assets/sounds/hit.ogg
const hit_namespaceObject = __webpack_require__.p + "74571561a471dca69251.ogg";
;// CONCATENATED MODULE: ./src/assets/sounds/human_hit_513.ogg
const human_hit_513_namespaceObject = __webpack_require__.p + "6352a171f1cca4c45fb0.ogg";
;// CONCATENATED MODULE: ./src/sdk/EntityName.ts

var EntityNames;
(function (EntityNames) {
    EntityNames["TILE_MARKER"] = "Tile Marker";
    EntityNames["INFERNO_SHIELD"] = "Inferno Shield";
    EntityNames["TZ_KAL_ZUK"] = "TzKal-Zuk";
    EntityNames["JAL_XIL"] = "Jal-Xil";
    EntityNames["JAL_ZEK"] = "Jal-Zek";
    EntityNames["YT_HUR_KOT"] = "Yt-HurKot";
    EntityNames["JAL_TOK_JAD"] = "JalTok-Jad";
    EntityNames["JAL_NIB"] = "Jal-Nib";
    EntityNames["JAL_MEJ_RAJ"] = "Jal-MejRah";
    EntityNames["JAL_MEJ_JAK"] = "Jal-MejJak";
    EntityNames["JAL_IM_KOT"] = "Jal-ImKot";
    EntityNames["JAL_AK_REK_XIL"] = "Jal-AkRek-Xil";
    EntityNames["JAL_AK_REK_MEJ"] = "Jal-AkRek-Mej";
    EntityNames["JAL_AK_REK_KET"] = "Jal-AkRek-Ket";
    EntityNames["JAL_AK"] = "Jal-Ak";
    EntityNames["PILLAR"] = "Pillar";
    EntityNames["SOL_HEREDIT"] = "Sol Heredit";
})(EntityNames || (EntityNames = {}));

;// CONCATENATED MODULE: ./src/sdk/rendering/TileMarkerModel.ts
var TileMarkerModel_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var TileMarkerModel_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


var TileMarkerModel = /** @class */ (function () {
    function TileMarkerModel(renderable, renderOrder) {
        this.renderable = renderable;
        var size = renderable.size;
        this.lineMaterial = new external_three_.LineBasicMaterial({
            color: renderable.colorHex,
            linewidth: 2,
        });
        var points = [
            new external_three_.Vector3(0, 0, 0),
            new external_three_.Vector3(size, 0, 0),
            new external_three_.Vector3(size, 0, 0),
            new external_three_.Vector3(size, 0, -size),
            new external_three_.Vector3(size, 0, -size),
            new external_three_.Vector3(0, 0, -size),
            new external_three_.Vector3(0, 0, -size),
            new external_three_.Vector3(0, 0, 0),
        ];
        var geometry = new external_three_.BufferGeometry().setFromPoints(points);
        this.outline = new external_three_.LineSegments(geometry, this.lineMaterial);
        if (renderOrder !== null) {
            drawLineOnTop(this.outline, renderOrder);
        }
    }
    TileMarkerModel.forRenderable = function (r, renderOrder) {
        if (renderOrder === void 0) { renderOrder = 1; }
        return new TileMarkerModel(r, renderOrder);
    };
    TileMarkerModel.prototype.draw = function (scene, clockDelta, tickPercent, location) {
        if (this.outline.parent !== scene) {
            scene.add(this.outline);
        }
        var x = location.x, y = location.y;
        this.outline.visible = this.renderable.visible(tickPercent);
        this.outline.position.x = x;
        this.outline.position.y = -0.49;
        this.outline.position.z = y;
        this.lineMaterial.color.setHex(this.renderable.colorHex);
    };
    TileMarkerModel.prototype.destroy = function (scene) {
        if (this.outline.parent === scene) {
            scene.remove(this.outline);
        }
    };
    TileMarkerModel.prototype.getWorldPosition = function () {
        return this.outline.getWorldPosition(new external_three_.Vector3());
    };
    TileMarkerModel.prototype.preload = function () {
        return TileMarkerModel_awaiter(this, void 0, void 0, function () {
            return TileMarkerModel_generator(this, function (_a) {
                // do nothing
                return [2 /*return*/];
            });
        });
    };
    return TileMarkerModel;
}());


;// CONCATENATED MODULE: ./src/content/TileMarker.ts

var TileMarker_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var TileMarker = /** @class */ (function (_super) {
    TileMarker_extends(TileMarker, _super);
    function TileMarker(region, location, color, size, saveable) {
        if (size === void 0) { size = 1; }
        if (saveable === void 0) { saveable = true; }
        var _this = _super.call(this, region, location) || this;
        _this._color = "#00FF00";
        _this._size = 1;
        _this.saveable = true;
        _this._color = color;
        _this._size = size;
        _this.saveable = saveable;
        if (saveable) {
            TileMarker.saveableMarkers.push(_this);
        }
        return _this;
    }
    TileMarker.onSetColor = function (color) {
        // saveable tile markers change color
        TileMarker.saveableMarkers.forEach(function (marker) {
            marker._color = color;
        });
    };
    TileMarker.loadAll = function (region) {
        if (Settings.tile_markers) {
            Settings.tile_markers
                .map(function (location) {
                return new TileMarker(region, location, Settings.tileMarkerColor);
            })
                .forEach(function (tileMarker) {
                region.addEntity(tileMarker);
            });
        }
    };
    TileMarker.prototype.entityName = function () {
        return EntityNames.TILE_MARKER;
    };
    Object.defineProperty(TileMarker.prototype, "collisionType", {
        get: function () {
            return CollisionType.NONE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TileMarker.prototype, "lineOfSight", {
        get: function () {
            return LineOfSightMask.NONE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TileMarker.prototype, "size", {
        get: function () {
            return this._size;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TileMarker.prototype, "color", {
        get: function () {
            return this._color;
        },
        enumerable: false,
        configurable: true
    });
    TileMarker.prototype.draw = function () {
        this.region.context.lineWidth = 2;
        this.region.context.strokeStyle = this._color;
        this.region.context.strokeRect(this.location.x * Settings.tileSize, (this.location.y - this.size + 1) * Settings.tileSize, this.size * Settings.tileSize, this.size * Settings.tileSize);
    };
    TileMarker.prototype.create3dModel = function () {
        return TileMarkerModel.forRenderable(this);
    };
    TileMarker.saveableMarkers = [];
    return TileMarker;
}(Entity));


;// CONCATENATED MODULE: ./src/sdk/Player.ts

var Player_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Player_assign = (undefined && undefined.__assign) || function () {
    Player_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return Player_assign.apply(this, arguments);
};




















/* eslint-disable @typescript-eslint/no-explicit-any */
var PlayerEffects = /** @class */ (function () {
    function PlayerEffects() {
        this.poisoned = 0;
        this.venomed = 0;
        this.stamina = 0;
    }
    return PlayerEffects;
}());
// player can rotate this many JAUs per client tick
var PLAYER_ROTATION_RATE_JAU = 64;
var CLIENT_TICKS_PER_SECOND = 50;
var JAU_PER_RADIAN = 512;
var RADIANS_PER_TICK = ((CLIENT_TICKS_PER_SECOND * PLAYER_ROTATION_RATE_JAU) / JAU_PER_RADIAN) * 0.6;
var ENABLE_POSITION_DEBUG = false;
// position that is "close enough"
var EPSILON = 0.1;
var Player = /** @class */ (function (_super) {
    Player_extends(Player, _super);
    function Player(region, location, options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, region, location, options) || this;
        _this.running = true;
        _this.cachedBonuses = null;
        _this.useSpecialAttack = false;
        _this.effects = new PlayerEffects();
        _this.regenTimer = new PlayerRegenTimer(_this);
        _this.autocastDelay = 1;
        _this.manualCastHasTarget = false;
        _this.eats = new Eating();
        _this.seekingItem = null;
        _this.path = [];
        _this.clickMarker = null;
        _this.aggroMarker = null;
        _this.pathMarkers = [];
        _this.currentPoseAnimation = PlayerAnimationIndices.Idle;
        // Rotation Code
        _this.restingAngle = 0;
        _this.nextAngle = 0;
        _this._angle = 0;
        _this.lastTickPercent = 0;
        _this.destinationLocation = location;
        _this.pathTargetLocation = location;
        _this.equipmentChanged();
        _this.clearXpDrops();
        _this.autoRetaliate = false;
        _this.eats.player = _this;
        _this.setUnitOptions(options);
        _this.prayerController = new PrayerController(_this);
        return _this;
    }
    Player.prototype.contextActions = function (region, x, y) {
        var _this = this;
        return _super.prototype.contextActions.call(this, region, x, y).concat([
            {
                text: [
                    { text: "Attack ", fillStyle: "white" },
                    { text: "Player", fillStyle: "yellow" },
                    {
                        text: " (level ".concat(this.combatLevel, ")"),
                        fillStyle: Trainer.player.combatLevelColor(this),
                    },
                ],
                action: function () {
                    Trainer.clickController.redClick();
                    Trainer.player.setAggro(_this);
                },
            },
        ]);
    };
    Player.prototype.setUnitOptions = function (options) {
        this.equipment = options.equipment || {};
        this.inventory = options.inventory || new Array(28).fill(null);
        this.equipmentChanged();
    };
    Player.prototype.interruptCombat = function () {
        this.setAggro(null);
    };
    Object.defineProperty(Player.prototype, "color", {
        get: function () {
            return "#00FF00";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Player.prototype, "height", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Player.prototype, "isPlayer", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Player.prototype, "attackRange", {
        get: function () {
            if (this.manualSpellCastSelection) {
                return this.manualSpellCastSelection.attackRange;
            }
            if (this.equipment.weapon) {
                return this.equipment.weapon.attackRange;
            }
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Player.prototype, "attackSpeed", {
        get: function () {
            if (this.manualSpellCastSelection) {
                return this.manualSpellCastSelection.attackSpeed;
            }
            if (this.equipment.weapon) {
                return this.equipment.weapon.attackSpeed;
            }
            return 5;
        },
        enumerable: false,
        configurable: true
    });
    Player.prototype.openInventorySlots = function () {
        var openSpots = [];
        for (var i = 0; i < 28; i++) {
            if (!this.inventory[i]) {
                openSpots.push(i);
            }
        }
        return openSpots;
    };
    Player.prototype.postAttacksEvent = function () {
        this.eats.checkRedemption(this);
    };
    Player.prototype.swapItemPositions = function (pos1, pos2) {
        var _a, _b;
        // positions can be negative if an item is destroyed due to consuming it on the same tick
        var temp = (_a = this.inventory[pos1]) !== null && _a !== void 0 ? _a : null;
        this.inventory[pos1] = (_b = this.inventory[pos2]) !== null && _b !== void 0 ? _b : null;
        this.inventory[pos2] = temp;
    };
    Player.prototype.equipmentChanged = function () {
        var _this = this;
        this.interruptCombat();
        var gear = [
            this.equipment.weapon,
            this.equipment.offhand,
            this.equipment.helmet,
            this.equipment.necklace,
            this.equipment.chest,
            this.equipment.legs,
            this.equipment.feet,
            this.equipment.gloves,
            this.equipment.ring,
            this.equipment.cape,
        ];
        if (this.equipment.weapon &&
            this.equipment.ammo &&
            this.equipment.weapon.compatibleAmmo().includes(this.equipment.ammo.itemName)) {
            gear.push(this.equipment.ammo);
        }
        else if (this.equipment.ammo && this.equipment.ammo.ammoType() == AmmoType.BLESSING) {
            gear.push(this.equipment.ammo);
        }
        // updated gear bonuses
        this.cachedBonuses = Unit.emptyBonuses();
        gear.forEach(function (g) {
            if (g && g.bonuses) {
                g.updateBonuses(gear);
                _this.cachedBonuses = Unit.mergeEquipmentBonuses(_this.cachedBonuses, g.bonuses);
            }
        });
        // update set effects
        var allSetEffects = [];
        gear.forEach(function (equipment) {
            if (equipment && equipment.equipmentSetEffect) {
                allSetEffects.push(equipment.equipmentSetEffect);
            }
        });
        var completeSetEffects = [];
        (0,lodash.uniq)(allSetEffects).forEach(function (setEffect) {
            var itemsInSet = setEffect.itemsInSet();
            var setItemsEquipped = 0;
            (0,lodash.find)(itemsInSet, function (itemName) {
                gear.forEach(function (equipment) {
                    if (!equipment) {
                        return;
                    }
                    if (itemName === equipment.itemName) {
                        setItemsEquipped++;
                    }
                });
            });
            if (itemsInSet.length === setItemsEquipped) {
                completeSetEffects.push(setEffect);
            }
        });
        this.setEffects = completeSetEffects;
        if (this.path.length === 0) {
            this.currentPoseAnimation = this.getIdlePoseId();
        }
        this.invalidateModel();
    };
    Object.defineProperty(Player.prototype, "bonuses", {
        get: function () {
            return this.cachedBonuses;
        },
        enumerable: false,
        configurable: true
    });
    Player.prototype.setStats = function () {
        // non boosted numbers
        this.stats = Settings.player_stats;
        // with boosts
        this.currentStats = JSON.parse(JSON.stringify(Settings.player_stats));
    };
    Object.defineProperty(Player.prototype, "weight", {
        get: function () {
            var gear = [
                this.equipment.weapon,
                this.equipment.offhand,
                this.equipment.helmet,
                this.equipment.necklace,
                this.equipment.chest,
                this.equipment.legs,
                this.equipment.feet,
                this.equipment.gloves,
                this.equipment.ring,
                this.equipment.cape,
                this.equipment.ammo,
            ];
            gear = gear.concat(this.inventory);
            gear = (0,lodash.filter)(gear);
            var kgs = Math.max(Math.min(64, (0,lodash.sumBy)(gear, "weight")), 0);
            return kgs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Player.prototype, "prayerDrainResistance", {
        get: function () {
            // https://oldschool.runescape.wiki/w/Prayer#Prayer_drain_mechanics
            return 2 * this.bonuses.other.prayer + 60;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Player.prototype, "type", {
        get: function () {
            return UnitTypes.PLAYER;
        },
        enumerable: false,
        configurable: true
    });
    Player.prototype.clearXpDrops = function () {
        this.xpDrops = {};
    };
    Player.prototype.grantXp = function (xpDrop) {
        if (!this.xpDrops[xpDrop.skill]) {
            this.xpDrops[xpDrop.skill] = 0;
        }
        this.xpDrops[xpDrop.skill] += xpDrop.xp;
    };
    Player.prototype.sendXpToController = function () {
        var _this = this;
        if (!XpDropController.controller) {
            return;
        }
        if (this !== Trainer.player) {
            return;
        }
        Object.keys(this.xpDrops).forEach(function (skill) {
            XpDropController.controller.registerXpDrop({
                skill: skill,
                xp: Math.ceil(_this.xpDrops[skill]),
            });
        });
        this.clearXpDrops();
    };
    Player.prototype.moveTo = function (x, y) {
        var _this = this;
        this.interruptCombat();
        this.manualSpellCastSelection = null;
        this.pathTargetLocation = null;
        var clickedOnEntities = Collision.collideableEntitiesAtPoint(this.region, x, y, 1);
        if (clickedOnEntities.length) {
            // Clicked on an entity, scan around to find the best spot to actually path to
            var clickedOnEntity = clickedOnEntities[0];
            var maxDist = Math.ceil(clickedOnEntity.size / 2);
            var bestDistances = [];
            var bestDistance = 9999;
            for (var yOff = -maxDist; yOff < maxDist; yOff++) {
                for (var xOff = -maxDist; xOff < maxDist; xOff++) {
                    var potentialX = x + xOff;
                    var potentialY = y + yOff;
                    var e = Collision.collideableEntitiesAtPoint(this.region, potentialX, potentialY, 1);
                    if (e.length === 0) {
                        var distance = Pathing.dist(potentialX, potentialY, x, y);
                        if (distance <= bestDistance) {
                            if (bestDistances[0] && bestDistances[0].bestDistance > distance) {
                                bestDistance = distance;
                                bestDistances = [];
                            }
                            bestDistances.push({
                                x: potentialX,
                                y: potentialY,
                                bestDistance: bestDistance,
                            });
                        }
                    }
                }
            }
            var winner = (0,lodash.minBy)(bestDistances, function (distance) {
                return Pathing.dist(distance.x, distance.y, _this.location.x, _this.location.y);
            });
            if (winner) {
                this.destinationLocation = { x: winner.x, y: winner.y };
            }
        }
        else {
            this.destinationLocation = { x: x, y: y };
        }
    };
    Player.prototype.attack = function () {
        if (this.manualSpellCastSelection) {
            var target = this.aggro;
            this.manualSpellCastSelection.cast(this, target);
            this.manualSpellCastSelection = null;
            this.interruptCombat();
            this.destinationLocation = this.location;
        }
        else {
            // use equipped weapon
            if (this.equipment.weapon) {
                if (this.equipment.weapon.hasSpecialAttack() && this.useSpecialAttack) {
                    if (this.currentStats.specialAttack >= this.equipment.weapon.specialAttackDrain()) {
                        this.equipment.weapon.specialAttack(this, this.aggro /* hack */);
                        this.currentStats.specialAttack -= this.equipment.weapon.specialAttackDrain();
                        this.regenTimer.specUsed();
                    }
                    this.useSpecialAttack = false;
                }
                else {
                    var bonuses = {};
                    if (this.equipment.helmet && this.equipment.helmet.itemName === ItemName.SLAYER_HELMET_I) {
                        bonuses.gearMeleeMultiplier = 7 / 6;
                        bonuses.gearRangeMultiplier = 1.15;
                        bonuses.gearMageMultiplier = 1.15;
                    }
                    return this.equipment.weapon.attack(this, this.aggro /* hack */, bonuses);
                }
            }
            else {
                return false;
            }
        }
        return true;
    };
    Player.prototype.activatePrayers = function () {
        this.lastOverhead = this.overhead;
        this.overhead = this.prayerController.overhead();
        if (this.lastOverhead && !this.overhead) {
            this.lastOverhead.playOffSound();
        }
        else if (this.lastOverhead !== this.overhead) {
            this.overhead.playOnSound();
        }
    };
    Player.prototype.setAggro = function (mob) {
        _super.prototype.setAggro.call(this, mob);
        if (mob !== this.aggro) {
            // do spam clicks constantly reset autocast delay? idk
            this.autocastDelay = 1; // not sure if this is actually correct behavior but whatever
        }
        if (this.manualSpellCastSelection && mob != null) {
            this.manualCastHasTarget = true;
        }
        else {
            this.manualCastHasTarget = false;
        }
        this.aggro = mob;
        this.seekingItem = null;
    };
    Player.prototype.setSeekingItem = function (item) {
        this.interruptCombat();
        this.seekingItem = item;
    };
    Player.prototype.determineDestination = function () {
        var _this = this;
        var _a;
        if (this.aggro) {
            if (this.aggro.dying > -1) {
                this.destinationLocation = this.location;
                return;
            }
            var isUnderAggrodMob = Collision.collisionMath(this.location.x, this.location.y, 1, this.aggro.location.x, this.aggro.location.y, this.aggro.size);
            this.setHasLOS();
            if (isUnderAggrodMob) {
                var maxDist = Math.ceil(this.aggro.size / 2);
                var bestDistance = 9999;
                var winner = null;
                for (var yy = -maxDist; yy < maxDist; yy++) {
                    for (var xx = -maxDist; xx < maxDist; xx++) {
                        var x = this.location.x + xx;
                        var y = this.location.y + yy;
                        if (Pathing.canTileBePathedTo(this.region, x, y, 1, {})) {
                            var distance = Pathing.dist(this.location.x, this.location.y, x, y);
                            if (distance > 0 && distance < bestDistance) {
                                bestDistance = distance;
                                winner = { x: x, y: y };
                            }
                        }
                    }
                }
                if (winner) {
                    this.destinationLocation = { x: winner.x, y: winner.y };
                }
                else {
                    console.log("I don't understand what could cause this, but i'd like to find out");
                }
            }
            else if (!this.hasLOS) {
                var seekingTiles_1 = [];
                // "When clicking on an npc, object, or player, the requested tiles will be all tiles"
                // "within melee range of the npc, object, or player."
                // For implementation reasons we also ensure the north/south tiles are added to seekingTiles *first* so that
                // in cases of ties, the north and south tiles are picked by minBy below.
                var aggroSize = this.aggro.size;
                (0,lodash.range)(0, aggroSize).forEach(function (xx) {
                    [-1, _this.aggro.size].forEach(function (yy) {
                        // Don't path into an unpathable object.
                        var px = _this.aggro.location.x + xx;
                        var py = _this.aggro.location.y - yy;
                        if (!Collision.collidesWithAnyEntities(_this.region, px, py, 1)) {
                            seekingTiles_1.push({
                                x: px,
                                y: py,
                            });
                        }
                    });
                });
                (0,lodash.range)(0, aggroSize).forEach(function (yy) {
                    [-1, _this.aggro.size].forEach(function (xx) {
                        // Don't path into an unpathable object.
                        var px = _this.aggro.location.x + xx;
                        var py = _this.aggro.location.y - yy;
                        if (!Collision.collidesWithAnyEntities(_this.region, px, py, 1)) {
                            seekingTiles_1.push({
                                x: px,
                                y: py,
                            });
                        }
                    });
                });
                // Create paths to all npc tiles
                var path = Pathing.constructPaths(this.region, this.location, seekingTiles_1);
                this.destinationLocation = (_a = path.destination) !== null && _a !== void 0 ? _a : this.location;
            }
            else {
                // stop moving
                this.destinationLocation = this.location;
            }
        }
        else if (this.seekingItem) {
            this.destinationLocation = this.seekingItem.groundLocation;
        }
    };
    Player.prototype.getIdlePoseId = function () {
        return this.equipment.weapon ? this.equipment.weapon.idleAnimationId : PlayerAnimationIndices.Idle;
    };
    // WARNING: client ticks do NOT happen in line with render or logic ticks. Do not use this for anything other than
    // visual logic.
    Player.prototype.clientTick = function (tickPercent) {
        // based on https://github.com/dennisdev/rs-map-viewer/blob/master/src/mapviewer/webgl/npc/Npc.ts#L115
        if (this.path.length === 0) {
            return;
        }
        var _a = this.perceivedLocation, x = _a.x, y = _a.y;
        var _b = this.path[0], nextX = _b.x, nextY = _b.y, run = _b.run;
        var currentAngle = this.getPerceivedRotation(tickPercent);
        // 30 client ticks per tick and we want to walk 1 tile per tick so
        var baseMovementSpeed = 1 / 30;
        var movementSpeed = baseMovementSpeed;
        this.currentPoseAnimation = PlayerAnimationIndices.Walk;
        var canRotate = true;
        if (currentAngle !== this.nextAngle && canRotate) {
            if (ENABLE_POSITION_DEBUG)
                console.log("must rotate", this.path.length, run);
            movementSpeed = baseMovementSpeed / 2;
            this.currentPoseAnimation = PlayerAnimationIndices.Rotate180;
        }
        if (this.path.length === 3) {
            if (ENABLE_POSITION_DEBUG)
                console.log("path length medium", this.path.length, run);
            movementSpeed = baseMovementSpeed * 1.5;
        }
        if (this.path.length > 3) {
            if (ENABLE_POSITION_DEBUG)
                console.log("path length warp", this.path.length, run);
            movementSpeed = baseMovementSpeed * 2;
        }
        if (this.path.length < 3) {
            if (ENABLE_POSITION_DEBUG)
                console.log("normal speed", this.path.length, run);
        }
        if (run) {
            movementSpeed *= 2;
            this.currentPoseAnimation = PlayerAnimationIndices.Run;
        }
        var diffX = Math.abs(x - nextX);
        var diffY = Math.abs(y - nextY);
        if (diffX > EPSILON || diffY > EPSILON) {
            if (x < nextX) {
                x = Math.min(x + movementSpeed, nextX);
            }
            else if (x > nextX) {
                x = Math.max(x - movementSpeed, nextX);
            }
            if (y < nextY) {
                y = Math.min(y + movementSpeed, nextY);
            }
            else if (y > nextY) {
                y = Math.max(y - movementSpeed, nextY);
            }
        }
        this.perceivedLocation = { x: x, y: y };
        diffX = Math.abs(x - nextX);
        diffY = Math.abs(y - nextY);
        if (diffX < EPSILON && diffY < EPSILON) {
            this.perceivedLocation.x = nextX;
            this.perceivedLocation.y = nextY;
            this.path.shift();
            if (ENABLE_POSITION_DEBUG) {
                var headTile = this.pathMarkers.shift();
                this.region.removeEntity(headTile);
            }
            if (this.path.length === 0) {
                this.currentPoseAnimation = this.getIdlePoseId();
                this.restingAngle = this.nextAngle;
            }
            else {
                this.nextAngle = this.getTargetAngle();
            }
        }
    };
    Player.prototype.moveTowardsDestination = function () {
        var _a;
        var _this = this;
        this.nextAngle = this.getTargetAngle();
        // Calculate run energy
        var dist = this.pathTargetLocation
            ? chebyshev_default()([this.location.x, this.location.y], [this.pathTargetLocation.x, this.pathTargetLocation.y])
            : 0;
        if (this.running && dist > 1) {
            var runReduction = 67 + Math.floor(67 + Math.min(Math.max(0, this.weight), 64) / 64);
            if (this.effects.stamina) {
                this.currentStats.run -= Math.floor(0.3 * runReduction);
            }
            else if (this.equipment.ring && this.equipment.ring.itemName === ItemName.RING_OF_ENDURANCE) {
                this.currentStats.run -= Math.floor(0.85 * runReduction);
            }
            else {
                this.currentStats.run -= runReduction;
            }
        }
        else {
            this.currentStats.run += Math.floor(this.currentStats.agility / 6) + 8;
        }
        this.currentStats.run = Math.min(Math.max(this.currentStats.run, 0), 10000);
        if (this.currentStats.run === 0) {
            this.running = false;
        }
        // Tick down stamina
        this.effects.stamina--;
        this.effects.stamina = Math.min(Math.max(this.effects.stamina, 0), 200);
        // Path to next position if not already there.
        if (!this.destinationLocation ||
            (this.location.x === this.destinationLocation.x && this.location.y === this.destinationLocation.y)) {
            this.pathTargetLocation = null;
            return;
        }
        var speed = this.running ? 2 : 1;
        var _b = Pathing.path(this.region, this.location, this.destinationLocation, speed, this.aggro), path = _b.path, destination = _b.destination;
        this.pathTargetLocation = destination;
        if (!path.length || !destination) {
            return;
        }
        var originalLocation = this.location;
        if (path.length < speed) {
            // Step to the destination
            this.location = path[path.length - 1];
        }
        else {
            // Move one or two steps forward
            this.location = path[speed - 1];
        }
        // postprocess the path to corners only
        // save the next 2 steps for interpolation purposes
        var newTiles = path.map(function (pos, idx) { return (Player_assign(Player_assign({}, pos), { run: _this.running && path.length >= 2, direction: Pathing.angle(idx === 0 ? originalLocation.x : path[idx - 1].x, idx === 0 ? originalLocation.y : path[idx - 1].y, pos.x, pos.y) })); });
        // only add corners to the path (and the last point)
        newTiles = newTiles.filter(function (v, idx) { return idx === path.length - 1 || v.direction !== newTiles[idx + 1].direction; });
        if (newTiles.length > 1 && newTiles[1].direction === newTiles[0].direction) {
            newTiles.shift();
        }
        if (ENABLE_POSITION_DEBUG) {
            newTiles.forEach(function (tile) {
                var marker = new ClickMarker(_this.region, tile, "#FF0000");
                _this.pathMarkers.push(marker);
                _this.region.addEntity(marker);
            });
        }
        (_a = this.path).push.apply(_a, newTiles);
        this.nextAngle = this.getTargetAngle();
    };
    Player.prototype.takeSeekingItem = function () {
        if (this.seekingItem) {
            if (this.seekingItem.groundLocation.x === this.location.x) {
                if (this.seekingItem.groundLocation.y === this.location.y) {
                    // Verify player is close. Apparently we need to have the player keep track of this item
                    this.region.removeGroundItem(this.seekingItem, this.location.x, this.location.y);
                    var slots = this.openInventorySlots();
                    if (slots.length) {
                        var slot = slots[0];
                        this.inventory[slot] = this.seekingItem;
                    }
                    this.seekingItem = null;
                }
            }
        }
    };
    Player.prototype.dead = function () {
        _super.prototype.dead.call(this);
        this.perceivedLocation = this.location;
        this.destinationLocation = this.location;
    };
    Player.prototype.getPerceivedRotation = function (tickPercent) {
        // https://gist.github.com/shaunlebron/8832585
        function shortAngleDist(a0, a1) {
            var da = (a1 - a0) % (Math.PI * 2);
            return ((2 * da) % (Math.PI * 2)) - da;
        }
        //
        var turnAmount = RADIANS_PER_TICK * Math.max(0, tickPercent - this.lastTickPercent);
        this.lastTickPercent = tickPercent;
        var diff = (this.nextAngle - this._angle + Math.PI * 2) % (Math.PI * 2);
        var direction = diff - Math.PI > 0 ? -1 : 1;
        if (diff >= turnAmount) {
            this._angle += turnAmount * direction;
        }
        else {
            this._angle = this.nextAngle;
        }
        return this._angle;
    };
    Player.prototype.getTargetAngle = function () {
        if (this.aggro) {
            var angle = Pathing.angle(this.perceivedLocation.x + this.size / 2, this.perceivedLocation.y - this.size / 2, this.aggro.location.x + this.aggro.size / 2, this.aggro.location.y - this.aggro.size / 2);
            return -angle;
        }
        if (this.path.length > 0) {
            var angle = Pathing.angle(this.perceivedLocation.x, this.perceivedLocation.y, this.path[0].x, this.path[0].y);
            return -angle;
        }
        return this.restingAngle;
    };
    Player.prototype.movementStep = function () {
        if (this.dying > -1) {
            return;
        }
        this.activatePrayers();
        this.takeSeekingItem();
        if (!this.isFrozen()) {
            this.determineDestination();
            this.moveTowardsDestination();
        }
        this.updatePathMarker();
        this.frozen--;
    };
    Player.prototype.removeClickMarker = function () {
        if (!this.clickMarker) {
            return;
        }
        this.clickMarker.remove();
        this.region.removeEntity(this.clickMarker);
        this.clickMarker = null;
    };
    Player.prototype.updatePathMarker = function () {
        if (!this.pathTargetLocation) {
            this.removeClickMarker();
            return;
        }
        if (this.clickMarker &&
            this.location.x === this.pathTargetLocation.x &&
            this.location.y === this.pathTargetLocation.x) {
            this.removeClickMarker();
        }
        else if (!this.clickMarker) {
            this.clickMarker = new ClickMarker(this.region, this.pathTargetLocation);
            this.region.addEntity(this.clickMarker);
        }
        else {
            this.clickMarker.location = this.pathTargetLocation;
        }
    };
    Player.prototype.hitSound = function (damaged) {
        return damaged ? new Sound(human_hit_513_namespaceObject, 0.1) : new Sound(hit_namespaceObject, 0.15);
    };
    Player.prototype.damageTaken = function () {
        if (this.prayerController.isPrayerActiveByName("Redemption") &&
            this.currentStats.hitpoint > 0 &&
            this.currentStats.hitpoint < Math.floor(this.stats.hitpoint / 10)) {
            this.eats.redemptioned = true;
        }
    };
    Player.prototype.pretick = function () {
        this.prayerController.tick(this);
    };
    Player.prototype.attackStep = function () {
        _super.prototype.attackStep.call(this);
        this.detectDeath();
        this.processIncomingAttacks();
        if (this.dying > -1) {
            return;
        }
        this.clearXpDrops();
        // clear aggro if target is nulled (e.g. healers on zuk after tag)
        if (this.aggro && this.aggro.isNulled) {
            this.aggro = null;
        }
        this.attackIfPossible();
        this.eats.tickFood(this);
        this.regenTimer.regen();
        this.sendXpToController();
    };
    Player.prototype.attackIfPossible = function () {
        if (this.canAttack() === false) {
            return;
        }
        if (this.aggro) {
            this.setHasLOS();
            if (this.hasLOS && this.attackDelay <= 0 && this.aggro.isDying() === false) {
                this.attack() && this.didAttack();
            }
            else if (this.manualSpellCastSelection &&
                this.manualCastHasTarget &&
                this.hasLOS &&
                this.attackDelay <= 0 &&
                this.aggro.dying == this.aggro.deathAnimationLength) {
                // Phantom/ghost barrage
                this.attack() && this.didAttack();
            }
            // After allowing ghost barrage, unset aggro if enemy is dead
            if (this.aggro && this.aggro.isDying()) {
                this.interruptCombat();
            }
        }
    };
    Player.prototype.draw = function (tickPercent) {
        // this.region.context.fillStyle = '#FFFF00'
        // this.region.context.fillRect(
        //   26 * Settings.tileSize,
        //   24 * Settings.tileSize,
        //   6 * Settings.tileSize,
        //   12 * Settings.tileSize
        // // 26 - 32 x
        // // 24 - 36 y
        // )
        if (Settings.displayPlayerLoS) {
            LineOfSight.drawLOS(this.region, this.location.x, this.location.y, this.size, this.attackRange, "#00FF0055", this.type === UnitTypes.MOB);
        }
        this.region.context.save();
        var perceivedLocation = this.getPerceivedLocation(tickPercent);
        var perceivedX = perceivedLocation.x;
        var perceivedY = perceivedLocation.y;
        // Perceived location
        if (this.dying === -1) {
            this.region.context.globalAlpha = 0.7;
            this.region.context.fillStyle = "#FFFF00";
            this.region.context.fillRect(perceivedX * Settings.tileSize, perceivedY * Settings.tileSize, Settings.tileSize, Settings.tileSize);
            this.region.context.globalAlpha = 1;
        }
        // Draw player on true tile
        this.region.context.fillStyle = "#ffffff73";
        // feedback for when you shoot
        if (this.shouldShowAttackAnimation()) {
            this.region.context.fillStyle = "#00FFFF";
        }
        if (this.dying > -1) {
            this.region.context.fillStyle = "#000";
        }
        this.region.context.strokeStyle = "#FFFFFF73";
        this.region.context.lineWidth = 3;
        this.region.context.fillRect(this.location.x * Settings.tileSize, this.location.y * Settings.tileSize, Settings.tileSize, Settings.tileSize);
        // Destination location
        this.region.context.strokeStyle = "#FFFFFF73";
        this.region.context.lineWidth = 3;
        this.region.context.strokeRect(this.destinationLocation.x * Settings.tileSize, this.destinationLocation.y * Settings.tileSize, Settings.tileSize, Settings.tileSize);
        this.region.context.restore();
        return { x: perceivedX, y: perceivedY };
    };
    Player.prototype.getPerceivedLocation = function (tickPercent) {
        return Player_assign(Player_assign({}, this.perceivedLocation), { z: 0 });
    };
    Player.prototype.drawUILayer = function (tickPercent, offset, context, scale, hitsplatsAbove) {
        if (this.dying > -1) {
            return;
        }
        context.save();
        context.translate(offset.x, offset.y);
        if (Settings.rotated === "south") {
            this.region.context.rotate(Math.PI);
        }
        this.drawHPBar(context, scale);
        this.drawHitsplats(context, scale, hitsplatsAbove);
        this.drawOverheadPrayers(context, scale);
        context.restore();
    };
    Player.prototype.create3dModel = function () {
        return GLTFModel.forRenderableMulti(this, Object.values(this.equipment)
            .map(function (e) { return e === null || e === void 0 ? void 0 : e.model; })
            .filter(function (e) { return !!e; }));
    };
    Object.defineProperty(Player.prototype, "animationIndex", {
        get: function () {
            return this.currentPoseAnimation;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Player.prototype, "drawOutline", {
        get: function () {
            // not needed with a real 3d model
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Player.prototype, "attackAnimationId", {
        get: function () {
            var _a;
            return (_a = this.equipment.weapon) === null || _a === void 0 ? void 0 : _a.attackAnimationId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Player.prototype, "canBlendAttackAnimation", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Player.prototype, "drawTrueTile", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Player.prototype, "trueTileRenderOrder", {
        get: function () {
            // player's true tile draws above most other things
            return 1000;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Player.prototype, "deathAnimationLength", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    return Player;
}(Unit));

var ClickMarker = /** @class */ (function (_super) {
    Player_extends(ClickMarker, _super);
    function ClickMarker(region, location, color) {
        if (color === void 0) { color = "#FFFFFF"; }
        return _super.call(this, region, location, color, 1, false) || this;
    }
    ClickMarker.prototype.remove = function () {
        this.dying = 0;
    };
    return ClickMarker;
}(TileMarker));

;// CONCATENATED MODULE: ./src/sdk/weapons/RangedWeapon.ts
var RangedWeapon_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var RangedWeapon_assign = (undefined && undefined.__assign) || function () {
    RangedWeapon_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return RangedWeapon_assign.apply(this, arguments);
};





var RangedWeapon = /** @class */ (function (_super) {
    RangedWeapon_extends(RangedWeapon, _super);
    function RangedWeapon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(RangedWeapon.prototype, "type", {
        get: function () {
            return EquipmentTypes.WEAPON;
        },
        enumerable: false,
        configurable: true
    });
    RangedWeapon.prototype.registerProjectile = function (from, to, bonuses, options) {
        if (options === void 0) { options = {}; }
        to.addProjectile(new Projectile(this, this.damage, from, to, "range", RangedWeapon_assign(RangedWeapon_assign({ sound: this.attackSound, hitSound: this.attackLandingSound, model: this.projectileModel }, this.projectileOptions), options)));
    };
    RangedWeapon.prototype.calculateHitDelay = function (distance) {
        return Math.floor((3 + distance) / 6) + 1;
    };
    RangedWeapon.prototype._calculatePrayerEffects = function (from, to, bonuses) {
        bonuses.effectivePrayers = {};
        if (from.type !== UnitTypes.MOB && from.prayerController) {
            var offensiveRange = from.prayerController.matchGroup(PrayerGroups.ACCURACY);
            if (offensiveRange) {
                bonuses.effectivePrayers.range = offensiveRange;
            }
        }
        if (to.type !== UnitTypes.MOB && to.prayerController) {
            var defence = to.prayerController.matchGroup(PrayerGroups.DEFENCE);
            if (defence) {
                bonuses.effectivePrayers.defence = defence;
            }
            var overhead = to.prayerController.overhead();
            if (overhead) {
                bonuses.effectivePrayers.overhead = overhead;
            }
        }
    };
    RangedWeapon.prototype.isBlockable = function (from, to, bonuses) {
        this._calculatePrayerEffects(from, to, bonuses);
        if (bonuses.effectivePrayers.overhead && bonuses.effectivePrayers.overhead.feature() === "range") {
            return true;
        }
        return false;
    };
    RangedWeapon.prototype._rangedAttack = function (from, to, bonuses) {
        var prayerMultiplier = 1;
        var rangePrayer = bonuses.effectivePrayers.range;
        if (rangePrayer) {
            if (rangePrayer.name === "Sharp Eye") {
                prayerMultiplier = 1.05;
            }
            else if (rangePrayer.name === "Hawk Eye") {
                prayerMultiplier = 1.1;
            }
            else if (rangePrayer.name === "Eagle Eye") {
                prayerMultiplier = 1.15;
            }
            else if (rangePrayer.name === "Rigour") {
                prayerMultiplier = 1.2;
            }
        }
        return (Math.floor(Math.floor(from.currentStats.range) * prayerMultiplier + (bonuses.isAccurate ? 3 : 0) + 8) *
            bonuses.voidMultiplier);
    };
    RangedWeapon.prototype._maxHit = function (from, to, bonuses) {
        var prayerMultiplier = 1;
        var rangePrayer = bonuses.effectivePrayers.range;
        if (rangePrayer) {
            if (rangePrayer.name === "Sharp Eye") {
                prayerMultiplier = 1.05;
            }
            else if (rangePrayer.name === "Hawk Eye") {
                prayerMultiplier = 1.1;
            }
            else if (rangePrayer.name === "Eagle Eye") {
                prayerMultiplier = 1.15;
            }
            else if (rangePrayer.name === "Rigour") {
                prayerMultiplier = 1.23;
            }
        }
        var rangedStrength = Math.floor(Math.floor(from.currentStats.range) * prayerMultiplier + (bonuses.isAccurate ? 3 : 0) + 8) *
            bonuses.voidMultiplier;
        var max = Math.floor(Math.floor(0.5 + ((rangedStrength * (from.bonuses.other.rangedStrength + 64)) / 640) * bonuses.gearRangeMultiplier) * this._damageMultiplier(from, to, bonuses));
        return max;
    };
    RangedWeapon.prototype._attackRoll = function (from, to, bonuses) {
        return Math.floor(Math.floor(this._rangedAttack(from, to, bonuses) * (from.bonuses.attack.range + 64) * bonuses.gearRangeMultiplier) * this._accuracyMultiplier(from, to, bonuses));
    };
    RangedWeapon.prototype._defenceRoll = function (from, to, bonuses) {
        var prayerMultiplier = 1;
        var defencePrayer = bonuses.effectivePrayers.defence;
        if (defencePrayer) {
            if (defencePrayer.name === "Thick Skin") {
                prayerMultiplier = 1.05;
            }
            else if (defencePrayer.name === "Mystic Will") {
                prayerMultiplier = 1.05;
            }
            else if (defencePrayer.name === "Rock Skin") {
                prayerMultiplier = 1.1;
            }
            else if (defencePrayer.name === "Mystic Lore") {
                prayerMultiplier = 1.1;
            }
            else if (defencePrayer.name === "Steel Skin") {
                prayerMultiplier = 1.15;
            }
            else if (defencePrayer.name === "Mystic Might") {
                prayerMultiplier = 1.15;
            }
            else if (defencePrayer.name === "Chivalry") {
                prayerMultiplier = 1.2;
            }
            else if (defencePrayer.name === "Piety") {
                prayerMultiplier = 1.25;
            }
            else if (defencePrayer.name === "Rigour") {
                prayerMultiplier = 1.25;
            }
            else if (defencePrayer.name === "Augury") {
                prayerMultiplier = 1.25;
            }
        }
        return (to.currentStats.defence * prayerMultiplier + 9) * (to.bonuses.defence.range + 64);
    };
    RangedWeapon.prototype._accuracyMultiplier = function (from, to, bonuses) {
        return 1; // Used for tbow passive effect
    };
    RangedWeapon.prototype._damageMultiplier = function (from, to, bonuses) {
        return 1; // Used for tbow passive effect
    };
    return RangedWeapon;
}(Weapon));


;// CONCATENATED MODULE: ./src/sdk/weapons/AoeRangedWeapon.ts
var AoeRangedWeapon_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

// A Range weapon that can hit any unit in the radius, without requiring direct LOS of the target.
// Example: Dinh's Bulwark, Verzik auto attacks.
var AoeRangedWeapon = /** @class */ (function (_super) {
    AoeRangedWeapon_extends(AoeRangedWeapon, _super);
    function AoeRangedWeapon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(AoeRangedWeapon.prototype, "isAreaAttack", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    return AoeRangedWeapon;
}(RangedWeapon));


;// CONCATENATED MODULE: ./src/sdk/weapons/MagicWeapon.ts
var MagicWeapon_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var MagicWeapon = /** @class */ (function (_super) {
    MagicWeapon_extends(MagicWeapon, _super);
    function MagicWeapon(projectileRules) {
        return _super.call(this, projectileRules) || this;
    }
    Object.defineProperty(MagicWeapon.prototype, "type", {
        get: function () {
            return EquipmentTypes.WEAPON;
        },
        enumerable: false,
        configurable: true
    });
    MagicWeapon.prototype.attack = function (from, to, bonuses, options) {
        if (bonuses === void 0) { bonuses = {}; }
        if (options === void 0) { options = {}; }
        return _super.prototype.attack.call(this, from, to, bonuses, options);
    };
    MagicWeapon.prototype.calculateHitDelay = function (distance) {
        return Math.floor((1 + distance) / 3) + 1;
    };
    MagicWeapon.prototype.isBlockable = function (from, to, bonuses) {
        this._calculatePrayerEffects(from, to, bonuses);
        if (bonuses.effectivePrayers.overhead && bonuses.effectivePrayers.overhead.feature() === "magic") {
            return true;
        }
        return false;
    };
    MagicWeapon.prototype._calculatePrayerEffects = function (from, to, bonuses) {
        bonuses.effectivePrayers = {};
        if (from.type !== UnitTypes.MOB && from.prayerController) {
            var offensiveMagic = from.prayerController.matchGroup(PrayerGroups.ACCURACY);
            if (offensiveMagic) {
                bonuses.effectivePrayers.magic = offensiveMagic;
            }
        }
        if (to.type !== UnitTypes.MOB && to.prayerController) {
            var defence = to.prayerController.matchGroup(PrayerGroups.DEFENCE);
            if (defence) {
                bonuses.effectivePrayers.defence = defence;
            }
            var overhead = to.prayerController.overhead();
            if (overhead) {
                bonuses.effectivePrayers.overhead = overhead;
            }
        }
    };
    MagicWeapon.prototype._magicLevel = function (from, to, bonuses) {
        var prayerMultiplier = 1;
        var magicPrayer = bonuses.effectivePrayers.magic;
        if (magicPrayer) {
            if (magicPrayer.name === "Mystic Will") {
                prayerMultiplier = 1.05;
            }
            else if (magicPrayer.name === "Mystic Lore") {
                prayerMultiplier = 1.1;
            }
            else if (magicPrayer.name === "Mystic Might") {
                prayerMultiplier = 1.15;
            }
            else if (magicPrayer.name === "Augury") {
                prayerMultiplier = 1.2;
            }
        }
        return Math.floor(Math.floor(from.currentStats.magic * prayerMultiplier) * bonuses.voidMultiplier +
            (bonuses.isAccurate ? 2 : 0) +
            9);
    };
    MagicWeapon.prototype._equipmentBonus = function (from, to, bonuses) {
        return from.bonuses.attack.magic;
    };
    MagicWeapon.prototype._magicDamageBonusMultiplier = function (from, to, bonuses) {
        return from.bonuses.other.magicDamage;
    };
    MagicWeapon.prototype._attackRoll = function (from, to, bonuses) {
        return Math.floor(this._magicLevel(from, to, bonuses) * (this._equipmentBonus(from, to, bonuses) + 64) * bonuses.gearMageMultiplier);
    };
    MagicWeapon.prototype._defenceRoll = function (from, to, bonuses) {
        var prayerMultiplier = 1;
        var defencePrayer = bonuses.effectivePrayers.defence;
        if (defencePrayer) {
            if (defencePrayer.name === "Thick Skin") {
                prayerMultiplier = 1.05;
            }
            else if (defencePrayer.name === "Mystic Will") {
                prayerMultiplier = 1.05;
            }
            else if (defencePrayer.name === "Rock Skin") {
                prayerMultiplier = 1.1;
            }
            else if (defencePrayer.name === "Mystic Lore") {
                prayerMultiplier = 1.1;
            }
            else if (defencePrayer.name === "Steel Skin") {
                prayerMultiplier = 1.15;
            }
            else if (defencePrayer.name === "Mystic Might") {
                prayerMultiplier = 1.15;
            }
            else if (defencePrayer.name === "Chivalry") {
                prayerMultiplier = 1.2;
            }
            else if (defencePrayer.name === "Piety") {
                prayerMultiplier = 1.25;
            }
            else if (defencePrayer.name === "Rigour") {
                prayerMultiplier = 1.25;
            }
            else if (defencePrayer.name === "Augury") {
                prayerMultiplier = 1.25;
            }
        }
        return (9 + to.currentStats.magic * prayerMultiplier) * (to.bonuses.defence.magic + 64);
    };
    MagicWeapon.prototype._maxHit = function (from, to, bonuses) {
        return Math.floor(this._baseSpellDamage(from, to, bonuses) * this._magicDamageBonusMultiplier(from, to, bonuses));
        // TODO: Most of this isn't implemented
        // Spell Base damage +3 if casting bolt spells with chaos gauntlets
        // Answer * (1 + magic damage bonus)
        // Round the answer down to the nearest integer
        // Answer * salve amulet bonus (Salve bonus does not stack with slayer bonus, skip to step 7 if using salve amulet)
        // Round the answer down to the nearest integer
        // Answer * slayer bonus
        // Round the answer down to the nearest integer
        // Answer * Tome of fire bonus
        // Round the answer down to the nearest integer
        // Answer * castle wars bonus
        // Round the answer down to the nearest integer
        // That is the max hit
    };
    MagicWeapon.prototype._baseSpellDamage = function (from, to, bonuses) {
        return bonuses.magicBaseSpellDamage; // Jal-Zek specific number for now.
    };
    return MagicWeapon;
}(Weapon));


;// CONCATENATED MODULE: ./src/sdk/weapons/BarrageSpell.ts
var BarrageSpell_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var BarrageSpell = /** @class */ (function (_super) {
    BarrageSpell_extends(BarrageSpell, _super);
    function BarrageSpell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BarrageSpell.prototype, "aoe", {
        get: function () {
            return [
                { x: 0, y: 0 },
                { x: -1, y: -1 },
                { x: -1, y: 0 },
                { x: -1, y: 1 },
                { x: 0, y: -1 },
                { x: 0, y: 1 },
                { x: 1, y: -1 },
                { x: 1, y: 0 },
                { x: 1, y: 1 },
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BarrageSpell.prototype, "attackRange", {
        get: function () {
            return 10;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BarrageSpell.prototype, "attackSpeed", {
        get: function () {
            return 5;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BarrageSpell.prototype, "maxConcurrentHits", {
        get: function () {
            return 9;
        },
        enumerable: false,
        configurable: true
    });
    BarrageSpell.prototype.attackStyle = function () {
        return AttackStyle.AUTOCAST;
    };
    BarrageSpell.prototype.cast = function (from, to) {
        var _this = this;
        from.grantXp(new XpDrop("magic", 52));
        // calculate AoE magic effects
        if (this.aoe.length) {
            var alreadyCastedOn_1 = [to];
            this.attack(from, to, { magicBaseSpellDamage: 30, attackStyle: "magic" });
            this.aoe.forEach(function (point) {
                Pathing.mobsAtAoeOffset(from.region, to, point).forEach(function (mob) {
                    if (alreadyCastedOn_1.length > _this.maxConcurrentHits) {
                        return;
                    }
                    if (alreadyCastedOn_1.indexOf(mob) > -1) {
                        return;
                    }
                    alreadyCastedOn_1.push(mob);
                    _this.attack(from, mob, { magicBaseSpellDamage: 30, attackStyle: "magic" }, { hidden: true });
                });
            });
        }
        else {
            this.attack(from, to, { magicBaseSpellDamage: 30, attackStyle: "magic" });
        }
    };
    BarrageSpell.prototype.attack = function (from, to, bonuses, options) {
        if (bonuses === void 0) { bonuses = {}; }
        if (options === void 0) { options = {}; }
        options.forceSWTile = true;
        return _super.prototype.attack.call(this, from, to, bonuses, options);
    };
    return BarrageSpell;
}(MagicWeapon));


;// CONCATENATED MODULE: ./src/sdk/weapons/BloodBarrageSpell.ts
var BloodBarrageSpell_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var BloodBarrageSpell = /** @class */ (function (_super) {
    BloodBarrageSpell_extends(BloodBarrageSpell, _super);
    function BloodBarrageSpell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BloodBarrageSpell.prototype, "itemName", {
        get: function () {
            return ItemName.BLOOD_BARRAGE;
        },
        enumerable: false,
        configurable: true
    });
    BloodBarrageSpell.prototype.attack = function (from, to, bonuses, options) {
        if (bonuses === void 0) { bonuses = {}; }
        if (options === void 0) { options = {}; }
        _super.prototype.attack.call(this, from, to, bonuses, options);
        if (from.currentStats.hitpoint < from.stats.hitpoint) {
            from.currentStats.hitpoint += Math.floor(this.damageRoll * 0.25);
            from.currentStats.hitpoint = Math.max(Math.min(from.stats.hitpoint, from.currentStats.hitpoint), 0);
        }
        return true;
    };
    return BloodBarrageSpell;
}(BarrageSpell));


;// CONCATENATED MODULE: ./src/sdk/weapons/IceBarrageSpell.ts
var IceBarrageSpell_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var IceBarrageSpell = /** @class */ (function (_super) {
    IceBarrageSpell_extends(IceBarrageSpell, _super);
    function IceBarrageSpell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(IceBarrageSpell.prototype, "itemName", {
        get: function () {
            return ItemName.ICE_BARRAGE;
        },
        enumerable: false,
        configurable: true
    });
    IceBarrageSpell.prototype.attack = function (from, to, bonuses, options) {
        if (bonuses === void 0) { bonuses = {}; }
        if (options === void 0) { options = {}; }
        _super.prototype.attack.call(this, from, to, bonuses, options);
        if (this.lastHitHit) {
            to.freeze(32);
        }
        return true;
    };
    return IceBarrageSpell;
}(BarrageSpell));


;// CONCATENATED MODULE: ./src/sdk/weapons/MeleeWeapon.ts
var MeleeWeapon_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var MeleeWeapon_assign = (undefined && undefined.__assign) || function () {
    MeleeWeapon_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return MeleeWeapon_assign.apply(this, arguments);
};





var MeleeWeapon = /** @class */ (function (_super) {
    MeleeWeapon_extends(MeleeWeapon, _super);
    function MeleeWeapon(projectileOptions) {
        if (projectileOptions === void 0) { projectileOptions = {}; }
        return _super.call(this, MeleeWeapon_assign({ hidden: true }, projectileOptions)) || this;
    }
    Object.defineProperty(MeleeWeapon.prototype, "type", {
        get: function () {
            return EquipmentTypes.WEAPON;
        },
        enumerable: false,
        configurable: true
    });
    MeleeWeapon.prototype.attack = function (from, to, bonuses) {
        if (bonuses === void 0) { bonuses = {}; }
        bonuses.attackStyle = bonuses.attackStyle || "slash";
        return _super.prototype.attack.call(this, from, to, bonuses);
    };
    MeleeWeapon.prototype._calculatePrayerEffects = function (from, to, bonuses) {
        bonuses.effectivePrayers = {};
        if (from.type !== UnitTypes.MOB && from.prayerController) {
            var offensiveAttack = from.prayerController.matchGroup(PrayerGroups.ACCURACY);
            if (offensiveAttack) {
                bonuses.effectivePrayers.attack = offensiveAttack;
            }
            var offensiveStrength = from.prayerController.matchGroup(PrayerGroups.STRENGTH);
            if (offensiveStrength) {
                bonuses.effectivePrayers.strength = offensiveStrength;
            }
        }
        if (to.type !== UnitTypes.MOB && to.prayerController) {
            var defence = to.prayerController.matchGroup(PrayerGroups.DEFENCE);
            if (defence) {
                bonuses.effectivePrayers.defence = defence;
            }
            var overhead = to.prayerController.overhead();
            if (overhead) {
                bonuses.effectivePrayers.overhead = overhead;
            }
        }
    };
    MeleeWeapon.prototype.isBlockable = function (from, to, bonuses) {
        this._calculatePrayerEffects(from, to, bonuses);
        var prayerAttackBlockStyle = bonuses.attackStyle;
        if (Weapon.isMeleeAttackStyle(prayerAttackBlockStyle)) {
            prayerAttackBlockStyle = "melee"; // because protect melee scans for the style as melee, generalize them
        }
        if (bonuses.effectivePrayers.overhead && bonuses.effectivePrayers.overhead.feature() === prayerAttackBlockStyle) {
            return true;
        }
        return false;
    };
    MeleeWeapon.prototype._strengthLevel = function (from, to, bonuses) {
        var prayerMultiplier = 1;
        var strengthPrayer = bonuses.effectivePrayers.strength;
        if (strengthPrayer) {
            if (strengthPrayer.name === "Burst of Strength") {
                prayerMultiplier = 1.05;
            }
            else if (strengthPrayer.name === "Superhuman Strength") {
                prayerMultiplier = 1.1;
            }
            else if (strengthPrayer.name === "Ultimate Strength") {
                prayerMultiplier = 1.15;
            }
            else if (strengthPrayer.name === "Chivalry") {
                prayerMultiplier = 1.18;
            }
            else if (strengthPrayer.name === "Piety") {
                prayerMultiplier = 1.23;
            }
        }
        if (from.type === UnitTypes.PLAYER) {
            bonuses.styleStrengthBonus = AttackStylesController.controller.getWeaponStrengthBonus(this.attackStyle());
        }
        else {
            bonuses.styleStrengthBonus = 0;
        }
        return Math.floor((Math.floor(from.currentStats.strength * prayerMultiplier) + bonuses.styleStrengthBonus + 8) * bonuses.voidMultiplier);
    };
    MeleeWeapon.prototype._maxHit = function (from, to, bonuses) {
        return Math.floor(Math.floor((this._strengthLevel(from, to, bonuses) * (from.bonuses.other.meleeStrength + 64) + 320) / 640) *
            bonuses.gearMeleeMultiplier *
            bonuses.overallMultiplier);
    };
    MeleeWeapon.prototype._attackLevel = function (from, to, bonuses) {
        var attackPrayer = bonuses.effectivePrayers.attack;
        var prayerMultiplier = 1;
        if (attackPrayer) {
            if (attackPrayer.name === "Clarity of Thought") {
                prayerMultiplier = 1.05;
            }
            else if (attackPrayer.name === "Improved Reflexes") {
                prayerMultiplier = 1.1;
            }
            else if (attackPrayer.name === "Incredible Reflexes") {
                prayerMultiplier = 1.15;
            }
            else if (attackPrayer.name === "Chivalry") {
                prayerMultiplier = 1.15;
            }
            else if (attackPrayer.name === "Piety") {
                prayerMultiplier = 1.2;
            }
        }
        return Math.floor((Math.floor(from.currentStats.attack * prayerMultiplier) + bonuses.styleBonus + 8) * bonuses.voidMultiplier);
    };
    MeleeWeapon.prototype._attackRoll = function (from, to, bonuses) {
        return Math.floor(this._attackLevel(from, to, bonuses) *
            (from.bonuses.attack[bonuses.attackStyle] + 64) *
            bonuses.gearMeleeMultiplier);
    };
    MeleeWeapon.prototype._defenceRoll = function (from, to, bonuses) {
        if (to.type === UnitTypes.MOB || to.type === UnitTypes.ENTITY) {
            return (to.currentStats.defence + 9) * (to.bonuses.defence[bonuses.attackStyle] + 64);
        }
        else {
            return this._defenceLevel(from, to, bonuses) * (to.bonuses.defence[bonuses.attackStyle] + 64);
        }
    };
    MeleeWeapon.prototype._defenceLevel = function (from, to, bonuses) {
        var defencePrayer = bonuses.effectivePrayers.defence;
        var prayerMultiplier = 1;
        if (defencePrayer) {
            if (defencePrayer.name === "Thick Skin") {
                prayerMultiplier = 1.05;
            }
            else if (defencePrayer.name === "Mystic Will") {
                prayerMultiplier = 1.05;
            }
            else if (defencePrayer.name === "Rock Skin") {
                prayerMultiplier = 1.1;
            }
            else if (defencePrayer.name === "Mystic Lore") {
                prayerMultiplier = 1.1;
            }
            else if (defencePrayer.name === "Steel Skin") {
                prayerMultiplier = 1.15;
            }
            else if (defencePrayer.name === "Mystic Might") {
                prayerMultiplier = 1.15;
            }
            else if (defencePrayer.name === "Chivalry") {
                prayerMultiplier = 1.2;
            }
            else if (defencePrayer.name === "Piety") {
                prayerMultiplier = 1.25;
            }
            else if (defencePrayer.name === "Rigour") {
                prayerMultiplier = 1.25;
            }
            else if (defencePrayer.name === "Augury") {
                prayerMultiplier = 1.25;
            }
        }
        return Math.floor(from.currentStats.defence * prayerMultiplier) + bonuses.styleBonus + 8;
    };
    Object.defineProperty(MeleeWeapon.prototype, "isMeleeAttack", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    return MeleeWeapon;
}(Weapon));


;// CONCATENATED MODULE: ./src/sdk/BoostPanel.ts








var BOOST_VISIBLE_STATS = [
    "attack",
    "strength",
    "defence",
    "range",
    "magic",
];
var BOOST_IMAGE_SRC = {
    "attack": attack_namespaceObject,
    "strength": strength_namespaceObject,
    "defence": defence_namespaceObject,
    "range": range_namespaceObject,
    "magic": magic_namespaceObject,
};
var BOOST_IMAGES = {};
Object.entries(BOOST_IMAGE_SRC).forEach(function (_a) {
    var skill = _a[0], src = _a[1];
    BOOST_IMAGES[skill] = ImageLoader.createImage(src);
});
var BoostPanel = /** @class */ (function () {
    function BoostPanel() {
    }
    BoostPanel.prototype.draw = function (context, scale, xLeft, yBottom) {
        var player = Trainer.player;
        if (!player) {
            return;
        }
        context.save();
        var boostedStats = BOOST_VISIBLE_STATS.filter(function (stat) { return player.currentStats[stat] !== player.stats[stat]; });
        context.globalAlpha = 0.5;
        context.fillStyle = "black";
        var CELL_SIZE = 24;
        var width = scale * CELL_SIZE;
        var height = scale * CELL_SIZE * boostedStats.length;
        context.fillRect(xLeft, yBottom - height, width, height);
        context.globalAlpha = 1;
        var y = yBottom - scale * CELL_SIZE;
        context.font = "".concat(scale * 12, "px OSRS");
        context.textAlign = "center";
        context.textBaseline = "middle";
        for (var _i = 0, boostedStats_1 = boostedStats; _i < boostedStats_1.length; _i++) {
            var boostedStat = boostedStats_1[_i];
            var current = player.currentStats[boostedStat];
            var target = player.stats[boostedStat];
            context.drawImage(BOOST_IMAGES[boostedStat], xLeft, y, scale * CELL_SIZE, scale * CELL_SIZE);
            context.fillStyle = "black";
            context.fillText("".concat(current), xLeft + (scale * CELL_SIZE) / 2 + 1, y + (scale * CELL_SIZE) / 2 + 1);
            if (current < target) {
                context.fillStyle = "red";
            }
            else {
                context.fillStyle = "lime";
            }
            context.fillText("".concat(current), xLeft + (scale * CELL_SIZE) / 2, y + (scale * CELL_SIZE) / 2);
            y -= scale * CELL_SIZE;
        }
        context.restore();
    };
    return BoostPanel;
}());


;// CONCATENATED MODULE: ./src/sdk/Chrome.ts
var Chrome = /** @class */ (function () {
    function Chrome() {
    }
    Chrome.size = function () {
        var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        var height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        return { width: width, height: height };
    };
    return Chrome;
}());


;// CONCATENATED MODULE: ./src/assets/images/interface/yellow_x_1.png
const yellow_x_1_namespaceObject = __webpack_require__.p + "9644628783e3944e683a.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/yellow_x_2.png
const yellow_x_2_namespaceObject = __webpack_require__.p + "459550810d5d6f723b74.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/yellow_x_3.png
const yellow_x_3_namespaceObject = __webpack_require__.p + "e6e38cf37e3ffe37e429.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/yellow_x_4.png
const yellow_x_4_namespaceObject = __webpack_require__.p + "4f4b9d50a01f72e78727.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/red_x_1.png
const red_x_1_namespaceObject = __webpack_require__.p + "19aff667ef7e1ef2dd66.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/red_x_2.png
const red_x_2_namespaceObject = __webpack_require__.p + "546a8577d1f09ae30b64.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/red_x_3.png
const red_x_3_namespaceObject = __webpack_require__.p + "d34bb88817b4743182e3.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/red_x_4.png
const red_x_4_namespaceObject = __webpack_require__.p + "7fa3d703bcb27a25f689.png";
;// CONCATENATED MODULE: ./src/sdk/ClickAnimation.ts










var ClickAnimation = /** @class */ (function () {
    function ClickAnimation(color, x, y) {
        this.color = color;
        this.x = x;
        this.y = y;
        this.ttl = 1;
    }
    ClickAnimation.prototype.draw = function (context) {
        if (this.ttl <= 0) {
            return;
        }
        var frameNumber = Math.floor((1 - this.ttl) * 4);
        var frames = this.color === "red" ? ClickAnimation.frames.red : ClickAnimation.frames.yellow;
        context.drawImage(frames[frameNumber], this.x - 9, this.y - 9);
        this.ttl -= 1.65 / Settings.fps;
    };
    ClickAnimation.frames = {
        red: [
            ImageLoader.createImage(red_x_1_namespaceObject),
            ImageLoader.createImage(red_x_2_namespaceObject),
            ImageLoader.createImage(red_x_3_namespaceObject),
            ImageLoader.createImage(red_x_4_namespaceObject),
        ],
        yellow: [
            ImageLoader.createImage(yellow_x_1_namespaceObject),
            ImageLoader.createImage(yellow_x_2_namespaceObject),
            ImageLoader.createImage(yellow_x_3_namespaceObject),
            ImageLoader.createImage(yellow_x_4_namespaceObject),
        ],
    };
    return ClickAnimation;
}());


;// CONCATENATED MODULE: ./src/sdk/ContextMenu.ts
var ContextMenu_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};


var ContextMenu = /** @class */ (function () {
    function ContextMenu() {
        this.isActive = false;
        this.location = { x: 0, y: 0 };
        this.cursorPosition = { x: 0, y: 0 };
        this.activatedPosition = { x: 0, y: 0 };
        this.width = 0;
        this.height = 0;
        this.menuOptions = [];
        this.linesOfText = [];
    }
    ContextMenu.prototype.setPosition = function (position) {
        this.location = position;
    };
    ContextMenu.prototype.setActive = function () {
        this.isActive = true;
    };
    ContextMenu.prototype.setInactive = function () {
        this.isActive = false;
    };
    ContextMenu.prototype.setMenuOptions = function (menuOptions) {
        this.menuOptions = menuOptions;
    };
    ContextMenu.prototype.cursorMovedTo = function (x, y) {
        var cRect = Viewport.viewport.canvas.getBoundingClientRect(); // Gets CSS pos, and width/height
        var canvasX = Math.round(x - cRect.left); // Subtract the 'left' of the canvas
        var canvasY = Math.round(y - cRect.top); // from the X/Y positions to make
        this.cursorPosition.x = canvasX;
        this.cursorPosition.y = canvasY;
        // cursor veering too far away, make inactive again
        if (Math.abs(canvasX - this.location.x) > this.width * 0.6) {
            this.setInactive();
        }
        if (canvasY - this.location.y < -10 || canvasY - this.location.y > this.height * 1.2) {
            this.setInactive();
        }
    };
    ContextMenu.prototype.draw = function (context) {
        var _this = this;
        if (this.isActive) {
            this.linesOfText = ContextMenu_spreadArray(ContextMenu_spreadArray([
                {
                    text: [{ text: "Choose Option", fillStyle: "#5f5445" }],
                    action: function () {
                        Trainer.clickController.yellowClick();
                    },
                }
            ], this.menuOptions, true), [
                {
                    text: [{ text: "Cancel", fillStyle: "white" }],
                    action: function () {
                        Trainer.clickController.yellowClick();
                    },
                },
            ], false);
            context.textAlign = "left";
            context.font = "17px OSRS";
            this.width = 0;
            this.linesOfText.forEach(function (line) {
                _this.width = Math.max(_this.width, _this.fillMixedTextWidth(context, line.text) + 10);
            });
            this.height = 22 + (this.linesOfText.length - 1) * 20;
            context.fillStyle = "#5f5445";
            context.fillRect(this.location.x - this.width / 2, this.location.y, this.width, this.height);
            context.fillStyle = "black";
            context.fillRect(this.location.x - this.width / 2 + 1, this.location.y + 1, this.width - 2, 17);
            context.lineWidth = 1;
            context.strokeStyle = "black";
            context.strokeRect(this.location.x - this.width / 2 + 2, this.location.y + 20, this.width - 4, this.height - 22);
            for (var i = 0; i < this.linesOfText.length; i++) {
                this.drawLineOfText(context, this.linesOfText[i].text, this.width, i * 20);
            }
        }
        context.restore();
    };
    ContextMenu.prototype.fillMixedText = function (ctx, text, x, y, inputColor) {
        var defaultFillStyle = ctx.fillStyle;
        var defaultFont = ctx.font;
        ctx.save();
        text.forEach(function (_a) {
            var text = _a.text, fillStyle = _a.fillStyle, font = _a.font;
            ctx.font = font || defaultFont;
            ctx.fillStyle = "black";
            ctx.fillText(text, x + 1, y + 1);
            if (fillStyle === "white") {
                ctx.fillStyle = inputColor;
            }
            else {
                ctx.fillStyle = fillStyle || defaultFillStyle;
            }
            ctx.fillText(text, x, y);
            x += ctx.measureText(text).width;
        });
        ctx.restore();
    };
    ContextMenu.prototype.fillMixedTextWidth = function (ctx, text) {
        var defaultFillStyle = ctx.fillStyle;
        var defaultFont = ctx.font;
        var x = 0;
        text.forEach(function (_a) {
            var text = _a.text, fillStyle = _a.fillStyle, font = _a.font;
            ctx.fillStyle = fillStyle || defaultFillStyle;
            ctx.font = font || defaultFont;
            x += ctx.measureText(text).width;
        });
        return x;
    };
    ContextMenu.prototype.drawLineOfText = function (ctx, text, width, y) {
        var isXAligned = this.cursorPosition.x > this.location.x - width / 2 && this.cursorPosition.x < this.location.x + width / 2;
        var isYAligned = this.cursorPosition.y > this.location.y + y + 2 && this.cursorPosition.y < this.location.y + 21 + y;
        var isHovered = isXAligned && isYAligned;
        this.fillMixedText(ctx, text, this.location.x - width / 2 + 4, this.location.y + 15 + y, isHovered ? "yellow" : "white");
    };
    ContextMenu.prototype.clicked = function (x, y) {
        var index = Math.floor((y - this.location.y) / 20);
        this.linesOfText[index].action();
    };
    return ContextMenu;
}());


;// CONCATENATED MODULE: ./src/assets/images/panels/inventory.png
const inventory_namespaceObject = __webpack_require__.p + "18150e2ac6a8a966226e.png";
;// CONCATENATED MODULE: ./src/assets/images/tabs/account.png
const account_namespaceObject = __webpack_require__.p + "1f12f0ce4e42733b2bf9.png";
;// CONCATENATED MODULE: ./src/sdk/controlpanels/BaseControls.ts


var BaseControls = /** @class */ (function () {
    function BaseControls() {
        this.panelImage = ImageLoader.createImage(this.panelImageReference);
        this.tabImage = ImageLoader.createImage(this.tabImageReference);
        this.selected = false;
    }
    Object.defineProperty(BaseControls.prototype, "keyBinding", {
        get: function () {
            return "";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseControls.prototype, "isAvailable", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseControls.prototype, "panelImageReference", {
        get: function () {
            return "";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseControls.prototype, "tabImageReference", {
        get: function () {
            return "";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseControls.prototype, "appearsOnLeftInMobile", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    BaseControls.prototype.cursorMovedto = function (x, y) {
        // Override me
    };
    BaseControls.prototype.panelRightClick = function (x, y) {
        // Override me
    };
    BaseControls.prototype.panelClickDown = function (x, y) {
        //
    };
    BaseControls.prototype.panelClickUp = function (x, y) {
        //
    };
    // called when the mouse is released, even outside the panel
    BaseControls.prototype.onMouseUp = function () {
        //
    };
    BaseControls.prototype.onWorldTick = function () {
        // Override me
    };
    BaseControls.prototype.draw = function (context, ctrl, x, y) {
        var scale = Settings.controlPanelScale;
        if (this.panelImage) {
            context.drawImage(this.panelImage, x, y, 204 * scale, 275 * scale);
        }
    };
    return BaseControls;
}());


;// CONCATENATED MODULE: ./src/sdk/controlpanels/AccountControls.ts
var AccountControls_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var AccountControls = /** @class */ (function (_super) {
    AccountControls_extends(AccountControls, _super);
    function AccountControls() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(AccountControls.prototype, "panelImageReference", {
        get: function () {
            return inventory_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AccountControls.prototype, "tabImageReference", {
        get: function () {
            return account_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return AccountControls;
}(BaseControls));


;// CONCATENATED MODULE: ./src/assets/images/tabs/standard_spellbook.png
const standard_spellbook_namespaceObject = __webpack_require__.p + "fb7c82526615db589b4c.png";
;// CONCATENATED MODULE: ./src/assets/images/panels/ancients.png
const ancients_namespaceObject = __webpack_require__.p + "36082bf32dd148238984.png";
;// CONCATENATED MODULE: ./src/sdk/controlpanels/AncientsSpellbookControls.ts
var AncientsSpellbookControls_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var AncientsSpellbookControls = /** @class */ (function (_super) {
    AncientsSpellbookControls_extends(AncientsSpellbookControls, _super);
    function AncientsSpellbookControls() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(AncientsSpellbookControls.prototype, "panelImageReference", {
        get: function () {
            return ancients_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AncientsSpellbookControls.prototype, "tabImageReference", {
        get: function () {
            // Need to extract the other images later
            return standard_spellbook_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AncientsSpellbookControls.prototype, "keyBinding", {
        get: function () {
            return Settings.spellbook_key;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AncientsSpellbookControls.prototype, "isAvailable", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    AncientsSpellbookControls.prototype.panelClickDown = function (x, y) {
        Trainer.player.manualSpellCastSelection = null;
        var scale = Settings.controlPanelScale;
        x = x / scale;
        y = y / scale;
        if (x >= 21 && x <= 42 && y >= 229 && y <= 249) {
            Trainer.player.manualSpellCastSelection = new IceBarrageSpell();
        }
        else if (x >= 166 && x <= 187 && y >= 194 && y <= 214) {
            Trainer.player.manualSpellCastSelection = new BloodBarrageSpell();
        }
    };
    AncientsSpellbookControls.prototype.draw = function (context, ctrl, x, y) {
        _super.prototype.draw.call(this, context, ctrl, x, y);
        context.fillStyle = "#D1BB7773";
        var scale = Settings.controlPanelScale;
        if (Trainer.player.manualSpellCastSelection) {
            if (Trainer.player.manualSpellCastSelection.itemName === ItemName.ICE_BARRAGE) {
                context.fillRect(x + 20 * scale, y + 225 * scale, 21 * scale, 21 * scale);
            }
            else if (Trainer.player.manualSpellCastSelection.itemName === ItemName.BLOOD_BARRAGE) {
                context.fillRect(x + 164 * scale, y + 188 * scale, 21 * scale, 21 * scale);
            }
        }
    };
    return AncientsSpellbookControls;
}(BaseControls));


;// CONCATENATED MODULE: ./src/assets/images/tabs/clanchat.png
const clanchat_namespaceObject = __webpack_require__.p + "ef9dfa98c2b20b493684.png";
;// CONCATENATED MODULE: ./src/sdk/controlpanels/ClanChatControls.ts
var ClanChatControls_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var ClanChatControls = /** @class */ (function (_super) {
    ClanChatControls_extends(ClanChatControls, _super);
    function ClanChatControls() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ClanChatControls.prototype, "panelImageReference", {
        get: function () {
            return inventory_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClanChatControls.prototype, "tabImageReference", {
        get: function () {
            return clanchat_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return ClanChatControls;
}(BaseControls));


;// CONCATENATED MODULE: ./src/assets/images/tabs/combat.png
const combat_namespaceObject = __webpack_require__.p + "567618a209a019add02b.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/interface/attack_style_button_highlighted.png
const attack_style_button_highlighted_namespaceObject = __webpack_require__.p + "e9d9d5b457be25fc56bf.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/interface/attack_style_button.png
const attack_style_button_namespaceObject = __webpack_require__.p + "e2d12881d5103270f71a.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/interface/auto_retal_button_highlighted.png
const auto_retal_button_highlighted_namespaceObject = __webpack_require__.p + "b5acb96712bcc3ae2209.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/interface/auto_retal_button.png
const auto_retal_button_namespaceObject = __webpack_require__.p + "e9f0f7bddc48ae1bbe71.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/interface/special_attack_background.png
const special_attack_background_namespaceObject = __webpack_require__.p + "9b389be090818faed9d3.png";
;// CONCATENATED MODULE: ./src/sdk/controlpanels/CombatControls.ts
var CombatControls_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();













var CombatControls = /** @class */ (function (_super) {
    CombatControls_extends(CombatControls, _super);
    function CombatControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selectedCombatStyleButtonImage = ImageLoader.createImage(attack_style_button_highlighted_namespaceObject);
        _this.combatStyleButtonImage = ImageLoader.createImage(attack_style_button_namespaceObject);
        _this.autoRetailButtonImage = ImageLoader.createImage(auto_retal_button_namespaceObject);
        _this.selectedAutoRetailButtonImage = ImageLoader.createImage(auto_retal_button_highlighted_namespaceObject);
        _this.specialAttackBarBackground = ImageLoader.createImage(special_attack_background_namespaceObject);
        return _this;
    }
    Object.defineProperty(CombatControls.prototype, "panelImageReference", {
        get: function () {
            return inventory_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CombatControls.prototype, "tabImageReference", {
        get: function () {
            return combat_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CombatControls.prototype, "keyBinding", {
        get: function () {
            return Settings.combat_key;
        },
        enumerable: false,
        configurable: true
    });
    CombatControls.prototype.updateStats = function (playerStats) {
        this.playerStats = playerStats;
    };
    CombatControls.prototype.panelClickDown = function (x, y) {
        var scale = Settings.controlPanelScale;
        x = x / scale;
        y = y / scale;
        var attackStyleOffsets = [
            { x: 25, y: 45 },
            { x: 105, y: 45 },
            { x: 25, y: 100 },
            { x: 105, y: 100 },
        ];
        var weapon = Trainer.player.equipment.weapon;
        var attackStyles = weapon.attackStyles();
        attackStyleOffsets.slice(0, attackStyles.length).forEach(function (offset, index) {
            if (offset.x < x && x < offset.x + 70 && offset.y < y && y < offset.y + 48) {
                AttackStylesController.controller.setWeaponAttackStyle(weapon, attackStyles[index]);
            }
        });
        if (x > 28 && x < 175 && y > 160 && y < 200) {
            Trainer.player.autoRetaliate = !Trainer.player.autoRetaliate;
        }
        if (x > 25 &&
            y > 210 &&
            x < 25 + this.specialAttackBarBackground.width &&
            y < 210 + this.specialAttackBarBackground.height) {
            var canSpec = Trainer.player.equipment.weapon && Trainer.player.equipment.weapon.hasSpecialAttack();
            if (canSpec) {
                Trainer.player.useSpecialAttack = !Trainer.player.useSpecialAttack;
            }
        }
    };
    Object.defineProperty(CombatControls.prototype, "isAvailable", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    CombatControls.prototype.drawAttackStyleButton = function (context, weapon, attackStyle, attackStyleImage, x, y) {
        var scale = Settings.controlPanelScale;
        var currentAttackStyle = weapon.attackStyle();
        var currentAttackStyleImage = currentAttackStyle === attackStyle ? this.selectedCombatStyleButtonImage : this.combatStyleButtonImage;
        context.drawImage(currentAttackStyleImage, x, y, currentAttackStyleImage.width * scale, currentAttackStyleImage.height * scale);
        context.drawImage(attackStyleImage, x + (35 - Math.floor(attackStyleImage.width / 2)) * scale, y + 5 * scale, attackStyleImage.width * scale, attackStyleImage.height * scale);
        context.font = 16 * scale + "px Stats_11";
        context.textAlign = "center";
        context.fillStyle = "#000";
        context.fillText((0,lodash.startCase)((0,lodash.toLower)(attackStyle)), x + 36 * scale, y + 41 * scale);
        context.fillStyle = "#FF9700";
        context.fillText((0,lodash.startCase)((0,lodash.toLower)(attackStyle)), x + 35 * scale, y + 40 * scale);
    };
    CombatControls.prototype.draw = function (context, ctrl, x, y) {
        var _this = this;
        var _a, _b;
        _super.prototype.draw.call(this, context, ctrl, x, y);
        var scale = Settings.controlPanelScale;
        var weapon = Trainer.player.equipment.weapon;
        if (!weapon) {
            return;
        }
        context.font = 21 * scale + "px Stats_11";
        context.textAlign = "center";
        context.fillStyle = "#000";
        context.fillText((0,lodash.startCase)((0,lodash.toLower)(weapon.itemName)), x + 101 * scale, y + 31 * scale);
        context.fillStyle = "#FF9700";
        context.fillText((0,lodash.startCase)((0,lodash.toLower)(weapon.itemName)), x + 100 * scale, y + 30 * scale);
        var attackStyleOffsets = [
            { x: 25, y: 45 },
            { x: 105, y: 45 },
            { x: 25, y: 100 },
            { x: 105, y: 100 },
        ];
        var attackStyles = weapon.attackStyles();
        var imageMap = AttackStylesController.attackStyleImageMap[weapon.attackStyleCategory()];
        if (imageMap) {
            attackStyles.forEach(function (style, index) {
                var offsets = attackStyleOffsets[index];
                var attackStyleImage = imageMap[weapon.attackStyles()[index]];
                if (attackStyleImage) {
                    _this.drawAttackStyleButton(context, weapon, weapon.attackStyles()[index], attackStyleImage, x + offsets.x * scale, y + offsets.y * scale);
                }
            });
        }
        var autoRetailateImage = Trainer.player.autoRetaliate
            ? this.selectedAutoRetailButtonImage
            : this.autoRetailButtonImage;
        context.drawImage(autoRetailateImage, x + 25 * scale, y + 155 * scale, autoRetailateImage.width * scale, autoRetailateImage.height * scale);
        context.font = 19 * scale + "px Stats_11";
        context.textAlign = "center";
        context.fillStyle = "#000";
        context.fillText("Auto Retaliate", x + 116 * scale, y + 183 * scale);
        context.fillStyle = "#FF9700";
        context.fillText("Auto Retaliate", x + 115 * scale, y + 182 * scale);
        var canSpec = Trainer.player.equipment.weapon && Trainer.player.equipment.weapon.hasSpecialAttack();
        var isUsingSpec = canSpec && Trainer.player.useSpecialAttack;
        if (canSpec) {
            var specAmount = ((_b = (_a = Trainer.player) === null || _a === void 0 ? void 0 : _a.currentStats.specialAttack) !== null && _b !== void 0 ? _b : 0.0) / 100.0;
            context.drawImage(this.specialAttackBarBackground, x + 25 * scale, y + 210 * scale, this.specialAttackBarBackground.width * scale, this.specialAttackBarBackground.height * scale);
            context.fillStyle = "#730606";
            context.fillRect(x + 28 * scale, y + 216 * scale, 144 * scale, 14 * scale);
            context.fillStyle = "#397d3b";
            context.fillRect(x + 28 * scale, y + 216 * scale, 144 * scale * specAmount, 14 * scale);
            context.fillStyle = "#000000";
            context.globalAlpha = 0.5;
            context.strokeRect(x + 28 * scale, y + 216 * scale, 144 * scale, 14 * scale);
            context.globalAlpha = 1;
            context.font = "".concat(16 * scale, "px Stats_11");
            context.textAlign = "center";
            context.fillStyle = isUsingSpec ? "#FFFF00" : "#000000";
            context.fillText("Special Attack: ".concat(Math.round(specAmount * 100), "%"), x + 100 * scale, y + 227 * scale);
        }
    };
    return CombatControls;
}(BaseControls));


;// CONCATENATED MODULE: ./src/assets/images/tabs/emotes.png
const emotes_namespaceObject = __webpack_require__.p + "069d85c2fc861db5b1b7.png";
;// CONCATENATED MODULE: ./src/sdk/controlpanels/EmotesControls.ts
var EmotesControls_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var EmotesControls = /** @class */ (function (_super) {
    EmotesControls_extends(EmotesControls, _super);
    function EmotesControls() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(EmotesControls.prototype, "panelImageReference", {
        get: function () {
            return inventory_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmotesControls.prototype, "tabImageReference", {
        get: function () {
            return emotes_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return EmotesControls;
}(BaseControls));


;// CONCATENATED MODULE: ./src/assets/images/tabs/empty.png
const empty_namespaceObject = __webpack_require__.p + "8607e94d4d31fd19f38e.png";
;// CONCATENATED MODULE: ./src/sdk/controlpanels/EmptyControls.ts
var EmptyControls_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var EmptyControls = /** @class */ (function (_super) {
    EmptyControls_extends(EmptyControls, _super);
    function EmptyControls() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(EmptyControls.prototype, "panelImageReference", {
        get: function () {
            return inventory_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmptyControls.prototype, "tabImageReference", {
        get: function () {
            return empty_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return EmptyControls;
}(BaseControls));


;// CONCATENATED MODULE: ./src/assets/images/panels/equipment.png
const equipment_namespaceObject = __webpack_require__.p + "8a7b4cacdddf24930d0c.png";
;// CONCATENATED MODULE: ./src/assets/images/tabs/equipment.png
const tabs_equipment_namespaceObject = __webpack_require__.p + "8e048a2727d4c0fed3fa.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/equipment_spot_used.png
const equipment_spot_used_namespaceObject = __webpack_require__.p + "1d10f87534406456a4d1.png";
;// CONCATENATED MODULE: ./src/sdk/controlpanels/EquipmentControls.ts
var EquipmentControls_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var EquipmentControls_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};









var EquipmentControls = /** @class */ (function (_super) {
    EquipmentControls_extends(EquipmentControls, _super);
    function EquipmentControls() {
        var _this = _super.call(this) || this;
        _this.usedSpotBackground = ImageLoader.createImage(equipment_spot_used_namespaceObject);
        _this.DEFAULT_EQUIPMENT_INTERACTIONS = [function (slot) { return _this.unequipItem(slot); }];
        _this.equipmentInteractions = EquipmentControls_spreadArray([], _this.DEFAULT_EQUIPMENT_INTERACTIONS, true);
        _this.clickedSlot = null;
        EquipmentControls.instance = _this;
        return _this;
    }
    EquipmentControls.prototype.resetEquipmentInteractions = function () {
        this.equipmentInteractions = EquipmentControls_spreadArray([], this.DEFAULT_EQUIPMENT_INTERACTIONS, true);
    };
    EquipmentControls.prototype.addEquipmentInteraction = function (interaction) {
        this.equipmentInteractions.unshift(interaction);
    };
    Object.defineProperty(EquipmentControls.prototype, "panelImageReference", {
        get: function () {
            return equipment_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EquipmentControls.prototype, "tabImageReference", {
        get: function () {
            return tabs_equipment_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EquipmentControls.prototype, "keyBinding", {
        get: function () {
            return Settings.equipment_key;
        },
        enumerable: false,
        configurable: true
    });
    EquipmentControls.prototype.panelClickDown = function (x, y) {
        var _this = this;
        var scale = Settings.controlPanelScale;
        x = x / scale;
        y = y / scale;
        var clicked = null;
        if (x > 84 && y > 11 && x < 84 + 36 && y < 11 + 36) {
            // helmet
            clicked = EquipmentTypes.HELMET;
        }
        else if (x > 43 && y > 50 && x < 43 + 36 && y < 50 + 36) {
            // cape
            clicked = EquipmentTypes.BACK;
        }
        else if (x > 84 && y > 50 && x < 84 + 36 && y < 50 + 36) {
            // necklace
            clicked = EquipmentTypes.NECK;
        }
        else if (x > 124 && y > 50 && x < 124 + 36 && y < 50 + 36) {
            // ammo
            clicked = EquipmentTypes.AMMO;
        }
        else if (x > 28 && y > 89 && x < 28 + 36 && y < 89 + 36) {
            // weapon
            clicked = EquipmentTypes.WEAPON;
        }
        else if (x > 84 && y > 89 && x < 84 + 36 && y < 89 + 36) {
            // chest
            clicked = EquipmentTypes.CHEST;
        }
        else if (x > 140 && y > 89 && x < 140 + 36 && y < 89 + 36) {
            // offhand
            clicked = EquipmentTypes.OFFHAND;
        }
        else if (x > 84 && y > 129 && x < 84 + 36 && y < 129 + 36) {
            // legs
            clicked = EquipmentTypes.LEGS;
        }
        else if (x > 28 && y > 169 && x < 28 + 36 && y < 169 + 36) {
            // gloves
            clicked = EquipmentTypes.GLOVES;
        }
        else if (x > 84 && y > 169 && x < 84 + 36 && y < 169 + 36) {
            // feet
            clicked = EquipmentTypes.FEET;
        }
        else if (x > 140 && y > 169 && x < 140 + 36 && y < 169 + 36) {
            // ring
            clicked = EquipmentTypes.RING;
        }
        this.clickedSlot = clicked;
        if (clicked) {
            InputController.controller.queueAction(function () {
                _this.equipmentInteractions[0](clicked);
            });
        }
    };
    EquipmentControls.prototype.panelClickUp = function () {
        this.clickedSlot = null;
    };
    EquipmentControls.prototype.unequipItem = function (clicked) {
        var _a;
        var equipmentSlot = EQUIPMENT_TYPE_TO_SLOT[clicked];
        (_a = Trainer.player.equipment[equipmentSlot]) === null || _a === void 0 ? void 0 : _a.unequip(Trainer.player);
    };
    Object.defineProperty(EquipmentControls.prototype, "isAvailable", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EquipmentControls.prototype, "appearsOnLeftInMobile", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    EquipmentControls.prototype.drawEquipment = function (context, x, y, slotX, slotY, scale, slot) {
        var equipmentSlot = EQUIPMENT_TYPE_TO_SLOT[slot];
        if (Trainer.player.equipment[equipmentSlot]) {
            context.drawImage(this.usedSpotBackground, x + slotX * scale, y + slotY * scale, this.usedSpotBackground.width * scale, this.usedSpotBackground.height * scale);
            if (this.clickedSlot === slot) {
                context.globalAlpha = 0.5;
            }
            else {
                context.globalAlpha = 1.0;
            }
            var sprite = Trainer.player.equipment[equipmentSlot].inventorySprite;
            context.drawImage(sprite, x + (slotX + 18 - Math.floor(sprite.width / 2)) * scale, y + (slotY + 18 - Math.floor(sprite.height / 2)) * scale, sprite.width * scale, sprite.height * scale);
            context.globalAlpha = 1.0;
        }
    };
    EquipmentControls.prototype.draw = function (context, ctrl, x, y) {
        _super.prototype.draw.call(this, context, ctrl, x, y);
        var scale = Settings.controlPanelScale;
        this.drawEquipment(context, x, y, 84, 11, scale, EquipmentTypes.HELMET);
        this.drawEquipment(context, x, y, 43, 50, scale, EquipmentTypes.BACK);
        this.drawEquipment(context, x, y, 84, 50, scale, EquipmentTypes.NECK);
        this.drawEquipment(context, x, y, 124, 50, scale, EquipmentTypes.AMMO);
        this.drawEquipment(context, x, y, 28, 89, scale, EquipmentTypes.WEAPON);
        this.drawEquipment(context, x, y, 84, 89, scale, EquipmentTypes.CHEST);
        this.drawEquipment(context, x, y, 140, 89, scale, EquipmentTypes.OFFHAND);
        this.drawEquipment(context, x, y, 84, 129, scale, EquipmentTypes.LEGS);
        this.drawEquipment(context, x, y, 28, 169, scale, EquipmentTypes.GLOVES);
        this.drawEquipment(context, x, y, 84, 169, scale, EquipmentTypes.FEET);
        this.drawEquipment(context, x, y, 140, 169, scale, EquipmentTypes.RING);
    };
    EquipmentControls.instance = null;
    return EquipmentControls;
}(BaseControls));


;// CONCATENATED MODULE: ./src/assets/images/tabs/friends.png
const friends_namespaceObject = __webpack_require__.p + "2caf18f36771b7339d68.png";
;// CONCATENATED MODULE: ./src/sdk/controlpanels/FriendsControls.ts
var FriendsControls_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var FriendsControls = /** @class */ (function (_super) {
    FriendsControls_extends(FriendsControls, _super);
    function FriendsControls() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(FriendsControls.prototype, "panelImageReference", {
        get: function () {
            return inventory_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FriendsControls.prototype, "tabImageReference", {
        get: function () {
            return friends_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return FriendsControls;
}(BaseControls));


;// CONCATENATED MODULE: ./src/assets/images/tabs/inventory.png
const tabs_inventory_namespaceObject = __webpack_require__.p + "a74076e4dc99902386b8.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_border.png
const map_border_namespaceObject = __webpack_require__.p + "f6233406c5f4b2624f9e.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_selected_num_orb.png
const map_selected_num_orb_namespaceObject = __webpack_require__.p + "24b37ff1d1aa49ff05b5.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_num_orb.png
const map_num_orb_namespaceObject = __webpack_require__.p + "ff52384590ff0b4bbd6b.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_border_mask.png
const map_border_mask_namespaceObject = __webpack_require__.p + "837464ad52b85c147d03.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/compass.png
const compass_namespaceObject = __webpack_require__.p + "6f1f3f50786a7bb62326.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_hitpoint_orb.png
const map_hitpoint_orb_namespaceObject = __webpack_require__.p + "9e4649d3b9840fac0bc1.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_prayer_orb.png
const map_prayer_orb_namespaceObject = __webpack_require__.p + "d8d30a814b3800fd65e4.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_prayer_on_orb.png
const map_prayer_on_orb_namespaceObject = __webpack_require__.p + "4ed40104ff4863fa4b08.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_run_orb.png
const map_run_orb_namespaceObject = __webpack_require__.p + "c9e2eaa0b3c8a5458c13.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_no_spec_orb.png
const map_no_spec_orb_namespaceObject = __webpack_require__.p + "73d2ce2fbffbe8a3d373.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_spec_orb.png
const map_spec_orb_namespaceObject = __webpack_require__.p + "f1e8f253f786ced20081.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_spec_on_orb.png
const map_spec_on_orb_namespaceObject = __webpack_require__.p + "8cb11164d4024ea68dcf.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_xp_button.png
const map_xp_button_namespaceObject = __webpack_require__.p + "b33f32c14e429e1d69f6.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_xp_hover_button.png
const map_xp_hover_button_namespaceObject = __webpack_require__.p + "463c5089a8aa627173d3.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_hitpoint_icon.png
const map_hitpoint_icon_namespaceObject = __webpack_require__.p + "c77ddb6ca212487bb2b0.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_prayer_icon.png
const map_prayer_icon_namespaceObject = __webpack_require__.p + "f5f2dbf08f6d63906db2.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_walk_icon.png
const map_walk_icon_namespaceObject = __webpack_require__.p + "5000d13f7684a3400c1e.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_run_icon.png
const map_run_icon_namespaceObject = __webpack_require__.p + "c707d2d8c0bafd1019b8.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_stam_icon.png
const map_stam_icon_namespaceObject = __webpack_require__.p + "5a89bcaea8926d0d7756.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_spec_icon.png
const map_spec_icon_namespaceObject = __webpack_require__.p + "37366ee3c2ce9bc12b09.png";
// EXTERNAL MODULE: ./node_modules/color-scales/lib/index.js
var lib = __webpack_require__(5416);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./src/sdk/MapController.ts



























/* eslint-disable @typescript-eslint/no-explicit-any */
var MapHover;
(function (MapHover) {
    MapHover[MapHover["NONE"] = 0] = "NONE";
    MapHover[MapHover["HITPOINT"] = 1] = "HITPOINT";
    MapHover[MapHover["PRAYER"] = 2] = "PRAYER";
    MapHover[MapHover["RUN"] = 3] = "RUN";
    MapHover[MapHover["SPEC"] = 4] = "SPEC";
    MapHover[MapHover["XP"] = 5] = "XP";
})(MapHover || (MapHover = {}));
var INITIAL_WIDTH = 210;
var INITIAL_HEIGHT = 180;
var MapController = /** @class */ (function () {
    function MapController() {
        this.colorScale = new (lib_default())(0, 1, ["#FF0000", "#FF7300", "#00FF00"], 1);
        this.outlineImage = ImageLoader.createImage(map_border_namespaceObject);
        this.mapAlphaImage = ImageLoader.createImage(map_border_mask_namespaceObject);
        this.mapNumberOrb = ImageLoader.createImage(map_num_orb_namespaceObject);
        this.mapSelectedNumberOrb = ImageLoader.createImage(map_selected_num_orb_namespaceObject);
        this.mapHitpointOrb = ImageLoader.createImage(map_hitpoint_orb_namespaceObject);
        this.mapPrayerOrb = ImageLoader.createImage(map_prayer_orb_namespaceObject);
        this.mapPrayerSelectedOrb = ImageLoader.createImage(map_prayer_on_orb_namespaceObject);
        this.mapRunOrb = ImageLoader.createImage(map_run_orb_namespaceObject);
        this.mapNoSpecOrb = ImageLoader.createImage(map_no_spec_orb_namespaceObject);
        this.mapSpecOrb = ImageLoader.createImage(map_spec_orb_namespaceObject);
        this.mapSpecOnOrb = ImageLoader.createImage(map_spec_on_orb_namespaceObject);
        this.mapHitpointIcon = ImageLoader.createImage(map_hitpoint_icon_namespaceObject);
        this.mapPrayerIcon = ImageLoader.createImage(map_prayer_icon_namespaceObject);
        this.mapWalkIcon = ImageLoader.createImage(map_walk_icon_namespaceObject);
        this.mapRunIcon = ImageLoader.createImage(map_run_icon_namespaceObject);
        this.mapStamIcon = ImageLoader.createImage(map_stam_icon_namespaceObject);
        this.mapSpecIcon = ImageLoader.createImage(map_spec_icon_namespaceObject);
        this.mapXpButton = ImageLoader.createImage(map_xp_button_namespaceObject);
        this.mapXpHoverButton = ImageLoader.createImage(map_xp_hover_button_namespaceObject);
        this.hovering = null;
        this.width = INITIAL_WIDTH;
        this.height = INITIAL_HEIGHT;
        this.hovering = MapHover.NONE;
        this.loadImages();
    }
    MapController.prototype.updateOrbsMask = function (currentStats, stats) {
        if (currentStats) {
            this.currentStats = currentStats;
        }
        if (stats) {
            this.stats = stats;
        }
        if (!this.mapHitpointOrb || !this.mapPrayerOrb || !this.mapRunOrb || !this.mapSpecOrb) {
            return;
        }
        var hitpointPercentage = this.currentStats.hitpoint / this.stats.hitpoint;
        this.mapHitpointOrbMasked = new OffscreenCanvas(this.mapHitpointOrb.width, this.mapHitpointOrb.height);
        var ctx = this.mapHitpointOrbMasked.getContext("2d");
        ctx.fillStyle = "white";
        ctx.drawImage(this.mapHitpointOrb, 0, 0);
        ctx.globalCompositeOperation = "destination-in";
        ctx.fillRect(0, this.mapHitpointOrb.height * (1 - hitpointPercentage), this.mapHitpointOrb.width, this.mapHitpointOrb.height * hitpointPercentage);
        ctx.globalCompositeOperation = "source-over";
        var prayerPercentage = this.currentStats.prayer / this.stats.prayer;
        this.mapPrayerOrbMasked = new OffscreenCanvas(this.mapPrayerOrb.width, this.mapPrayerOrb.height);
        ctx = this.mapPrayerOrbMasked.getContext("2d");
        ctx.fillStyle = "white";
        ctx.drawImage(ControlPanelController.controls.PRAYER.hasQuickPrayersActivated ? this.mapPrayerSelectedOrb : this.mapPrayerOrb, 0, 0);
        ctx.globalCompositeOperation = "destination-in";
        ctx.fillRect(0, this.mapPrayerOrb.height * (1 - prayerPercentage), this.mapPrayerOrb.width, this.mapPrayerOrb.height * prayerPercentage);
        ctx.globalCompositeOperation = "source-over";
        var runPercentage = this.currentStats.run / 10000;
        this.mapRunOrbMasked = new OffscreenCanvas(this.mapRunOrb.width, this.mapRunOrb.height);
        ctx = this.mapRunOrbMasked.getContext("2d");
        ctx.fillStyle = "white";
        ctx.drawImage(Trainer.player.running ? this.mapRunOrb : this.mapNoSpecOrb, 0, 0);
        ctx.globalCompositeOperation = "destination-in";
        ctx.fillRect(0, this.mapRunOrb.height * (1 - runPercentage), this.mapRunOrb.width, this.mapRunOrb.height * runPercentage);
        ctx.globalCompositeOperation = "source-over";
        var specPercentage = this.currentStats.specialAttack / 100;
        this.mapSpecOrbMasked = new OffscreenCanvas(this.mapSpecOrb.width, this.mapSpecOrb.height);
        ctx = this.mapSpecOrbMasked.getContext("2d");
        ctx.fillStyle = "white";
        var specOrb = this.mapNoSpecOrb;
        if (Trainer.player.equipment.weapon && Trainer.player.equipment.weapon.hasSpecialAttack()) {
            if (Trainer.player.useSpecialAttack) {
                specOrb = this.mapSpecOnOrb;
            }
            else {
                specOrb = this.mapSpecOrb;
            }
        }
        ctx.drawImage(specOrb, 0, 0);
        ctx.globalCompositeOperation = "destination-in";
        ctx.fillRect(0, this.mapSpecOrb.height * (1 - specPercentage), this.mapRunOrb.width, this.mapRunOrb.height * specPercentage);
        ctx.globalCompositeOperation = "source-over";
    };
    MapController.prototype.loadImages = function () {
        var _this = this;
        var compassImage = ImageLoader.createImage(compass_namespaceObject);
        compassImage.addEventListener("load", function () {
            _this.compassImage = new OffscreenCanvas(51, 51);
            var context = _this.compassImage.getContext("2d");
            context.drawImage(compassImage, 0, 0);
            // only draw image where mask is
            context.globalCompositeOperation = "destination-in";
            // draw our circle mask
            context.fillStyle = "#000";
            context.beginPath();
            var size = 38;
            context.arc((51 - size) * 0.5 + size * 0.5, // x
            (51 - size) * 0.5 + size * 0.5, // y
            size * 0.5, // radius
            0, // start angle
            2 * Math.PI);
            context.fill();
            // restore to default composite operation (is draw over current image)
            context.globalCompositeOperation = "source-over";
        });
    };
    MapController.prototype.generateMaskedMap = function () {
        this.mapCanvas = new OffscreenCanvas(152, 152);
        var mapContext = this.mapCanvas.getContext("2d");
        mapContext.save();
        mapContext.translate(76, 76);
        mapContext.rotate(Viewport.viewport.getMapRotation());
        mapContext.translate(-76, -76);
        if (Trainer.player.region.mapImage) {
            var compatCtx = mapContext;
            compatCtx.webkitImageSmoothingEnabled = false;
            compatCtx.mozImageSmoothingEnabled = false;
            compatCtx.imageSmoothingEnabled = false;
            mapContext.drawImage(Trainer.player.region.mapImage, 0, 0, 152, 152);
            compatCtx.webkitImageSmoothingEnabled = true;
            compatCtx.mozImageSmoothingEnabled = true;
            compatCtx.imageSmoothingEnabled = true;
        }
        mapContext.globalCompositeOperation = "destination-out";
        mapContext.drawImage(this.mapAlphaImage, 0, 0);
        mapContext.globalCompositeOperation = "source-over";
        mapContext.restore();
    };
    MapController.prototype.cursorMovedTo = function (event) {
        var width = Chrome.size().width;
        var scale = Settings.minimapScale;
        var offset = width - this.width - (Settings.menuVisible ? 232 : 0);
        var x = (event.offsetX - offset) / scale;
        var y = event.offsetY / scale;
        this.hovering = MapHover.NONE;
        if (x > 4 && x < 28 && y > 31 && y < 56) {
            this.hovering = MapHover.XP;
        }
        else if (x > 4 && x < 53 && y > 53 && y < 81) {
            this.hovering = MapHover.HITPOINT;
        }
        else if (x > 4 && x < 53 && y > 90 && y < 113) {
            this.hovering = MapHover.PRAYER;
        }
        else if (x > 15 && x < 67 && y > 122 && y < 149) {
            this.hovering = MapHover.RUN;
        }
        else if (x > 38 && x < 90 && y > 148 && y < 173) {
            this.hovering = MapHover.SPEC;
        }
    };
    MapController.prototype.rightClick = function (event) {
        var _this = this;
        var menuOptions = [];
        var intercepted = false;
        var width = Chrome.size().width;
        var scale = Settings.minimapScale;
        var offset = width - this.width - (Settings.menuVisible ? 232 : 0);
        var x = (event.offsetX - offset) / scale;
        var y = event.offsetY / scale;
        if (x > 4 && x < 20 && y > 31 && y < 48) {
            intercepted = true;
            if (Settings.displayXpDrops === true) {
                menuOptions = [
                    {
                        text: [
                            { text: "Hide ", fillStyle: "white" },
                            { text: "XP drops", fillStyle: "#FF911F" },
                        ],
                        action: function () {
                            Settings.displayXpDrops = false;
                        },
                    },
                ];
            }
            else {
                menuOptions = [
                    {
                        text: [
                            { text: "Show ", fillStyle: "white" },
                            { text: "XP drops", fillStyle: "#FF911F" },
                        ],
                        action: function () {
                            Settings.displayXpDrops = true;
                        },
                    },
                ];
            }
        }
        else if (x > 33 && x < 64 && y > 5 && y < 36) {
            intercepted = true;
            menuOptions = [
                {
                    text: [{ text: "Look North", fillStyle: "white" }],
                    action: function () {
                        Viewport.viewport.rotateNorth();
                    },
                },
                {
                    text: [{ text: "Look South", fillStyle: "white" }],
                    action: function () {
                        Viewport.viewport.rotateSouth();
                    },
                },
            ];
        }
        else if (x > 4 && x < 52 && y > 53 && y < 73) {
            // intercepted = true;
            // hitpoint
        }
        else if (x > 4 && x < 53 && y > 90 && y < 113) {
            intercepted = true;
            // prayer
            menuOptions = [
                {
                    text: [{ text: "Activate Quick-prayers", fillStyle: "white" }],
                    action: function () {
                        _this.toggleQuickprayers();
                    },
                },
            ];
        }
        else if (x > 15 && x < 67 && y > 122 && y < 149) {
            intercepted = true;
            // run
            menuOptions = [
                {
                    text: [{ text: "Toggle Run", fillStyle: "white" }],
                    action: function () {
                        Trainer.player.running = !Trainer.player.running;
                    },
                },
            ];
        }
        else if (x > 38 && x < 90 && y > 148 && y < 175) {
            if (this.canSpecialAttack()) {
                intercepted = true;
                // special attack
                menuOptions = [
                    {
                        text: [
                            { text: "Use ", fillStyle: "white" },
                            { text: "Special Attack", fillStyle: "#FF911F" },
                        ],
                        action: function () {
                            _this.toggleSpecialAttack();
                        },
                    },
                ];
            }
        }
        Viewport.viewport.contextMenu.setMenuOptions(menuOptions);
        Viewport.viewport.contextMenu.setActive();
        return intercepted;
    };
    MapController.prototype.leftClickDown = function (event) {
        var intercepted = false;
        var width = Chrome.size().width;
        var scale = Settings.minimapScale;
        var offset = width - this.width - (Settings.menuVisible ? 232 : 0);
        var x = (event.offsetX - offset) / scale;
        var y = event.offsetY / scale;
        if (x > 4 && x < 20 && y > 31 && y < 48) {
            Settings.displayXpDrops = !Settings.displayXpDrops;
            intercepted = true;
            Settings.persistToStorage();
        }
        else if (x > 33 && x < 64 && y > 5 && y < 36) {
            intercepted = true;
            if (Viewport.viewport.getMapRotation() === 0) {
                Viewport.viewport.rotateSouth();
            }
            else {
                Viewport.viewport.rotateNorth();
            }
            Settings.persistToStorage();
        }
        else if (x > 4 && x < 52 && y > 53 && y < 73) {
            intercepted = true;
            // this.hovering = MapHover.HITPOINT;
        }
        else if (x > 4 && x < 53 && y > 90 && y < 113) {
            intercepted = true;
            this.toggleQuickprayers();
        }
        else if (x > 15 && x < 67 && y > 122 && y < 149) {
            intercepted = true;
            Trainer.player.running = !Trainer.player.running;
        }
        else if (x > 38 && x < 90 && y > 148 && y < 175) {
            intercepted = true;
            this.toggleSpecialAttack();
        }
        this.updateOrbsMask(this.currentStats, this.stats);
        return intercepted;
    };
    MapController.prototype.canSpecialAttack = function () {
        return Trainer.player.equipment.weapon && Trainer.player.equipment.weapon.hasSpecialAttack();
    };
    MapController.prototype.toggleSpecialAttack = function () {
        if (this.canSpecialAttack()) {
            Trainer.player.useSpecialAttack = !Trainer.player.useSpecialAttack;
        }
    };
    MapController.prototype.toggleQuickprayers = function () {
        if (ControlPanelController.controls.PRAYER.hasQuickPrayersActivated) {
            ControlPanelController.controls.PRAYER.deactivateAllPrayers();
            Trainer.player.prayerController.drainCounter = 0;
        }
        else {
            ControlPanelController.controls.PRAYER.activateQuickPrayers();
        }
    };
    MapController.prototype.draw = function (ctx) {
        var width = Chrome.size().width;
        var gameHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        Settings.minimapScale = (gameHeight / 500 > 1 ? 1 : gameHeight / 500) * Settings.maxUiScale;
        var scale = Settings.minimapScale;
        this.width = INITIAL_WIDTH * scale;
        this.height = INITIAL_HEIGHT * scale;
        var offset = width - this.width - (Settings.menuVisible ? 232 : 0);
        ctx.font = 16 * scale + "px Stats_11";
        ctx.textAlign = "center";
        this.generateMaskedMap();
        ctx.drawImage(this.mapCanvas, offset + 52 * scale, 8, 152 * scale, 152 * scale);
        // draw compass
        ctx.save();
        ctx.translate(offset + 50.5 * scale, 23.5 * scale);
        ctx.rotate(Viewport.viewport.getMapRotation());
        ctx.translate(-50.5 * scale, -23.5 * scale);
        if (this.compassImage) {
            ctx.drawImage(this.compassImage, 25 * scale, -2, 51 * scale, 51 * scale);
        }
        ctx.restore();
        ctx.drawImage(this.outlineImage, offset + 28 * scale, 0, 182 * scale, 166 * scale);
        ctx.drawImage(this.hovering == MapHover.XP ? this.mapXpHoverButton : this.mapXpButton, offset, 26, 27 * scale, 27 * scale);
        ctx.drawImage(this.hovering == MapHover.HITPOINT ? this.mapSelectedNumberOrb : this.mapNumberOrb, offset, 47 * scale, 57 * scale, 34 * scale);
        ctx.drawImage(this.hovering == MapHover.PRAYER ? this.mapSelectedNumberOrb : this.mapNumberOrb, offset, 81 * scale, 57 * scale, 34 * scale);
        ctx.drawImage(this.hovering == MapHover.RUN ? this.mapSelectedNumberOrb : this.mapNumberOrb, offset + 10 * scale, 114 * scale, 57 * scale, 34 * scale);
        ctx.drawImage(this.hovering == MapHover.SPEC ? this.mapSelectedNumberOrb : this.mapNumberOrb, offset + 32 * scale, 140 * scale, 57 * scale, 34 * scale);
        ctx.drawImage(this.mapHitpointOrbMasked, offset + 27 * scale, 51 * scale, 26 * scale, 26 * scale);
        ctx.drawImage(this.mapHitpointIcon, offset + 27 * scale, 51 * scale, 26 * scale, 26 * scale);
        ctx.drawImage(this.mapPrayerOrbMasked, offset + 27 * scale, 85 * scale, 26 * scale, 26 * scale);
        ctx.drawImage(this.mapPrayerIcon, offset + 27 * scale, 85 * scale, 26 * scale, 26 * scale);
        ctx.drawImage(this.mapRunOrbMasked, offset + 37 * scale, 118 * scale, 26 * scale, 26 * scale);
        var mapRunIcon = this.mapWalkIcon;
        if (Trainer.player.effects.stamina) {
            mapRunIcon = this.mapStamIcon;
        }
        else if (Trainer.player.running) {
            mapRunIcon = this.mapRunIcon;
        }
        ctx.drawImage(mapRunIcon, offset + 37 * scale, 118 * scale, 26 * scale, 26 * scale);
        ctx.drawImage(this.mapSpecOrbMasked, offset + 59 * scale, 144 * scale, 26 * scale, 26 * scale);
        ctx.drawImage(this.mapSpecIcon, offset + 57 * scale, 142 * scale, 30 * scale, 30 * scale);
        // // hitpoints
        ctx.fillStyle = "black";
        ctx.fillText(String(this.currentStats.hitpoint), offset + 15 * scale, 74 * scale);
        ctx.fillStyle = this.colorScale.getColor(this.currentStats.hitpoint / this.stats.hitpoint).toHexString();
        ctx.fillText(String(this.currentStats.hitpoint), offset + 14 * scale, 73 * scale);
        // prayer
        ctx.fillStyle = "black";
        ctx.fillText(String(this.currentStats.prayer), offset + 15 * scale, 108 * scale);
        ctx.fillStyle = this.colorScale.getColor(this.currentStats.prayer / this.stats.prayer).toHexString();
        ctx.fillText(String(this.currentStats.prayer), offset + 14 * scale, 107 * scale);
        // run
        ctx.fillStyle = "black";
        ctx.fillText(String(Math.floor(this.currentStats.run / 100)), offset + 25 * scale, 140 * scale);
        ctx.fillStyle = this.colorScale.getColor(this.currentStats.run / 10000).toHexString();
        ctx.fillText(String(Math.floor(this.currentStats.run / 100)), offset + 24 * scale, 139 * scale);
        // spec
        ctx.fillStyle = "black";
        ctx.fillText(String(this.currentStats.specialAttack), offset + 47 * scale, 166 * scale);
        ctx.fillStyle = this.colorScale.getColor(this.currentStats.specialAttack / 100).toHexString();
        ctx.fillText(String(this.currentStats.specialAttack), offset + 46 * scale, 165 * scale);
    };
    MapController.controller = new MapController();
    return MapController;
}());


;// CONCATENATED MODULE: ./src/sdk/controlpanels/InventoryControls.ts
var InventoryControls_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var InventoryControls_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};











/* eslint-disable @typescript-eslint/no-explicit-any */
var MS_PER_ANTI_DRAG = 20; // per client tick
var DRAG_RADIUS = 5;
var InventoryControls = /** @class */ (function (_super) {
    InventoryControls_extends(InventoryControls, _super);
    function InventoryControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.antiDragTimerAt = 0;
        _this.clickedDownItem = null;
        _this.clickedDownLocation = null;
        _this.draggedItem = false;
        _this.cursorLocation = null;
        // this is the visual representation of the inventory, which updates instantly when items are moved but is refreshed
        // every tick
        _this.inventoryCache = [];
        return _this;
    }
    Object.defineProperty(InventoryControls.prototype, "panelImageReference", {
        get: function () {
            return inventory_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InventoryControls.prototype, "tabImageReference", {
        get: function () {
            return tabs_inventory_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InventoryControls.prototype, "keyBinding", {
        get: function () {
            return Settings.inventory_key;
        },
        enumerable: false,
        configurable: true
    });
    InventoryControls.prototype.cursorMovedto = function (x, y) {
        this.cursorLocation = { x: x, y: y };
        this.draggedItem || (this.draggedItem = Pathing.dist(this.cursorLocation.x, this.cursorLocation.y, this.clickedDownLocation.x, this.clickedDownLocation.y) > DRAG_RADIUS && this.canDrag());
    };
    Object.defineProperty(InventoryControls.prototype, "isAvailable", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InventoryControls.prototype, "appearsOnLeftInMobile", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    InventoryControls.prototype.onWorldTick = function () {
        this.inventoryCache = InventoryControls_spreadArray([], Trainer.player.inventory, true);
    };
    InventoryControls.prototype.panelRightClick = function (x, y) {
        var scale = Settings.controlPanelScale;
        var menuOptions = [];
        var clickedItem = (0,lodash.first)((0,lodash.filter)(Trainer.player.inventory, function (inventoryItem, index) {
            if (!inventoryItem) {
                return;
            }
            var x2 = index % 4;
            var y2 = Math.floor(index / 4);
            var itemX = 20 + x2 * 43;
            var itemY = 17 + (y2 + 1) * 35;
            return Collision.collisionMath(x, y, 1, itemX * scale, itemY * scale, 32 * scale);
        }));
        if (clickedItem) {
            menuOptions = menuOptions.concat(clickedItem.contextActions(Trainer.player));
        }
        Viewport.viewport.contextMenu.setMenuOptions(menuOptions);
        Viewport.viewport.contextMenu.setActive();
    };
    InventoryControls.prototype.onMouseUp = function () {
        this.clickedDownItem = null;
    };
    InventoryControls.prototype.panelClickUp = function (x, y) {
        if (!this.clickedDownItem) {
            return;
        }
        var scale = Settings.controlPanelScale;
        var sanitizedInventory = Trainer.player.inventory.map(function (item, index) {
            if (item) {
                return item;
            }
            return {
                inventoryPosition: function () { return index; },
                isPlaceholder: true,
            };
        });
        var clickedItem = (0,lodash.first)((0,lodash.filter)(sanitizedInventory, function (inventoryItem, index) {
            if (!inventoryItem) {
                return;
            }
            var x2 = index % 4;
            var y2 = Math.floor(index / 4);
            var itemX = 20 + x2 * 43;
            var itemY = 17 + (y2 + 1) * 35;
            return Collision.collisionMath(x, y, 1, itemX * scale, itemY * scale, 32 * scale);
        }));
        var isPlaceholder = clickedItem && !!clickedItem.isPlaceholder;
        if (!isPlaceholder && clickedItem && this.clickedDownItem === clickedItem && !this.draggedItem) {
            // clicking an item
            if (clickedItem.hasInventoryLeftClick) {
                InputController.controller.queueAction(function () { return clickedItem.inventoryLeftClick(Trainer.player); });
                MapController.controller.updateOrbsMask(null, null);
            }
            else {
                clickedItem.selected = true;
            }
            this.clickedDownItem = null;
            this.cursorLocation = null;
            return;
        }
        if (!this.canDrag()) {
            this.clickedDownItem = null;
            this.cursorLocation = null;
            return;
        }
        if (!isPlaceholder && clickedItem) {
            var theItemWereReplacing = clickedItem;
            var theItemWereReplacingPosition_1 = clickedItem.inventoryPosition(Trainer.player);
            var thisPosition_1 = this.clickedDownItem.inventoryPosition(Trainer.player);
            // update the local cache immediately, but the real position updates upon server tick
            this.inventoryCache[theItemWereReplacingPosition_1] = this.clickedDownItem;
            this.inventoryCache[thisPosition_1] = theItemWereReplacing;
            InputController.controller.queueAction(function () {
                Trainer.player.swapItemPositions(theItemWereReplacingPosition_1, thisPosition_1);
            });
        }
        else if (clickedItem) {
            var thisPosition_2 = this.clickedDownItem.inventoryPosition(Trainer.player);
            var clickedPosition_1 = clickedItem.inventoryPosition(Trainer.player);
            this.inventoryCache[clickedPosition_1] = this.clickedDownItem;
            this.inventoryCache[thisPosition_2] = null;
            InputController.controller.queueAction(function () {
                Trainer.player.swapItemPositions(clickedPosition_1, thisPosition_2);
            });
        }
        this.clickedDownItem = null;
        this.cursorLocation = null;
    };
    InventoryControls.prototype.panelClickDown = function (x, y) {
        this.cursorLocation = { x: x, y: y };
        this.clickedDownLocation = { x: x, y: y };
        this.draggedItem = false;
        var scale = Settings.controlPanelScale;
        var clickedItem = (0,lodash.first)((0,lodash.filter)(this.inventoryCache, function (inventoryItem, index) {
            if (!inventoryItem) {
                return;
            }
            var x2 = index % 4;
            var y2 = Math.floor(index / 4);
            var itemX = 20 + x2 * 43;
            var itemY = 17 + (y2 + 1) * 35;
            return Collision.collisionMath(x, y, 1, itemX * scale, itemY * scale, 32 * scale);
        }));
        Trainer.player.inventory.forEach(function (inventoryItem) { return inventoryItem && (inventoryItem.selected = false); });
        if (clickedItem) {
            this.clickedDownItem = clickedItem;
            this.antiDragTimerAt = Date.now() + Settings.antiDrag * MS_PER_ANTI_DRAG;
        }
    };
    InventoryControls.prototype.canDrag = function () {
        return Date.now() >= this.antiDragTimerAt;
    };
    InventoryControls.prototype.draw = function (context, ctrl, x, y) {
        var _this = this;
        _super.prototype.draw.call(this, context, ctrl, x, y);
        var scale = Settings.controlPanelScale;
        this.inventoryCache.forEach(function (inventoryItem, index) {
            var x2 = index % 4;
            var y2 = Math.floor(index / 4);
            var itemX = x + (20 + x2 * 43) * scale;
            var itemY = y + (17 + y2 * 35) * scale;
            if (inventoryItem !== null) {
                context.fillStyle = "#ffffff22";
                // Viewport.viewport.context.fillRect(itemX, itemY, 32, 32)
                var sprite = inventoryItem.inventorySprite;
                var xOff = Math.floor((32 - sprite.width) / 2);
                var yOff = Math.floor((32 - sprite.height) / 2);
                if (inventoryItem === _this.clickedDownItem) {
                    context.globalAlpha = 0.4;
                    if (_this.draggedItem) {
                        context.drawImage(sprite, x + _this.cursorLocation.x - (sprite.width * scale) / 2, y + _this.cursorLocation.y - (sprite.height * scale) / 2, sprite.width * scale, sprite.height * scale);
                    }
                    else {
                        context.drawImage(sprite, itemX + xOff, itemY + yOff, sprite.width * scale, sprite.height * scale);
                    }
                    context.globalAlpha = 1;
                }
                else {
                    context.drawImage(sprite, itemX + xOff, itemY + yOff, sprite.width * scale, sprite.height * scale);
                }
                if (inventoryItem.selected) {
                    context.beginPath();
                    context.fillStyle = "#D1BB7773";
                    context.arc(itemX + 15 * scale, itemY + 17 * scale, 16 * scale, 0, 2 * Math.PI);
                    context.fill();
                }
            }
        });
    };
    return InventoryControls;
}(BaseControls));


;// CONCATENATED MODULE: ./src/assets/images/tabs/music.png
const music_namespaceObject = __webpack_require__.p + "025083410fbfe0d5d502.png";
;// CONCATENATED MODULE: ./src/sdk/controlpanels/MusicControls.ts
var MusicControls_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var MusicControls = /** @class */ (function (_super) {
    MusicControls_extends(MusicControls, _super);
    function MusicControls() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MusicControls.prototype, "panelImageReference", {
        get: function () {
            return inventory_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MusicControls.prototype, "tabImageReference", {
        get: function () {
            return music_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return MusicControls;
}(BaseControls));


;// CONCATENATED MODULE: ./src/assets/images/panels/prayer.png
const prayer_namespaceObject = __webpack_require__.p + "cd1f698745df0f346549.png";
;// CONCATENATED MODULE: ./src/assets/images/tabs/prayer.png
const tabs_prayer_namespaceObject = __webpack_require__.p + "58f1554e26e66ab79f02.png";
;// CONCATENATED MODULE: ./src/sdk/controlpanels/PrayerControls.ts
var PrayerControls_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var PrayerControls = /** @class */ (function (_super) {
    PrayerControls_extends(PrayerControls, _super);
    function PrayerControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasQuickPrayersActivated = false;
        return _this;
    }
    Object.defineProperty(PrayerControls.prototype, "panelImageReference", {
        get: function () {
            return prayer_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PrayerControls.prototype, "tabImageReference", {
        get: function () {
            return tabs_prayer_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PrayerControls.prototype, "keyBinding", {
        get: function () {
            return Settings.prayer_key;
        },
        enumerable: false,
        configurable: true
    });
    PrayerControls.prototype.deactivateAllPrayers = function () {
        this.hasQuickPrayersActivated = false;
        Trainer.player.prayerController.activePrayers().forEach(function (prayer) { return prayer.deactivate(); });
    };
    PrayerControls.prototype.activateQuickPrayers = function () {
        this.hasQuickPrayersActivated = true;
        Trainer.player.prayerController.prayers.forEach(function (prayer) {
            prayer.deactivate();
            if (prayer.name === "Protect from Magic") {
                prayer.activate(Trainer.player);
            }
            if (prayer.name === "Rigour") {
                prayer.activate(Trainer.player);
            }
        });
    };
    PrayerControls.prototype.panelClickDown = function (x, y) {
        var scale = Settings.controlPanelScale;
        x = x / scale;
        y = y / scale;
        var gridX = x - 14;
        var gridY = y - 22;
        var clickedPrayer = Trainer.player.prayerController.prayers[Math.floor(gridY / 35) * 5 + Math.floor(gridX / 35)];
        if (clickedPrayer && Trainer.player.currentStats.prayer > 0) {
            clickedPrayer.toggle(Trainer.player);
            if (this.hasQuickPrayersActivated && Trainer.player.prayerController.activePrayers().length === 0) {
                ControlPanelController.controls.PRAYER.hasQuickPrayersActivated = false;
            }
        }
    };
    Object.defineProperty(PrayerControls.prototype, "isAvailable", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    PrayerControls.prototype.draw = function (context, ctrl, x, y) {
        _super.prototype.draw.call(this, context, ctrl, x, y);
        var scale = Settings.controlPanelScale;
        Trainer.player.prayerController.prayers.forEach(function (prayer, index) {
            var x2 = index % 5;
            var y2 = Math.floor(index / 5);
            if (prayer.isActive || prayer.isLit) {
                context.beginPath();
                context.fillStyle = "#D1BB7773";
                context.arc(x + 10 * scale + (x2 + 0.5) * 36.8 * scale, y + (16 + (y2 + 0.5) * 37) * scale, 18 * scale, 0, 2 * Math.PI);
                context.fill();
            }
            if (Trainer.player.stats.prayer < prayer.levelRequirement()) {
                context.beginPath();
                context.fillStyle = "#00000073";
                context.arc(x + 10 * scale + (x2 + 0.5) * 36.8 * scale, y + (16 + (y2 + 0.5) * 37) * scale, 18 * scale, 0, 2 * Math.PI);
                context.fill();
            }
        });
    };
    return PrayerControls;
}(BaseControls));


;// CONCATENATED MODULE: ./src/assets/images/tabs/quests.png
const quests_namespaceObject = __webpack_require__.p + "bc106c524270af1a8fb0.png";
;// CONCATENATED MODULE: ./src/sdk/controlpanels/QuestsControls.ts
var QuestsControls_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var QuestsControls = /** @class */ (function (_super) {
    QuestsControls_extends(QuestsControls, _super);
    function QuestsControls() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(QuestsControls.prototype, "panelImageReference", {
        get: function () {
            return inventory_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestsControls.prototype, "tabImageReference", {
        get: function () {
            return quests_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return QuestsControls;
}(BaseControls));


;// CONCATENATED MODULE: ./src/assets/images/tabs/settings.png
const settings_namespaceObject = __webpack_require__.p + "4eddceb9b3276d1d9d05.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/sound_effect_volume.png
const sound_effect_volume_namespaceObject = __webpack_require__.p + "40937a29a5183bbcb15d.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/area_sound_volume.png
const area_sound_volume_namespaceObject = __webpack_require__.p + "6100d0aa77486ff1ddb1.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/disabled_option_overlay.png
const disabled_option_overlay_namespaceObject = __webpack_require__.p + "7babad158bacf9b7fa8c.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/button_red_up.png
const button_red_up_namespaceObject = __webpack_require__.p + "897905b6a68aab206528.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/button_green_down.png
const button_green_down_namespaceObject = __webpack_require__.p + "1e1e5bdc45303a02b71a.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/button_active.png
const button_active_namespaceObject = __webpack_require__.p + "87854f595bea4412f7db.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/button_inactive.png
const button_inactive_namespaceObject = __webpack_require__.p + "ca097d23e59046bc81d0.png";
;// CONCATENATED MODULE: ./src/assets/images/controlTabs/inventory.png
const controlTabs_inventory_namespaceObject = __webpack_require__.p + "2c56a14077c7c5d569ea.png";
;// CONCATENATED MODULE: ./src/assets/images/controlTabs/spellbook.png
const spellbook_namespaceObject = __webpack_require__.p + "b6bba618e2163708b0a2.png";
;// CONCATENATED MODULE: ./src/assets/images/controlTabs/prayer.png
const controlTabs_prayer_namespaceObject = __webpack_require__.p + "c5193e506916cfbfc1ed.png";
;// CONCATENATED MODULE: ./src/assets/images/controlTabs/equipment.png
const controlTabs_equipment_namespaceObject = __webpack_require__.p + "8c54f0224843596d75c4.png";
;// CONCATENATED MODULE: ./src/assets/images/controlTabs/style.png
const style_namespaceObject = __webpack_require__.p + "37366ee3c2ce9bc12b09.png";
;// CONCATENATED MODULE: ./src/sdk/utils/BrowserUtils.ts
var BrowserUtils = /** @class */ (function () {
    function BrowserUtils() {
    }
    BrowserUtils.getQueryVar = function (varName) {
        // Grab and unescape the query string - appending an '&' keeps the RegExp simple
        // for the sake of this example.
        var queryStr = unescape(window.location.search) + "&";
        // Dynamic replacement RegExp
        var regex = new RegExp(".*?[&\\?]" + varName + "=(.*?)&.*");
        // Apply RegExp to the query string
        var val = queryStr.replace(regex, "$1");
        // If the string is the same, we didn't find a match - return false
        return val === queryStr ? "" : val;
    };
    return BrowserUtils;
}());


;// CONCATENATED MODULE: ./src/sdk/ui/ToggleButton.ts



var ACTIVE_BUTTON_IMAGE = ImageLoader.createImage(button_active_namespaceObject);
var INACTIVE_BUTTON_IMAGE = ImageLoader.createImage(button_inactive_namespaceObject);
var ToggleButton = /** @class */ (function () {
    function ToggleButton(label, xOffset, yOffset, isActive, onClick, activeButtonImage, inactiveButtonImage, overlayInactive) {
        if (activeButtonImage === void 0) { activeButtonImage = ACTIVE_BUTTON_IMAGE; }
        if (inactiveButtonImage === void 0) { inactiveButtonImage = INACTIVE_BUTTON_IMAGE; }
        if (overlayInactive === void 0) { overlayInactive = false; }
        this.label = label;
        this.xOffset = xOffset;
        this.yOffset = yOffset;
        this.isActive = isActive;
        this.onClick = onClick;
        this.activeButtonImage = activeButtonImage;
        this.inactiveButtonImage = inactiveButtonImage;
        this.overlayInactive = overlayInactive;
    }
    ToggleButton.prototype.draw = function (context, scale, panelX, panelY) {
        var active = this.isActive();
        context.drawImage(active || this.overlayInactive ? this.activeButtonImage : this.inactiveButtonImage, panelX + this.xOffset * scale, panelY + this.yOffset * scale, this.activeButtonImage.width * scale, this.activeButtonImage.height * scale);
        if (this.overlayInactive && !active) {
            context.drawImage(this.inactiveButtonImage, panelX + this.xOffset * scale, panelY + this.yOffset * scale, this.inactiveButtonImage.width * scale, this.inactiveButtonImage.height * scale);
        }
        context.save();
        context.fillStyle = "#FFFF00";
        context.font = 16 * scale + "px OSRS";
        context.textBaseline = "middle";
        context.textAlign = "center";
        context.fillText(this.label, panelX + (this.xOffset + this.activeButtonImage.width / 2) * scale, panelY + (this.yOffset + ACTIVE_BUTTON_IMAGE.height / 2) * scale);
        context.restore();
    };
    ToggleButton.prototype.onPanelClick = function (x, y) {
        if (x >= this.xOffset &&
            x <= this.xOffset + this.activeButtonImage.width &&
            y >= this.yOffset &&
            y <= this.yOffset + this.activeButtonImage.height) {
            this.onClick();
            return true;
        }
        return false;
    };
    ToggleButton.prototype.onMouseMove = function (x, y) {
        return false;
    };
    return ToggleButton;
}());


;// CONCATENATED MODULE: ./src/sdk/ui/KeyBindingButton.ts



var KeyBindingButton_ACTIVE_BUTTON_IMAGE = ImageLoader.createImage(button_active_namespaceObject);
var KeyBindingButton_INACTIVE_BUTTON_IMAGE = ImageLoader.createImage(button_inactive_namespaceObject);
var KeyBindingButton = /** @class */ (function () {
    function KeyBindingButton(label, xOffset, yOffset, isActive, onClick, overlay) {
        this.label = label;
        this.xOffset = xOffset;
        this.yOffset = yOffset;
        this.isActive = isActive;
        this.onClick = onClick;
        this.overlay = overlay;
    }
    KeyBindingButton.prototype.draw = function (context, scale, panelX, panelY) {
        var active = this.isActive();
        context.drawImage(active ? KeyBindingButton_ACTIVE_BUTTON_IMAGE : KeyBindingButton_INACTIVE_BUTTON_IMAGE, panelX + this.xOffset * scale, panelY + this.yOffset * scale, KeyBindingButton_ACTIVE_BUTTON_IMAGE.width * scale, KeyBindingButton_ACTIVE_BUTTON_IMAGE.height * scale);
        context.drawImage(this.overlay, panelX + this.xOffset * scale + 3, panelY + this.yOffset * scale + 2, this.overlay.width * scale, this.overlay.height * scale);
        context.save();
        context.fillStyle = "#FFFF00";
        context.font = 16 * scale + "px OSRS";
        context.textBaseline = "middle";
        context.textAlign = "center";
        context.fillText(this.label(), panelX + (this.xOffset + 30) * scale, panelY + (this.yOffset + 30) * scale);
        context.restore();
    };
    KeyBindingButton.prototype.onPanelClick = function (x, y) {
        if (x >= this.xOffset &&
            x <= this.xOffset + KeyBindingButton_ACTIVE_BUTTON_IMAGE.width &&
            y >= this.yOffset &&
            y <= this.yOffset + KeyBindingButton_ACTIVE_BUTTON_IMAGE.height) {
            this.onClick();
            return true;
        }
        return false;
    };
    KeyBindingButton.prototype.onMouseMove = function (x, y) {
        return false;
    };
    return KeyBindingButton;
}());


;// CONCATENATED MODULE: ./src/sdk/controlpanels/SettingsControls.ts
var SettingsControls_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





















var SettingsControls = /** @class */ (function (_super) {
    SettingsControls_extends(SettingsControls, _super);
    function SettingsControls() {
        var _this = _super.call(this) || this;
        _this.soundImage = ImageLoader.createImage(sound_effect_volume_namespaceObject);
        _this.areaSoundImage = ImageLoader.createImage(area_sound_volume_namespaceObject);
        _this.disabledOverlay = ImageLoader.createImage(disabled_option_overlay_namespaceObject);
        _this.redUpImage = ImageLoader.createImage(button_red_up_namespaceObject);
        _this.greenDownImage = ImageLoader.createImage(button_green_down_namespaceObject);
        _this.activeButtonImage = ImageLoader.createImage(button_active_namespaceObject);
        _this.inactiveButtonImage = ImageLoader.createImage(button_inactive_namespaceObject);
        _this.inventoryImage = ImageLoader.createImage(controlTabs_inventory_namespaceObject);
        _this.spellbookImage = ImageLoader.createImage(spellbook_namespaceObject);
        _this.prayerImage = ImageLoader.createImage(controlTabs_prayer_namespaceObject);
        _this.equipmentImage = ImageLoader.createImage(controlTabs_equipment_namespaceObject);
        _this.combatImage = ImageLoader.createImage(style_namespaceObject);
        _this.components = [
            // Sound
            new ToggleButton("", 20, 20, function () { return Settings.playsAudio; }, function () { return (Settings.playsAudio = !Settings.playsAudio); }, _this.soundImage, _this.disabledOverlay, true),
            // Area Sound
            new ToggleButton("", 20, 60, function () { return Settings.playsAreaAudio; }, function () { return (Settings.playsAreaAudio = !Settings.playsAreaAudio); }, _this.areaSoundImage, _this.disabledOverlay, true),
            new ToggleButton("Metronome", 140, 20, function () { return Settings.metronome; }, function () { return (Settings.metronome = !Settings.metronome); }),
            // Key bindings
            new KeyBindingButton(function () { return Settings.inventory_key; }, 22, 170, function () { return _this.bindingKey === "inventory"; }, function () { return _this.startKeyBinding("inventory"); }, _this.inventoryImage),
            new KeyBindingButton(function () { return Settings.spellbook_key; }, 82, 170, function () { return _this.bindingKey === "spellbook"; }, function () { return _this.startKeyBinding("spellbook"); }, _this.spellbookImage),
            new KeyBindingButton(function () { return Settings.prayer_key; }, 142, 170, function () { return _this.bindingKey === "prayer"; }, function () { return _this.startKeyBinding("prayer"); }, _this.prayerImage),
            new KeyBindingButton(function () { return Settings.equipment_key; }, 22, 220, function () { return _this.bindingKey === "equipment"; }, function () { return _this.startKeyBinding("equipment"); }, _this.equipmentImage),
            new KeyBindingButton(function () { return Settings.combat_key; }, 82, 220, function () { return _this.bindingKey === "combat"; }, function () { return _this.startKeyBinding("combat"); }, _this.combatImage),
            // Menu   
            new ToggleButton("Menu", 142, 220, function () { return Settings.menuVisible; }, function () {
                Settings.menuVisible = !Settings.menuVisible;
                if (Settings.menuVisible) {
                    document.getElementById("right_panel").classList.remove("hidden");
                }
                else {
                    document.getElementById("right_panel").classList.add("hidden");
                }
                Viewport.viewport.calculateViewport();
            }),
        ];
        SettingsControls.instance = _this;
        _this.bindingKey = null;
        document.addEventListener("keydown", function (event) {
            var key = event.key;
            if (_this.bindingKey) {
                event.preventDefault();
                if (_this.bindingKey === "inventory") {
                    Settings.inventory_key = key;
                }
                else if (_this.bindingKey === "spellbook") {
                    Settings.spellbook_key = key;
                }
                else if (_this.bindingKey === "prayer") {
                    Settings.prayer_key = key;
                }
                else if (_this.bindingKey === "equipment") {
                    Settings.equipment_key = key;
                }
                else if (_this.bindingKey === "combat") {
                    Settings.combat_key = key;
                }
                _this.bindingKey = null;
                setTimeout(function () {
                    Settings.is_keybinding = false;
                }, 20);
                Settings.persistToStorage();
            }
        });
        return _this;
    }
    Object.defineProperty(SettingsControls.prototype, "panelImageReference", {
        get: function () {
            return inventory_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SettingsControls.prototype, "tabImageReference", {
        get: function () {
            return settings_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    SettingsControls.prototype.addComponent = function (component) {
        this.components.push(component);
    };
    Object.defineProperty(SettingsControls.prototype, "isAvailable", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SettingsControls.prototype, "appearsOnLeftInMobile", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    SettingsControls.prototype.startKeyBinding = function (key) {
        Settings.is_keybinding = true;
        this.bindingKey = key;
    };
    Object.defineProperty(SettingsControls.prototype, "keyBinding", {
        get: function () {
            return BrowserUtils.getQueryVar("settings_key");
        },
        enumerable: false,
        configurable: true
    });
    SettingsControls.prototype.panelClickDown = function (x, y) {
        var scale = Settings.controlPanelScale;
        x = x / scale;
        y = y / scale;
        if (x > 74 && x < 89 && y > 20 && y < 36) {
            Settings.maxUiScale += 0.05;
        }
        else if (x > 75 && x < 89 && y > 51 && y < 67) {
            Settings.maxUiScale -= 0.05;
        }
        else if (x > 100 && x < 115 && y > 20 && y < 36) {
            Settings.inputDelay += 20;
        }
        else if (x > 100 && x < 115 && y > 51 && y < 67) {
            Settings.inputDelay -= 20;
        }
        else {
            this.components.forEach(function (component) {
                component.onPanelClick(x, y);
            });
        }
        Settings.inputDelay = Math.max(0, Settings.inputDelay);
        Settings.maxUiScale = Math.max(0.5, Math.min(2.0, Settings.maxUiScale));
        Settings.persistToStorage();
    };
    SettingsControls.prototype.draw = function (context, ctrl, x, y) {
        _super.prototype.draw.call(this, context, ctrl, x, y);
        var scale = Settings.controlPanelScale;
        context.drawImage(this.redUpImage, x + 74 * scale, y + 20 * scale, this.redUpImage.width * scale, this.redUpImage.height * scale);
        context.fillStyle = "#FFFF00";
        context.font = 16 * scale + "px OSRS";
        context.textAlign = "center";
        context.fillText(String(Math.round((Settings.maxUiScale - 1.0) * 100)) + "%", x + 79 * scale, y + 48 * scale);
        context.drawImage(this.greenDownImage, x + 74 * scale, y + 51 * scale, this.greenDownImage.width * scale, this.greenDownImage.height * scale);
        context.fillText("UI", x + 80 * scale, y + 81 * scale);
        context.drawImage(this.redUpImage, x + 100 * scale, y + 20 * scale, this.redUpImage.width * scale, this.redUpImage.height * scale);
        context.fillStyle = "#FFFF00";
        context.font = 16 * scale + "px OSRS";
        context.textAlign = "center";
        context.fillText(String(Settings.inputDelay), x + 106 * scale, y + 48 * scale);
        context.drawImage(this.greenDownImage, x + 100 * scale, y + 51 * scale, this.greenDownImage.width * scale, this.greenDownImage.height * scale);
        context.fillText("Ping", x + 107 * scale, y + 81 * scale);
        if (this.bindingKey === null) {
            context.fillText("Key Bindings", x + 100 * scale, y + (133 + 30) * scale);
        }
        else {
            context.fillText("Press Key To Bind", x + 100 * scale, y + (133 + 30) * scale);
        }
        this.components.forEach(function (component) {
            component.draw(context, scale, x, y);
        });
    };
    SettingsControls.instance = null;
    return SettingsControls;
}(BaseControls));


;// CONCATENATED MODULE: ./src/assets/images/panels/stats.png
const stats_namespaceObject = __webpack_require__.p + "9e44221bcc08b6b42e12.png";
;// CONCATENATED MODULE: ./src/assets/images/tabs/stats.png
const tabs_stats_namespaceObject = __webpack_require__.p + "b1a7dadcea3162ff59f3.png";
;// CONCATENATED MODULE: ./src/sdk/controlpanels/StatsControls.ts
var StatsControls_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var StatsControls = /** @class */ (function (_super) {
    StatsControls_extends(StatsControls, _super);
    function StatsControls() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(StatsControls.prototype, "panelImageReference", {
        get: function () {
            return stats_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StatsControls.prototype, "tabImageReference", {
        get: function () {
            return tabs_stats_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StatsControls.prototype, "isAvailable", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    StatsControls.prototype.levelPrompt = function (skill) {
        var newLvl = parseInt(prompt("What level would you like to set your " + skill + "?", "99"));
        if (isNaN(newLvl)) {
            return -1;
        }
        if (newLvl > 0 && newLvl < 100) {
            return newLvl;
        }
        return -1;
    };
    StatsControls.prototype.panelClickUp = function (x, y) {
        var scale = Settings.controlPanelScale;
        x = x / scale;
        y = y / scale;
        if (x > 9 && x < 73) {
            if (y > 12 && y < 44) {
                var newLvl = this.levelPrompt("attack");
                if (newLvl > 0) {
                    Trainer.player.stats.attack = newLvl;
                    Trainer.player.currentStats.attack = newLvl;
                    Settings.player_stats = Trainer.player.stats;
                    Settings.persistToStorage();
                }
            }
            else if (y > 44 && y < 76) {
                // str
                var newLvl = this.levelPrompt("strength");
                if (newLvl > 0) {
                    Trainer.player.stats.strength = newLvl;
                    Trainer.player.currentStats.strength = newLvl;
                    Settings.player_stats = Trainer.player.stats;
                    Settings.persistToStorage();
                }
            }
            else if (y > 76 && y < 108) {
                // def
                var newLvl = this.levelPrompt("defence");
                if (newLvl > 0) {
                    Trainer.player.stats.defence = newLvl;
                    Trainer.player.currentStats.defence = newLvl;
                    Settings.player_stats = Trainer.player.stats;
                    Settings.persistToStorage();
                }
            }
            else if (y > 108 && y < 140) {
                // ranged
                var newLvl = this.levelPrompt("range");
                if (newLvl > 0) {
                    Trainer.player.stats.range = newLvl;
                    Trainer.player.currentStats.range = newLvl;
                    Settings.player_stats = Trainer.player.stats;
                    Settings.persistToStorage();
                }
            }
            else if (y > 140 && y < 172) {
                //prayer
                var newLvl = this.levelPrompt("prayer");
                if (newLvl > 0) {
                    Trainer.player.stats.prayer = newLvl;
                    Trainer.player.currentStats.prayer = newLvl;
                    Settings.player_stats = Trainer.player.stats;
                    Settings.persistToStorage();
                }
            }
            else if (y > 172 && y < 204) {
                //magic
                var newLvl = this.levelPrompt("magic");
                if (newLvl > 0) {
                    Trainer.player.stats.magic = newLvl;
                    Trainer.player.currentStats.magic = newLvl;
                    Settings.player_stats = Trainer.player.stats;
                    Settings.persistToStorage();
                }
            }
        }
        else if (x > 74 && x < 138) {
            if (y > 12 && y < 44) {
                // hp
                var newLvl = this.levelPrompt("hitpoint");
                if (newLvl > 0) {
                    Trainer.player.stats.hitpoint = newLvl;
                    Trainer.player.currentStats.hitpoint = newLvl;
                    Settings.player_stats = Trainer.player.stats;
                    Settings.persistToStorage();
                }
            }
            else if (y > 44 && y < 76) {
                // agility
                var newLvl = this.levelPrompt("agility");
                if (newLvl > 0) {
                    Trainer.player.stats.agility = newLvl;
                    Trainer.player.currentStats.agility = newLvl;
                    Settings.player_stats = Trainer.player.stats;
                    Settings.persistToStorage();
                }
            }
        }
    };
    Object.defineProperty(StatsControls.prototype, "appearsOnLeftInMobile", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    StatsControls.prototype.draw = function (context, ctrl, x, y) {
        _super.prototype.draw.call(this, context, ctrl, x, y);
        var scale = Settings.controlPanelScale;
        context.font = 16 * scale + "px Stats_11";
        context.fillStyle = "#000";
        context.fillText(String(Trainer.player.currentStats.attack), x + 49 * scale, y + 22 * scale);
        context.fillStyle = "#FFFF00";
        context.fillText(String(Trainer.player.currentStats.attack), x + 48 * scale, y + 21 * scale);
        context.fillStyle = "#000";
        context.fillText(String(Trainer.player.stats.attack), x + 61 * scale, y + 36 * scale);
        context.fillStyle = "#FFFF00";
        context.fillText(String(Trainer.player.stats.attack), x + 60 * scale, y + 35 * scale);
        context.fillStyle = "#000";
        context.fillText(String(Trainer.player.currentStats.strength), x + 49 * scale, y + (22 + 32) * scale);
        context.fillStyle = "#FFFF00";
        context.fillText(String(Trainer.player.currentStats.strength), x + 48 * scale, y + (21 + 32) * scale);
        context.fillStyle = "#000";
        context.fillText(String(Trainer.player.stats.strength), x + 61 * scale, y + (36 + 32) * scale);
        context.fillStyle = "#FFFF00";
        context.fillText(String(Trainer.player.stats.strength), x + 60 * scale, y + (35 + 32) * scale);
        context.fillStyle = "#000";
        context.fillText(String(Trainer.player.currentStats.defence), x + 49 * scale, y + (22 + 64) * scale);
        context.fillStyle = "#FFFF00";
        context.fillText(String(Trainer.player.currentStats.defence), x + 48 * scale, y + (21 + 64) * scale);
        context.fillStyle = "#000";
        context.fillText(String(Trainer.player.stats.defence), x + 61 * scale, y + (36 + 64) * scale);
        context.fillStyle = "#FFFF00";
        context.fillText(String(Trainer.player.stats.defence), x + 60 * scale, y + (35 + 64) * scale);
        context.fillStyle = "#000";
        context.fillText(String(Trainer.player.currentStats.range), x + 49 * scale, y + (22 + 96) * scale);
        context.fillStyle = "#FFFF00";
        context.fillText(String(Trainer.player.currentStats.range), x + 48 * scale, y + (21 + 96) * scale);
        context.fillStyle = "#000";
        context.fillText(String(Trainer.player.stats.range), x + 61 * scale, y + (36 + 96) * scale);
        context.fillStyle = "#FFFF00";
        context.fillText(String(Trainer.player.stats.range), x + 60 * scale, y + (35 + 96) * scale);
        context.fillStyle = "#000";
        context.fillText(String(Trainer.player.currentStats.prayer), x + 49 * scale, y + (22 + 128) * scale);
        context.fillStyle = "#FFFF00";
        context.fillText(String(Trainer.player.currentStats.prayer), x + 48 * scale, y + (21 + 128) * scale);
        context.fillStyle = "#000";
        context.fillText(String(Trainer.player.stats.prayer), x + 61 * scale, y + (36 + 128) * scale);
        context.fillStyle = "#FFFF00";
        context.fillText(String(Trainer.player.stats.prayer), x + 60 * scale, y + (35 + 128) * scale);
        context.fillStyle = "#000";
        context.fillText(String(Trainer.player.currentStats.magic), x + 49 * scale, y + (22 + 160) * scale);
        context.fillStyle = "#FFFF00";
        context.fillText(String(Trainer.player.currentStats.magic), x + 48 * scale, y + (21 + 160) * scale);
        context.fillStyle = "#000";
        context.fillText(String(Trainer.player.stats.magic), x + 61 * scale, y + (36 + 160) * scale);
        context.fillStyle = "#FFFF00";
        context.fillText(String(Trainer.player.stats.magic), x + 60 * scale, y + (35 + 160) * scale);
        context.fillStyle = "#000";
        context.fillText(String(Trainer.player.currentStats.hitpoint), x + (49 + 63) * scale, y + 22 * scale);
        context.fillStyle = "#FFFF00";
        context.fillText(String(Trainer.player.currentStats.hitpoint), x + (48 + 63) * scale, y + 21 * scale);
        context.fillStyle = "#000";
        context.fillText(String(Trainer.player.stats.hitpoint), x + (61 + 63) * scale, y + 36 * scale);
        context.fillStyle = "#FFFF00";
        context.fillText(String(Trainer.player.stats.hitpoint), x + (60 + 63) * scale, y + 35 * scale);
        context.fillStyle = "#000";
        context.fillText(String(Trainer.player.currentStats.agility), x + (49 + 63) * scale, y + (22 + 32) * scale);
        context.fillStyle = "#FFFF00";
        context.fillText(String(Trainer.player.currentStats.agility), x + (48 + 63) * scale, y + (21 + 32) * scale);
        context.fillStyle = "#000";
        context.fillText(String(Trainer.player.stats.agility), x + (61 + 63) * scale, y + (36 + 32) * scale);
        context.fillStyle = "#FFFF00";
        context.fillText(String(Trainer.player.stats.agility), x + (60 + 63) * scale, y + (35 + 32) * scale);
    };
    return StatsControls;
}(BaseControls));


;// CONCATENATED MODULE: ./src/sdk/ControlPanelController.ts



















var BASE_WIDTH = 33 * 7;
var BASE_HEIGHT = 36 * 2 + 275;
var ControlPanelController = /** @class */ (function () {
    function ControlPanelController() {
        var _this = this;
        this.boostPanel = new BoostPanel();
        this.isUsingExternalUI = false;
        this.width = BASE_WIDTH;
        this.height = BASE_HEIGHT;
        this.desktopControls = [
            ControlPanelController.controls.COMBAT,
            ControlPanelController.controls.STATS,
            new QuestsControls(),
            ControlPanelController.controls.INVENTORY,
            ControlPanelController.controls.EQUIPMENT,
            ControlPanelController.controls.PRAYER,
            ControlPanelController.controls.ANCIENTSSPELLBOOK,
            new EmptyControls(),
            new FriendsControls(),
            new AccountControls(),
            new ClanChatControls(),
            ControlPanelController.controls.SETTINGS,
            new EmotesControls(),
            new MusicControls(),
        ];
        this.mobileControls = [
            ControlPanelController.controls.COMBAT,
            ControlPanelController.controls.PRAYER,
            ControlPanelController.controls.ANCIENTSSPELLBOOK,
            new EmotesControls(),
            new ClanChatControls(),
            new FriendsControls(),
            new AccountControls(),
            // break
            ControlPanelController.controls.INVENTORY,
            ControlPanelController.controls.EQUIPMENT,
            ControlPanelController.controls.STATS,
            new QuestsControls(),
            new MusicControls(),
            ControlPanelController.controls.SETTINGS,
            new EmptyControls(),
        ];
        this.controls = Settings.mobileCheck() ? this.mobileControls : this.desktopControls;
        this.selectedControl = ControlPanelController.controls.PRAYER;
        document.addEventListener("keydown", function (event) {
            if (Settings.is_keybinding) {
                return;
            }
            if (_this.isUsingExternalUI) {
                return;
            }
            _this.controls.forEach(function (control) {
                if (control.keyBinding === event.key) {
                    _this.selectedControl = control;
                    event.preventDefault();
                }
            });
        });
    }
    ControlPanelController.prototype.getTabScale = function () {
        var _a = Chrome.size(), width = _a.width, height = _a.height;
        var controlAreaHeight = height - MapController.controller.height;
        var scaleRatio = controlAreaHeight / 7 / 36;
        var maxScaleRatio = Settings.maxUiScale;
        if (Settings.mobileCheck() && width > 600) {
            maxScaleRatio = Settings.maxUiScale * 1.1;
        }
        if (scaleRatio > maxScaleRatio) {
            scaleRatio = maxScaleRatio;
        }
        // not the best place for these setters...
        Settings.controlPanelScale = scaleRatio * 0.915;
        this.width = BASE_WIDTH * scaleRatio;
        this.height = BASE_HEIGHT * scaleRatio;
        return scaleRatio;
    };
    ControlPanelController.prototype.boostPosition = function () {
        var _a = Chrome.size(), width = _a.width, height = _a.height;
        var scale = this.getTabScale();
        if (Settings.mobileCheck()) {
            var mapHeight = 170 * Settings.minimapScale;
            var spacer = (height - mapHeight - 36 * scale * 7) / 2;
            return { x: 15, y: mapHeight + spacer };
        }
        else {
            return {
                x: width - 231 * scale - (Settings.menuVisible ? 232 : 0) + 28,
                y: height - 72 * scale,
            };
        }
    };
    ControlPanelController.prototype.tabPosition = function (i) {
        // let scale = Settings.controlPanelScale
        var _a = Chrome.size(), width = _a.width, height = _a.height;
        var scale = this.getTabScale();
        if (Settings.mobileCheck()) {
            var mapHeight = 170 * Settings.minimapScale;
            var spacer = (height - mapHeight - 36 * scale * 7) / 2;
            if (i < 7) {
                return { x: 15, y: mapHeight + spacer + i * 36 * scale };
            }
            else {
                return {
                    x: width - 33 * scale - 15 - (Settings.menuVisible ? 232 : 0),
                    y: mapHeight + spacer + (i - 7) * 36 * scale,
                };
            }
        }
        else {
            var x = i % 7;
            var y = Math.floor(i / 7);
            return {
                x: width - 231 * scale + x * 33 * scale - (Settings.menuVisible ? 232 : 0),
                y: height - 72 * scale + y * 36 * scale,
            };
        }
    };
    ControlPanelController.prototype.cursorMovedTo = function (e) {
        var scale = Settings.controlPanelScale;
        if (this.selectedControl) {
            var x = e.offsetX;
            var y = e.offsetY;
            var panelWidth = 204 * scale;
            var panelHeight = 275 * scale;
            var panelPosition = this.controlPosition(this.selectedControl);
            var panelX = panelPosition.x;
            var panelY = panelPosition.y;
            if (panelX < x && x < panelX + panelWidth) {
                if (panelY < y && y < panelY + panelHeight) {
                    var relativeX = x - panelX;
                    var relativeY = y - panelY;
                    this.selectedControl.cursorMovedto(relativeX, relativeY);
                }
            }
        }
    };
    ControlPanelController.prototype.controlPanelRightClick = function (e) {
        var intercepted = false;
        var scale = Settings.controlPanelScale;
        var x = e.offsetX;
        var y = e.offsetY;
        var panelWidth = 204 * scale;
        var panelHeight = 275 * scale;
        var panelPosition = this.controlPosition(this.selectedControl);
        var panelX = panelPosition.x;
        var panelY = panelPosition.y;
        if (panelX < x && x < panelX + panelWidth) {
            if (panelY < y && y < panelY + panelHeight) {
                var relativeX = x - panelX;
                var relativeY = y - panelY;
                intercepted = true;
                this.selectedControl.panelRightClick(relativeX, relativeY);
            }
        }
        return intercepted;
    };
    ControlPanelController.prototype.controlPanelClickUp = function (e) {
        var scale = Settings.controlPanelScale;
        if (!this.selectedControl) {
            return false;
        }
        var intercepted = false;
        var x = e.offsetX;
        var y = e.offsetY;
        var panelWidth = 204 * scale;
        var panelHeight = 275 * scale;
        var panelPosition = this.controlPosition(this.selectedControl);
        var panelX = panelPosition.x;
        var panelY = panelPosition.y;
        if (panelX < x && x < panelX + panelWidth) {
            if (panelY < y && y < panelY + panelHeight) {
                var relativeX = x - panelX;
                var relativeY = y - panelY;
                intercepted = true;
                this.selectedControl.panelClickUp(relativeX, relativeY);
            }
        }
        this.selectedControl.onMouseUp();
        return intercepted;
    };
    ControlPanelController.prototype.setActiveControl = function (index) {
        this.selectedControl = ControlPanelController.controls[index];
    };
    ControlPanelController.prototype.controlPanelClickDown = function (e) {
        var _this = this;
        var intercepted = false;
        var scale = Settings.controlPanelScale;
        var x = e.offsetX;
        var y = e.offsetY;
        this.controls.forEach(function (control, index) {
            var tabPosition = _this.tabPosition(index);
            if (tabPosition.x <= x && x < tabPosition.x + 33 * scale) {
                if (tabPosition.y <= y && y < tabPosition.y + 36 * scale) {
                    intercepted = true;
                    if (_this.controls[index] === _this.selectedControl) {
                        _this.selectedControl = null;
                        return;
                    }
                    _this.selectedControl = _this.controls[index];
                }
            }
        });
        if (!this.selectedControl) {
            return intercepted;
        }
        var panelWidth = 204 * scale;
        var panelHeight = 275 * scale;
        var panelPosition = this.controlPosition(this.selectedControl);
        var panelX = panelPosition.x;
        var panelY = panelPosition.y;
        if (panelX < x && x < panelX + panelWidth) {
            if (panelY < y && y < panelY + panelHeight) {
                var relativeX = x - panelX;
                var relativeY = y - panelY;
                intercepted = true;
                this.selectedControl.panelClickDown(relativeX, relativeY);
            }
        }
        return intercepted;
    };
    ControlPanelController.prototype.controlPosition = function (control) {
        var scale = this.getTabScale();
        var _a = Chrome.size(), width = _a.width, height = _a.height;
        if (Settings.mobileCheck()) {
            var mapHeight = 170 * Settings.minimapScale;
            var spacer = (height - mapHeight - 36 * scale * 7) / 2;
            if (this.selectedControl.appearsOnLeftInMobile) {
                // left side mobile
                return { x: 33 * scale + 15, y: mapHeight + spacer };
            }
            else {
                // right side mobile
                return {
                    x: width - 33 * scale - 15 - 200 * Settings.controlPanelScale - (Settings.menuVisible ? 232 : 0),
                    y: mapHeight + spacer,
                };
            }
        }
        else {
            // desktop compact
            return {
                x: width - 188 * scale - (Settings.menuVisible ? 232 : 0),
                y: height - 72 * scale - 251 * scale,
            };
        }
    };
    ControlPanelController.prototype.onWorldTick = function () {
        this.controls.forEach(function (control) {
            control.onWorldTick();
        });
    };
    ControlPanelController.prototype.draw = function (context) {
        var _this = this;
        context.fillStyle = "#000";
        var scale = this.getTabScale();
        if (this.selectedControl && this.selectedControl.draw) {
            var position = this.controlPosition(this.selectedControl);
            this.selectedControl.draw(context, this, position.x, position.y);
        }
        // TODO: make this rendering configurable
        var boostPosition = this.boostPosition();
        this.boostPanel.draw(context, scale, boostPosition.x, boostPosition.y);
        var selectedPosition = null;
        this.controls.forEach(function (control, index) {
            var tabPosition = _this.tabPosition(index);
            if (control.tabImage) {
                context.drawImage(control.tabImage, tabPosition.x, tabPosition.y, control.tabImage.width * scale, control.tabImage.height * scale);
            }
            if (control.isAvailable === false) {
                context.fillStyle = "#00000099";
                context.fillRect(tabPosition.x, tabPosition.y, 33 * scale, 36 * scale);
            }
            if (control === _this.selectedControl) {
                selectedPosition = tabPosition;
            }
        });
        if (selectedPosition) {
            context.strokeStyle = "#00FF0073";
            context.lineWidth = 3;
            context.strokeRect(selectedPosition.x, selectedPosition.y, 33 * scale, 36 * scale);
        }
    };
    ControlPanelController.controls = Object.freeze({
        COMBAT: new CombatControls(),
        INVENTORY: new InventoryControls(),
        PRAYER: new PrayerControls(),
        EQUIPMENT: new EquipmentControls(),
        STATS: new StatsControls(),
        ANCIENTSSPELLBOOK: new AncientsSpellbookControls(),
        SETTINGS: new SettingsControls(),
    });
    ControlPanelController.controller = new ControlPanelController();
    return ControlPanelController;
}());


;// CONCATENATED MODULE: ./src/sdk/rendering/EmptyModel.ts
var EmptyModel_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var EmptyModel_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

var EmptyModel = /** @class */ (function () {
    function EmptyModel() {
    }
    EmptyModel.forRenderable = function (r) {
        return new EmptyModel();
    };
    EmptyModel.prototype.draw = function (scene, clockDelta, tickPercent, location) {
        // do nothing
    };
    EmptyModel.prototype.destroy = function (scene) {
        // do nothing
    };
    EmptyModel.prototype.getWorldPosition = function () {
        return new external_three_.Vector3(0, 0, 0);
    };
    EmptyModel.prototype.preload = function () {
        return EmptyModel_awaiter(this, void 0, void 0, function () {
            return EmptyModel_generator(this, function (_a) {
                // do nothing
                return [2 /*return*/];
            });
        });
    };
    return EmptyModel;
}());


;// CONCATENATED MODULE: ./src/content/MovementBlocker.ts

var MovementBlocker_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var InvisibleMovementBlocker = /** @class */ (function (_super) {
    MovementBlocker_extends(InvisibleMovementBlocker, _super);
    function InvisibleMovementBlocker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(InvisibleMovementBlocker.prototype, "lineOfSight", {
        get: function () {
            return LineOfSightMask.NONE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InvisibleMovementBlocker.prototype, "collisionType", {
        get: function () {
            return CollisionType.BLOCK_MOVEMENT;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InvisibleMovementBlocker.prototype, "size", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    InvisibleMovementBlocker.prototype.draw = function () {
        // force empty draw
    };
    InvisibleMovementBlocker.prototype.create3dModel = function () {
        return new EmptyModel();
    };
    return InvisibleMovementBlocker;
}(Entity));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Ahrims_robeskirt.png
const Ahrims_robeskirt_namespaceObject = __webpack_require__.p + "2cc60d9e1e0b8de9345f.png";
;// CONCATENATED MODULE: ./src/sdk/gear/Legs.ts
var Legs_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Legs = /** @class */ (function (_super) {
    Legs_extends(Legs, _super);
    function Legs() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Legs.prototype, "type", {
        get: function () {
            return EquipmentTypes.LEGS;
        },
        enumerable: false,
        configurable: true
    });
    Legs.prototype.assignToPlayer = function (player) {
        player.equipment.legs = this;
    };
    Legs.prototype.unassignToPlayer = function (player) {
        player.equipment.legs = null;
    };
    Legs.prototype.currentEquipment = function (player) {
        return player.equipment.legs;
    };
    return Legs;
}(Equipment));


;// CONCATENATED MODULE: ./src/content/equipment/AhrimsRobeskirt.ts
var AhrimsRobeskirt_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var AhrimsRobeskirt = /** @class */ (function (_super) {
    AhrimsRobeskirt_extends(AhrimsRobeskirt, _super);
    function AhrimsRobeskirt() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 22,
                range: -7,
            },
            defence: {
                stab: 33,
                slash: 30,
                crush: 36,
                magic: 22,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(AhrimsRobeskirt.prototype, "inventoryImage", {
        get: function () {
            return Ahrims_robeskirt_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AhrimsRobeskirt.prototype, "itemName", {
        get: function () {
            return ItemName.AHRIMS_ROBESKIRT;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AhrimsRobeskirt.prototype, "weight", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    return AhrimsRobeskirt;
}(Legs));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Ahrims_robetop.png
const Ahrims_robetop_namespaceObject = __webpack_require__.p + "a59308eae87975037074.png";
;// CONCATENATED MODULE: ./src/sdk/gear/Chest.ts
var Chest_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Chest = /** @class */ (function (_super) {
    Chest_extends(Chest, _super);
    function Chest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Chest.prototype, "type", {
        get: function () {
            return EquipmentTypes.CHEST;
        },
        enumerable: false,
        configurable: true
    });
    Chest.prototype.assignToPlayer = function (player) {
        player.equipment.chest = this;
    };
    Chest.prototype.unassignToPlayer = function (player) {
        player.equipment.chest = null;
    };
    Chest.prototype.currentEquipment = function (player) {
        return player.equipment.chest;
    };
    return Chest;
}(Equipment));


;// CONCATENATED MODULE: ./src/content/equipment/AhrimsRobetop.ts
var AhrimsRobetop_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var AhrimsRobetop = /** @class */ (function (_super) {
    AhrimsRobetop_extends(AhrimsRobetop, _super);
    function AhrimsRobetop() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: +22,
                range: -7,
            },
            defence: {
                stab: 33,
                slash: 30,
                crush: 36,
                magic: 22,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(AhrimsRobetop.prototype, "inventoryImage", {
        get: function () {
            return Ahrims_robetop_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AhrimsRobetop.prototype, "itemName", {
        get: function () {
            return ItemName.AHRIMS_ROBETOP;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AhrimsRobetop.prototype, "weight", {
        get: function () {
            return 4.535;
        },
        enumerable: false,
        configurable: true
    });
    return AhrimsRobetop;
}(Chest));


;// CONCATENATED MODULE: ./src/sdk/gear/Necklace.ts
var Necklace_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Necklace = /** @class */ (function (_super) {
    Necklace_extends(Necklace, _super);
    function Necklace() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Necklace.prototype, "type", {
        get: function () {
            return EquipmentTypes.NECK;
        },
        enumerable: false,
        configurable: true
    });
    Necklace.prototype.assignToPlayer = function (player) {
        player.equipment.necklace = this;
    };
    Necklace.prototype.unassignToPlayer = function (player) {
        player.equipment.necklace = null;
    };
    Necklace.prototype.currentEquipment = function (player) {
        return player.equipment.necklace;
    };
    return Necklace;
}(Equipment));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Amulet_of_torture.png
const Amulet_of_torture_namespaceObject = __webpack_require__.p + "6d26b6d46c50ae336d08.png";
;// CONCATENATED MODULE: ./src/sdk/utils/Assets.ts
var Assets_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var Assets_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var Assets = /** @class */ (function () {
    function Assets() {
    }
    /**
     * Returns the appropriate URL for an asset and also schedules it for preloading.
     */
    Assets.getAssetUrl = function (asset) {
        var _this = this;
        // TODO switch CDN based on build variable 
        var url = "https://assets-soltrainer.netlify.app/".concat(asset);
        //const url = `https://oldschool-cdn.com/${asset}`;
        if (Assets.loadedAssets[url]) {
            return url;
        }
        Assets.loadingAssetUrls.push(url);
        Assets.assetCount++;
        Promise.resolve().then(function () { return Assets_awaiter(_this, void 0, void 0, function () {
            var response, bytes;
            var _this = this;
            return Assets_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.debug("Preloading asset: ".concat(url));
                        return [4 /*yield*/, fetch(url)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.arrayBuffer()];
                    case 2:
                        bytes = _a.sent();
                        console.debug("Preloaded asset: ".concat(url, ", ").concat(response.statusText, ": ").concat(bytes.byteLength));
                        Assets.onProgressFns.forEach(function (onProgressFns) {
                            return onProgressFns(_this.assetCount - _this.loadingAssetUrls.length, _this.assetCount);
                        });
                        Assets.loadingAssetUrls = this.loadingAssetUrls.filter(function (u) { return u !== url; });
                        Assets.loadedAssets[url] = true;
                        return [2 /*return*/];
                }
            });
        }); });
        return url;
    };
    Assets.onAssetProgress = function (progressFn) {
        Assets.onProgressFns.push(progressFn);
    };
    Assets.onAllAssetsLoaded = function (loadFn) {
        Assets.onLoadFns.push(loadFn);
    };
    Assets.checkAssetsLoaded = function (timer) {
        if (Assets.loadingAssetUrls.length === 0) {
            Assets.onLoadFns.forEach(function (onLoadFunction) { return onLoadFunction(); });
            clearInterval(timer);
        }
    };
    Assets.assetCount = 0;
    Assets.loadingAssetUrls = [];
    Assets.onProgressFns = [];
    Assets.onLoadFns = [];
    Assets.loadedAssets = {};
    return Assets;
}());


;// CONCATENATED MODULE: ./src/content/equipment/AmuletOfTorture.ts
var AmuletOfTorture_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var AmuletOfTorture = /** @class */ (function (_super) {
    AmuletOfTorture_extends(AmuletOfTorture, _super);
    function AmuletOfTorture() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.Model = Assets.getAssetUrl("models/player_amulet_of_torture__or_.glb");
        _this.bonuses = {
            attack: {
                stab: 15,
                slash: 15,
                crush: 15,
                magic: 0,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 10,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 2,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(AmuletOfTorture.prototype, "inventoryImage", {
        get: function () {
            return Amulet_of_torture_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AmuletOfTorture.prototype, "itemName", {
        get: function () {
            return ItemName.AMULET_OF_TORTURE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AmuletOfTorture.prototype, "weight", {
        get: function () {
            return 0.005;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AmuletOfTorture.prototype, "model", {
        get: function () {
            return this.Model;
        },
        enumerable: false,
        configurable: true
    });
    return AmuletOfTorture;
}(Necklace));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Ancestral_robe_bottom.png
const Ancestral_robe_bottom_namespaceObject = __webpack_require__.p + "71516c473c20a432a5d5.png";
;// CONCATENATED MODULE: ./src/content/equipment/AncestralRobebottom.ts
var AncestralRobebottom_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var AncestralRobebottom = /** @class */ (function (_super) {
    AncestralRobebottom_extends(AncestralRobebottom, _super);
    function AncestralRobebottom() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.Model = Assets.getAssetUrl("models/player_ancestral_robe_bottom.glb");
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 26,
                range: -7,
            },
            defence: {
                stab: 27,
                slash: 24,
                crush: 30,
                magic: 20,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0.02,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(AncestralRobebottom.prototype, "inventoryImage", {
        get: function () {
            return Ancestral_robe_bottom_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AncestralRobebottom.prototype, "itemName", {
        get: function () {
            return ItemName.ANCESTRAL_ROBEBOTTOM;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AncestralRobebottom.prototype, "weight", {
        get: function () {
            return 1.814;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AncestralRobebottom.prototype, "model", {
        get: function () {
            return this.Model;
        },
        enumerable: false,
        configurable: true
    });
    return AncestralRobebottom;
}(Legs));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Ancestral_robe_top.png
const Ancestral_robe_top_namespaceObject = __webpack_require__.p + "cac83f53c6d604ae3a44.png";
;// CONCATENATED MODULE: ./src/content/equipment/AncestralRobetop.ts
var AncestralRobetop_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var AncestralRobetop = /** @class */ (function (_super) {
    AncestralRobetop_extends(AncestralRobetop, _super);
    function AncestralRobetop() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.Model = Assets.getAssetUrl("models/player_ancestral_robe_top.glb");
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 35,
                range: -8,
            },
            defence: {
                stab: 42,
                slash: 31,
                crush: 51,
                magic: 28,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0.02,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(AncestralRobetop.prototype, "inventoryImage", {
        get: function () {
            return Ancestral_robe_top_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AncestralRobetop.prototype, "itemName", {
        get: function () {
            return ItemName.ANCESTRAL_ROBETOP;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AncestralRobetop.prototype, "weight", {
        get: function () {
            return 2.721;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AncestralRobetop.prototype, "model", {
        get: function () {
            return this.Model;
        },
        enumerable: false,
        configurable: true
    });
    return AncestralRobetop;
}(Chest));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Armadyl_chainskirt.png
const Armadyl_chainskirt_namespaceObject = __webpack_require__.p + "2b0c6187b019dba49e07.png";
;// CONCATENATED MODULE: ./src/content/equipment/ArmadylChainskirt.ts
var ArmadylChainskirt_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var ArmadylChainskirt = /** @class */ (function (_super) {
    ArmadylChainskirt_extends(ArmadylChainskirt, _super);
    function ArmadylChainskirt() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: -6,
                slash: -6,
                crush: -6,
                magic: -10,
                range: 20,
            },
            defence: {
                stab: 32,
                slash: 26,
                crush: 34,
                magic: 40,
                range: 33,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 1,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(ArmadylChainskirt.prototype, "inventoryImage", {
        get: function () {
            return Armadyl_chainskirt_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ArmadylChainskirt.prototype, "itemName", {
        get: function () {
            return ItemName.ARMADYL_CHAINSKIRT;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ArmadylChainskirt.prototype, "weight", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    return ArmadylChainskirt;
}(Legs));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Armadyl_chestplate.png
const Armadyl_chestplate_namespaceObject = __webpack_require__.p + "2feaa80335ebe5b0f03e.png";
;// CONCATENATED MODULE: ./src/content/equipment/ArmadylChestplate.ts
var ArmadylChestplate_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var ArmadylChestplate = /** @class */ (function (_super) {
    ArmadylChestplate_extends(ArmadylChestplate, _super);
    function ArmadylChestplate() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: -7,
                slash: -7,
                crush: -7,
                magic: -15,
                range: 33,
            },
            defence: {
                stab: 56,
                slash: 48,
                crush: 61,
                magic: 70,
                range: 57,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 1,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(ArmadylChestplate.prototype, "inventoryImage", {
        get: function () {
            return Armadyl_chestplate_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ArmadylChestplate.prototype, "itemName", {
        get: function () {
            return ItemName.ARMADYL_CHESTPLATE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ArmadylChestplate.prototype, "weight", {
        get: function () {
            return 4;
        },
        enumerable: false,
        configurable: true
    });
    return ArmadylChestplate;
}(Chest));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Avas_accumulator.png
const Avas_accumulator_namespaceObject = __webpack_require__.p + "6d9bbe438a8a346dc8cb.png";
;// CONCATENATED MODULE: ./src/sdk/gear/Cape.ts
var Cape_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Cape = /** @class */ (function (_super) {
    Cape_extends(Cape, _super);
    function Cape() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Cape.prototype, "type", {
        get: function () {
            return EquipmentTypes.AMMO;
        },
        enumerable: false,
        configurable: true
    });
    Cape.prototype.assignToPlayer = function (player) {
        player.equipment.cape = this;
    };
    Cape.prototype.unassignToPlayer = function (player) {
        player.equipment.cape = null;
    };
    Cape.prototype.currentEquipment = function (player) {
        return player.equipment.cape;
    };
    return Cape;
}(Equipment));


;// CONCATENATED MODULE: ./src/content/equipment/AvasAccumulator.ts
var AvasAccumulator_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var AvasAccumulator = /** @class */ (function (_super) {
    AvasAccumulator_extends(AvasAccumulator, _super);
    function AvasAccumulator() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 4,
            },
            defence: {
                stab: 0,
                slash: 1,
                crush: 0,
                magic: 4,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(AvasAccumulator.prototype, "inventoryImage", {
        get: function () {
            return Avas_accumulator_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AvasAccumulator.prototype, "itemName", {
        get: function () {
            return ItemName.AVAS_ACCUMULATOR;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AvasAccumulator.prototype, "weight", {
        get: function () {
            return 4.535;
        },
        enumerable: false,
        configurable: true
    });
    return AvasAccumulator;
}(Cape));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Avas_assembler.png
const Avas_assembler_namespaceObject = __webpack_require__.p + "c0ba96057ff35545dbff.png";
;// CONCATENATED MODULE: ./src/content/equipment/AvasAssembler.ts
var AvasAssembler_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var AvasAssembler = /** @class */ (function (_super) {
    AvasAssembler_extends(AvasAssembler, _super);
    function AvasAssembler() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.Model = Assets.getAssetUrl("models/player_ava_s_assembler.glb");
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 8,
            },
            defence: {
                stab: 1,
                slash: 1,
                crush: 1,
                magic: 8,
                range: 2,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 2,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(AvasAssembler.prototype, "inventoryImage", {
        get: function () {
            return Avas_assembler_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AvasAssembler.prototype, "itemName", {
        get: function () {
            return ItemName.AVAS_ASSEMBLER;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AvasAssembler.prototype, "weight", {
        get: function () {
            return 5.896;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AvasAssembler.prototype, "model", {
        get: function () {
            return this.Model;
        },
        enumerable: false,
        configurable: true
    });
    return AvasAssembler;
}(Cape));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Avernic_defender.png
const Avernic_defender_namespaceObject = __webpack_require__.p + "5871953a1548bdf96ca4.png";
;// CONCATENATED MODULE: ./src/sdk/gear/Offhand.ts
var Offhand_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Offhand = /** @class */ (function (_super) {
    Offhand_extends(Offhand, _super);
    function Offhand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Offhand.prototype, "type", {
        get: function () {
            return EquipmentTypes.OFFHAND;
        },
        enumerable: false,
        configurable: true
    });
    Offhand.prototype.inventoryLeftClick = function (player) {
        var currentWeapon = player.equipment.weapon || null;
        var currentOffhand = player.equipment.offhand || null;
        var openInventorySlots = player.openInventorySlots();
        openInventorySlots.unshift(player.inventory.indexOf(this));
        var neededInventorySlots = 0;
        if (currentWeapon && currentWeapon.isTwoHander) {
            neededInventorySlots++;
        }
        if (neededInventorySlots > openInventorySlots.length) {
            return;
        }
        this.assignToPlayer(player);
        if (currentOffhand) {
            player.inventory[openInventorySlots.shift()] = currentOffhand;
        }
        else {
            player.inventory[openInventorySlots.shift()] = null;
            openInventorySlots = player.openInventorySlots();
        }
        if (currentWeapon && currentWeapon.isTwoHander) {
            player.inventory[openInventorySlots.shift()] = currentWeapon;
            player.equipment.weapon = null;
        }
        player.equipmentChanged();
    };
    Offhand.prototype.assignToPlayer = function (player) {
        player.equipment.offhand = this;
    };
    Offhand.prototype.unassignToPlayer = function (player) {
        player.equipment.offhand = null;
    };
    Offhand.prototype.currentEquipment = function (player) {
        return player.equipment.offhand;
    };
    return Offhand;
}(Equipment));


;// CONCATENATED MODULE: ./src/content/equipment/AvernicDefender.ts
var AvernicDefender_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var AvernicDefender = /** @class */ (function (_super) {
    AvernicDefender_extends(AvernicDefender, _super);
    function AvernicDefender() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.Model = Assets.getAssetUrl("models/player_avernic_defender.glb");
        _this.bonuses = {
            attack: {
                stab: 30,
                slash: 29,
                crush: 28,
                magic: -5,
                range: -4,
            },
            defence: {
                stab: 30,
                slash: 29,
                crush: 28,
                magic: -5,
                range: -4,
            },
            other: {
                meleeStrength: 8,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(AvernicDefender.prototype, "inventoryImage", {
        get: function () {
            return Avernic_defender_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AvernicDefender.prototype, "itemName", {
        get: function () {
            return ItemName.AVERNIC_DEFENDER;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AvernicDefender.prototype, "weight", {
        get: function () {
            return 0.453;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AvernicDefender.prototype, "model", {
        get: function () {
            return this.Model;
        },
        enumerable: false,
        configurable: true
    });
    return AvernicDefender;
}(Offhand));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Barrows_gloves.png
const Barrows_gloves_namespaceObject = __webpack_require__.p + "09e747f4e8a7fe133858.png";
;// CONCATENATED MODULE: ./src/sdk/gear/Gloves.ts
var Gloves_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Gloves = /** @class */ (function (_super) {
    Gloves_extends(Gloves, _super);
    function Gloves() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Gloves.prototype, "type", {
        get: function () {
            return EquipmentTypes.GLOVES;
        },
        enumerable: false,
        configurable: true
    });
    Gloves.prototype.assignToPlayer = function (player) {
        player.equipment.gloves = this;
    };
    Gloves.prototype.unassignToPlayer = function (player) {
        player.equipment.gloves = null;
    };
    Gloves.prototype.currentEquipment = function (player) {
        return player.equipment.gloves;
    };
    return Gloves;
}(Equipment));


;// CONCATENATED MODULE: ./src/content/equipment/BarrowsGloves.ts
var BarrowsGloves_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var BarrowsGloves = /** @class */ (function (_super) {
    BarrowsGloves_extends(BarrowsGloves, _super);
    function BarrowsGloves() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.Model = Assets.getAssetUrl("models/player_barrows_gloves.glb");
        _this.bonuses = {
            attack: {
                stab: 12,
                slash: 12,
                crush: 12,
                magic: 6,
                range: 12,
            },
            defence: {
                stab: 12,
                slash: 12,
                crush: 12,
                magic: 6,
                range: 12,
            },
            other: {
                meleeStrength: 12,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(BarrowsGloves.prototype, "inventoryImage", {
        get: function () {
            return Barrows_gloves_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BarrowsGloves.prototype, "itemName", {
        get: function () {
            return ItemName.BARROWS_GLOVES;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BarrowsGloves.prototype, "weight", {
        get: function () {
            return 0.226;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BarrowsGloves.prototype, "model", {
        get: function () {
            return this.Model;
        },
        enumerable: false,
        configurable: true
    });
    return BarrowsGloves;
}(Gloves));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Black_d'hide_body.png
const Black_d_hide_body_namespaceObject = __webpack_require__.p + "62e1a2ab01a8006886eb.png";
;// CONCATENATED MODULE: ./src/content/equipment/BlackDhideBody.ts
var BlackDhideBody_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var BlackDhideBody = /** @class */ (function (_super) {
    BlackDhideBody_extends(BlackDhideBody, _super);
    function BlackDhideBody() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -15,
                range: 30,
            },
            defence: {
                stab: 55,
                slash: 47,
                crush: 60,
                magic: 50,
                range: 55,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(BlackDhideBody.prototype, "inventoryImage", {
        get: function () {
            return Black_d_hide_body_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlackDhideBody.prototype, "itemName", {
        get: function () {
            return ItemName.BLACK_D_HIDE_BODY;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlackDhideBody.prototype, "weight", {
        get: function () {
            return 6.803;
        },
        enumerable: false,
        configurable: true
    });
    return BlackDhideBody;
}(Chest));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Black_d'hide_chaps.png
const Black_d_hide_chaps_namespaceObject = __webpack_require__.p + "8ac1d10b4dafe8f651b8.png";
;// CONCATENATED MODULE: ./src/content/equipment/BlackDhideChaps.ts
var BlackDhideChaps_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var BlackDhideChaps = /** @class */ (function (_super) {
    BlackDhideChaps_extends(BlackDhideChaps, _super);
    function BlackDhideChaps() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -10,
                range: 17,
            },
            defence: {
                stab: 31,
                slash: 25,
                crush: 33,
                magic: 28,
                range: 31,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(BlackDhideChaps.prototype, "inventoryImage", {
        get: function () {
            return Black_d_hide_chaps_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlackDhideChaps.prototype, "itemName", {
        get: function () {
            return ItemName.BLACK_D_HIDE_CHAPS;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlackDhideChaps.prototype, "weight", {
        get: function () {
            return 5.443;
        },
        enumerable: false,
        configurable: true
    });
    return BlackDhideChaps;
}(Legs));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Black_d'hide_vambraces.png
const Black_d_hide_vambraces_namespaceObject = __webpack_require__.p + "d98b753d6facf4353c79.png";
;// CONCATENATED MODULE: ./src/content/equipment/BlackDhideVambraces.ts
var BlackDhideVambraces_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var BlackDhideVambraces = /** @class */ (function (_super) {
    BlackDhideVambraces_extends(BlackDhideVambraces, _super);
    function BlackDhideVambraces() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -10,
                range: 11,
            },
            defence: {
                stab: 6,
                slash: 5,
                crush: 7,
                magic: 8,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(BlackDhideVambraces.prototype, "inventoryImage", {
        get: function () {
            return Black_d_hide_vambraces_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlackDhideVambraces.prototype, "itemName", {
        get: function () {
            return ItemName.BLACK_D_HIDE_VAMBRACES;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlackDhideVambraces.prototype, "weight", {
        get: function () {
            return 0.283;
        },
        enumerable: false,
        configurable: true
    });
    return BlackDhideVambraces;
}(Gloves));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Crystal_body.png
const Crystal_body_namespaceObject = __webpack_require__.p + "be7aae7b71a022d6099a.png";
;// CONCATENATED MODULE: ./src/content/equipment/CrystalBody.ts
var CrystalBody_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var CrystalBody = /** @class */ (function (_super) {
    CrystalBody_extends(CrystalBody, _super);
    function CrystalBody() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.Model = Assets.getAssetUrl("models/player_crystal_body.glb");
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -18,
                range: 31,
            },
            defence: {
                stab: 46,
                slash: 38,
                crush: 48,
                magic: 44,
                range: 68,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 3,
                crystalAccuracy: 0.15,
                crystalDamage: 0.075,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(CrystalBody.prototype, "inventoryImage", {
        get: function () {
            return Crystal_body_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CrystalBody.prototype, "itemName", {
        get: function () {
            return ItemName.CRYSTAL_BODY;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CrystalBody.prototype, "weight", {
        get: function () {
            return 2;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CrystalBody.prototype, "model", {
        get: function () {
            return this.Model;
        },
        enumerable: false,
        configurable: true
    });
    return CrystalBody;
}(Chest));


;// CONCATENATED MODULE: ./src/sdk/gear/Helmet.ts
var Helmet_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Helmet = /** @class */ (function (_super) {
    Helmet_extends(Helmet, _super);
    function Helmet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Helmet.prototype, "type", {
        get: function () {
            return EquipmentTypes.HELMET;
        },
        enumerable: false,
        configurable: true
    });
    Helmet.prototype.assignToPlayer = function (player) {
        player.equipment.helmet = this;
    };
    Helmet.prototype.unassignToPlayer = function (player) {
        player.equipment.helmet = null;
    };
    Helmet.prototype.currentEquipment = function (player) {
        return player.equipment.helmet;
    };
    return Helmet;
}(Equipment));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Crystal_helm.png
const Crystal_helm_namespaceObject = __webpack_require__.p + "9fda6ee6355df1ff1cd5.png";
;// CONCATENATED MODULE: ./src/content/equipment/CrystalHelm.ts
var CrystalHelm_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var CrystalHelm = /** @class */ (function (_super) {
    CrystalHelm_extends(CrystalHelm, _super);
    function CrystalHelm() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.Model = Assets.getAssetUrl("models/player_crystal_helm.glb");
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -10,
                range: 9,
            },
            defence: {
                stab: 12,
                slash: 8,
                crush: 14,
                magic: 10,
                range: 18,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 2,
                crystalAccuracy: 0.05,
                crystalDamage: 0.025,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(CrystalHelm.prototype, "itemName", {
        get: function () {
            return ItemName.CRYSTAL_HELM;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CrystalHelm.prototype, "weight", {
        get: function () {
            return 0.5;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CrystalHelm.prototype, "inventoryImage", {
        get: function () {
            return Crystal_helm_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CrystalHelm.prototype, "model", {
        get: function () {
            return this.Model;
        },
        enumerable: false,
        configurable: true
    });
    return CrystalHelm;
}(Helmet));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Crystal_legs.png
const Crystal_legs_namespaceObject = __webpack_require__.p + "aff1e233dc0085b88760.png";
;// CONCATENATED MODULE: ./src/content/equipment/CrystalLegs.ts
var CrystalLegs_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var CrystalLegs = /** @class */ (function (_super) {
    CrystalLegs_extends(CrystalLegs, _super);
    function CrystalLegs() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.Model = Assets.getAssetUrl("models/player_crystal_legs.glb");
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -12,
                range: 18,
            },
            defence: {
                stab: 26,
                slash: 21,
                crush: 30,
                magic: 34,
                range: 38,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 2,
                crystalAccuracy: 0.1,
                crystalDamage: 0.05,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(CrystalLegs.prototype, "inventoryImage", {
        get: function () {
            return Crystal_legs_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CrystalLegs.prototype, "itemName", {
        get: function () {
            return ItemName.CRYSTAL_LEGS;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CrystalLegs.prototype, "weight", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CrystalLegs.prototype, "model", {
        get: function () {
            return this.Model;
        },
        enumerable: false,
        configurable: true
    });
    return CrystalLegs;
}(Legs));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Crystal_shield.png
const Crystal_shield_namespaceObject = __webpack_require__.p + "fb0e4ae148289f189947.png";
;// CONCATENATED MODULE: ./src/content/equipment/CrystalShield.ts
var CrystalShield_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var CrystalShield = /** @class */ (function (_super) {
    CrystalShield_extends(CrystalShield, _super);
    function CrystalShield() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -10,
                range: -10,
            },
            defence: {
                stab: 51,
                slash: 54,
                crush: 53,
                magic: 0,
                range: 80,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(CrystalShield.prototype, "inventoryImage", {
        get: function () {
            return Crystal_shield_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CrystalShield.prototype, "itemName", {
        get: function () {
            return ItemName.CRYSTAL_SHIELD;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CrystalShield.prototype, "weight", {
        get: function () {
            return 2.721;
        },
        enumerable: false,
        configurable: true
    });
    return CrystalShield;
}(Offhand));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Dagon'hai_robe_top.png
const Dagon_hai_robe_top_namespaceObject = __webpack_require__.p + "57d9dee7f04bf2ad3f99.png";
;// CONCATENATED MODULE: ./src/content/equipment/DagonhaiRobeTop.ts
var DagonhaiRobeTop_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var DagonhaiRobeTop = /** @class */ (function (_super) {
    DagonhaiRobeTop_extends(DagonhaiRobeTop, _super);
    function DagonhaiRobeTop() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 25,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 21,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 2,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(DagonhaiRobeTop.prototype, "inventoryImage", {
        get: function () {
            return Dagon_hai_robe_top_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DagonhaiRobeTop.prototype, "itemName", {
        get: function () {
            return ItemName.DAGON_HAI_ROBE_TOP;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DagonhaiRobeTop.prototype, "weight", {
        get: function () {
            return 4;
        },
        enumerable: false,
        configurable: true
    });
    return DagonhaiRobeTop;
}(Chest));


;// CONCATENATED MODULE: ./src/sdk/gear/Feet.ts
var Feet_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Feet = /** @class */ (function (_super) {
    Feet_extends(Feet, _super);
    function Feet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Feet.prototype, "type", {
        get: function () {
            return EquipmentTypes.FEET;
        },
        enumerable: false,
        configurable: true
    });
    Feet.prototype.assignToPlayer = function (player) {
        player.equipment.feet = this;
    };
    Feet.prototype.unassignToPlayer = function (player) {
        player.equipment.feet = null;
    };
    Feet.prototype.currentEquipment = function (player) {
        return player.equipment.feet;
    };
    return Feet;
}(Equipment));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Devout_boots.png
const Devout_boots_namespaceObject = __webpack_require__.p + "49dbc5a6dc3c8483321d.png";
;// CONCATENATED MODULE: ./src/content/equipment/DevoutBoots.ts
var DevoutBoots_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var DevoutBoots = /** @class */ (function (_super) {
    DevoutBoots_extends(DevoutBoots, _super);
    function DevoutBoots() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 5,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(DevoutBoots.prototype, "inventoryImage", {
        get: function () {
            return Devout_boots_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DevoutBoots.prototype, "itemName", {
        get: function () {
            return ItemName.HOLY_BLESSING;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DevoutBoots.prototype, "weight", {
        get: function () {
            return 0.5;
        },
        enumerable: false,
        configurable: true
    });
    return DevoutBoots;
}(Feet));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Diamond_bolts_e_5.png
const Diamond_bolts_e_5_namespaceObject = __webpack_require__.p + "fce26b202f2728d673f0.png";
;// CONCATENATED MODULE: ./src/content/equipment/DiamondBoltsE.ts
var DiamondBoltsE_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var DiamondBoltsE = /** @class */ (function (_super) {
    DiamondBoltsE_extends(DiamondBoltsE, _super);
    function DiamondBoltsE() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 105,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(DiamondBoltsE.prototype, "inventoryImage", {
        get: function () {
            return Diamond_bolts_e_5_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DiamondBoltsE.prototype, "weight", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DiamondBoltsE.prototype, "itemName", {
        get: function () {
            return ItemName.DIAMOND_BOLTS_E;
        },
        enumerable: false,
        configurable: true
    });
    return DiamondBoltsE;
}(Ammo));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Dizana's_quiver.png
const Dizana_s_quiver_namespaceObject = __webpack_require__.p + "1d7154d5998b78d5ff03.png";
;// CONCATENATED MODULE: ./src/content/equipment/DizanasQuiver.ts
var DizanasQuiver_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var DizanasQuiver = /** @class */ (function (_super) {
    DizanasQuiver_extends(DizanasQuiver, _super);
    function DizanasQuiver() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.Model = Assets.getAssetUrl("models/player_dizana_s_max_cape.glb");
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 18,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 3,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(DizanasQuiver.prototype, "inventoryImage", {
        get: function () {
            return Dizana_s_quiver_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DizanasQuiver.prototype, "itemName", {
        get: function () {
            return ItemName.DIZANAS_QUIVER;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DizanasQuiver.prototype, "weight", {
        get: function () {
            return 0.453;
        },
        enumerable: false,
        configurable: true
    });
    DizanasQuiver.prototype.updateBonuses = function (gear) {
        var weapon = gear.find(function (item) { return (item === null || item === void 0 ? void 0 : item.type) === EquipmentTypes.WEAPON; });
        if (!weapon || !(weapon instanceof RangedWeapon)) {
            this.bonuses.other.rangedStrength = 3;
            return;
        }
        if (weapon.compatibleAmmo().includes(ItemName.DRAGON_ARROWS)) {
            this.bonuses.other.rangedStrength = 4;
        }
        else {
            this.bonuses.other.rangedStrength = 3;
        }
    };
    Object.defineProperty(DizanasQuiver.prototype, "model", {
        get: function () {
            return this.Model;
        },
        enumerable: false,
        configurable: true
    });
    return DizanasQuiver;
}(Cape));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Dragon_arrow_5.png
const Dragon_arrow_5_namespaceObject = __webpack_require__.p + "28cf0a2a68f651babc1a.png";
;// CONCATENATED MODULE: ./src/content/equipment/DragonArrows.ts
var DragonArrows_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var DragonArrows = /** @class */ (function (_super) {
    DragonArrows_extends(DragonArrows, _super);
    function DragonArrows() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 60,
                magicDamage: 0,
                prayer: 1,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(DragonArrows.prototype, "inventoryImage", {
        get: function () {
            return Dragon_arrow_5_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DragonArrows.prototype, "weight", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DragonArrows.prototype, "itemName", {
        get: function () {
            return ItemName.DRAGON_ARROWS;
        },
        enumerable: false,
        configurable: true
    });
    return DragonArrows;
}(Ammo));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Ferocious_gloves.png
const Ferocious_gloves_namespaceObject = __webpack_require__.p + "0865ae07961873a2ceb3.png";
;// CONCATENATED MODULE: ./src/content/equipment/FerociousGloves.ts
var FerociousGloves_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var FerociousGloves = /** @class */ (function (_super) {
    FerociousGloves_extends(FerociousGloves, _super);
    function FerociousGloves() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.Model = Assets.getAssetUrl("models/player_ferocious_gloves.glb");
        _this.bonuses = {
            attack: {
                stab: 16,
                slash: 16,
                crush: 16,
                magic: -16,
                range: -16,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 6,
                range: 0,
            },
            other: {
                meleeStrength: 14,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(FerociousGloves.prototype, "inventoryImage", {
        get: function () {
            return Ferocious_gloves_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FerociousGloves.prototype, "itemName", {
        get: function () {
            return ItemName.FEROCIOUS_GLOVES;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FerociousGloves.prototype, "weight", {
        get: function () {
            return 0.226;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FerociousGloves.prototype, "model", {
        get: function () {
            return this.Model;
        },
        enumerable: false,
        configurable: true
    });
    return FerociousGloves;
}(Gloves));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Guthix_robe_top.png
const Guthix_robe_top_namespaceObject = __webpack_require__.p + "e464a8a0832f7e88745c.png";
;// CONCATENATED MODULE: ./src/content/equipment/GuthixRobeTop.ts
var GuthixRobeTop_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var GuthixRobeTop = /** @class */ (function (_super) {
    GuthixRobeTop_extends(GuthixRobeTop, _super);
    function GuthixRobeTop() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 4,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 4,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 6,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(GuthixRobeTop.prototype, "inventoryImage", {
        get: function () {
            return Guthix_robe_top_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GuthixRobeTop.prototype, "itemName", {
        get: function () {
            return ItemName.GUTHIX_ROBE_TOP;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GuthixRobeTop.prototype, "weight", {
        get: function () {
            return 1.8;
        },
        enumerable: false,
        configurable: true
    });
    return GuthixRobeTop;
}(Chest));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Holy_blessing.png
const Holy_blessing_namespaceObject = __webpack_require__.p + "aa4f3594b16acd852a6d.png";
;// CONCATENATED MODULE: ./src/content/equipment/HolyBlessing.ts
var HolyBlessing_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var HolyBlessing = /** @class */ (function (_super) {
    HolyBlessing_extends(HolyBlessing, _super);
    function HolyBlessing() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 1,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(HolyBlessing.prototype, "inventoryImage", {
        get: function () {
            return Holy_blessing_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HolyBlessing.prototype, "weight", {
        get: function () {
            return 0.51;
        },
        enumerable: false,
        configurable: true
    });
    HolyBlessing.prototype.ammoType = function () {
        return AmmoType.BLESSING;
    };
    return HolyBlessing;
}(Ammo));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Infernal_cape.png
const Infernal_cape_namespaceObject = __webpack_require__.p + "727de56aa689bbba637d.png";
;// CONCATENATED MODULE: ./src/content/equipment/InfernalCape.ts
var InfernalCape_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var InfernalCape = /** @class */ (function (_super) {
    InfernalCape_extends(InfernalCape, _super);
    function InfernalCape() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 4,
                slash: 4,
                crush: 4,
                magic: 1,
                range: 1,
            },
            defence: {
                stab: 12,
                slash: 12,
                crush: 12,
                magic: 12,
                range: 12,
            },
            other: {
                meleeStrength: 8,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 2,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(InfernalCape.prototype, "itemName", {
        get: function () {
            return ItemName.INFERNAL_CAPE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InfernalCape.prototype, "weight", {
        get: function () {
            return 1.814;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InfernalCape.prototype, "inventoryImage", {
        get: function () {
            return Infernal_cape_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InfernalCape.prototype, "model", {
        get: function () {
            return Assets.getAssetUrl("models/player_infernal_cape.glb");
        },
        enumerable: false,
        configurable: true
    });
    return InfernalCape;
}(Cape));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Justiciar_chestguard.png
const Justiciar_chestguard_namespaceObject = __webpack_require__.p + "98ec70c4ca4cd1cec982.png";
;// CONCATENATED MODULE: ./src/content/seteffects/JusticiarSetEffect.ts
var JusticiarSetEffect_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var JusticiarSetEffect = /** @class */ (function (_super) {
    JusticiarSetEffect_extends(JusticiarSetEffect, _super);
    function JusticiarSetEffect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    JusticiarSetEffect.effectName = function () {
        return SetEffectTypes.JUSTICIAR;
    };
    JusticiarSetEffect.itemsInSet = function () {
        return [ItemName.JUSTICIAR_FACEGUARD, ItemName.JUSTICIAR_CHESTGUARD, ItemName.JUSTICIAR_LEGGUARDS];
    };
    return JusticiarSetEffect;
}(SetEffect));


;// CONCATENATED MODULE: ./src/content/equipment/JusticiarChestguard.ts
var JusticiarChestguard_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var JusticiarChestguard = /** @class */ (function (_super) {
    JusticiarChestguard_extends(JusticiarChestguard, _super);
    function JusticiarChestguard() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -40,
                range: -20,
            },
            defence: {
                stab: 132,
                slash: 130,
                crush: 117,
                magic: -16,
                range: 142,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 4,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(JusticiarChestguard.prototype, "equipmentSetEffect", {
        get: function () {
            return JusticiarSetEffect;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JusticiarChestguard.prototype, "itemName", {
        get: function () {
            return ItemName.JUSTICIAR_CHESTGUARD;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JusticiarChestguard.prototype, "weight", {
        get: function () {
            return 9.979;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JusticiarChestguard.prototype, "inventoryImage", {
        get: function () {
            return Justiciar_chestguard_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return JusticiarChestguard;
}(Chest));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Justiciar_faceguard.png
const Justiciar_faceguard_namespaceObject = __webpack_require__.p + "4f5483683adcf33e249a.png";
;// CONCATENATED MODULE: ./src/content/equipment/JusticiarFaceguard.ts
var JusticiarFaceguard_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var JusticiarFaceguard = /** @class */ (function (_super) {
    JusticiarFaceguard_extends(JusticiarFaceguard, _super);
    function JusticiarFaceguard() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -6,
                range: -2,
            },
            defence: {
                stab: 60,
                slash: 63,
                crush: 59,
                magic: -6,
                range: 67,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 2,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(JusticiarFaceguard.prototype, "equipmentSetEffect", {
        get: function () {
            return JusticiarSetEffect;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JusticiarFaceguard.prototype, "itemName", {
        get: function () {
            return ItemName.JUSTICIAR_FACEGUARD;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JusticiarFaceguard.prototype, "weight", {
        get: function () {
            return 2.721;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JusticiarFaceguard.prototype, "inventoryImage", {
        get: function () {
            return Justiciar_faceguard_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return JusticiarFaceguard;
}(Helmet));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Justiciar_legguards.png
const Justiciar_legguards_namespaceObject = __webpack_require__.p + "c2d796ca3c1347642af9.png";
;// CONCATENATED MODULE: ./src/content/equipment/JusticiarLegguards.ts
var JusticiarLegguards_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var JusticiarLegguards = /** @class */ (function (_super) {
    JusticiarLegguards_extends(JusticiarLegguards, _super);
    function JusticiarLegguards() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -31,
                range: -17,
            },
            defence: {
                stab: 95,
                slash: 92,
                crush: 93,
                magic: -14,
                range: 102,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 4,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(JusticiarLegguards.prototype, "equipmentSetEffect", {
        get: function () {
            return JusticiarSetEffect;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JusticiarLegguards.prototype, "itemName", {
        get: function () {
            return ItemName.JUSTICIAR_LEGGUARDS;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JusticiarLegguards.prototype, "weight", {
        get: function () {
            return 9.071;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JusticiarLegguards.prototype, "inventoryImage", {
        get: function () {
            return Justiciar_legguards_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return JusticiarLegguards;
}(Legs));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Mages_book.png
const Mages_book_namespaceObject = __webpack_require__.p + "a901d504b1dd52279a73.png";
;// CONCATENATED MODULE: ./src/content/equipment/MagesBook.ts
var MagesBook_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var MagesBook = /** @class */ (function (_super) {
    MagesBook_extends(MagesBook, _super);
    function MagesBook() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 15,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 15,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(MagesBook.prototype, "inventoryImage", {
        get: function () {
            return Mages_book_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MagesBook.prototype, "itemName", {
        get: function () {
            return ItemName.MAGES_BOOK;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MagesBook.prototype, "weight", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    return MagesBook;
}(Offhand));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Masori_body_(f).png
const Masori_body_f_namespaceObject = __webpack_require__.p + "6a92d9b862390ef9febb.png";
;// CONCATENATED MODULE: ./src/content/equipment/MasoriBodyF.ts
var MasoriBodyF_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var MasoriBodyF = /** @class */ (function (_super) {
    MasoriBodyF_extends(MasoriBodyF, _super);
    function MasoriBodyF() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.Model = Assets.getAssetUrl("models/player_masori_body__f_.glb");
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -4,
                range: 43,
            },
            defence: {
                stab: 59,
                slash: 52,
                crush: 64,
                magic: 74,
                range: 60,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 4,
                magicDamage: 0,
                prayer: 1,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(MasoriBodyF.prototype, "inventoryImage", {
        get: function () {
            return Masori_body_f_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MasoriBodyF.prototype, "itemName", {
        get: function () {
            return ItemName.MASORI_BODY_F;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MasoriBodyF.prototype, "weight", {
        get: function () {
            return 10;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MasoriBodyF.prototype, "model", {
        get: function () {
            return this.Model;
        },
        enumerable: false,
        configurable: true
    });
    return MasoriBodyF;
}(Chest));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Masori_chaps_(f).png
const Masori_chaps_f_namespaceObject = __webpack_require__.p + "1e49a7aea5615fefcab7.png";
;// CONCATENATED MODULE: ./src/content/equipment/MasoriChapsF.ts
var MasoriChapsF_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var MasoriChapsF = /** @class */ (function (_super) {
    MasoriChapsF_extends(MasoriChapsF, _super);
    function MasoriChapsF() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.Model = Assets.getAssetUrl("models/player_masori_chaps__f_.glb");
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -2,
                range: 27,
            },
            defence: {
                stab: 35,
                slash: 30,
                crush: 39,
                magic: 46,
                range: 37,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 2,
                magicDamage: 0,
                prayer: 1,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(MasoriChapsF.prototype, "inventoryImage", {
        get: function () {
            return Masori_chaps_f_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MasoriChapsF.prototype, "itemName", {
        get: function () {
            return ItemName.MASORI_CHAPS_F;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MasoriChapsF.prototype, "weight", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MasoriChapsF.prototype, "model", {
        get: function () {
            return this.Model;
        },
        enumerable: false,
        configurable: true
    });
    return MasoriChapsF;
}(Legs));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Masori_mask_(f).png
const Masori_mask_f_namespaceObject = __webpack_require__.p + "d83225d1a874c411570e.png";
;// CONCATENATED MODULE: ./src/content/equipment/MasoriMaskF.ts
var MasoriMaskF_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var MasoriMaskF = /** @class */ (function (_super) {
    MasoriMaskF_extends(MasoriMaskF, _super);
    function MasoriMaskF() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.Model = Assets.getAssetUrl("models/player_masori_mask__f_.glb");
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -1,
                range: 12,
            },
            defence: {
                stab: 8,
                slash: 10,
                crush: 12,
                magic: 12,
                range: 9,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 2,
                magicDamage: 0,
                prayer: 1,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(MasoriMaskF.prototype, "inventoryImage", {
        get: function () {
            return Masori_mask_f_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MasoriMaskF.prototype, "itemName", {
        get: function () {
            return ItemName.MASORI_MASK_F;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MasoriMaskF.prototype, "weight", {
        get: function () {
            return 10;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MasoriMaskF.prototype, "model", {
        get: function () {
            return this.Model;
        },
        enumerable: false,
        configurable: true
    });
    return MasoriMaskF;
}(Helmet));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Necklace_of_anguish.png
const Necklace_of_anguish_namespaceObject = __webpack_require__.p + "43f1b1b98ea920f194d1.png";
;// CONCATENATED MODULE: ./src/content/equipment/NecklaceOfAnguish.ts
var NecklaceOfAnguish_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var NecklaceOfAnguish = /** @class */ (function (_super) {
    NecklaceOfAnguish_extends(NecklaceOfAnguish, _super);
    function NecklaceOfAnguish() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.Model = Assets.getAssetUrl("models/player_necklace_of_anguish__or_.glb");
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 15,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 5,
                magicDamage: 0,
                prayer: 2,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(NecklaceOfAnguish.prototype, "inventoryImage", {
        get: function () {
            return Necklace_of_anguish_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NecklaceOfAnguish.prototype, "itemName", {
        get: function () {
            return ItemName.NECKLACE_OF_ANGUISH;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NecklaceOfAnguish.prototype, "weight", {
        get: function () {
            return 0.01;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NecklaceOfAnguish.prototype, "model", {
        get: function () {
            return this.Model;
        },
        enumerable: false,
        configurable: true
    });
    return NecklaceOfAnguish;
}(Necklace));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Occult_necklace.png
const Occult_necklace_namespaceObject = __webpack_require__.p + "19f8d58df7e42cee725b.png";
;// CONCATENATED MODULE: ./src/content/equipment/OccultNecklace.ts
var OccultNecklace_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var OccultNecklace = /** @class */ (function (_super) {
    OccultNecklace_extends(OccultNecklace, _super);
    function OccultNecklace() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 12,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0.1,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(OccultNecklace.prototype, "inventoryImage", {
        get: function () {
            return Occult_necklace_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OccultNecklace.prototype, "itemName", {
        get: function () {
            return ItemName.OCCULT_NECKLACE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OccultNecklace.prototype, "weight", {
        get: function () {
            return 0.005;
        },
        enumerable: false,
        configurable: true
    });
    return OccultNecklace;
}(Necklace));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Pegasian_boots.png
const Pegasian_boots_namespaceObject = __webpack_require__.p + "42501411e063b25bdcc9.png";
;// CONCATENATED MODULE: ./src/content/equipment/PegasianBoots.ts
var PegasianBoots_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var PegasianBoots = /** @class */ (function (_super) {
    PegasianBoots_extends(PegasianBoots, _super);
    function PegasianBoots() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.Model = Assets.getAssetUrl("models/player_pegasian_boots.glb");
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -12,
                range: 12,
            },
            defence: {
                stab: 5,
                slash: 5,
                crush: 5,
                magic: 5,
                range: 5,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(PegasianBoots.prototype, "inventoryImage", {
        get: function () {
            return Pegasian_boots_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PegasianBoots.prototype, "itemName", {
        get: function () {
            return ItemName.PEGASIAN_BOOTS;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PegasianBoots.prototype, "weight", {
        get: function () {
            return 1.814;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PegasianBoots.prototype, "model", {
        get: function () {
            return this.Model;
        },
        enumerable: false,
        configurable: true
    });
    return PegasianBoots;
}(Feet));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Primordial_boots.png
const Primordial_boots_namespaceObject = __webpack_require__.p + "224afeb7d3861e1e3aa2.png";
;// CONCATENATED MODULE: ./src/content/equipment/PrimordialBoots.ts
var PrimordialBoots_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var PrimordialBoots = /** @class */ (function (_super) {
    PrimordialBoots_extends(PrimordialBoots, _super);
    function PrimordialBoots() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.Model = Assets.getAssetUrl("models/player_primordial_boots.glb");
        _this.bonuses = {
            attack: {
                stab: 2,
                slash: 2,
                crush: 2,
                magic: -14,
                range: -1,
            },
            defence: {
                stab: 22,
                slash: 22,
                crush: 22,
                magic: 5,
                range: 5,
            },
            other: {
                meleeStrength: 5,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(PrimordialBoots.prototype, "inventoryImage", {
        get: function () {
            return Primordial_boots_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PrimordialBoots.prototype, "itemName", {
        get: function () {
            return ItemName.PRIMORDIAL_BOOTS;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PrimordialBoots.prototype, "weight", {
        get: function () {
            return 1.814;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PrimordialBoots.prototype, "model", {
        get: function () {
            return this.Model;
        },
        enumerable: false,
        configurable: true
    });
    return PrimordialBoots;
}(Feet));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Ranger_boots.png
const Ranger_boots_namespaceObject = __webpack_require__.p + "9329bdf2582d40ebd2c8.png";
;// CONCATENATED MODULE: ./src/content/equipment/RangerBoots.ts
var RangerBoots_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var RangerBoots = /** @class */ (function (_super) {
    RangerBoots_extends(RangerBoots, _super);
    function RangerBoots() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 10,
                range: 8,
            },
            defence: {
                stab: 2,
                slash: 3,
                crush: 4,
                magic: 2,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(RangerBoots.prototype, "inventoryImage", {
        get: function () {
            return Ranger_boots_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RangerBoots.prototype, "itemName", {
        get: function () {
            return ItemName.RANGER_BOOTS;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RangerBoots.prototype, "weight", {
        get: function () {
            return 0.283;
        },
        enumerable: false,
        configurable: true
    });
    return RangerBoots;
}(Feet));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Ring_of_endurance.png
const Ring_of_endurance_namespaceObject = __webpack_require__.p + "890056edc0dd633a51a6.png";
;// CONCATENATED MODULE: ./src/sdk/gear/Ring.ts
var Ring_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Ring = /** @class */ (function (_super) {
    Ring_extends(Ring, _super);
    function Ring() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Ring.prototype, "type", {
        get: function () {
            return EquipmentTypes.RING;
        },
        enumerable: false,
        configurable: true
    });
    Ring.prototype.assignToPlayer = function (player) {
        player.equipment.ring = this;
    };
    Ring.prototype.unassignToPlayer = function (player) {
        player.equipment.ring = null;
    };
    Ring.prototype.currentEquipment = function (player) {
        return player.equipment.ring;
    };
    return Ring;
}(Equipment));


;// CONCATENATED MODULE: ./src/content/equipment/RingOfEndurance.ts
var RingOfEndurance_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var RingOfEndurance = /** @class */ (function (_super) {
    RingOfEndurance_extends(RingOfEndurance, _super);
    function RingOfEndurance() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(RingOfEndurance.prototype, "inventoryImage", {
        get: function () {
            return Ring_of_endurance_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RingOfEndurance.prototype, "itemName", {
        get: function () {
            return ItemName.RING_OF_ENDURANCE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RingOfEndurance.prototype, "weight", {
        get: function () {
            return 0.006;
        },
        enumerable: false,
        configurable: true
    });
    return RingOfEndurance;
}(Ring));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Ring_of_suffering_imbued.png
const Ring_of_suffering_imbued_namespaceObject = __webpack_require__.p + "94d4d466cc96a524a1a4.png";
;// CONCATENATED MODULE: ./src/content/equipment/RingOfSufferingImbued.ts
var RingOfSufferingImbued_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var RingOfSufferingImbued = /** @class */ (function (_super) {
    RingOfSufferingImbued_extends(RingOfSufferingImbued, _super);
    function RingOfSufferingImbued() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            defence: {
                stab: 20,
                slash: 20,
                crush: 20,
                magic: 20,
                range: 20,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 4,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(RingOfSufferingImbued.prototype, "inventoryImage", {
        get: function () {
            return Ring_of_suffering_imbued_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RingOfSufferingImbued.prototype, "itemName", {
        get: function () {
            return ItemName.RING_OF_SUFFERING_I;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RingOfSufferingImbued.prototype, "weight", {
        get: function () {
            return 0.006;
        },
        enumerable: false,
        configurable: true
    });
    return RingOfSufferingImbued;
}(Ring));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Robin_hood_hat.png
const Robin_hood_hat_namespaceObject = __webpack_require__.p + "264b9330fb34193ae334.png";
;// CONCATENATED MODULE: ./src/content/equipment/RobinHoodHat.ts
var RobinHoodHat_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var RobinHoodHat = /** @class */ (function (_super) {
    RobinHoodHat_extends(RobinHoodHat, _super);
    function RobinHoodHat() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -10,
                range: 8,
            },
            defence: {
                stab: 4,
                slash: 6,
                crush: 8,
                magic: 4,
                range: 4,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(RobinHoodHat.prototype, "itemName", {
        get: function () {
            return ItemName.ROBIN_HOOD_HAT;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RobinHoodHat.prototype, "weight", {
        get: function () {
            return 0.283;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RobinHoodHat.prototype, "inventoryImage", {
        get: function () {
            return Robin_hood_hat_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return RobinHoodHat;
}(Helmet));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Ruby_bolts_e_5.png
const Ruby_bolts_e_5_namespaceObject = __webpack_require__.p + "db177c42bc396af883a7.png";
;// CONCATENATED MODULE: ./src/content/equipment/RubyBoltsE.ts
var RubyBoltsE_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var RubyBoltsE = /** @class */ (function (_super) {
    RubyBoltsE_extends(RubyBoltsE, _super);
    function RubyBoltsE() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 103,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(RubyBoltsE.prototype, "inventoryImage", {
        get: function () {
            return Ruby_bolts_e_5_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RubyBoltsE.prototype, "weight", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RubyBoltsE.prototype, "itemName", {
        get: function () {
            return ItemName.RUBY_BOLTS_E;
        },
        enumerable: false,
        configurable: true
    });
    return RubyBoltsE;
}(Ammo));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Rune_crossbow.png
const Rune_crossbow_namespaceObject = __webpack_require__.p + "1a26adebd3caaa134cf7.png";
;// CONCATENATED MODULE: ./src/content/equipment/RuneCrossbow.ts

var RuneCrossbow_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var RuneCrossbow = /** @class */ (function (_super) {
    RuneCrossbow_extends(RuneCrossbow, _super);
    function RuneCrossbow() {
        var _this = _super.call(this) || this;
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 90,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 20,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    RuneCrossbow.prototype.compatibleAmmo = function () {
        return [ItemName.RUBY_BOLTS_E, ItemName.DIAMOND_BOLTS_E];
    };
    RuneCrossbow.prototype.attackStyles = function () {
        return [AttackStyle.ACCURATE, AttackStyle.RAPID, AttackStyle.LONGRANGE];
    };
    RuneCrossbow.prototype.attackStyleCategory = function () {
        return AttackStyleTypes.CROSSBOW;
    };
    RuneCrossbow.prototype.defaultStyle = function () {
        return AttackStyle.RAPID;
    };
    Object.defineProperty(RuneCrossbow.prototype, "weight", {
        get: function () {
            return 6;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RuneCrossbow.prototype, "itemName", {
        get: function () {
            return ItemName.RUNE_CROSSBOW;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RuneCrossbow.prototype, "isTwoHander", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RuneCrossbow.prototype, "attackRange", {
        get: function () {
            if (this.attackStyle() === AttackStyle.LONGRANGE) {
                return 9;
            }
            return 7;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RuneCrossbow.prototype, "attackSpeed", {
        get: function () {
            if (this.attackStyle() === AttackStyle.LONGRANGE) {
                return 6;
            }
            return 5;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RuneCrossbow.prototype, "inventoryImage", {
        get: function () {
            return Rune_crossbow_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    RuneCrossbow.prototype.rollDamage = function (from, to, bonuses) {
        if (from.equipment.ammo &&
            from.equipment.ammo.itemName === ItemName.RUBY_BOLTS_E &&
            Random.get() < 0.066 &&
            from.currentStats.hitpoint - Math.floor(from.currentStats.hitpoint * 0.1) > 0) {
            this.damage = to.currentStats.hitpoint * 0.2;
            from.addProjectile(new Projectile(this, Math.floor(from.currentStats.hitpoint * 0.1), from, from, "rubyboltspec", {
                reduceDelay: 15,
            }));
        }
        else if (from.equipment.ammo &&
            from.equipment.ammo.itemName === ItemName.DIAMOND_BOLTS_E &&
            Random.get() < 0.11) {
            this.damage = this._calculateHitDamage(from, to, bonuses);
        }
        else if (from.equipment.ammo) {
            _super.prototype.rollDamage.call(this, from, to, bonuses);
        }
        else {
            this.damage = -1;
        }
    };
    return RuneCrossbow;
}(RangedWeapon));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Rune_kiteshield.png
const Rune_kiteshield_namespaceObject = __webpack_require__.p + "3f05ba4439d416e69eeb.png";
;// CONCATENATED MODULE: ./src/content/equipment/RuneKiteshield.ts
var RuneKiteshield_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var RuneKiteshield = /** @class */ (function (_super) {
    RuneKiteshield_extends(RuneKiteshield, _super);
    function RuneKiteshield() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -8,
                range: -3,
            },
            defence: {
                stab: 44,
                slash: 48,
                crush: 46,
                magic: -1,
                range: 46,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(RuneKiteshield.prototype, "inventoryImage", {
        get: function () {
            return Rune_kiteshield_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RuneKiteshield.prototype, "itemName", {
        get: function () {
            return ItemName.RUNE_KITESHIELD;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RuneKiteshield.prototype, "weight", {
        get: function () {
            return 5.443;
        },
        enumerable: false,
        configurable: true
    });
    return RuneKiteshield;
}(Offhand));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Saradomin_d'hide_body.png
const Saradomin_d_hide_body_namespaceObject = __webpack_require__.p + "a2157c65b24180833483.png";
;// CONCATENATED MODULE: ./src/content/equipment/SaradominBody.ts
var SaradominBody_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var SaradominBody = /** @class */ (function (_super) {
    SaradominBody_extends(SaradominBody, _super);
    function SaradominBody() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -15,
                range: 30,
            },
            defence: {
                stab: 55,
                slash: 47,
                crush: 60,
                magic: 50,
                range: 55,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 1,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(SaradominBody.prototype, "inventoryImage", {
        get: function () {
            return Saradomin_d_hide_body_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaradominBody.prototype, "itemName", {
        get: function () {
            return ItemName.SARADOMIN_D_HIDE_BODY;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaradominBody.prototype, "weight", {
        get: function () {
            return 6;
        },
        enumerable: false,
        configurable: true
    });
    return SaradominBody;
}(Chest));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Saradomin_chaps.png
const Saradomin_chaps_namespaceObject = __webpack_require__.p + "fa0df6d30ba889e9d0fd.png";
;// CONCATENATED MODULE: ./src/content/equipment/SaradominChaps.ts
var SaradominChaps_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var SaradominChaps = /** @class */ (function (_super) {
    SaradominChaps_extends(SaradominChaps, _super);
    function SaradominChaps() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -10,
                range: 17,
            },
            defence: {
                stab: 31,
                slash: 25,
                crush: 33,
                magic: 28,
                range: 31,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 1,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(SaradominChaps.prototype, "inventoryImage", {
        get: function () {
            return Saradomin_chaps_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaradominChaps.prototype, "itemName", {
        get: function () {
            return ItemName.SARADOMIN_D_HIDE_CHAPS;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaradominChaps.prototype, "weight", {
        get: function () {
            return 5;
        },
        enumerable: false,
        configurable: true
    });
    return SaradominChaps;
}(Legs));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Saradomin_coif.png
const Saradomin_coif_namespaceObject = __webpack_require__.p + "faadf937db7f869441d1.png";
;// CONCATENATED MODULE: ./src/content/equipment/SaradominCoif.ts
var SaradominCoif_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var SaradominCoif = /** @class */ (function (_super) {
    SaradominCoif_extends(SaradominCoif, _super);
    function SaradominCoif() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -1,
                range: 7,
            },
            defence: {
                stab: 4,
                slash: 7,
                crush: 10,
                magic: 4,
                range: 8,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 1,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(SaradominCoif.prototype, "itemName", {
        get: function () {
            return ItemName.SARADOMIN_COIF;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaradominCoif.prototype, "weight", {
        get: function () {
            return 0.9;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaradominCoif.prototype, "inventoryImage", {
        get: function () {
            return Saradomin_coif_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return SaradominCoif;
}(Helmet));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Saradomin_d'hide_boots.png
const Saradomin_d_hide_boots_namespaceObject = __webpack_require__.p + "c664deaa02cd04f05e50.png";
;// CONCATENATED MODULE: ./src/content/equipment/SaradominDhideBoots.ts
var SaradominDhideBoots_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var SaradominDhideBoots = /** @class */ (function (_super) {
    SaradominDhideBoots_extends(SaradominDhideBoots, _super);
    function SaradominDhideBoots() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -10,
                range: 7,
            },
            defence: {
                stab: 4,
                slash: 4,
                crush: 4,
                magic: 4,
                range: 43,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 1,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(SaradominDhideBoots.prototype, "inventoryImage", {
        get: function () {
            return Saradomin_d_hide_boots_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaradominDhideBoots.prototype, "itemName", {
        get: function () {
            return ItemName.SARADOMIN_D_HIDE_BOOTS;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaradominDhideBoots.prototype, "weight", {
        get: function () {
            return 1.4;
        },
        enumerable: false,
        configurable: true
    });
    return SaradominDhideBoots;
}(Feet));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Slayer_helmet_imbued.png
const Slayer_helmet_imbued_namespaceObject = __webpack_require__.p + "8e4333a69302dacf6ddb.png";
;// CONCATENATED MODULE: ./src/content/equipment/SlayerHelmet.ts
var SlayerHelmet_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var SlayerHelmet = /** @class */ (function (_super) {
    SlayerHelmet_extends(SlayerHelmet, _super);
    function SlayerHelmet() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.Model = Assets.getAssetUrl("models/player_tzkal_slayer_helmet__i_.glb");
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 3,
                range: 3,
            },
            defence: {
                stab: 30,
                slash: 32,
                crush: 27,
                magic: 10,
                range: 30,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(SlayerHelmet.prototype, "itemName", {
        get: function () {
            return ItemName.SLAYER_HELMET_I;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SlayerHelmet.prototype, "weight", {
        get: function () {
            return 2.267;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SlayerHelmet.prototype, "inventoryImage", {
        get: function () {
            return Slayer_helmet_imbued_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SlayerHelmet.prototype, "model", {
        get: function () {
            return this.Model;
        },
        enumerable: false,
        configurable: true
    });
    return SlayerHelmet;
}(Helmet));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Torva_full_helm.png
const Torva_full_helm_namespaceObject = __webpack_require__.p + "fb3a28ae5f0e22557c22.png";
;// CONCATENATED MODULE: ./src/content/equipment/TorvaFullhelm.ts
var TorvaFullhelm_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var TorvaFullhelm = /** @class */ (function (_super) {
    TorvaFullhelm_extends(TorvaFullhelm, _super);
    function TorvaFullhelm() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -5,
                range: -5,
            },
            defence: {
                stab: 59,
                slash: 60,
                crush: 62,
                magic: -2,
                range: 57,
            },
            other: {
                meleeStrength: 8,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 1,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(TorvaFullhelm.prototype, "itemName", {
        get: function () {
            return ItemName.TORVA_FULL_HELM;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TorvaFullhelm.prototype, "weight", {
        get: function () {
            return 2.721;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TorvaFullhelm.prototype, "inventoryImage", {
        get: function () {
            return Torva_full_helm_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TorvaFullhelm.prototype, "model", {
        get: function () {
            return Assets.getAssetUrl("models/player_sanguine_torva_full_helm.glb");
        },
        enumerable: false,
        configurable: true
    });
    return TorvaFullhelm;
}(Helmet));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Torva_platebody.png
const Torva_platebody_namespaceObject = __webpack_require__.p + "8aea30662351c7f44539.png";
;// CONCATENATED MODULE: ./src/content/equipment/TorvaPlatebody.ts
var TorvaPlatebody_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var TorvaPlatebody = /** @class */ (function (_super) {
    TorvaPlatebody_extends(TorvaPlatebody, _super);
    function TorvaPlatebody() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -18,
                range: -14,
            },
            defence: {
                stab: 117,
                slash: 111,
                crush: 117,
                magic: -11,
                range: 142,
            },
            other: {
                meleeStrength: 6,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 1,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(TorvaPlatebody.prototype, "itemName", {
        get: function () {
            return ItemName.TORVA_PLATEBODY;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TorvaPlatebody.prototype, "weight", {
        get: function () {
            return 9.979;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TorvaPlatebody.prototype, "inventoryImage", {
        get: function () {
            return Torva_platebody_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TorvaPlatebody.prototype, "model", {
        get: function () {
            return Assets.getAssetUrl("models/player_sanguine_torva_platebody.glb");
        },
        enumerable: false,
        configurable: true
    });
    return TorvaPlatebody;
}(Chest));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Torva_platelegs.png
const Torva_platelegs_namespaceObject = __webpack_require__.p + "63d41a914ed6fb1ae456.png";
;// CONCATENATED MODULE: ./src/content/equipment/TorvaPlatelegs.ts
var TorvaPlatelegs_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var TorvaPlatelegs = /** @class */ (function (_super) {
    TorvaPlatelegs_extends(TorvaPlatelegs, _super);
    function TorvaPlatelegs() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -24,
                range: -11,
            },
            defence: {
                stab: 87,
                slash: 78,
                crush: 79,
                magic: -9,
                range: 102,
            },
            other: {
                meleeStrength: 4,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 1,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(TorvaPlatelegs.prototype, "itemName", {
        get: function () {
            return ItemName.TORVA_PLATELEGS;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TorvaPlatelegs.prototype, "weight", {
        get: function () {
            return 9.071;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TorvaPlatelegs.prototype, "inventoryImage", {
        get: function () {
            return Torva_platelegs_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TorvaPlatelegs.prototype, "model", {
        get: function () {
            return Assets.getAssetUrl("models/player_sanguine_torva_platelegs.glb");
        },
        enumerable: false,
        configurable: true
    });
    return TorvaPlatelegs;
}(Legs));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Ultor_ring.png
const Ultor_ring_namespaceObject = __webpack_require__.p + "e15c2dcd7da909808905.png";
;// CONCATENATED MODULE: ./src/content/equipment/UltorRing.ts
var UltorRing_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var UltorRing = /** @class */ (function (_super) {
    UltorRing_extends(UltorRing, _super);
    function UltorRing() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 12,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(UltorRing.prototype, "inventoryImage", {
        get: function () {
            return Ultor_ring_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UltorRing.prototype, "itemName", {
        get: function () {
            return ItemName.ULTOR_RING;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UltorRing.prototype, "weight", {
        get: function () {
            return 0.012;
        },
        enumerable: false,
        configurable: true
    });
    return UltorRing;
}(Ring));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Zaryte_vambraces.png
const Zaryte_vambraces_namespaceObject = __webpack_require__.p + "8a9b26ff4e684d18c31c.png";
;// CONCATENATED MODULE: ./src/content/equipment/ZaryteVambraces.ts
var ZaryteVambraces_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var ZaryteVambraces = /** @class */ (function (_super) {
    ZaryteVambraces_extends(ZaryteVambraces, _super);
    function ZaryteVambraces() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.Model = Assets.getAssetUrl("models/player_zaryte_vambraces.glb");
        _this.bonuses = {
            attack: {
                stab: -8,
                slash: -8,
                crush: -8,
                magic: 0,
                range: 18,
            },
            defence: {
                stab: 8,
                slash: 8,
                crush: 8,
                magic: 5,
                range: 8,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 2,
                magicDamage: 0,
                prayer: 1,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(ZaryteVambraces.prototype, "inventoryImage", {
        get: function () {
            return Zaryte_vambraces_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ZaryteVambraces.prototype, "itemName", {
        get: function () {
            return ItemName.ZARYTE_VAMBRACES;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ZaryteVambraces.prototype, "weight", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ZaryteVambraces.prototype, "model", {
        get: function () {
            return this.Model;
        },
        enumerable: false,
        configurable: true
    });
    return ZaryteVambraces;
}(Gloves));


;// CONCATENATED MODULE: ./src/content/equipment/index.ts
// generated using Generate Index https://marketplace.visualstudio.com/items?itemName=JayFong.generate-index
// @index('./*.ts', f => `export { ${f.name} } from './${f.name}';`)
























































;// CONCATENATED MODULE: ./src/assets/images/potions/Bastion_potion_1.png
const Bastion_potion_1_namespaceObject = __webpack_require__.p + "636af55bf883f8ae8c0b.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Bastion_potion_2.png
const Bastion_potion_2_namespaceObject = __webpack_require__.p + "e5792ad36f5016aa44a6.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Bastion_potion_3.png
const Bastion_potion_3_namespaceObject = __webpack_require__.p + "0f9949a5d8115814d9c7.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Bastion_potion_4.png
const Bastion_potion_4_namespaceObject = __webpack_require__.p + "13c4b13062891ea6eb45.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Vial.png
const Vial_namespaceObject = __webpack_require__.p + "ad696066da7b6acbd886.png";
;// CONCATENATED MODULE: ./src/assets/sounds/liquid_2401.ogg
const liquid_2401_namespaceObject = __webpack_require__.p + "ab6db81a3c50eaab57e3.ogg";
;// CONCATENATED MODULE: ./src/sdk/gear/Potion.ts
var Potion_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var Potion = /** @class */ (function (_super) {
    Potion_extends(Potion, _super);
    function Potion() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.vial = ImageLoader.createImage(Vial_namespaceObject);
        _this.doses = 4;
        _this.defaultAction = "Drink";
        return _this;
    }
    Potion.prototype.drink = function (player) {
        player.interruptCombat();
    };
    Object.defineProperty(Potion.prototype, "weight", {
        get: function () {
            return 0.226;
        },
        enumerable: false,
        configurable: true
    });
    Potion.prototype.updateInventorySprite = function () {
        // Override me
    };
    Object.defineProperty(Potion.prototype, "hasInventoryLeftClick", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Potion.prototype.inventoryLeftClick = function (player) {
        var didDrink = false;
        if (this.doses > 0) {
            didDrink = player.eats.drinkPotion(this);
        }
        if (this.doses === 0) {
            this.consumeItem(player);
        }
        if (didDrink) {
            SoundCache.play(new Sound(liquid_2401_namespaceObject, 0.1));
        }
        this.updateInventorySprite();
    };
    return Potion;
}(Item));


;// CONCATENATED MODULE: ./src/content/items/BastionPotion.ts
var BastionPotion_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var BastionPotion = /** @class */ (function (_super) {
    BastionPotion_extends(BastionPotion, _super);
    function BastionPotion(doses) {
        if (doses === void 0) { doses = 4; }
        var _this = _super.call(this) || this;
        _this.oneDose = ImageLoader.createImage(Bastion_potion_1_namespaceObject);
        _this.twoDose = ImageLoader.createImage(Bastion_potion_2_namespaceObject);
        _this.threeDose = ImageLoader.createImage(Bastion_potion_3_namespaceObject);
        _this.fourDose = ImageLoader.createImage(Bastion_potion_4_namespaceObject);
        _this.doses = doses;
        _this.updateInventorySprite();
        return _this;
    }
    Object.defineProperty(BastionPotion.prototype, "inventoryImage", {
        get: function () {
            if (this.doses === 4) {
                return Bastion_potion_4_namespaceObject;
            }
            else if (this.doses === 3) {
                return Bastion_potion_3_namespaceObject;
            }
            else if (this.doses === 2) {
                return Bastion_potion_2_namespaceObject;
            }
            else if (this.doses === 1) {
                return Bastion_potion_1_namespaceObject;
            }
            return Vial_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BastionPotion.prototype, "itemName", {
        get: function () {
            return ItemName.BASTION_POTION;
        },
        enumerable: false,
        configurable: true
    });
    BastionPotion.prototype.drink = function (player) {
        _super.prototype.drink.call(this, player);
        var rangedBoost = Math.floor(player.stats.range * 0.1) + 4;
        player.currentStats.range += rangedBoost;
        player.currentStats.range = Math.min(player.currentStats.range, player.stats.range + rangedBoost);
        var defenceBoost = Math.floor(player.stats.defence * 0.15) + 5;
        player.currentStats.defence += defenceBoost;
        player.currentStats.defence = Math.min(player.currentStats.defence, player.stats.defence + defenceBoost);
    };
    BastionPotion.prototype.updateInventorySprite = function () {
        if (this.doses === 4) {
            this.inventorySprite = this.fourDose;
        }
        else if (this.doses === 3) {
            this.inventorySprite = this.threeDose;
        }
        else if (this.doses === 2) {
            this.inventorySprite = this.twoDose;
        }
        else if (this.doses === 1) {
            this.inventorySprite = this.oneDose;
        }
        else {
            this.inventorySprite = this.vial;
        }
    };
    return BastionPotion;
}(Potion));


;// CONCATENATED MODULE: ./src/assets/images/potions/Cooked_karambwan.png
const Cooked_karambwan_namespaceObject = __webpack_require__.p + "dc6865db7096d28466a1.png";
;// CONCATENATED MODULE: ./src/sdk/gear/Food.ts
var Food_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var Food = /** @class */ (function (_super) {
    Food_extends(Food, _super);
    function Food() {
        var _this = _super.call(this) || this;
        _this.healAmount = 0;
        _this.inventorySprite = ImageLoader.createImage(_this.inventoryImage);
        _this.defaultAction = "Eat";
        return _this;
    }
    Food.prototype.eat = function (player) {
        player.interruptCombat();
        if (player.currentStats.hitpoint < player.stats.hitpoint) {
            player.currentStats.hitpoint += this.healAmount;
            player.currentStats.hitpoint = Math.min(player.currentStats.hitpoint, player.stats.hitpoint);
        }
    };
    Object.defineProperty(Food.prototype, "weight", {
        get: function () {
            return 0.226;
        },
        enumerable: false,
        configurable: true
    });
    Food.prototype.updateInventorySprite = function () {
        // Override me
    };
    Object.defineProperty(Food.prototype, "hasInventoryLeftClick", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Food.prototype.inventoryLeftClick = function (player) {
        player.eats.eatFood(this);
    };
    return Food;
}(Item));


;// CONCATENATED MODULE: ./src/content/items/Karambwan.ts
var Karambwan_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var Karambwan = /** @class */ (function (_super) {
    Karambwan_extends(Karambwan, _super);
    function Karambwan() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.healAmount = 18;
        _this.inventorySprite = ImageLoader.createImage(Cooked_karambwan_namespaceObject);
        return _this;
    }
    Object.defineProperty(Karambwan.prototype, "inventoryImage", {
        get: function () {
            return Cooked_karambwan_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Karambwan.prototype, "itemName", {
        get: function () {
            return ItemName.KARAMBWAN;
        },
        enumerable: false,
        configurable: true
    });
    Karambwan.prototype.inventoryLeftClick = function (player) {
        player.eats.eatComboFood(this);
    };
    return Karambwan;
}(Food));


;// CONCATENATED MODULE: ./src/assets/images/potions/Saradomin_brew_1.png
const Saradomin_brew_1_namespaceObject = __webpack_require__.p + "6d301986630e5cd961a3.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Saradomin_brew_2.png
const Saradomin_brew_2_namespaceObject = __webpack_require__.p + "07bda9025bed6f655105.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Saradomin_brew_3.png
const Saradomin_brew_3_namespaceObject = __webpack_require__.p + "ec6a5f708194be82511e.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Saradomin_brew_4.png
const Saradomin_brew_4_namespaceObject = __webpack_require__.p + "a576a0f0be7654477a6a.png";
;// CONCATENATED MODULE: ./src/content/items/SaradominBrew.ts
var SaradominBrew_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var SaradominBrew = /** @class */ (function (_super) {
    SaradominBrew_extends(SaradominBrew, _super);
    function SaradominBrew(doses) {
        if (doses === void 0) { doses = 4; }
        var _this = _super.call(this) || this;
        _this.oneDose = ImageLoader.createImage(Saradomin_brew_1_namespaceObject);
        _this.twoDose = ImageLoader.createImage(Saradomin_brew_2_namespaceObject);
        _this.threeDose = ImageLoader.createImage(Saradomin_brew_3_namespaceObject);
        _this.fourDose = ImageLoader.createImage(Saradomin_brew_4_namespaceObject);
        _this.doses = doses;
        _this.updateInventorySprite();
        return _this;
    }
    Object.defineProperty(SaradominBrew.prototype, "inventoryImage", {
        get: function () {
            if (this.doses === 4) {
                return Saradomin_brew_4_namespaceObject;
            }
            else if (this.doses === 3) {
                return Saradomin_brew_3_namespaceObject;
            }
            else if (this.doses === 2) {
                return Saradomin_brew_2_namespaceObject;
            }
            else if (this.doses === 1) {
                return Saradomin_brew_1_namespaceObject;
            }
            return Vial_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaradominBrew.prototype, "itemName", {
        get: function () {
            return ItemName.SARADOMIN_BREW;
        },
        enumerable: false,
        configurable: true
    });
    SaradominBrew.prototype.drink = function (player) {
        _super.prototype.drink.call(this, player);
        var healAmount = Math.floor(player.stats.hitpoint * 0.15) + 2;
        player.currentStats.hitpoint += healAmount;
        player.currentStats.hitpoint = Math.max(1, Math.min(player.currentStats.hitpoint, player.stats.hitpoint + healAmount));
        var defenceBoost = Math.floor(player.currentStats.defence * 0.2) + 2;
        var maxDefenceBoost = Math.floor(player.stats.defence * 0.2) + 2;
        player.currentStats.defence += defenceBoost;
        player.currentStats.defence = Math.max(1, Math.min(player.currentStats.defence, player.stats.defence + maxDefenceBoost));
        var attackNerf = Math.floor(player.currentStats.attack * 0.1) + 2;
        player.currentStats.attack -= attackNerf;
        player.currentStats.attack = Math.max(1, Math.min(player.currentStats.attack, player.stats.attack + attackNerf));
        var strengthNerf = Math.floor(player.currentStats.strength * 0.1) + 2;
        player.currentStats.strength -= strengthNerf;
        player.currentStats.strength = Math.max(1, Math.min(player.currentStats.strength, player.stats.strength + strengthNerf));
        var rangeNerf = Math.floor(player.currentStats.range * 0.1) + 2;
        player.currentStats.range -= rangeNerf;
        player.currentStats.range = Math.max(1, Math.min(player.currentStats.range, player.stats.range + rangeNerf));
        var magicNerf = Math.floor(player.currentStats.magic * 0.1) + 2;
        player.currentStats.magic -= magicNerf;
        player.currentStats.magic = Math.max(1, Math.min(player.currentStats.magic, player.stats.magic + magicNerf));
    };
    SaradominBrew.prototype.updateInventorySprite = function () {
        if (this.doses === 4) {
            this.inventorySprite = this.fourDose;
        }
        else if (this.doses === 3) {
            this.inventorySprite = this.threeDose;
        }
        else if (this.doses === 2) {
            this.inventorySprite = this.twoDose;
        }
        else if (this.doses === 1) {
            this.inventorySprite = this.oneDose;
        }
        else {
            this.inventorySprite = this.vial;
        }
    };
    return SaradominBrew;
}(Potion));


;// CONCATENATED MODULE: ./src/assets/images/potions/Shark.png
const Shark_namespaceObject = __webpack_require__.p + "5fd9b1d13620db82a7ba.png";
;// CONCATENATED MODULE: ./src/content/items/Shark.ts
var Shark_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var Shark = /** @class */ (function (_super) {
    Shark_extends(Shark, _super);
    function Shark() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.healAmount = 20;
        _this.inventorySprite = ImageLoader.createImage(Shark_namespaceObject);
        return _this;
    }
    Object.defineProperty(Shark.prototype, "inventoryImage", {
        get: function () {
            return Shark_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Shark.prototype, "itemName", {
        get: function () {
            return ItemName.SHARK;
        },
        enumerable: false,
        configurable: true
    });
    return Shark;
}(Food));


;// CONCATENATED MODULE: ./src/assets/images/potions/Stamina_potion_1.png
const Stamina_potion_1_namespaceObject = __webpack_require__.p + "fb99098de0399de96dc7.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Stamina_potion_2.png
const Stamina_potion_2_namespaceObject = __webpack_require__.p + "aadc9ce4a625f6c0b93a.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Stamina_potion_3.png
const Stamina_potion_3_namespaceObject = __webpack_require__.p + "6ca719b61b657e86ba8f.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Stamina_potion_4.png
const Stamina_potion_4_namespaceObject = __webpack_require__.p + "d0a151c232cc32080774.png";
;// CONCATENATED MODULE: ./src/content/items/StaminaPotion.ts
var StaminaPotion_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var StaminaPotion = /** @class */ (function (_super) {
    StaminaPotion_extends(StaminaPotion, _super);
    function StaminaPotion(doses) {
        if (doses === void 0) { doses = 4; }
        var _this = _super.call(this) || this;
        _this.oneDose = ImageLoader.createImage(Stamina_potion_1_namespaceObject);
        _this.twoDose = ImageLoader.createImage(Stamina_potion_2_namespaceObject);
        _this.threeDose = ImageLoader.createImage(Stamina_potion_3_namespaceObject);
        _this.fourDose = ImageLoader.createImage(Stamina_potion_4_namespaceObject);
        _this.doses = doses;
        _this.updateInventorySprite();
        return _this;
    }
    Object.defineProperty(StaminaPotion.prototype, "inventoryImage", {
        get: function () {
            if (this.doses === 4) {
                return Stamina_potion_4_namespaceObject;
            }
            else if (this.doses === 3) {
                return Stamina_potion_3_namespaceObject;
            }
            else if (this.doses === 2) {
                return Stamina_potion_2_namespaceObject;
            }
            else if (this.doses === 1) {
                return Stamina_potion_1_namespaceObject;
            }
            return Vial_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StaminaPotion.prototype, "itemName", {
        get: function () {
            return ItemName.STAMINA_POTION;
        },
        enumerable: false,
        configurable: true
    });
    StaminaPotion.prototype.drink = function (player) {
        _super.prototype.drink.call(this, player);
        player.effects.stamina = 200; // 2 minutes = 200 ticks
        player.currentStats.run += 2000;
        player.currentStats.run = Math.min(Math.max(player.currentStats.run, 0), 10000);
    };
    StaminaPotion.prototype.updateInventorySprite = function () {
        if (this.doses === 4) {
            this.inventorySprite = this.fourDose;
        }
        else if (this.doses === 3) {
            this.inventorySprite = this.threeDose;
        }
        else if (this.doses === 2) {
            this.inventorySprite = this.twoDose;
        }
        else if (this.doses === 1) {
            this.inventorySprite = this.oneDose;
        }
        else {
            this.inventorySprite = this.vial;
        }
    };
    return StaminaPotion;
}(Potion));


;// CONCATENATED MODULE: ./src/assets/images/potions/Super_combat_potion_1.png
const Super_combat_potion_1_namespaceObject = __webpack_require__.p + "b6f74412d077c073d2b6.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Super_combat_potion_2.png
const Super_combat_potion_2_namespaceObject = __webpack_require__.p + "336099951e549fed3760.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Super_combat_potion_3.png
const Super_combat_potion_3_namespaceObject = __webpack_require__.p + "4879c086e7bbb593b315.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Super_combat_potion_4.png
const Super_combat_potion_4_namespaceObject = __webpack_require__.p + "8fcc0e9f8e481a8e2bbb.png";
;// CONCATENATED MODULE: ./src/content/items/SuperCombatPotion.ts
var SuperCombatPotion_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var SuperCombatPotion = /** @class */ (function (_super) {
    SuperCombatPotion_extends(SuperCombatPotion, _super);
    function SuperCombatPotion(doses) {
        if (doses === void 0) { doses = 4; }
        var _this = _super.call(this) || this;
        _this.oneDose = ImageLoader.createImage(Super_combat_potion_1_namespaceObject);
        _this.twoDose = ImageLoader.createImage(Super_combat_potion_2_namespaceObject);
        _this.threeDose = ImageLoader.createImage(Super_combat_potion_3_namespaceObject);
        _this.fourDose = ImageLoader.createImage(Super_combat_potion_4_namespaceObject);
        _this.doses = doses;
        _this.updateInventorySprite();
        return _this;
    }
    Object.defineProperty(SuperCombatPotion.prototype, "inventoryImage", {
        get: function () {
            if (this.doses === 4) {
                return Super_combat_potion_4_namespaceObject;
            }
            else if (this.doses === 3) {
                return Super_combat_potion_3_namespaceObject;
            }
            else if (this.doses === 2) {
                return Super_combat_potion_2_namespaceObject;
            }
            else if (this.doses === 1) {
                return Super_combat_potion_1_namespaceObject;
            }
            return Vial_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuperCombatPotion.prototype, "itemName", {
        get: function () {
            return ItemName.SUPER_COMBAT_POTION;
        },
        enumerable: false,
        configurable: true
    });
    SuperCombatPotion.prototype.drink = function (player) {
        _super.prototype.drink.call(this, player);
        var boost = function (stat) {
            var boost = Math.floor(player.stats[stat] * 0.15) + 5;
            player.currentStats[stat] += boost;
            player.currentStats[stat] = Math.min(player.currentStats[stat], player.stats[stat] + boost);
        };
        boost('strength');
        boost('attack');
        boost('defence');
    };
    SuperCombatPotion.prototype.updateInventorySprite = function () {
        if (this.doses === 4) {
            this.inventorySprite = this.fourDose;
        }
        else if (this.doses === 3) {
            this.inventorySprite = this.threeDose;
        }
        else if (this.doses === 2) {
            this.inventorySprite = this.twoDose;
        }
        else if (this.doses === 1) {
            this.inventorySprite = this.oneDose;
        }
        else {
            this.inventorySprite = this.vial;
        }
    };
    return SuperCombatPotion;
}(Potion));


;// CONCATENATED MODULE: ./src/assets/images/potions/Super_restore_1.png
const Super_restore_1_namespaceObject = __webpack_require__.p + "892a956fd6bf47c01da2.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Super_restore_2.png
const Super_restore_2_namespaceObject = __webpack_require__.p + "80698cf160e1397c6584.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Super_restore_3.png
const Super_restore_3_namespaceObject = __webpack_require__.p + "f133e18ee4792571230f.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Super_restore_4.png
const Super_restore_4_namespaceObject = __webpack_require__.p + "25999282f61594e19650.png";
;// CONCATENATED MODULE: ./src/content/items/SuperRestore.ts
var SuperRestore_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var SuperRestore = /** @class */ (function (_super) {
    SuperRestore_extends(SuperRestore, _super);
    function SuperRestore(doses) {
        if (doses === void 0) { doses = 4; }
        var _this = _super.call(this) || this;
        _this.oneDose = ImageLoader.createImage(Super_restore_1_namespaceObject);
        _this.twoDose = ImageLoader.createImage(Super_restore_2_namespaceObject);
        _this.threeDose = ImageLoader.createImage(Super_restore_3_namespaceObject);
        _this.fourDose = ImageLoader.createImage(Super_restore_4_namespaceObject);
        _this.doses = doses;
        _this.updateInventorySprite();
        return _this;
    }
    Object.defineProperty(SuperRestore.prototype, "inventoryImage", {
        get: function () {
            if (this.doses === 4) {
                return Super_restore_4_namespaceObject;
            }
            else if (this.doses === 3) {
                return Super_restore_3_namespaceObject;
            }
            else if (this.doses === 2) {
                return Super_restore_2_namespaceObject;
            }
            else if (this.doses === 1) {
                return Super_restore_1_namespaceObject;
            }
            return Vial_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuperRestore.prototype, "itemName", {
        get: function () {
            return ItemName.SUPER_RESTORE;
        },
        enumerable: false,
        configurable: true
    });
    SuperRestore.prototype.drink = function (player) {
        _super.prototype.drink.call(this, player);
        var prayerBonus = Math.floor(player.stats.prayer * 0.27) + 8;
        player.currentStats.prayer += prayerBonus;
        player.currentStats.prayer = Math.min(player.currentStats.prayer, player.stats.prayer);
        if (player.currentStats.attack < player.stats.attack) {
            var attackBonus = Math.floor(player.stats.attack * 0.25) + 8;
            player.currentStats.attack += attackBonus;
            player.currentStats.attack = Math.min(player.currentStats.attack, player.stats.attack);
        }
        if (player.currentStats.strength < player.stats.strength) {
            var strengthBonus = Math.floor(player.stats.strength * 0.25) + 8;
            player.currentStats.strength += strengthBonus;
            player.currentStats.strength = Math.min(player.currentStats.strength, player.stats.strength);
        }
        if (player.currentStats.range < player.stats.range) {
            var rangeBonus = Math.floor(player.stats.range * 0.25) + 8;
            player.currentStats.range += rangeBonus;
            player.currentStats.range = Math.min(player.currentStats.range, player.stats.range);
        }
        if (player.currentStats.magic < player.stats.magic) {
            var magicBonus = Math.floor(player.stats.magic * 0.25) + 8;
            player.currentStats.magic += magicBonus;
            player.currentStats.magic = Math.min(player.currentStats.magic, player.stats.magic);
        }
    };
    SuperRestore.prototype.updateInventorySprite = function () {
        if (this.doses === 4) {
            this.inventorySprite = this.fourDose;
        }
        else if (this.doses === 3) {
            this.inventorySprite = this.threeDose;
        }
        else if (this.doses === 2) {
            this.inventorySprite = this.twoDose;
        }
        else if (this.doses === 1) {
            this.inventorySprite = this.oneDose;
        }
        else {
            this.inventorySprite = this.vial;
        }
    };
    return SuperRestore;
}(Potion));


;// CONCATENATED MODULE: ./src/content/items/index.ts
// generated using Generate Index https://marketplace.visualstudio.com/items?itemName=JayFong.generate-index
// @index('./*.ts', f => `export { ${f.name} } from './${f.name}';`)








;// CONCATENATED MODULE: ./src/assets/images/equipment/Ancient_staff.png
const Ancient_staff_namespaceObject = __webpack_require__.p + "d024f094c1755b6c5a08.png";
;// CONCATENATED MODULE: ./src/content/weapons/AncientStaff.ts

var AncientStaff_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var AncientStaff = /** @class */ (function (_super) {
    AncientStaff_extends(AncientStaff, _super);
    function AncientStaff() {
        var _this = _super.call(this) || this;
        _this.bonuses = {
            attack: {
                stab: 10,
                slash: -1,
                crush: 40,
                magic: 15,
                range: 0,
            },
            defence: {
                stab: 2,
                slash: 3,
                crush: 1,
                magic: 15,
                range: 0,
            },
            other: {
                meleeStrength: 50,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: -1,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    AncientStaff.prototype.attackStyles = function () {
        return [AttackStyle.ACCURATE, AttackStyle.AGGRESSIVECRUSH, AttackStyle.DEFENSIVE];
    };
    AncientStaff.prototype.attackStyleCategory = function () {
        return AttackStyleTypes.STAFF;
    };
    AncientStaff.prototype.defaultStyle = function () {
        return AttackStyle.AGGRESSIVECRUSH;
    };
    Object.defineProperty(AncientStaff.prototype, "itemName", {
        get: function () {
            return ItemName.ANCIENT_STAFF;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AncientStaff.prototype, "isTwoHander", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    AncientStaff.prototype.hasSpecialAttack = function () {
        return false;
    };
    Object.defineProperty(AncientStaff.prototype, "attackRange", {
        get: function () {
            // TODO: Override with spell selection
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AncientStaff.prototype, "attackSpeed", {
        get: function () {
            return 4;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AncientStaff.prototype, "inventoryImage", {
        get: function () {
            return Ancient_staff_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return AncientStaff;
}(MeleeWeapon));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Black_chinchompa.png
const Black_chinchompa_namespaceObject = __webpack_require__.p + "5c47f1bf32c8560a8368.png";
;// CONCATENATED MODULE: ./src/assets/sounds/thrown_axe_2706.ogg
const thrown_axe_2706_namespaceObject = __webpack_require__.p + "0648b6fcd16341f7a75d.ogg";
;// CONCATENATED MODULE: ./src/assets/sounds/chinchompa_explode_360.ogg
const chinchompa_explode_360_namespaceObject = __webpack_require__.p + "5d0bebb1af2cac15e023.ogg";
;// CONCATENATED MODULE: ./src/content/weapons/BlackChinchompa.ts

var BlackChinchompa_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var BlackChinchompa_assign = (undefined && undefined.__assign) || function () {
    BlackChinchompa_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return BlackChinchompa_assign.apply(this, arguments);
};










var BlackChinchompa = /** @class */ (function (_super) {
    BlackChinchompa_extends(BlackChinchompa, _super);
    function BlackChinchompa() {
        var _this = _super.call(this) || this;
        _this.maxConcurrentHits = 9;
        _this.Model = Assets.getAssetUrl("models/player_black_chinchompa.glb");
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 80,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 30,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    // same as toxic blowpipe and other thrown weapon
    BlackChinchompa.prototype.calculateHitDelay = function (distance) {
        return Math.floor(distance / 6) + 1;
    };
    BlackChinchompa.prototype.attackStyles = function () {
        return [AttackStyle.SHORT_FUSE, AttackStyle.MEDIUM_FUSE, AttackStyle.LONG_FUSE];
    };
    BlackChinchompa.prototype.attackStyleCategory = function () {
        return AttackStyleTypes.CHINCHOMPA;
    };
    BlackChinchompa.prototype.defaultStyle = function () {
        return AttackStyle.MEDIUM_FUSE;
    };
    Object.defineProperty(BlackChinchompa.prototype, "attackSpeed", {
        get: function () {
            if (this.attackStyle() === AttackStyle.MEDIUM_FUSE) {
                return 3;
            }
            return 4;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlackChinchompa.prototype, "weight", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlackChinchompa.prototype, "itemName", {
        get: function () {
            return ItemName.BLACK_CHINCHOMPA;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlackChinchompa.prototype, "isTwoHander", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlackChinchompa.prototype, "attackRange", {
        get: function () {
            if (this.attackStyle() === AttackStyle.LONG_FUSE) {
                return 10;
            }
            return 9;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlackChinchompa.prototype, "inventoryImage", {
        get: function () {
            return Black_chinchompa_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlackChinchompa.prototype, "attackSound", {
        get: function () {
            return new Sound(thrown_axe_2706_namespaceObject, 0.1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlackChinchompa.prototype, "attackLandingSound", {
        get: function () {
            return new Sound(chinchompa_explode_360_namespaceObject, 0.1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlackChinchompa.prototype, "aoe", {
        get: function () {
            return [
                { x: 0, y: 0 },
                { x: -1, y: -1 },
                { x: -1, y: 0 },
                { x: -1, y: 1 },
                { x: 0, y: -1 },
                { x: 0, y: 1 },
                { x: 1, y: -1 },
                { x: 1, y: 0 },
                { x: 1, y: 1 },
            ];
        },
        enumerable: false,
        configurable: true
    });
    BlackChinchompa.prototype.attack = function (from, to, bonuses, options) {
        var _this = this;
        if (bonuses === void 0) { bonuses = {}; }
        if (options === void 0) { options = {}; }
        if (this.aoe.length) {
            var alreadyCastedOn_1 = [to];
            var initialResult = _super.prototype.attack.call(this, from, to, bonuses, options);
            if (initialResult) {
                this.aoe.forEach(function (point) {
                    Pathing.mobsAtAoeOffset(from.region, to, point).forEach(function (mob) {
                        if (alreadyCastedOn_1.length > _this.maxConcurrentHits) {
                            return;
                        }
                        if (alreadyCastedOn_1.indexOf(mob) > -1) {
                            return;
                        }
                        alreadyCastedOn_1.push(mob);
                        // HACK: chin gets massive accuracy bonus if main roll hits
                        from.bonuses.attack.range += 100000;
                        _super.prototype.attack.call(_this, from, mob, bonuses, BlackChinchompa_assign(BlackChinchompa_assign({}, options), { hidden: true }));
                        from.bonuses.attack.range -= 100000;
                    });
                });
            }
            return initialResult;
        }
        else {
            return _super.prototype.attack.call(this, from, to, bonuses, options);
        }
    };
    Object.defineProperty(BlackChinchompa.prototype, "model", {
        get: function () {
            return this.Model;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlackChinchompa.prototype, "attackAnimationId", {
        get: function () {
            return PlayerAnimationIndices.ThrowChinchompa;
        },
        enumerable: false,
        configurable: true
    });
    return BlackChinchompa;
}(RangedWeapon));


;// CONCATENATED MODULE: ./src/assets/images/weapons/Blade_of_saeldor.png
const Blade_of_saeldor_namespaceObject = __webpack_require__.p + "a301225fcfef86c6e1eb.png";
;// CONCATENATED MODULE: ./src/assets/sounds/scythe_swing_2524.ogg
const scythe_swing_2524_namespaceObject = __webpack_require__.p + "e29b7dcebd4355ba70c5.ogg";
;// CONCATENATED MODULE: ./src/content/weapons/BladeOfSaeldor.ts
var BladeOfSaeldor_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var BladeOfSaeldor = /** @class */ (function (_super) {
    BladeOfSaeldor_extends(BladeOfSaeldor, _super);
    function BladeOfSaeldor() {
        var _this = _super.call(this) || this;
        _this.Model = Assets.getAssetUrl("models/player_blade_of_saeldor.glb");
        _this.bonuses = {
            attack: {
                stab: 55,
                slash: 94,
                crush: 0,
                magic: 0,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 89,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    BladeOfSaeldor.prototype.attackStyles = function () {
        return [AttackStyle.ACCURATE, AttackStyle.AGGRESSIVESLASH, AttackStyle.STAB, AttackStyle.DEFENSIVE];
    };
    BladeOfSaeldor.prototype.attackStyleCategory = function () {
        return AttackStyleTypes.SLASHSWORD;
    };
    BladeOfSaeldor.prototype.defaultStyle = function () {
        return AttackStyle.AGGRESSIVESLASH;
    };
    Object.defineProperty(BladeOfSaeldor.prototype, "itemName", {
        get: function () {
            return ItemName.BLADE_OF_SAELDOR;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BladeOfSaeldor.prototype, "isTwoHander", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    BladeOfSaeldor.prototype.hasSpecialAttack = function () {
        return false;
    };
    Object.defineProperty(BladeOfSaeldor.prototype, "attackRange", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BladeOfSaeldor.prototype, "attackSpeed", {
        get: function () {
            return 4;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BladeOfSaeldor.prototype, "inventoryImage", {
        get: function () {
            return Blade_of_saeldor_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BladeOfSaeldor.prototype, "model", {
        get: function () {
            return this.Model;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BladeOfSaeldor.prototype, "attackAnimationId", {
        get: function () {
            return PlayerAnimationIndices.SwordSlash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BladeOfSaeldor.prototype, "idleAnimationId", {
        get: function () {
            return PlayerAnimationIndices.Idle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BladeOfSaeldor.prototype, "attackSound", {
        get: function () {
            return new Sound(scythe_swing_2524_namespaceObject, 0.1);
        },
        enumerable: false,
        configurable: true
    });
    return BladeOfSaeldor;
}(MeleeWeapon));


;// CONCATENATED MODULE: ./src/assets/images/weapons/blowpipe.png
const blowpipe_namespaceObject = __webpack_require__.p + "8c5cdb0e15f1a0d457b5.png";
;// CONCATENATED MODULE: ./src/assets/sounds/dart_2696.ogg
const dart_2696_namespaceObject = __webpack_require__.p + "2233c709847618502501.ogg";
;// CONCATENATED MODULE: ./src/assets/sounds/snake_hit_800.ogg
const snake_hit_800_namespaceObject = __webpack_require__.p + "0dbd74bee50215229d64.ogg";
;// CONCATENATED MODULE: ./src/content/weapons/Blowpipe.ts

var Blowpipe_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Blowpipe_assign = (undefined && undefined.__assign) || function () {
    Blowpipe_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return Blowpipe_assign.apply(this, arguments);
};










var Blowpipe = /** @class */ (function (_super) {
    Blowpipe_extends(Blowpipe, _super);
    function Blowpipe() {
        var _this = _super.call(this, {
            modelScale: 1 / 128,
            visualDelayTicks: 1,
            visualHitEarlyTicks: 0,
            verticalOffset: -0.75,
            motionInterpolator: new ArcProjectileMotionInterpolator(0.5),
        }) || this;
        _this.Model = Assets.getAssetUrl("models/player_toxic_blowpipe.glb");
        _this.ProjectileModel = Assets.getAssetUrl("models/dragon_dart.glb");
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 30,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 20 + 35,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        SoundCache.preload(_this.attackSound.src);
        return _this;
    }
    Blowpipe.prototype.calculateHitDelay = function (distance) {
        return Math.floor(distance / 6) + 1;
    };
    Blowpipe.prototype.attackStyles = function () {
        return [AttackStyle.ACCURATE, AttackStyle.RAPID, AttackStyle.LONGRANGE];
    };
    Blowpipe.prototype.attackStyleCategory = function () {
        return AttackStyleTypes.THROWN;
    };
    Blowpipe.prototype.defaultStyle = function () {
        return AttackStyle.RAPID;
    };
    Object.defineProperty(Blowpipe.prototype, "attackRange", {
        get: function () {
            if (this.attackStyle() === AttackStyle.LONGRANGE) {
                return 7;
            }
            return 5;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Blowpipe.prototype, "attackSpeed", {
        get: function () {
            if (this.attackStyle() === AttackStyle.LONGRANGE) {
                return 3;
            }
            return 2;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Blowpipe.prototype, "weight", {
        get: function () {
            return 0.5;
        },
        enumerable: false,
        configurable: true
    });
    Blowpipe.prototype.specialAttack = function (from, to, bonuses, options) {
        if (bonuses === void 0) { bonuses = {}; }
        if (options === void 0) { options = {}; }
        _super.prototype.specialAttack.call(this, from, to, bonuses, options);
        bonuses.isSpecialAttack = true;
        // BP special attack takes an extra tick to land
        _super.prototype.attack.call(this, from, to, bonuses, Blowpipe_assign(Blowpipe_assign({}, options), { reduceDelay: -1, visualHitEarlyTicks: 1, visualDelayTicks: 1, projectileSound: this.specialAttackSound }));
        var healAttackerBy = Math.floor(this.damageRoll / 2);
        from.currentStats.hitpoint += healAttackerBy;
        from.currentStats.hitpoint = Math.min(from.currentStats.hitpoint, from.stats.hitpoint);
    };
    Blowpipe.prototype._damageMultiplier = function (from, to, bonuses) {
        if (bonuses.isSpecialAttack) {
            return 1.5;
        }
        return 1;
    };
    Blowpipe.prototype._accuracyMultiplier = function (from, to, bonuses) {
        if (bonuses.isSpecialAttack) {
            return 2;
        }
        return 1;
    };
    Object.defineProperty(Blowpipe.prototype, "itemName", {
        get: function () {
            return ItemName.TOXIC_BLOWPIPE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Blowpipe.prototype, "isTwoHander", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Blowpipe.prototype.hasSpecialAttack = function () {
        return true;
    };
    Object.defineProperty(Blowpipe.prototype, "inventoryImage", {
        get: function () {
            return blowpipe_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Blowpipe.prototype, "attackSound", {
        get: function () {
            return new Sound(dart_2696_namespaceObject, 0.1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Blowpipe.prototype, "specialAttackSound", {
        get: function () {
            return new Sound(snake_hit_800_namespaceObject, 0.5);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Blowpipe.prototype, "model", {
        get: function () {
            return this.Model;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Blowpipe.prototype, "attackAnimationId", {
        get: function () {
            return PlayerAnimationIndices.FireBlowpipe;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Blowpipe.prototype, "projectileModel", {
        get: function () {
            return this.ProjectileModel;
        },
        enumerable: false,
        configurable: true
    });
    return Blowpipe;
}(RangedWeapon));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Bow_of_faerdhinen.png
const Bow_of_faerdhinen_namespaceObject = __webpack_require__.p + "8395f74e86249d12c9b1.png";
;// CONCATENATED MODULE: ./src/assets/sounds/crystal_bow_1352.ogg
const crystal_bow_1352_namespaceObject = __webpack_require__.p + "809317c701bbc35d5120.ogg";
;// CONCATENATED MODULE: ./src/content/weapons/BowOfFaerdhinen.ts

var BowOfFaerdhinen_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var BowOfFaerdhinen = /** @class */ (function (_super) {
    BowOfFaerdhinen_extends(BowOfFaerdhinen, _super);
    function BowOfFaerdhinen() {
        var _this = _super.call(this) || this;
        _this.Model = Assets.getAssetUrl("models/player_bow_of_faerdhinen.glb");
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 128,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 106,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    BowOfFaerdhinen.prototype.attackStyles = function () {
        return [AttackStyle.ACCURATE, AttackStyle.RAPID, AttackStyle.LONGRANGE];
    };
    BowOfFaerdhinen.prototype.attackStyleCategory = function () {
        return AttackStyleTypes.BOW;
    };
    BowOfFaerdhinen.prototype.defaultStyle = function () {
        return AttackStyle.RAPID;
    };
    Object.defineProperty(BowOfFaerdhinen.prototype, "attackSound", {
        get: function () {
            return new Sound(crystal_bow_1352_namespaceObject, 0.1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BowOfFaerdhinen.prototype, "attackSpeed", {
        get: function () {
            if (this.attackStyle() === AttackStyle.LONGRANGE) {
                return 5;
            }
            return 4;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BowOfFaerdhinen.prototype, "weight", {
        get: function () {
            return 1.5;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BowOfFaerdhinen.prototype, "itemName", {
        get: function () {
            return ItemName.BOWFA;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BowOfFaerdhinen.prototype, "isTwoHander", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BowOfFaerdhinen.prototype, "attackRange", {
        get: function () {
            return 10;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BowOfFaerdhinen.prototype, "inventoryImage", {
        get: function () {
            return Bow_of_faerdhinen_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    BowOfFaerdhinen.prototype._accuracyMultiplier = function (from, to, bonuses) {
        return from.bonuses.other.crystalAccuracy || 1;
    };
    BowOfFaerdhinen.prototype._damageMultiplier = function (from, to, bonuses) {
        return from.bonuses.other.crystalDamage || 1;
    };
    Object.defineProperty(BowOfFaerdhinen.prototype, "model", {
        get: function () {
            return this.Model;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BowOfFaerdhinen.prototype, "attackAnimationId", {
        get: function () {
            return PlayerAnimationIndices.FireBow;
        },
        enumerable: false,
        configurable: true
    });
    return BowOfFaerdhinen;
}(RangedWeapon));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Kodai_wand.png
const Kodai_wand_namespaceObject = __webpack_require__.p + "4d6670d0c42d9d3e1d79.png";
;// CONCATENATED MODULE: ./src/content/weapons/KodaiWand.ts

var KodaiWand_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var KodaiWand = /** @class */ (function (_super) {
    KodaiWand_extends(KodaiWand, _super);
    function KodaiWand() {
        var _this = _super.call(this) || this;
        _this.autocastSpell = new BloodBarrageSpell();
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 28,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 3,
                crush: 3,
                magic: 20,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0.15,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    KodaiWand.prototype.attack = function (from, to, bonuses) {
        if (bonuses === void 0) { bonuses = {}; }
        if (this.attackStyle() === AttackStyle.AUTOCAST) {
            if (from.isPlayer) {
                var player = from;
                if (player.autocastDelay === 0) {
                    this.autocastSpell.cast(from, to);
                    return true;
                }
                if (player.autocastDelay > 0) {
                    player.autocastDelay--;
                }
                return false;
            }
        }
        return _super.prototype.attack.call(this, from, to, bonuses);
    };
    KodaiWand.prototype.attackStyles = function () {
        return [AttackStyle.ACCURATE, AttackStyle.AGGRESSIVECRUSH, AttackStyle.DEFENSIVE, AttackStyle.AUTOCAST];
    };
    KodaiWand.prototype.attackStyleCategory = function () {
        return AttackStyleTypes.STAFF;
    };
    KodaiWand.prototype.defaultStyle = function () {
        return AttackStyle.AUTOCAST;
    };
    Object.defineProperty(KodaiWand.prototype, "weight", {
        get: function () {
            return 0.198;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KodaiWand.prototype, "itemName", {
        get: function () {
            return ItemName.KODAI_WAND;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KodaiWand.prototype, "isTwoHander", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    KodaiWand.prototype.hasSpecialAttack = function () {
        return false;
    };
    Object.defineProperty(KodaiWand.prototype, "attackRange", {
        get: function () {
            if (this.attackStyle() === AttackStyle.AUTOCAST) {
                return 10;
            }
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KodaiWand.prototype, "attackSpeed", {
        get: function () {
            if (this.attackStyle() === AttackStyle.AUTOCAST) {
                return 5;
            }
            return 4;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KodaiWand.prototype, "inventoryImage", {
        get: function () {
            return Kodai_wand_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return KodaiWand;
}(MeleeWeapon));


;// CONCATENATED MODULE: ./src/assets/images/weapons/scytheOfVitur.png
const scytheOfVitur_namespaceObject = __webpack_require__.p + "670ddc4f152a60d91516.png";
;// CONCATENATED MODULE: ./src/content/weapons/ScytheOfVitur.ts
var ScytheOfVitur_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var ScytheOfVitur_assign = (undefined && undefined.__assign) || function () {
    ScytheOfVitur_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return ScytheOfVitur_assign.apply(this, arguments);
};









var EXTRA_HIT_LOCATIONS = [
    [
        [-1, -1],
        [1, -1],
    ],
    [
        [1, 1],
        [1, -1],
    ],
    [
        [-1, 1],
        [1, 1],
    ],
    [
        [-1, 1],
        [-1, -1],
    ], // West
];
var ScytheOfVitur = /** @class */ (function (_super) {
    ScytheOfVitur_extends(ScytheOfVitur, _super);
    function ScytheOfVitur() {
        var _this = _super.call(this) || this;
        _this.bonuses = {
            attack: {
                stab: 70,
                slash: 125,
                crush: 30,
                magic: -6,
                range: 0,
            },
            defence: {
                stab: -2,
                slash: 8,
                crush: 10,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 75,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    ScytheOfVitur.prototype.attackStyles = function () {
        return [AttackStyle.REAP, AttackStyle.AGGRESSIVESLASH, AttackStyle.AGGRESSIVECRUSH, AttackStyle.DEFENSIVE];
    };
    ScytheOfVitur.prototype.attackStyleCategory = function () {
        return AttackStyleTypes.SCYTHE;
    };
    ScytheOfVitur.prototype.defaultStyle = function () {
        return AttackStyle.AGGRESSIVESLASH;
    };
    Object.defineProperty(ScytheOfVitur.prototype, "itemName", {
        get: function () {
            return ItemName.SCYTHE_OF_VITUR;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScytheOfVitur.prototype, "isTwoHander", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    ScytheOfVitur.prototype.hasSpecialAttack = function () {
        return false;
    };
    Object.defineProperty(ScytheOfVitur.prototype, "attackRange", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScytheOfVitur.prototype, "attackSpeed", {
        get: function () {
            return 5;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScytheOfVitur.prototype, "inventoryImage", {
        get: function () {
            return scytheOfVitur_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    ScytheOfVitur.prototype.attack = function (from, to, bonuses) {
        var _this = this;
        var region = from.region;
        // As there is no concept of player direction yet, we dynamically calculate this based on the relative location of
        // the attacker.
        // Find the closest tile on the npc to us.
        var targetTile = to.getClosestTileTo(from.location.x, from.location.y);
        var dx = from.location.x - targetTile[0];
        var dy = from.location.y - targetTile[1];
        var direction;
        if (dx < 0) {
            direction = 1; // East
        }
        else if (dx > 0) {
            direction = 3; // West
        }
        else if (dy < 0) {
            direction = 2; // South
        }
        else {
            direction = 0; // North
        }
        // Full damage attack, but each subsequent hit does half of the last.
        var multiplier = 1.0;
        _super.prototype.attack.call(this, from, to, bonuses);
        EXTRA_HIT_LOCATIONS[direction].forEach(function (hit) {
            var xx = from.location.x + hit[0];
            var yy = from.location.y + hit[1];
            var collision = Collision.collidesWithAnyMobs(region, xx, yy, from.size);
            multiplier *= 0.5;
            var extraHitBonuses = ScytheOfVitur_assign(ScytheOfVitur_assign({}, bonuses), { overallMultiplier: multiplier });
            if (collision) {
                _super.prototype.attack.call(_this, from, collision, extraHitBonuses);
            }
            else {
                _super.prototype.attack.call(_this, from, to, extraHitBonuses);
            }
        });
        return true;
    };
    Object.defineProperty(ScytheOfVitur.prototype, "model", {
        get: function () {
            return Assets.getAssetUrl("models/player_sanguine_scythe_of_vitur.glb");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScytheOfVitur.prototype, "attackAnimationId", {
        get: function () {
            return PlayerAnimationIndices.ScytheSwing;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScytheOfVitur.prototype, "idleAnimationId", {
        get: function () {
            return PlayerAnimationIndices.ScytheIdle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScytheOfVitur.prototype, "attackSound", {
        get: function () {
            return new Sound(scythe_swing_2524_namespaceObject, 0.1);
        },
        enumerable: false,
        configurable: true
    });
    return ScytheOfVitur;
}(MeleeWeapon));


;// CONCATENATED MODULE: ./src/assets/images/weapons/twistedBow.png
const twistedBow_namespaceObject = __webpack_require__.p + "b2079f07ece4024ef387.png";
;// CONCATENATED MODULE: ./src/assets/sounds/shortbow_2702.ogg
const shortbow_2702_namespaceObject = __webpack_require__.p + "2ce638c76332bb029a35.ogg";
;// CONCATENATED MODULE: ./src/content/weapons/TwistedBow.ts

var TwistedBow_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









var TwistedBow = /** @class */ (function (_super) {
    TwistedBow_extends(TwistedBow, _super);
    function TwistedBow(geno) {
        if (geno === void 0) { geno = false; }
        var _this = _super.call(this, {
            modelScale: 1 / 128,
            visualDelayTicks: 1,
            visualHitEarlyTicks: 1,
            verticalOffset: -0.75,
            motionInterpolator: new ArcProjectileMotionInterpolator(1),
        }) || this;
        _this.Model = Assets.getAssetUrl("models/player_twisted_bow.glb");
        _this.ProjectileModel = Assets.getAssetUrl("models/dragon_arrow.glb");
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: geno ? 10000 : 70,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: geno ? 80 : 20,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        SoundCache.preload(_this.attackSound.src);
        return _this;
    }
    TwistedBow.prototype.compatibleAmmo = function () {
        return [ItemName.DRAGON_ARROWS];
    };
    TwistedBow.prototype.attackStyles = function () {
        return [AttackStyle.ACCURATE, AttackStyle.RAPID, AttackStyle.LONGRANGE];
    };
    TwistedBow.prototype.attackStyleCategory = function () {
        return AttackStyleTypes.BOW;
    };
    TwistedBow.prototype.defaultStyle = function () {
        return AttackStyle.RAPID;
    };
    Object.defineProperty(TwistedBow.prototype, "attackSpeed", {
        get: function () {
            if (this.attackStyle() === AttackStyle.LONGRANGE) {
                return 6;
            }
            return 5;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TwistedBow.prototype, "attackSound", {
        get: function () {
            return new Sound(shortbow_2702_namespaceObject, 0.1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TwistedBow.prototype, "weight", {
        get: function () {
            return 1.814;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TwistedBow.prototype, "itemName", {
        get: function () {
            return ItemName.TWISTED_BOW;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TwistedBow.prototype, "isTwoHander", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TwistedBow.prototype, "attackRange", {
        get: function () {
            return 10;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TwistedBow.prototype, "inventoryImage", {
        get: function () {
            return twistedBow_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    TwistedBow.prototype._accuracyMultiplier = function (from, to, bonuses) {
        var magic = Math.min(Math.max(to.currentStats.magic, to.bonuses.attack.magic), 250);
        var multiplier = (140 + ((10 * 3 * magic) / 10 - 10) / 100 - Math.pow((3 * magic) / 10 - 100, 2) / 100) / 100;
        return Math.min(1.4, Math.max(0, multiplier));
    };
    TwistedBow.prototype._damageMultiplier = function (from, to, bonuses) {
        var magic = Math.min(Math.max(to.currentStats.magic, to.bonuses.attack.magic), 250);
        var multiplier = (250 + ((10 * 3 * magic) / 10 - 14) / 100 - Math.pow((3 * magic) / 10 - 140, 2) / 100) / 100;
        return Math.min(2.5, Math.max(0, multiplier));
    };
    Object.defineProperty(TwistedBow.prototype, "model", {
        get: function () {
            return this.Model;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TwistedBow.prototype, "attackAnimationId", {
        get: function () {
            return PlayerAnimationIndices.FireBow;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TwistedBow.prototype, "projectileModel", {
        get: function () {
            return this.ProjectileModel;
        },
        enumerable: false,
        configurable: true
    });
    return TwistedBow;
}(RangedWeapon));


;// CONCATENATED MODULE: ./src/content/weapons/index.ts
// generated using Generate Index https://marketplace.visualstudio.com/items?itemName=JayFong.generate-index
// @index('./*.ts', f => `export { ${f.name} } from './${f.name}';`)









;// CONCATENATED MODULE: ./src/content/index.ts






;// CONCATENATED MODULE: ./src/sdk/ui/Button.ts



var Button_ACTIVE_BUTTON_IMAGE = ImageLoader.createImage(button_active_namespaceObject);
var Button_INACTIVE_BUTTON_IMAGE = ImageLoader.createImage(button_inactive_namespaceObject);
var Button = /** @class */ (function () {
    function Button(label, xOffset, yOffset, onClick, activeButtonImage, inactiveButtonImage, overlayInactive) {
        if (activeButtonImage === void 0) { activeButtonImage = Button_ACTIVE_BUTTON_IMAGE; }
        if (inactiveButtonImage === void 0) { inactiveButtonImage = Button_INACTIVE_BUTTON_IMAGE; }
        if (overlayInactive === void 0) { overlayInactive = false; }
        this.label = label;
        this.xOffset = xOffset;
        this.yOffset = yOffset;
        this.onClick = onClick;
        this.activeButtonImage = activeButtonImage;
        this.inactiveButtonImage = inactiveButtonImage;
        this.overlayInactive = overlayInactive;
        this.hovered = false;
    }
    Button.prototype.draw = function (context, scale, panelX, panelY) {
        context.drawImage(this.hovered || this.overlayInactive ? this.activeButtonImage : this.inactiveButtonImage, panelX + this.xOffset * scale, panelY + this.yOffset * scale, this.activeButtonImage.width * scale, this.activeButtonImage.height * scale);
        if (this.overlayInactive && !this.hovered) {
            context.drawImage(this.inactiveButtonImage, panelX + this.xOffset * scale, panelY + this.yOffset * scale, this.inactiveButtonImage.width * scale, this.inactiveButtonImage.height * scale);
        }
        context.save();
        context.fillStyle = "#FFFF00";
        context.font = 16 * scale + "px OSRS";
        context.textBaseline = "middle";
        context.textAlign = "center";
        context.fillText(this.label, panelX + (this.xOffset + this.activeButtonImage.width / 2) * scale, panelY + (this.yOffset + Button_ACTIVE_BUTTON_IMAGE.height / 2) * scale);
        context.restore();
    };
    Button.prototype._isMouseOver = function (x, y) {
        return (x >= this.xOffset &&
            x <= this.xOffset + this.activeButtonImage.width &&
            y >= this.yOffset &&
            y <= this.yOffset + this.activeButtonImage.height);
    };
    Button.prototype.onPanelClick = function (x, y) {
        if (this._isMouseOver(x, y)) {
            this.onClick();
            return true;
        }
        return false;
    };
    Button.prototype.onMouseMove = function (x, y) {
        this.hovered = this._isMouseOver(x, y);
        return this.hovered;
    };
    return Button;
}());


;// CONCATENATED MODULE: ./src/sdk/Region.ts

var Region_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var Region_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};






var CardinalDirection;
(function (CardinalDirection) {
    CardinalDirection[CardinalDirection["NORTH"] = 0] = "NORTH";
    CardinalDirection[CardinalDirection["SOUTH"] = 1] = "SOUTH";
})(CardinalDirection || (CardinalDirection = {}));
// Base class for any trainer region.
var Region = /** @class */ (function () {
    function Region() {
        this.players = [];
        this.newMobs = [];
        this.mobs = [];
        this.entities = [];
        // free-floating projectiles not associated with a mob/player. TODO maybe they all should be here.
        this.projectiles = [];
        this.groundItems = {};
    }
    Object.defineProperty(Region.prototype, "serialNumber", {
        get: function () {
            if (!this._serialNumber) {
                this._serialNumber = String(Math.random());
            }
            return this._serialNumber;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Region.prototype, "initialFacing", {
        get: function () {
            return CardinalDirection.SOUTH;
        },
        enumerable: false,
        configurable: true
    });
    Region.prototype.midTick = function () {
        // Override me
    };
    Region.prototype.postTick = function () {
        // Override me
    };
    Region.prototype.addPlayer = function (player) {
        this.players.push(player);
        player.addedToWorld();
    };
    Region.prototype.rightClickActions = function () {
        return [];
    };
    Object.defineProperty(Region.prototype, "context", {
        get: function () {
            if (!this.canvas) {
                if (Settings.mobileCheck()) {
                    this.canvas = new OffscreenCanvas(2000, 2000);
                }
                else {
                    this.canvas = new OffscreenCanvas(10000, 10000);
                }
            }
            return this.canvas.getContext("2d");
        },
        enumerable: false,
        configurable: true
    });
    Region.prototype.addEntity = function (entity) {
        this.entities.push(entity);
    };
    Region.prototype.removeEntity = function (entity) {
        entity.dying = 0;
        (0,lodash.remove)(this.entities, entity);
    };
    Region.prototype.addMob = function (mob) {
        if (!mob.region.world) {
            this.mobs.push(mob);
            mob.addedToWorld();
        }
        else {
            this.newMobs.push(mob);
        }
    };
    Region.prototype.removeMob = function (mob) {
        (0,lodash.remove)(this.mobs, mob);
    };
    Region.prototype.removePlayer = function (player) {
        (0,lodash.remove)(this.players, player);
        if (this.players.length === 0) {
            this.onGameOver();
        }
    };
    Region.prototype.addGroundItem = function (player, item, x, y) {
        if (!this.groundItems[x]) {
            this.groundItems[x] = {};
        }
        if (!this.groundItems[x][y]) {
            this.groundItems[x][y] = [];
        }
        item.groundLocation = { x: player.location.x, y: player.location.y };
        this.groundItems[x][y].push(item);
    };
    Region.prototype.addProjectile = function (projectile) {
        this.projectiles.push(projectile);
    };
    Region.prototype.removeProjectile = function (projectile) {
        (0,lodash.remove)(this.projectiles, projectile);
    };
    Region.prototype.getName = function () {
        return "My Region";
    };
    Object.defineProperty(Region.prototype, "width", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Region.prototype, "height", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Region.prototype.mapImagePath = function () {
        return "";
    };
    Region.prototype.drawWorldBackground = function (context, scale) {
        // Override me
    };
    Region.prototype.drawDefaultFloor = function () {
        return true;
    };
    Region.prototype.groundItemsAtLocation = function (x, y) {
        return (this.groundItems[x] ? this.groundItems[x][y] : []) || [];
    };
    Region.prototype.removeGroundItem = function (item, x, y) {
        if (this.groundItems[x]) {
            if (this.groundItems[x][y]) {
                (0,lodash.remove)(this.groundItems[x][y], item);
            }
        }
    };
    Region.prototype.drawGroundItems = function (ctx) {
        var _this = this;
        Object.entries(this.groundItems).forEach(function (scope1) {
            var x = parseInt(scope1[0]);
            Object.entries(_this.groundItems[x]).forEach(function (scope2) {
                var y = parseInt(scope2[0]);
                var items = _this.groundItems[x][y];
                items.forEach(function (item) {
                    ctx.drawImage(item.inventorySprite, x * Settings.tileSize, y * Settings.tileSize, Settings.tileSize, Settings.tileSize);
                });
            });
        });
    };
    Region.prototype.reset = function () {
        this.players = [];
        this.mobs = [];
        this.newMobs = [];
        this.entities = [];
        this.projectiles = [];
        this.groundItems = {};
        TileMarker.loadAll(this);
        Viewport.viewport.reset();
        var reset = this.initialiseRegion();
        Viewport.viewport.setPlayer(reset.player);
        return reset;
    };
    Region.prototype.onGameOver = function () {
        // Override me
        Viewport.viewport.components.push(new Button("Reset", 120, 60, function () { return Trainer.reset(); }));
    };
    Region.prototype.getSidebarContent = function () {
        return "Nothing to see here";
    };
    // calls preload on all renderable children
    Region.prototype.preload = function () {
        return Region_awaiter(this, void 0, void 0, function () {
            return Region_generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(this.entities.map(function (entity) { return entity.preload(); }))];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, Promise.all(this.mobs.map(function (mob) { return mob.preload(); }))];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, Promise.all(this.newMobs.map(function (mob) { return mob.preload(); }))];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, Promise.all(this.players.map(function (players) { return players.preload(); }))];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return Region;
}());


;// CONCATENATED MODULE: ./node_modules/three/examples/jsm/libs/stats.module.js
var Stats = function () {

	var mode = 0;

	var container = document.createElement( 'div' );
	container.style.cssText = 'position:fixed;top:0;left:0;cursor:pointer;opacity:0.9;z-index:10000';
	container.addEventListener( 'click', function ( event ) {

		event.preventDefault();
		showPanel( ++ mode % container.children.length );

	}, false );

	//

	function addPanel( panel ) {

		container.appendChild( panel.dom );
		return panel;

	}

	function showPanel( id ) {

		for ( var i = 0; i < container.children.length; i ++ ) {

			container.children[ i ].style.display = i === id ? 'block' : 'none';

		}

		mode = id;

	}

	//

	var beginTime = ( performance || Date ).now(), prevTime = beginTime, frames = 0;

	var fpsPanel = addPanel( new Stats.Panel( 'FPS', '#0ff', '#002' ) );
	var msPanel = addPanel( new Stats.Panel( 'MS', '#0f0', '#020' ) );

	if ( self.performance && self.performance.memory ) {

		var memPanel = addPanel( new Stats.Panel( 'MB', '#f08', '#201' ) );

	}

	showPanel( 0 );

	return {

		REVISION: 16,

		dom: container,

		addPanel: addPanel,
		showPanel: showPanel,

		begin: function () {

			beginTime = ( performance || Date ).now();

		},

		end: function () {

			frames ++;

			var time = ( performance || Date ).now();

			msPanel.update( time - beginTime, 200 );

			if ( time >= prevTime + 1000 ) {

				fpsPanel.update( ( frames * 1000 ) / ( time - prevTime ), 100 );

				prevTime = time;
				frames = 0;

				if ( memPanel ) {

					var memory = performance.memory;
					memPanel.update( memory.usedJSHeapSize / 1048576, memory.jsHeapSizeLimit / 1048576 );

				}

			}

			return time;

		},

		update: function () {

			beginTime = this.end();

		},

		// Backwards Compatibility

		domElement: container,
		setMode: showPanel

	};

};

Stats.Panel = function ( name, fg, bg ) {

	var min = Infinity, max = 0, round = Math.round;
	var PR = round( window.devicePixelRatio || 1 );

	var WIDTH = 80 * PR, HEIGHT = 48 * PR,
		TEXT_X = 3 * PR, TEXT_Y = 2 * PR,
		GRAPH_X = 3 * PR, GRAPH_Y = 15 * PR,
		GRAPH_WIDTH = 74 * PR, GRAPH_HEIGHT = 30 * PR;

	var canvas = document.createElement( 'canvas' );
	canvas.width = WIDTH;
	canvas.height = HEIGHT;
	canvas.style.cssText = 'width:80px;height:48px';

	var context = canvas.getContext( '2d' );
	context.font = 'bold ' + ( 9 * PR ) + 'px Helvetica,Arial,sans-serif';
	context.textBaseline = 'top';

	context.fillStyle = bg;
	context.fillRect( 0, 0, WIDTH, HEIGHT );

	context.fillStyle = fg;
	context.fillText( name, TEXT_X, TEXT_Y );
	context.fillRect( GRAPH_X, GRAPH_Y, GRAPH_WIDTH, GRAPH_HEIGHT );

	context.fillStyle = bg;
	context.globalAlpha = 0.9;
	context.fillRect( GRAPH_X, GRAPH_Y, GRAPH_WIDTH, GRAPH_HEIGHT );

	return {

		dom: canvas,

		update: function ( value, maxValue ) {

			min = Math.min( min, value );
			max = Math.max( max, value );

			context.fillStyle = bg;
			context.globalAlpha = 1;
			context.fillRect( 0, 0, WIDTH, GRAPH_Y );
			context.fillStyle = fg;
			context.fillText( round( value ) + ' ' + name + ' (' + round( min ) + '-' + round( max ) + ')', TEXT_X, TEXT_Y );

			context.drawImage( canvas, GRAPH_X + PR, GRAPH_Y, GRAPH_WIDTH - PR, GRAPH_HEIGHT, GRAPH_X, GRAPH_Y, GRAPH_WIDTH - PR, GRAPH_HEIGHT );

			context.fillRect( GRAPH_X + GRAPH_WIDTH - PR, GRAPH_Y, PR, GRAPH_HEIGHT );

			context.fillStyle = bg;
			context.globalAlpha = 0.9;
			context.fillRect( GRAPH_X + GRAPH_WIDTH - PR, GRAPH_Y, PR, round( ( 1 - ( value / maxValue ) ) * GRAPH_HEIGHT ) );

		}

	};

};

/* harmony default export */ const stats_module = (Stats);

;// CONCATENATED MODULE: ./src/sdk/rendering/Actor.ts
var Actor = /** @class */ (function () {
    function Actor(unit) {
        this.unit = unit;
        this.model = unit.get3dModel();
    }
    Actor.prototype.draw = function (scene, clockDelta, tickPercent) {
        if (!this.model) {
            return;
        }
        var worldLocation = this.unit.getPerceivedLocation(tickPercent);
        var rotationRadians = this.unit.getPerceivedRotation(tickPercent);
        var pitchRadians = this.unit.getPerceivedPitch(tickPercent);
        var modelOffsets = this.unit.getPerceivedOffsets(tickPercent);
        this.model.draw(scene, clockDelta, tickPercent, worldLocation, rotationRadians, pitchRadians, this.unit.visible(tickPercent), modelOffsets);
    };
    Actor.prototype.shouldRemove = function () {
        return this.unit.shouldDestroy();
    };
    Actor.prototype.getModel = function () {
        return this.model;
    };
    Actor.prototype.destroy = function (scene) {
        var _a;
        (_a = this.model) === null || _a === void 0 ? void 0 : _a.destroy(scene);
    };
    return Actor;
}());


;// CONCATENATED MODULE: ./src/sdk/Viewport3d.ts

var Viewport3d_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var Viewport3d_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var Viewport3d_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};










// how many pixels wide should 2d elements be scaled to
var SPRITE_SCALE = 32;
var MIN_PITCH = -Math.PI / 2;
var MAX_PITCH = 0.1;
var FLOOR_Y_POS = -0.5;
var ROTATE_MULT = 0.006;
var ZOOM_MULT = 0.005;
var TOUCH_MULT = 2;
var Viewport3d = /** @class */ (function () {
    function Viewport3d(faceCameraSouth) {
        if (faceCameraSouth === void 0) { faceCameraSouth = true; }
        var _this = this;
        this.canvasDimensions = this.calculateCanvasDimensions();
        this.pivot = new external_three_.Object3D();
        this.yaw = new external_three_.Object3D();
        this.pitch = new external_three_.Object3D();
        this.yawDelta = 0;
        this.pitchDelta = 0;
        this.touchStart = null;
        this.touchStart2 = null;
        this.stats = new stats_module();
        this.knownActors = new Map();
        this.selectedTile = null;
        this.clock = new external_three_.Clock();
        this.scene = new external_three_.Scene();
        this.canvas = new OffscreenCanvas(this.canvasDimensions.width, this.canvasDimensions.height);
        this.uiCanvas = new OffscreenCanvas(this.canvasDimensions.width, this.canvasDimensions.height);
        this.uiCanvasContext = this.uiCanvas.getContext("2d");
        this.checkGpu();
        this.camera = new external_three_.PerspectiveCamera(70, this.canvasDimensions.width / this.canvasDimensions.height, 0.1, 50);
        this.raycaster = new external_three_.Raycaster();
        this.raycaster.params.Points.threshold = 0.1;
        this.raycaster.params.Line.threshold = 0.1;
        var worldCanvas = document.getElementById("world");
        this.initCameraEvents(worldCanvas);
        window.addEventListener("resize", function () { return _this.updateCanvasSize(); });
        this.renderer = new external_three_.WebGLRenderer({
            canvas: this.canvas,
            logarithmicDepthBuffer: true,
            antialias: true,
            //precision: "lowp", // is this making everything purple on mobile?
        });
        // Set up camera positioning
        this.camera.position.set(0, 1, 0);
        this.pivot.position.set(0, 0, 0);
        // Face south
        if (faceCameraSouth) {
            this.yaw.rotation.y = Math.PI;
        }
        // Pitch down slightly
        this.pitch.rotation.x = -0.7;
        // Zoom out
        this.camera.position.z = 12;
        this.scene.add(this.pivot);
        this.pivot.add(this.yaw);
        this.yaw.add(this.pitch);
        this.pitch.add(this.camera);
        var lineMaterial = new external_three_.LineBasicMaterial({
            color: "#FFFFFF",
            linewidth: 2,
        });
        var points = [
            new external_three_.Vector3(0, 0, 0),
            new external_three_.Vector3(1, 0, 0),
            new external_three_.Vector3(1, 0, 0),
            new external_three_.Vector3(1, 0, -1),
            new external_three_.Vector3(1, 0, -1),
            new external_three_.Vector3(0, 0, -1),
            new external_three_.Vector3(0, 0, -1),
            new external_three_.Vector3(0, 0, 0),
        ];
        var geometry = new external_three_.BufferGeometry().setFromPoints(points);
        this.selectedTileMesh = new external_three_.LineSegments(geometry, lineMaterial);
        this.scene.add(this.selectedTileMesh);
        this.animate();
    }
    Viewport3d.prototype.checkGpu = function () {
        var _a, _b;
        try {
            var canvas = document.createElement("canvas");
            var gl = canvas.getContext("webgl");
            var debugInfo = gl === null || gl === void 0 ? void 0 : gl.getExtension("WEBGL_debug_renderer_info");
            var gpuInfo = (_b = (_a = gl === null || gl === void 0 ? void 0 : gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL)) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : "none";
            if (gpuInfo.includes("nvidia") ||
                gpuInfo.includes("gpu") ||
                gpuInfo.includes("geforce") ||
                gpuInfo.includes("amd") ||
                gpuInfo.includes("radeon")) {
                return;
            }
            if (gpuInfo === "none" || gpuInfo.includes("google") || gpuInfo.includes("apple") || gpuInfo.includes("intel")) {
                document.getElementById("gpu_warning").innerHTML =
                    "<span style=\"color: #FF6666\">Software rendering detected. Framerate may be low. Turn on Hardware Acceleration in your browser if you have a GPU.<br />".concat(gpuInfo, "</span>");
            }
        }
        catch (err) {
            console.warn("error trying to detect gpu", err);
        }
    };
    // implementation from https://codepen.io/seanwasere/pen/BaMBoPd
    Viewport3d.prototype.onDocumentMouseMove = function (e) {
        if ((e.buttons & 4) !== 4)
            return;
        this.yaw.rotation.y -= e.movementX * ROTATE_MULT;
        var v = this.pitch.rotation.x - e.movementY * ROTATE_MULT;
        if (v > MIN_PITCH && v < MAX_PITCH) {
            this.pitch.rotation.x = v;
        }
        return false;
    };
    Viewport3d.prototype.onDocumentMouseWheel = function (e) {
        var v = this.camera.position.z + e.deltaY * ZOOM_MULT;
        if (v >= 2 && v <= 20) {
            this.camera.position.z = v;
        }
        e.preventDefault();
        return false;
    };
    Viewport3d.prototype.onDocumentTouchStart = function (e) {
        if (e.touches.length >= 1) {
            this.touchStart = e.touches[0];
        }
        if (e.touches.length === 2) {
            this.touchStart2 = e.touches[1];
        }
    };
    Viewport3d.prototype.onDocumentTouchMove = function (e) {
        if (!this.touchStart) {
            return;
        }
        if (e.touches.length === 1) {
            // drag - rotate
            var deltaX = (e.touches[0].clientX - this.touchStart.clientX) * TOUCH_MULT;
            var deltaY = (e.touches[0].clientY - this.touchStart.clientY) * TOUCH_MULT;
            this.yaw.rotation.y -= deltaX * ROTATE_MULT;
            var v = this.pitch.rotation.x - deltaY * ROTATE_MULT;
            if (v > MIN_PITCH && v < MAX_PITCH) {
                this.pitch.rotation.x = v;
            }
            this.touchStart = e.touches[0];
        }
        else if (e.touches.length === 2 && this.touchStart2 !== null) {
            // pinch - zoom
            var oldDist = Pathing.dist(this.touchStart.clientX, this.touchStart.clientY, this.touchStart2.clientX, this.touchStart2.clientY);
            var currentDist = Pathing.dist(e.touches[0].clientX, e.touches[0].clientY, e.touches[1].clientX, e.touches[1].clientY);
            var delta = (oldDist - currentDist) * TOUCH_MULT;
            var v = this.camera.position.z + delta * ZOOM_MULT;
            if (v >= 2 && v <= 20) {
                this.camera.position.z = v;
            }
            this.touchStart = e.touches[0];
            this.touchStart2 = e.touches[1];
        }
        e.preventDefault();
        return false;
    };
    Viewport3d.prototype.onDocumentTouchEnd = function (e) {
        this.touchStart = null;
        this.touchStart2 = null;
    };
    Viewport3d.prototype.onKeyDown = function (e) {
        var allowWasd = !Settings.isUsingWasdKeybind;
        if (!allowWasd && ["w", "a", "s", "d"].includes(e.key.toLowerCase())) {
            return;
        }
        // values are desired change per second
        switch (e.key) {
            case "ArrowLeft":
            case "a":
            case "A":
                this.yawDelta = -2;
                break;
            case "ArrowRight":
            case "d":
            case "D":
                this.yawDelta = 2;
                break;
            case "ArrowUp":
            case "w":
            case "W":
                this.pitchDelta = -1;
                break;
            case "ArrowDown":
            case "s":
            case "S":
                this.pitchDelta = 1;
                break;
        }
    };
    Viewport3d.prototype.onKeyUp = function (e) {
        var allowWasd = !Settings.isUsingWasdKeybind;
        if (!allowWasd && ["w", "a", "s", "d"].includes(e.key.toLowerCase())) {
            return;
        }
        switch (e.key) {
            case "ArrowLeft":
            case "ArrowRight":
            case "a":
            case "d":
            case "A":
            case "D":
                this.yawDelta = 0;
                break;
            case "ArrowUp":
            case "ArrowDown":
            case "w":
            case "s":
            case "W":
            case "S":
                this.pitchDelta = 0;
                break;
        }
    };
    Viewport3d.prototype.initCameraEvents = function (canvas) {
        canvas.addEventListener("mousemove", this.onDocumentMouseMove.bind(this), false);
        canvas.addEventListener("wheel", this.onDocumentMouseWheel.bind(this), false);
        canvas.addEventListener("touchstart", this.onDocumentTouchStart.bind(this), false);
        canvas.addEventListener("touchmove", this.onDocumentTouchMove.bind(this), false);
        canvas.addEventListener("touchend", this.onDocumentTouchEnd.bind(this), false);
        window.addEventListener("keydown", this.onKeyDown.bind(this), false);
        window.addEventListener("keyup", this.onKeyUp.bind(this), false);
    };
    Viewport3d.prototype.calculateCanvasDimensions = function () {
        var _a = Chrome.size(), width = _a.width, height = _a.height;
        var visibleWidth = width - (Settings.menuVisible ? 232 : 0);
        return { width: visibleWidth, height: height };
    };
    Viewport3d.prototype.render = function () {
        this.renderer.render(this.scene, this.camera);
    };
    Viewport3d.prototype.animate = function () {
        var _this = this;
        this.animateHandle = requestAnimationFrame(function () { return _this.animate(); });
        this.render();
        this.stats.update();
    };
    Viewport3d.prototype.initialise = function (world, region) {
        return Viewport3d_awaiter(this, void 0, void 0, function () {
            var hemiLight, ambientLight, floorCanvas, floorContext, floorTexture, floorGeometry, floorMaterial, plane;
            return Viewport3d_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        document.body.appendChild(this.stats.dom);
                        hemiLight = new external_three_.HemisphereLight(0xffffff, 0xffffff);
                        hemiLight.position.set(0, 100, 0);
                        this.scene.add(hemiLight);
                        ambientLight = new external_three_.AmbientLight(0xffffff, 1);
                        this.scene.add(ambientLight);
                        floorCanvas = new OffscreenCanvas(region.width * SPRITE_SCALE, region.height * SPRITE_SCALE);
                        floorContext = floorCanvas.getContext("2d");
                        region.drawWorldBackground(floorContext, SPRITE_SCALE);
                        floorTexture = new external_three_.Texture(floorCanvas);
                        floorTexture.needsUpdate = true;
                        floorGeometry = new external_three_.PlaneGeometry(region.width, region.height, 1, 1);
                        floorMaterial = new external_three_.MeshStandardMaterial({
                            map: floorTexture,
                            transparent: true,
                            color: 0xffffff,
                            side: external_three_.FrontSide,
                        });
                        floorGeometry.rotateX(-Math.PI / 2);
                        floorGeometry.translate(region.width / 2, FLOOR_Y_POS, region.height / 2 - 1);
                        plane = new external_three_.Mesh(floorGeometry, floorMaterial);
                        plane.userData.clickable = true;
                        // used for right-click walk here
                        plane.userData.isFloor = true;
                        plane.visible = Trainer.player.region.drawDefaultFloor();
                        this.scene.add(plane);
                        this.scene.add(this.selectedTileMesh);
                        // preload by adding a bunch of models to the scene but out of sight
                        return [4 /*yield*/, Trainer.player.region.preload()];
                    case 1:
                        // preload by adding a bunch of models to the scene but out of sight
                        _a.sent();
                        return [4 /*yield*/, this.renderer.compileAsync(this.scene, this.camera)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Viewport3d.prototype.reset = function () {
        var _this = this;
        this.knownActors.forEach(function (actor) { return actor.destroy(_this.scene); });
        this.knownActors = new Map();
    };
    Viewport3d.prototype.updateCanvasSize = function () {
        // update canvas if necessary
        var newDimensions = this.calculateCanvasDimensions();
        if (newDimensions.width !== this.canvasDimensions.width || newDimensions.height !== this.canvasDimensions.height) {
            this.canvas.width = newDimensions.width;
            this.canvas.height = newDimensions.height;
            this.uiCanvas.width = newDimensions.width;
            this.uiCanvas.height = newDimensions.height;
            this.camera.aspect = newDimensions.width / newDimensions.height;
            this.camera.updateProjectionMatrix();
            this.renderer.setSize(newDimensions.width, newDimensions.height, false);
            this.canvasDimensions = newDimensions;
        }
    };
    Viewport3d.prototype.draw = function (world, region) {
        this.updateCanvasSize();
        this.draw3dScene(world, region);
        this.draw2dScene(world, region);
        return {
            canvas: this.canvas,
            uiCanvas: this.uiCanvas,
            flip: false,
            offsetX: 0,
            offsetY: 0,
        };
    };
    Viewport3d.prototype.updateCamera = function (delta) {
        this.yaw.rotation.y += this.yawDelta * delta;
        this.pitch.rotation.x = Math.max(Math.min(this.pitch.rotation.x + this.pitchDelta * delta, MAX_PITCH), MIN_PITCH);
    };
    Viewport3d.prototype.draw3dScene = function (world, region) {
        var _this = this;
        // create actors
        region.entities.forEach(function (entity) {
            var actor = _this.knownActors.get(entity);
            if (!actor) {
                actor = new Actor(entity);
                _this.knownActors.set(entity, actor);
            }
        });
        var projectiles = [];
        region.players.forEach(function (player) {
            var actor = _this.knownActors.get(player);
            if (!actor) {
                actor = new Actor(player);
                _this.knownActors.set(player, actor);
            }
            // Update the camera position relative to the player's mesh
            var v = new external_three_.Vector3(0.5, 0, -0.5);
            v.add(actor.getModel().getWorldPosition());
            _this.pivot.position.lerp(v, 0.1);
            // Add all projectiles to scene
            projectiles.push.apply(projectiles, player.incomingProjectiles);
        });
        region.mobs.concat(region.newMobs).forEach(function (mob) {
            var actor = _this.knownActors.get(mob);
            if (!actor) {
                actor = new Actor(mob);
                _this.knownActors.set(mob, actor);
            }
            // Add all projectiles to scene
            projectiles.push.apply(projectiles, mob.incomingProjectiles);
        });
        region.projectiles.forEach(function (projectile) {
            var actor = _this.knownActors.get(projectile);
            if (!actor) {
                actor = new Actor(projectile);
                _this.knownActors.set(projectile, actor);
            }
            // Add all projectiles to scene
            projectiles.push(projectile);
        });
        projectiles.forEach(function (projectile) {
            var actor = _this.knownActors.get(projectile);
            if (!actor) {
                actor = new Actor(projectile);
                _this.knownActors.set(projectile, actor);
            }
        });
        var delta = this.clock.getDelta();
        this.updateCamera(delta);
        this.knownActors.forEach(function (actor, entity) {
            if (actor.shouldRemove()) {
                // remove destroyed actors
                actor.destroy(_this.scene);
                _this.knownActors.delete(entity);
            }
            else {
                actor.draw(_this.scene, delta, world.tickPercent);
            }
        });
        // highlight selected tile
        if (this.selectedTile) {
            this.selectedTileMesh.position.x = this.selectedTile.x - 0.5;
            this.selectedTileMesh.position.y = -0.49;
            this.selectedTileMesh.position.z = this.selectedTile.y - 0.5;
            this.selectedTileMesh.visible = !Trainer.clickController.hasSelectedMob();
        }
    };
    Viewport3d.prototype.draw2dScene = function (world, region) {
        var _this = this;
        // draw UI elements into a separate canvas that gets drawn over the 3d canvas
        this.uiCanvasContext.clearRect(0, 0, this.uiCanvas.width, this.uiCanvas.height);
        var translator = function (pos, z) {
            if (z === void 0) { z = 0; }
            return _this.projectToScreen(new external_three_.Vector3(pos.x, z, pos.y));
        };
        var get2dOffset = function (r) {
            var perceivedLocation = r.getPerceivedLocation(world.tickPercent);
            var _a = translator({
                x: perceivedLocation.x + r.size / 2,
                y: perceivedLocation.y - r.size / 2,
            }, r.height), x = _a.x, y = _a.y;
            return { x: x, y: y };
        };
        var units = Viewport3d_spreadArray(Viewport3d_spreadArray([], region.players, true), (world.getReadyTimer <= 0 ? region.mobs : []), true);
        var renderables = units.concat(region.entities);
        renderables.forEach(function (r) {
            r.drawUILayer(world.tickPercent, get2dOffset(r), _this.uiCanvasContext, SPRITE_SCALE, false);
        });
    };
    // return canvas coordinates from world coordinates
    Viewport3d.prototype.projectToScreen = function (vector) {
        var newVector = vector.clone();
        newVector.project(this.camera);
        var _a = this.canvasDimensions, width = _a.width, height = _a.height;
        return {
            x: Math.round((newVector.x + 1) * (width / 2)),
            y: Math.round((-newVector.y + 1) * (height / 2)),
        };
    };
    // return intersection with world object or world coordinates from canvas coordinates
    Viewport3d.prototype.translateClick = function (offsetX, offsetY, world, viewport) {
        var _a = this.canvasDimensions, width = _a.width, height = _a.height;
        var rayX = (offsetX / width) * 2 - 1;
        var rayY = -(offsetY / height) * 2 + 1;
        this.raycaster.setFromCamera(new external_three_.Vector2(rayX, rayY), this.camera);
        // check intersection of the ray and the flor plane
        var floorPlane = new external_three_.Plane(new external_three_.Vector3(0, -1, 0), FLOOR_Y_POS);
        var floor = new external_three_.Vector3(0, 0, 0);
        this.raycaster.ray.intersectPlane(floorPlane, floor);
        this.selectedTile = {
            x: Math.floor(floor.x) + 0.5,
            y: Math.floor(floor.z) + 1.5,
        };
        var intersections = this.raycaster.intersectObjects(this.scene.children.filter(function (c) { return c.userData.clickable === true; }));
        // check if there were any NPCs on the way.
        var mobs = intersections
            .filter(function (i) { return i.object.userData.unit instanceof Mob; })
            .map(function (i) { return i.object.userData.unit; });
        // Note: we currently only handle clicking on mobs
        if (mobs.length > 0) {
            return {
                type: "entities",
                mobs: lodash_default().uniq(mobs),
                players: [],
                groundItems: [],
                location: {
                    x: this.selectedTile.x,
                    y: this.selectedTile.y,
                },
            };
        }
        return {
            type: "coordinate",
            location: {
                x: this.selectedTile.x,
                y: this.selectedTile.y,
            },
        };
    };
    Viewport3d.prototype.setMapRotation = function (direction) {
        if (direction === CardinalDirection.SOUTH) {
            this.yaw.rotation.y = Math.PI;
        }
        else if (direction === CardinalDirection.NORTH) {
            this.yaw.rotation.y = 0;
        }
    };
    Viewport3d.prototype.getMapRotation = function () {
        return this.yaw.rotation.y;
    };
    return Viewport3d;
}());


;// CONCATENATED MODULE: ./src/sdk/Viewport2d.ts

var Viewport2d_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var Viewport2d_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var Viewport2d_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};







var Viewport2d = /** @class */ (function () {
    function Viewport2d() {
    }
    Viewport2d.prototype.initialise = function (world, region) {
        return Viewport2d_awaiter(this, void 0, void 0, function () {
            return Viewport2d_generator(this, function (_a) {
                // do nothing, but maybe we should buffer the world background
                return [2 /*return*/];
            });
        });
    };
    Viewport2d.prototype.reset = function () {
        // do nothing
    };
    Viewport2d.prototype.draw = function (world, region) {
        var _this = this;
        region.context.save();
        region.drawWorldBackground(region.context, Settings.tileSize);
        region.drawGroundItems(region.context);
        // Draw all things on the map
        var renderables = Viewport2d_spreadArray([], region.entities, true);
        var units = [];
        if (world.getReadyTimer <= 0) {
            units.push.apply(units, region.mobs);
            units.push.apply(units, region.newMobs);
        }
        units.push.apply(units, region.players);
        renderables.concat(units).forEach(function (r) {
            var location = r.getPerceivedLocation(world.tickPercent);
            r.draw(world.tickPercent, region.context, location, Settings.tileSize);
        });
        var getOffset = function (r) {
            var perceivedLocation = r.getPerceivedLocation(world.tickPercent);
            var perceivedX = perceivedLocation.x;
            var perceivedY = perceivedLocation.y;
            return {
                x: perceivedX * Settings.tileSize + (r.size * Settings.tileSize) / 2,
                y: (perceivedY - r.size + 1) * Settings.tileSize + (r.size * Settings.tileSize) / 2,
            };
        };
        region.entities.forEach(function (entity) { return entity.drawUILayer(world.tickPercent, getOffset(entity), entity.region.context, Settings.tileSize, true); });
        if (world.getReadyTimer <= 0) {
            region.mobs.forEach(function (mob) {
                return mob.drawUILayer(world.tickPercent, getOffset(mob), mob.region.context, Settings.tileSize, true);
            });
            region.players.forEach(function (player) {
                player.drawUILayer(world.tickPercent, getOffset(player), player.region.context, Settings.tileSize, true);
            });
            units.forEach(function (unit) {
                if (unit.dying === -1) {
                    _this.drawIncomingProjectiles(unit, unit.region.context, world.tickPercent);
                }
            });
        }
        region.context.restore();
        var _a = Viewport.viewport.getViewport(world.tickPercent), viewportX = _a.viewportX, viewportY = _a.viewportY;
        return {
            canvas: region.canvas,
            uiCanvas: null,
            flip: Settings.rotated === "south",
            offsetX: -viewportX * Settings.tileSize,
            offsetY: -viewportY * Settings.tileSize,
        };
    };
    Viewport2d.prototype.translateClick = function (offsetX, offsetY, world, viewport) {
        var _a = viewport.getViewport(world.tickPercent), viewportX = _a.viewportX, viewportY = _a.viewportY;
        var x = offsetX + viewportX * Settings.tileSize;
        var y = offsetY + viewportY * Settings.tileSize;
        if (Settings.rotated === "south") {
            x = viewport.width * Settings.tileSize - offsetX + viewportX * Settings.tileSize;
            y = viewport.height * Settings.tileSize - offsetY + viewportY * Settings.tileSize;
        }
        var adjustedX = x / Settings.tileSize;
        var adjustedY = y / Settings.tileSize;
        var mobs = [];
        var players = [];
        var groundItems = [];
        var region = Trainer.player.region;
        mobs.push.apply(mobs, Collision.collidesWithAnyMobsAtPerceivedDisplayLocation(region, adjustedX, adjustedY, world.tickPercent));
        players.push.apply(players, Collision.collidesWithAnyPlayersAtPerceivedDisplayLocation(region, adjustedX, adjustedY, world.tickPercent).filter(function (player) { return player !== Trainer.player; }));
        groundItems.push.apply(groundItems, region.groundItemsAtLocation(Math.floor(adjustedX), Math.floor(adjustedY)));
        if (mobs.length > 0 || players.length > 0 || groundItems.length > 0) {
            return {
                type: "entities",
                mobs: lodash_default().uniq(mobs),
                players: players,
                groundItems: groundItems,
                location: {
                    x: adjustedX,
                    y: adjustedY,
                },
            };
        }
        return {
            type: "coordinate",
            location: {
                x: adjustedX,
                y: adjustedY,
            },
        };
    };
    // The rendering context is the world.
    Viewport2d.prototype.drawIncomingProjectiles = function (unit, context, tickPercent, scale) {
        if (scale === void 0) { scale = Settings.tileSize; }
        var incomingProjectiles = unit.incomingProjectiles;
        incomingProjectiles.forEach(function (projectile) {
            if (projectile.options.hidden) {
                return;
            }
            if (projectile.remainingDelay < 0) {
                return;
            }
            var startX = projectile.currentLocation.x;
            var startY = projectile.currentLocation.y;
            var _a = projectile.getTargetDestination(tickPercent), endX = _a.x, endY = _a.y;
            var perceivedX = Pathing.linearInterpolation(startX, endX, tickPercent / (projectile.remainingDelay + 1));
            var perceivedY = Pathing.linearInterpolation(startY, endY, tickPercent / (projectile.remainingDelay + 1));
            context.save();
            context.translate(perceivedX * Settings.tileSize, perceivedY * Settings.tileSize);
            if (projectile.image) {
                context.rotate(Math.PI);
                context.drawImage(projectile.image, -scale / 2, -scale / 2, scale, scale);
            }
            else {
                context.beginPath();
                context.fillStyle = "#D1BB7773";
                if (projectile.attackStyle === "slash" ||
                    projectile.attackStyle === "crush" ||
                    projectile.attackStyle === "stab") {
                    context.fillStyle = "#FF000073";
                }
                else if (projectile.attackStyle === "range") {
                    context.fillStyle = "#00FF0073";
                }
                else if (projectile.attackStyle === "magic") {
                    context.fillStyle = "#0000FF73";
                }
                else if (projectile.attackStyle === "heal") {
                    context.fillStyle = "#9813aa73";
                }
                else {
                    console.log("[WARN] This style is not accounted for in custom coloring: ", projectile.attackStyle);
                }
                context.arc(0, 0, 5, 0, 2 * Math.PI);
                context.fill();
            }
            context.restore();
        });
    };
    Viewport2d.prototype.setMapRotation = function (direction) {
        if (direction === CardinalDirection.SOUTH) {
            Settings.rotated = "south";
        }
        else if (direction === CardinalDirection.NORTH) {
            Settings.rotated = "north";
        }
    };
    Viewport2d.prototype.getMapRotation = function () {
        return Settings.rotated === "south" ? Math.PI : 0;
    };
    return Viewport2d;
}());


;// CONCATENATED MODULE: ./src/sdk/Viewport.ts

var Viewport_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var Viewport_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};













var Viewport = /** @class */ (function () {
    function Viewport(delegate) {
        this.delegate = delegate;
        this.activeButtonImage = ImageLoader.createImage(button_active_namespaceObject);
        this.contextMenu = new ContextMenu();
        this.components = [];
    }
    Viewport.setupViewport = function (region, force2d) {
        if (force2d === void 0) { force2d = false; }
        var faceInitialSouth = region.initialFacing === CardinalDirection.SOUTH;
        // called after Settings have been initialized
        Viewport.viewport = new Viewport(Settings.use3dView && !force2d ? new Viewport3d(faceInitialSouth) : new Viewport2d());
    };
    /**
     * Return all objects or world coordinates at the given position (relative to the top-left of the viewport).
     */
    Viewport.prototype.translateClick = function (offsetX, offsetY, world) {
        return this.delegate.translateClick(offsetX, offsetY, world, this);
    };
    Object.defineProperty(Viewport.prototype, "context", {
        get: function () {
            return this.canvas.getContext("2d");
        },
        enumerable: false,
        configurable: true
    });
    Viewport.prototype.setPlayer = function (player) {
        var _this = this;
        Trainer.setPlayer(player);
        window.addEventListener("orientationchange", function () { return _this.calculateViewport(); });
        window.addEventListener("resize", function () { return _this.calculateViewport(); });
        window.addEventListener("wheel", function () { return _this.calculateViewport(); });
        window.addEventListener("resize", function () { return _this.calculateViewport(); });
        this.canvas = document.getElementById("world");
        this.calculateViewport();
        this.canvas.width = Settings._tileSize * 2 * this.width;
        this.canvas.height = Settings._tileSize * 2 * this.height;
        if (!this.clickController) {
            this.clickController = new ClickController(this);
            this.clickController.registerClickActions();
        }
        Trainer.setClickController(this.clickController);
    };
    // called after all graphics have loaded
    Viewport.prototype.initialise = function () {
        return Viewport_awaiter(this, void 0, void 0, function () {
            return Viewport_generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.delegate.initialise(Trainer.player.region.world, Trainer.player.region)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Viewport.prototype.reset = function () {
        this.delegate.reset();
        this.components = [];
    };
    Viewport.prototype.calculateViewport = function () {
        var _a = Chrome.size(), width = _a.width, height = _a.height;
        Settings._tileSize = width / Trainer.player.region.width;
        this.width = width / Settings.tileSize;
        this.height = height / Settings.tileSize;
        if (width !== this.canvas.width || height !== this.canvas.height) {
            this.canvas.width = width;
            this.canvas.height = height;
        }
    };
    Viewport.prototype.getViewport = function (tickPercent) {
        if (Trainer.player.dying > -1) {
            tickPercent = 0;
        }
        var _a = Trainer.player.getPerceivedLocation(tickPercent), x = _a.x, y = _a.y;
        var viewportX = x + 0.5 - this.width / 2;
        var viewportY = y + 0.5 - this.height / 2;
        return { viewportX: viewportX, viewportY: viewportY };
    };
    Viewport.prototype.drawText = function (text, x, y) {
        x = Math.floor(x);
        y = Math.floor(y);
        this.context.fillStyle = "#000";
        this.context.fillText(text, x - 2, y - 2);
        this.context.fillText(text, x + 2, y - 2);
        this.context.fillText(text, x, y);
        this.context.fillText(text, x, y - 4);
        this.context.fillStyle = "#FFFFFF";
        this.context.fillText(text, x, y - 2);
    };
    Viewport.prototype.tick = function () {
        if (MapController.controller && Trainer.player) {
            MapController.controller.updateOrbsMask(Trainer.player.currentStats, Trainer.player.stats);
        }
    };
    Viewport.prototype.getMapRotation = function () {
        return this.delegate.getMapRotation();
    };
    Viewport.prototype.rotateSouth = function () {
        this.delegate.setMapRotation(CardinalDirection.SOUTH);
    };
    Viewport.prototype.rotateNorth = function () {
        this.delegate.setMapRotation(CardinalDirection.NORTH);
    };
    Viewport.prototype.getDelegate = function () {
        return this.delegate;
    };
    Viewport.prototype.draw = function (world) {
        var _this = this;
        this.context.globalAlpha = 1;
        this.context.fillStyle = "#3B3224";
        this.context.restore();
        this.context.save();
        this.context.fillStyle = "black";
        var _a = Chrome.size(), width = _a.width, height = _a.height;
        this.context.fillRect(0, 0, width, height);
        var _b = this.delegate.draw(world, Trainer.player.region), canvas = _b.canvas, uiCanvas = _b.uiCanvas, flip = _b.flip, offsetX = _b.offsetX, offsetY = _b.offsetY;
        if (flip) {
            this.context.rotate(Math.PI);
            this.context.translate(-width, -height);
        }
        this.context.drawImage(canvas, offsetX, offsetY);
        if (uiCanvas) {
            this.context.drawImage(uiCanvas, offsetX, offsetY);
        }
        this.context.restore();
        this.context.save();
        // draw control panel
        ControlPanelController.controller.draw(this.context);
        XpDropController.controller.draw(this.context, width - 140 - MapController.controller.width - (Settings.menuVisible ? 232 : 0), 0, world.tickPercent);
        MapController.controller.draw(this.context);
        this.contextMenu.draw(this.context);
        this.components.forEach(function (component) { return component.draw(_this.context, Settings.maxUiScale, 0, 0); });
        if (this.clickController.clickAnimation) {
            this.clickController.clickAnimation.draw(this.context);
        }
        this.context.restore();
        this.context.save();
        this.context.textAlign = "left";
        if (world.getReadyTimer > 0) {
            this.context.font = "72px OSRS";
            this.context.textAlign = "center";
            this.drawText("GET READY...".concat(world.getReadyTimer), width / 2, height / 2 - 50);
        }
        this.context.restore();
    };
    return Viewport;
}());


;// CONCATENATED MODULE: ./src/sdk/ClickController.ts











var ClickController = /** @class */ (function () {
    function ClickController(viewport) {
        this.clickAnimation = null;
        this.eventListeners = [];
        this.recentlySelectedMobs = [];
        this.viewport = viewport;
    }
    ClickController.prototype.unload = function () {
        this.viewport.canvas.removeEventListener("mousedown", this.eventListeners[0]);
        this.viewport.canvas.removeEventListener("mouseup", this.eventListeners[1]);
        this.viewport.canvas.removeEventListener("mousemove", this.eventListeners[2]);
        this.viewport.canvas.removeEventListener("mousemove", this.eventListeners[3]);
        this.viewport.canvas.removeEventListener("mousemove", this.eventListeners[4]);
        this.viewport.canvas.removeEventListener("mousemove", this.eventListeners[5]);
        this.viewport.canvas.removeEventListener("wheel", this.eventListeners[6]);
    };
    ClickController.prototype.registerClickActions = function () {
        this.viewport.canvas.addEventListener("mousedown", (this.eventListeners[0] = this.clickDown.bind(this)));
        this.viewport.canvas.addEventListener("mouseup", (this.eventListeners[1] = this.leftClickUp.bind(this)));
        this.viewport.canvas.addEventListener("mousemove", (this.eventListeners[2] = function (e) { return ControlPanelController.controller.cursorMovedTo(e); }));
        this.viewport.canvas.addEventListener("mousemove", (this.eventListeners[3] = function (e) { return MapController.controller.cursorMovedTo(e); }));
        this.viewport.canvas.addEventListener("mousemove", (this.eventListeners[4] = function (e) { return Viewport.viewport.contextMenu.cursorMovedTo(e.clientX, e.clientY); }));
        this.viewport.canvas.addEventListener("mousemove", (this.eventListeners[5] = this.mouseMoved.bind(this)));
        this.viewport.canvas.addEventListener("wheel", (this.eventListeners[6] = this.wheel.bind(this)));
    };
    ClickController.prototype.wheel = function (e) {
        Settings.zoomScale -= e.deltaY / 500;
        if (Settings.zoomScale < 0.5) {
            Settings.zoomScale = 0.5;
        }
        if (Settings.zoomScale > 2) {
            Settings.zoomScale = 2;
        }
        Settings.persistToStorage();
    };
    ClickController.prototype.leftClickUp = function (e) {
        if (e.button !== 0) {
            return;
        }
        var intercepted = ControlPanelController.controller.controlPanelClickUp(e);
        if (intercepted) {
            return;
        }
    };
    ClickController.prototype.hasSelectedMob = function () {
        return this.recentlySelectedMobs.length > 0;
    };
    ClickController.prototype.mouseMoved = function (e) {
        var scale = Settings.maxUiScale;
        if (this.viewport.components.some(function (component) { return component.onMouseMove(e.offsetX / scale, e.offsetY / scale); })) {
            return;
        }
        var world = Trainer.player.region.world;
        var hoveredOn = Viewport.viewport.translateClick(e.offsetX, e.offsetY, world);
        this.recentlySelectedMobs.forEach(function (mob) {
            mob.selected = false;
        });
        this.recentlySelectedMobs = [];
        if (hoveredOn && hoveredOn.type === "entities") {
            var firstMob = hoveredOn.mobs.find(function () { return true; });
            if (firstMob) {
                firstMob.selected = true;
                this.recentlySelectedMobs.push(firstMob);
            }
        }
    };
    ClickController.prototype.getClickedOn = function (e, world, region) {
        var xAlign = Viewport.viewport.contextMenu.location.x - Viewport.viewport.contextMenu.width / 2 < e.offsetX &&
            e.offsetX < Viewport.viewport.contextMenu.location.x + Viewport.viewport.contextMenu.width / 2;
        var yAlign = Viewport.viewport.contextMenu.location.y < e.offsetY &&
            e.offsetY < Viewport.viewport.contextMenu.location.y + Viewport.viewport.contextMenu.height;
        if (Viewport.viewport.contextMenu.isActive && xAlign && yAlign) {
            Viewport.viewport.contextMenu.clicked(e.offsetX, e.offsetY);
            Viewport.viewport.contextMenu.setInactive();
            return;
        }
        var intercepted = MapController.controller.leftClickDown(e);
        if (intercepted) {
            return;
        }
        var controlPanelIntercepted = ControlPanelController.controller.controlPanelClickDown(e);
        if (controlPanelIntercepted) {
            return;
        }
        var scale = Settings.maxUiScale;
        if (this.viewport.components.some(function (component) { return component.onPanelClick(e.offsetX / scale, e.offsetY / scale); })) {
            return;
        }
        var clickedOn = Viewport.viewport.translateClick(e.offsetX, e.offsetY, world);
        if (!clickedOn) {
            return null;
        }
        var _a = clickedOn.location, x = _a.x, y = _a.y;
        var mobs = [];
        var players = [];
        var groundItems = [];
        if (clickedOn.type === "entities") {
            mobs.push.apply(mobs, clickedOn.mobs);
            players.push.apply(players, clickedOn.players);
            groundItems.push.apply(groundItems, clickedOn.groundItems);
        }
        return { mobs: mobs, players: players, groundItems: groundItems, x: x, y: y };
    };
    ClickController.prototype.clickDown = function (e) {
        var _this = this;
        if (e.button === 2) {
            this.rightClickDown(e);
        }
        if (e.button !== 0) {
            return;
        }
        var region = Trainer.player.region;
        var world = Trainer.player.region.world;
        var player = Trainer.player;
        Viewport.viewport.contextMenu.cursorMovedTo(e.clientX, e.clientY);
        var clickedOn = this.getClickedOn(e, world, region);
        if (!clickedOn) {
            return;
        }
        var mobs = clickedOn.mobs, players = clickedOn.players, groundItems = clickedOn.groundItems, x = clickedOn.x, y = clickedOn.y;
        Trainer.player.interruptCombat();
        var inputController = InputController.controller;
        if (!e.shiftKey && mobs.length && mobs[0].canBeAttacked()) {
            this.redClick();
            inputController.queueAction(function () { return _this.playerAttackClick(mobs[0]); });
        }
        else if (!e.shiftKey && players.length) {
            this.redClick();
            inputController.queueAction(function () { return _this.playerAttackClick(players[0]); });
        }
        else if (!e.shiftKey && groundItems.length) {
            this.redClick();
            inputController.queueAction(function () { return player.setSeekingItem(groundItems[0]); });
        }
        else if (x !== null && y !== null) {
            this.yellowClick();
            inputController.queueAction(function () { return _this.playerWalkClick(x, y); });
        }
        Viewport.viewport.contextMenu.setInactive();
    };
    ClickController.prototype.rightClickDown = function (e) {
        var _this = this;
        var region = Trainer.player.region;
        var world = Trainer.player.region.world;
        Viewport.viewport.contextMenu.setPosition({ x: e.offsetX, y: e.offsetY });
        if (ControlPanelController.controller.controlPanelRightClick(e)) {
            return;
        }
        if (MapController.controller.rightClick(e)) {
            return;
        }
        var clickedOn = this.getClickedOn(e, world, region);
        if (!clickedOn) {
            return;
        }
        var mobs = clickedOn.mobs, players = clickedOn.players, groundItems = clickedOn.groundItems, x = clickedOn.x, y = clickedOn.y;
        Viewport.viewport.contextMenu.destinationLocation = {
            x: Math.floor(x),
            y: Math.floor(y),
        };
        /* gather options */
        var menuOptions = [];
        mobs.forEach(function (mob) {
            menuOptions = menuOptions.concat(mob.contextActions(region, x, y));
        });
        players.forEach(function (player) {
            if (player !== Trainer.player) {
                menuOptions = menuOptions.concat(player.contextActions(region, x, y));
            }
        });
        groundItems.forEach(function (item) {
            menuOptions.push({
                text: [
                    { text: "Take ", fillStyle: "white" },
                    { text: item.itemName, fillStyle: "#FF911F" },
                ],
                action: function () { return InputController.controller.queueAction(function () { return Trainer.player.setSeekingItem(item); }); },
            });
        });
        menuOptions.push({
            text: [{ text: "Walk Here", fillStyle: "white" }],
            action: function () {
                _this.yellowClick();
                var x = Viewport.viewport.contextMenu.destinationLocation.x;
                var y = Viewport.viewport.contextMenu.destinationLocation.y;
                InputController.controller.queueAction(function () { return _this.playerWalkClick(x, y); });
            },
        }, {
            text: [{ text: "Mark / Unmark Tile", fillStyle: "white" }],
            action: function () {
                _this.yellowClick();
                var x = Viewport.viewport.contextMenu.destinationLocation.x;
                var y = Viewport.viewport.contextMenu.destinationLocation.y;
                var removed = false;
                var entitiesAtPoint = Pathing.entitiesAtPoint(region, x, y, 1);
                entitiesAtPoint.forEach(function (entity) {
                    if (entity.entityName() === EntityNames.TILE_MARKER && entity.saveable) {
                        region.removeEntity(entity);
                        removed = true;
                    }
                });
                if (!removed) {
                    region.addEntity(new TileMarker(Trainer.player.region, { x: x, y: y }, "#FF0000"));
                }
                Settings.tile_markers = (0,lodash.filter)((0,lodash.filter)(region.entities, function (entity) { return entity.entityName() === EntityNames.TILE_MARKER; }), function (tileMarker) { return tileMarker.saveable; }).map(function (entity) { return entity.location; });
                Settings.persistToStorage();
            },
        });
        menuOptions = menuOptions.concat(region.rightClickActions());
        Viewport.viewport.contextMenu.setMenuOptions(menuOptions);
        Viewport.viewport.contextMenu.setActive();
    };
    ClickController.prototype.playerAttackClick = function (mob) {
        Trainer.player.setAggro(mob);
    };
    ClickController.prototype.playerWalkClick = function (x, y) {
        Trainer.player.moveTo(Math.floor(x), Math.floor(y));
    };
    ClickController.prototype.redClick = function () {
        this.clickAnimation = new ClickAnimation("red", Viewport.viewport.contextMenu.cursorPosition.x, Viewport.viewport.contextMenu.cursorPosition.y);
    };
    ClickController.prototype.yellowClick = function () {
        this.clickAnimation = new ClickAnimation("yellow", Viewport.viewport.contextMenu.cursorPosition.x, Viewport.viewport.contextMenu.cursorPosition.y);
    };
    return ClickController;
}());


;// CONCATENATED MODULE: ./src/sdk/controlpanels/StandardSpellbookControls.ts
var StandardSpellbookControls_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var StandardSpellbookControls = /** @class */ (function (_super) {
    StandardSpellbookControls_extends(StandardSpellbookControls, _super);
    function StandardSpellbookControls() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(StandardSpellbookControls.prototype, "panelImageReference", {
        get: function () {
            return inventory_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StandardSpellbookControls.prototype, "tabImageReference", {
        get: function () {
            return standard_spellbook_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return StandardSpellbookControls;
}(BaseControls));


;// CONCATENATED MODULE: ./src/assets/sounds/bonk.ogg
const bonk_namespaceObject = __webpack_require__.p + "5e4bdd862b2d716855cd.ogg";
;// CONCATENATED MODULE: ./src/sdk/World.ts










var CLIENT_TICK_MS = 20;
var World = /** @class */ (function () {
    function World() {
        this.regions = [];
        this.globalTickCounter = 0;
        this.isPaused = true;
        this.getReadyTimer = 0;
        this.deltaTimeSincePause = -1;
        this.deltaTimeSinceLastTick = -1;
        this.fpsInterval = 1000 / Settings.fps;
        this.frameCount = 0;
        this.tickTimer = 0;
        this.clientTickTimer = 0;
        this.clientTickHandle = null;
    }
    World.prototype.addRegion = function (region) {
        this.regions.push(region);
    };
    World.prototype.startTicking = function () {
        var _this = this;
        this.isPaused = false;
        if (this.deltaTimeSincePause === -1) {
            this.tickTimer = window.performance.now();
            this.then = window.performance.now();
        }
        else {
            this.then = window.performance.now() - this.deltaTimeSincePause;
            this.tickTimer = window.performance.now() - this.deltaTimeSinceLastTick;
            this.deltaTimeSincePause = -1;
        }
        ControlPanelController.controller.onWorldTick();
        this.browserLoop(window.performance.now());
        this.clientTickHandle = setInterval(function () { return _this.doClientTick(); }, CLIENT_TICK_MS);
    };
    World.prototype.stopTicking = function () {
        this.deltaTimeSincePause = window.performance.now() - this.then;
        this.deltaTimeSinceLastTick = window.performance.now() - this.tickTimer;
        this.isPaused = true;
        clearInterval(this.clientTickHandle);
        this.clientTickHandle = null;
    };
    World.prototype.doClientTick = function () {
        var now = window.performance.now();
        var clientTickElapsed = now - this.clientTickTimer;
        // client tick every 20ms, doing multiple if missed
        var tickPercent = (now - this.tickTimer) / Settings.tickMs;
        var clientTicksElapsed = Math.min(50, Math.max(1, Math.floor(clientTickElapsed / CLIENT_TICK_MS)));
        for (var i = 0; i < clientTicksElapsed; i++) {
            this.tickClient(tickPercent);
            this.clientTickTimer = now;
        }
    };
    World.prototype.browserLoop = function (now) {
        window.requestAnimationFrame(this.browserLoop.bind(this));
        if (this.isPaused) {
            return;
        }
        var elapsed = now - this.then;
        var tickElapsed = now - this.tickTimer;
        if (tickElapsed >= 600) {
            this.tickTimer = now;
            if (this.getReadyTimer > 0) {
                this.getReadyTimer--;
            }
            this.tickWorld();
        }
        this.tickPercent = (window.performance.now() - this.tickTimer) / Settings.tickMs;
        if (elapsed > this.fpsInterval) {
            this.then = now - (elapsed % this.fpsInterval);
            Viewport.viewport.draw(this);
            this.frameCount++;
        }
    };
    World.prototype.tickWorld = function (n) {
        var _this = this;
        if (n === void 0) { n = 1; }
        this.globalTickCounter++;
        InputController.controller.onWorldTick();
        ControlPanelController.controller.onWorldTick();
        this.regions.forEach(function (region) { return _this.tickRegion(region); });
        if (n > 1) {
            return this.tickWorld(n - 1);
        }
    };
    World.prototype.tickClient = function (tickPercent) {
        var _this = this;
        this.regions.forEach(function (region) { return _this.clientTick(region, tickPercent); });
    };
    World.prototype.tickRegion = function (region) {
        var _a;
        var _this = this;
        Pathing.purgeTileCache();
        if (Settings.metronome) {
            new Audio(bonk_namespaceObject).play();
        }
        // TODO: Clean up this since its now region based
        if (region.newMobs.length) {
            (_a = region.mobs).unshift.apply(_a, region.newMobs);
            region.newMobs = [];
        }
        region.players.forEach(function (player) { return player.pretick(); });
        region.entities.forEach(function (entity) { return entity.tick(); });
        if (this.getReadyTimer == 0) {
            region.mobs.forEach(function (mob) {
                mob.timerStep();
            });
            region.mobs.forEach(function (mob) {
                mob.movementStep();
            });
            region.mobs.forEach(function (mob) { return mob.attackStep(); });
            region.newMobs.forEach(function (mob) {
                mob.timerStep();
            });
            region.newMobs.forEach(function (mob) {
                mob.movementStep();
            });
            region.newMobs.forEach(function (mob) { return mob.attackStep(); });
        }
        DelayedAction.afterNpcTick();
        region.projectiles = (0,lodash.filter)(region.projectiles, function (projectile) { return !projectile.shouldDestroy(); });
        region.projectiles.forEach(function (projectile) {
            projectile.onTick();
            if (projectile.remainingDelay === 0) {
                projectile.beforeHit();
            }
        });
        region.players.forEach(function (player) {
            player.timerStep();
            player.movementStep();
            if (_this.getReadyTimer <= 0) {
                player.attackStep();
            }
        });
        region.midTick();
        DelayedAction.tick();
        XpDropController.controller.tick();
        Viewport.viewport.tick();
        region.postTick();
        // Safely remove the dead stuff from the world. If we do it while iterating we can cause ticks to be stole'd
        var deadPlayers = region.players.filter(function (player) { return player.dying === 0; });
        var deadMobs = region.mobs.filter(function (mob) { return mob.dying === 0; });
        var deadEntities = region.entities.filter(function (entity) { return entity.dying === 0; });
        deadPlayers.forEach(function (player) { return region.removePlayer(player); });
        deadMobs.forEach(function (mob) { return region.removeMob(mob); });
        deadEntities.forEach(function (entity) { return region.removeEntity(entity); });
    };
    World.prototype.clientTick = function (region, tickPercent) {
        region.players.forEach(function (player) {
            player.clientTick(tickPercent);
        });
    };
    return World;
}());


;// CONCATENATED MODULE: ./src/sdk/testing/TestNpc.ts
var TestNpc_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



// this is a JalXil in all but name, from the old test
var TestNpc = /** @class */ (function (_super) {
    TestNpc_extends(TestNpc, _super);
    function TestNpc(region, location, options) {
        return _super.call(this, region, location, options) || this;
    }
    TestNpc.prototype.setStats = function () {
        this.stunned = 1;
        this.weapons = {
            crush: new MeleeWeapon(),
            range: new RangedWeapon(),
        };
        // non boosted numbers
        this.stats = {
            attack: 140,
            strength: 180,
            defence: 60,
            range: 250,
            magic: 90,
            hitpoint: 125,
        };
        // with boosts
        this.currentStats = JSON.parse(JSON.stringify(this.stats));
    };
    Object.defineProperty(TestNpc.prototype, "bonuses", {
        get: function () {
            return {
                attack: {
                    stab: 0,
                    slash: 0,
                    crush: 0,
                    magic: 0,
                    range: 40,
                },
                defence: {
                    stab: 0,
                    slash: 0,
                    crush: 0,
                    magic: 0,
                    range: 0,
                },
                other: {
                    meleeStrength: 0,
                    rangedStrength: 50,
                    magicDamage: 0,
                    prayer: 0,
                },
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TestNpc.prototype, "attackSpeed", {
        get: function () {
            return 4;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TestNpc.prototype, "attackRange", {
        get: function () {
            return 15;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TestNpc.prototype, "size", {
        get: function () {
            return 3;
        },
        enumerable: false,
        configurable: true
    });
    TestNpc.prototype.attackStyleForNewAttack = function () {
        return "range";
    };
    TestNpc.prototype.canMeleeIfClose = function () {
        return "crush";
    };
    return TestNpc;
}(Mob));


;// CONCATENATED MODULE: ./src/sdk/testing/TestRegion.ts
var TestRegion_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var TestRegion = /** @class */ (function (_super) {
    TestRegion_extends(TestRegion, _super);
    function TestRegion(_width, _height) {
        var _this = _super.call(this) || this;
        _this._width = _width;
        _this._height = _height;
        return _this;
    }
    Object.defineProperty(TestRegion.prototype, "width", {
        get: function () {
            return this._width;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TestRegion.prototype, "height", {
        get: function () {
            return this._height;
        },
        enumerable: false,
        configurable: true
    });
    TestRegion.prototype.initialiseRegion = function () {
        return null;
    };
    return TestRegion;
}(Region));


;// CONCATENATED MODULE: ./src/sdk/utils/__mocks__/Assets.ts
var Assets_Assets = /** @class */ (function () {
    function Assets() {
    }
    Assets.getAssetUrl = function (x) {
        return x;
    };
    return Assets;
}());


;// CONCATENATED MODULE: ./src/sdk/utils/__mocks__/SoundCache.ts
var SoundCache_Sound = /** @class */ (function () {
    function Sound(src, volume) {
        if (volume === void 0) { volume = 1; }
        this.src = src;
        this.volume = volume;
    }
    return Sound;
}());

var SoundCache_SoundCache = /** @class */ (function () {
    function SoundCache() {
    }
    SoundCache.preload = function () {
        return;
    };
    SoundCache.play = function () {
        return;
    };
    return SoundCache;
}());


;// CONCATENATED MODULE: ./src/sdk/index.ts
// generated using Generate Index https://marketplace.visualstudio.com/items?itemName=JayFong.generate-index
// @index('./**/*.ts', f => `export * from '${f.path}';`)




























































































;// CONCATENATED MODULE: ./src/sdk/rendering/PointingModel.ts
var PointingModel_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var PointingModel_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

var PointingModel = /** @class */ (function () {
    function PointingModel(size, height, color, unit, drawOffset) {
        if (drawOffset === void 0) { drawOffset = {}; }
        this.size = size;
        this.drawOffset = drawOffset;
        this.geometry = new external_three_.BoxGeometry(size * 0.6, height, size * 0.6);
        this.material = new external_three_.MeshStandardMaterial({ color: color });
        this.mainMesh = new external_three_.Mesh(this.geometry, this.material);
        this.mainMesh.userData.clickable = unit !== null && unit.selectable;
        this.mainMesh.userData.unit = unit;
        // west is 0 degrees
        this.arrowHelper = new external_three_.ArrowHelper(new external_three_.Vector3(1, 0, 0), new external_three_.Vector3(0, 0, 0), 1, color);
        this.mainMesh.add(this.arrowHelper);
    }
    PointingModel.forRenderable = function (r) {
        return new PointingModel(r.size, r.height, r.colorHex, r);
    };
    PointingModel.prototype.draw = function (scene, clockDelta, tickPercent, location, pitch, rotation) {
        if (this.mainMesh.parent !== scene) {
            scene.add(this.mainMesh);
        }
        var size = this.size;
        var x = location.x, y = location.y, z = location.z;
        // conversion from Location3 to Vector3
        // lerp because we only move the perceived location in client ticks
        var targetPosition = new external_three_.Vector3(x + size / 2, z, y - size / 2).add({
            x: this.drawOffset.x || 0,
            y: this.drawOffset.y || 0,
            z: this.drawOffset.z || 0,
        });
        this.mainMesh.position.lerp(targetPosition, 0.25);
        this.mainMesh.setRotationFromAxisAngle(new external_three_.Vector3(0, 1, 0), rotation);
    };
    PointingModel.prototype.destroy = function (scene) {
        if (this.mainMesh.parent === scene) {
            scene.remove(this.mainMesh);
        }
    };
    PointingModel.prototype.getWorldPosition = function () {
        return this.mainMesh.getWorldPosition(new external_three_.Vector3());
    };
    PointingModel.prototype.preload = function () {
        return PointingModel_awaiter(this, void 0, void 0, function () {
            return PointingModel_generator(this, function (_a) {
                // do nothing
                return [2 /*return*/];
            });
        });
    };
    return PointingModel;
}());


;// CONCATENATED MODULE: ./src/sdk/rendering/index.ts
// generated using Generate Index https://marketplace.visualstudio.com/items?itemName=JayFong.generate-index
// @index('./**/*.ts', f => `export * from '${f.path}';`)











;// CONCATENATED MODULE: ./src/index.ts




})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=main.js.map